import { AddPlayerTypeDiscountPage } from './../../modal-screens/player-voucher/add-player-type-discount/add-player-type-discount.page';
import { Browser } from '@capacitor/browser';
import { toJpeg } from 'html-to-image';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  Renderer2,
  Input,
} from '@angular/core';
import { CustomSha1 } from 'src/custom/sha1';
import { sha256 } from 'js-sha256';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerService } from 'src/providers/player-service/player-service';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  AlertController,
  PopoverController,
  ToastController,
  IonContent,
  ScrollDetail,
} from '@ionic/angular';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { adjustViewZIndex } from 'src/globals';
import {
  createPlayerList,
  FriendRequest,
  FriendRequestList,
  PlayerHomeInfo,
  PlayerInfo,
  PlayerList,
  PlayerGroup,
} from 'src/data/player-data';
import {
  AbstractNotificationHandlerPage,
  NotificationHandlerInfo,
} from 'src/providers/pushnotification-service/notification-handler-constructs';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { Observable, Subscription } from 'rxjs';
import { ClubInfo, CourseInfo } from 'src/data/club-course';
import { JsonService } from 'src/json-util';
import {
  TeeTimeSlotDisplay,
  ClubTeeTimeSlots,
  CurrencyData,
  DisplayPrices,
  TeeTimeSlot,
  TeeTimeBooking,
  TeeTimeBookingPlayer,
  TeeTimeBookingOptions,
  PlayerData,
  ClubData,
  CaddySelectionCriteria,
  CaddyData,
  BuggyCaddiePreference,
  PlayerBuggyCaddiePreference,
  ItemizedBill,
  BuggyAssignment,
  BookingPlayerCharges,
  PaymentGatewayInfo,
  BookingOfflinePayment,
  OfflinePayment,
  TeeTimeBookingDiscount,
  TeeTimeClubVoucher,
  TeeTimePricingPlan,
  BookingDiscountBillItem,
  TeeTimeClubVoucherSeries,
  TeeTimeDiscount,
  DiscountPlayerClub,
  PlayerTypes,
  BookingPayment,
  BookingCount,
  TeeTimeBookingAdditionalItem,
  TeeTimePriceComponent,
  TeeTimePrice,
  DiscountCompany,
  BuggyType,
  BookingPlayerType,
  ClubMembershipExtended,
  ClubMembership,
  Bill,
  PlayerRoundScores,
  PlainScoreCard,
  PlayerBookingTypeAssociation,
} from 'src/data/mygolf.data';
import { TeeBox } from 'src/data/tee-box';
import { NewGameInfo } from 'src/data/game-round';
import { HandicapService } from 'src/providers/handicap-service/handicap-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import * as moment from 'moment';
import { PlayerHomeDataService, PlayerHomeActions } from 'src/redux/player-home';
import { PremiumFeaturePrice } from 'src/data/premium-subscription';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import {
  InAppBrowser,
  InAppBrowserOptions,
  InAppBrowserEvent,
} from '@awesome-cordova-plugins/in-app-browser/ngx';
import * as global from 'src/globals';
import { SessionInfo, SessionState } from 'src/data/authentication-info';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ServerInfo } from 'src/data/server-info';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { take } from 'rxjs/internal/operators/take';
import { NewContactPage } from '../../new-contact/new-contact.page';
import { NavigationExtras, Router } from '@angular/router';
import { ProfilePage } from '../../profile/profile.page';
import { of } from 'rxjs/internal/observable/of';
import { CourseBox } from '../../modal-screens/course-box/course-box.page';
import { FriendListPage } from '../../friend-list/friend-list.page';
import { AddPlayerListPage } from '../../modal-screens/add-player-list/add-player-list.page';

import { EventObserver } from 'src/providers/event-service';
import { PlayerGroupsPage } from '../../player-groups/player-groups.page';
import { CaddyListPage } from '../../modal-screens/caddy-list/caddy-list.page';
import { PlayerAddressPage } from '../../modal-screens/player-address/player-address.page';
import {
  ClubPaymentMethod,
  PricesDisplayPage,
} from '../../modal-screens/prices-display/prices-display.page';
import { isPresent } from 'src/providers/common-service';
import { EditProfilePage } from '../../edit-profile/edit-profile.page';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';
import { TeeSlotListModal } from '../../modal-screens/tee-slot-list/tee-slot-list.page';
import { PlayerVoucherPage } from '../../modal-screens/player-voucher/player-voucher.page';
import { VoucherListModal } from '../../modal-screens/voucher-list/voucher-list.page';
import { RedeemPlayerClubCreditsModal } from '../../modal-screens/redeem-player-club-credits/redeem-player-club-credits.page';
import { BuggySeatingPage } from '../../modal-screens/buggy-seating/buggy-seating.page';
import { PlayerListPage } from '../../modal-screens/player-list/player-list.page';
import { RefundBookingPlayersModal } from '../../modal-screens/refund-booking-players/refund-booking-players.page';
import { ManageVoucherPage } from '../../modal-screens/manage-voucher/manage-voucher.page';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { AdditionalItemsListModal } from '../../modal-screens/additional-items-list/additional-items-list';
import { EditTeeTimeSettingsPage } from '../../modal-screens/edit-teetime-settings/edit-teetime-settings';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { distinctUntilChanged } from 'rxjs/operators';
import { ClubService } from 'src/providers/club-service/club-service';
import { NormalgameService } from 'src/providers/normalgame-service/normalgame-service';
import { CurrentScorecardActions } from 'src/redux/scorecard';
import { OtherDealsComponent } from './other-deals/other-deals.component';
import { BookingConfirmationComponent } from './booking-confirmation/booking-confirmation.component';
import { TeeSlotSettingsComponent } from './tee-slot-settings/tee-slot-settings.component';
import { CheckInComponent } from './check-in/check-in.component';
import { ChangesHolesComponent } from './changes-holes/changes-holes.component';
import { OptionsModalComponent } from './options-modal/options-modal.component';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { MoreMenuPopoverComponent } from './more-menu-popover/more-menu-popover.component';
import { UpdateNhsModalComponent } from '../../normalgame/flight-setup/update-nhs-modal/update-nhs-modal.component';
import { HamerburgMenuComponent } from './hamerburg-menu/hamerburg-menu.component';
import { ManagePlayerGroupPage } from './manage-player-group/manage-player-group.page';
import { SaveGroupPage } from './save-group/save-group.page';
import { Location } from '@angular/common';
import { io } from 'socket.io-client';
import { DealsPage } from './deals/deals.page';
import { PaymentSelectionPage } from './payment-selection/payment-selection.page';
import { ClubRatingsModal } from '../../modal-screens/club-ratings/club-ratings';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { FileSharer } from '@byteowls/capacitor-filesharer';
import { Share } from '@capacitor/share'; //EXCLUDE FOR NOW FOR CAPACITOR 5
import { HttpClient } from '@angular/common/http';
import { read } from 'fs';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';

import { Filesystem, Directory, WriteFileResult } from '@capacitor/filesystem';
import { htmlStringUtility } from 'src/app/Core/html-string-utlity';
import { Capacitor } from '@capacitor/core';

import OneSignal from 'onesignal-cordova-plugin';

import { SUBSCRIBE_TEETIME_BOOKING, WebsocketActions } from 'src/redux/wstomp';

export interface PlayerBookingTypeAssociationExt {
  bookingPlayer?: TeeTimeBookingPlayer;
  playerTypes?: Array<PlayerBookingTypeAssociation>;
}

export interface BookingBuggy {
  buggySlot: number;
  driving: boolean;
  bookingPlayer?: TeeTimeBookingPlayer;
  pairingNo: number;
  walking: boolean;
  totalPlayers: number;
  maxAllowed: number;
}
export interface BookingCaddy {
  caddySelectionCriteria?: CaddySelectionCriteria;
  caddyPreferred?: CaddyData;
  caddyAssigned?: CaddyData;
  caddiePreferred?: number;
  caddieAssigned?: number;
  caddyRequired?: boolean;
  caddyRequested?: boolean;
  caddyPairing?: number;
}
export interface CaddyPairing {
  caddySelectionCriteria?: CaddySelectionCriteria;
  caddyPreferred?: CaddyData;
  caddyAssigned?: CaddyData;
  caddiePreferred?: number;
  caddieAssigned?: number;
  caddyRequired?: boolean;
  caddyRequested?: boolean;
  caddyPairing?: number;
}
export interface RatingItem {
  itemId?: string;
  name?: string;
  rating?: number;
}
export interface Ipay88Details {
  merchantCode?: string;
  merchantKey?: string;
}

export interface AddlBookingPlayers {
  searchById?: number;
  searchByMembership?: string;
  playerName?: string;
  playerId?: number;
  image?: string;
  profile?: string;
  phone?: string;
  player?: any;
  email?: string;
  address?: any;
}

function createAddlBookingPlayers(length, member: boolean = false): AddlBookingPlayers {
  return {
    searchById: null,
    searchByMembership: '',
    playerName: member ? `Member ${length}` : `Guest ${length}`,
    playerId: null,
    image: null,
    profile: null,
    phone: null,
    player: null,
    email: '',
    address: {},
  };
}

declare let html2canvas: any;

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.page.html',
  styleUrls: ['./booking-details.page.scss'],
})
export class BookingDetailsPage implements OnInit {
  public htmlContent: string = '';
  public imageDataUrl: string | null = null;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  public friends: string = 'friend';
  public friendType: string = 'friend';
  public friendScreenName: string = 'Friends';
  public bookings: string = 'search';
  public holesPlayed: string = '2';
  public requestByPlayer: boolean;
  public searchPlayer: string = '';
  public searchFriend: string = '';
  public refreshAttempted: boolean = false;
  public refreshPlayer: boolean = false;
  public sentExist: boolean = false;
  public receiveExist: boolean = false;
  public playerList: PlayerList;
  public requestFriends: FriendRequestList;
  public listFriends: PlayerList;
  public receivedList: Array<FriendRequest> = new Array<FriendRequest>();
  public sentList: Array<FriendRequest> = new Array<FriendRequest>();
  public friendRequests: Array<FriendRequest> = new Array<FriendRequest>();
  public playerRequests: Array<FriendRequest> = new Array<FriendRequest>();
  public refreshOnEnter: boolean = false;
  tabs: any;
  public grpTeeSlotInfo: boolean = true;
  public grpPlayerDetails: boolean = false;
  public grpPairings: boolean = false;
  public grpPayment: boolean = false;
  public grpCheckIn: boolean = false;
  public grpFeedback: boolean = false;
  public grpFood: boolean = false;
  public grpAdditionals: boolean = false;
  teeSlotNew: boolean = true;
  teeTimeSlotDisplay: TeeTimeSlotDisplay;
  teeTimeSlot: TeeTimeSlot;
  public currentPlayer: PlayerInfo;
  public otherPlayers: Array<PlayerInfo>;
  public gameInfo: NewGameInfo;
  clubInfo: any;
  clubs: ClubTeeTimeSlots;
  currency: CurrencyData;
  prices: DisplayPrices;
  promoPrices: DisplayPrices;
  displayPrices: boolean = false;
  isPromo: boolean = false;
  bookingSlot: TeeTimeBooking;
  nineHoles: boolean = true;
  bookingPlayers: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBookingPlayer>();
  playersList: Array<PlayerInfo> = new Array<PlayerInfo>();
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  currentPlayerId: number;
  groupSelected: boolean = false;
  playerSlot: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBooking>();
  slots: Array<number> = [];
  buggyReq: number = 0;
  caddyReq: number = 0;
  playerReq: number = 0;
  bookForOther: boolean = false;
  buggySlots: Array<BookingBuggy> = new Array<BookingBuggy>();
  caddySlots: Array<BookingCaddy> = new Array<BookingCaddy>();
  playerIsDriving: boolean = false;
  selectPaymentMethod: string = 'online';
  paymentAmountType: string = 'full';
  searchByMembership: Array<string> = new Array<string>();
  searchById: Array<number> = new Array<number>();
  clubSearchByMembership: string;
  clubSearchById: number;
  closeAdditionalNotice: boolean = false;
  expandPlayers: Array<boolean> = [false, false, false, false, false, false];
  buggySeatings: Array<BookingBuggy>;
  buggy;
  caddyPairing: Array<CaddyPairing> = new Array<CaddyPairing>();
  depositAmount: number = 0;
  playerDriving: Array<string> = ['other', 'other', 'other', 'other'];
  bookingType: string = '';
  serverInfo: ServerInfo;
  botsOut: boolean = true;
  caddyRemoveFlag: boolean = false;
  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };
  paymentStatus: string = 'Pending';
  countdownTimer: string;
  checkInPlayers: Array<any> = [false, false, false, false, false, false];
  checkInAllPlayers: boolean = false;
  etaCounter: number = 30;
  arrivalOption: string = 'eta';
  navbar: any;
  sticky: any;
  bookingOptions: TeeTimeBookingOptions;
  uniqBuggy: any;
  uniqCaddy: Array<TeeTimeBookingPlayer>;
  buggyCaddyPreference: BuggyCaddiePreference = {};
  newBuggyCaddyPreference: BuggyCaddiePreference = {};
  buggyRequired: boolean = false;
  caddyRequired: boolean = false;
  buggyRequested: number = 0;
  caddyRequested: number = 0;
  bookingItemBill: ItemizedBill;
  refresherBill: boolean = false;
  displayPayHistory: boolean = false;
  displayRefundHistory: boolean = false;
  @ViewChild('myInput') myInput: ElementRef;
  myStuff: string = '';
  paymentClickedBoolean: boolean = false;
  asgmtDiff: boolean = false;
  caddyDiff: Array<TeeTimeBookingPlayer>;
  buggyDiff: Array<TeeTimeBookingPlayer>;
  buggiesAssigned: Array<BuggyAssignment>;
  lblNoDiscountApplied: 'No discount(s) applied';
  selectedSegment: 'Player Details' | 'Buggies/Caddies' | 'Additional Items' = 'Player Details';
  paymentMode: boolean = false;
  clubRating: number = 0;
  bookingRating: number = 0;
  caddyRating: Array<number> = new Array<number>();
  caddyRatingComment: Array<string> = new Array<string>();
  caddyRatingCommentOn: Array<boolean> = new Array<boolean>();
  clubRatingItems: Array<RatingItem> = new Array<RatingItem>();
  doneRating: boolean = false;
  paymentBackendURL: string;
  paymentRedirectURL: string;
  paymentCallbackURL: string;
  paymentInternalURL: string;
  paymentSignAlgo: string;
  paymentPageURL: string;
  goToPaymentURL: string;
  merchantCode = 'M27515';
  localBill: number;
  playerChargeAmount: number;
  afterBook: boolean = false;
  private ipay88Details: Ipay88Details;
  paymentGatewayList: Array<PaymentGatewayInfo>;
  fromClub: boolean = false;
  currSession: SessionInfo;
  clubBookingPlayers: PlayerData;
  pgDescription: string;
  paymentConfirmClickedBoolean: boolean = false;
  clubPayment: boolean = false;
  captchaResponse: string = '';
  bookingDiscounts: Array<TeeTimeBookingDiscount>;
  viewVoucherApplied: boolean = false;
  removedPlayers: Array<TeeTimeBookingPlayer>;
  playerVoucher: Array<TeeTimeClubVoucher>;
  voucherSeries: Array<TeeTimeClubVoucherSeries>;
  clubDiscounts: Array<TeeTimeDiscount>;
  playersBalance: number = 0;
  assignmentDone: boolean = false;
  updatingPlayer: boolean = false;
  togglePlanDetails: boolean = false;
  togglePlanPromoDetails: boolean = false;
  playerMaxBooking: BookingCount;
  dummyPhoneNumber: number;
  bookingCancelGuard: boolean = false;
  nineHolesAllowed: boolean = false;
  eighteenHolesAllowed: boolean = false;
  allowClubContactInfo: boolean = true;
  paymentFailed: boolean = false;
  paymentDateTime: any = null;
  appFooterHide: boolean = true;
  sandboxPayment: boolean = false;
  applicablePlayerTypes: any;
  isClubSpecific: boolean = false;
  additionalItems: Array<TeeTimeBookingAdditionalItem>;
  filenameBill: string = '';
  billPlayerIds: Array<number>;
  userType: string = 'player';
  fromPartner: boolean = false;
  partnerInfo: DiscountCompany;
  private sessionStatusSubscription: Subscription;
  bookingPlayerTypes: Array<BookingPlayerType>;
  dataExtras: any;
  buggyTypeList: Array<BuggyType> = new Array<BuggyType>();
  pricingIgnoreDate: boolean = false;
  testMode: string = 'empty';
  slotPrices: Array<TeeTimePrice>;
  pricingComponents: Array<TeeTimePriceComponent>;
  filteredClubMembership: Array<ClubMembershipExtended> = [];
  mg2uPlayerList: Array<any> = [];
  selectedBuggyType: Array<BuggyType>;
  appAttribute: any;
  showConsoleLog: boolean = false;
  enablePaymentTimer: boolean = false;
  showRecalculate: boolean = false;
  paymentTimerDuration: number = 5;
  gameCourses: Array<CourseInfo>;
  fromClubList: boolean = false;
  aditionaleTypeArray: string[] = [];
  playerDetailsExpanded: boolean[] = [];
  editPlayerDetailsExpanded: boolean[] = [];
  isPricingPlanSeeMore: boolean = false;
  driverAssginged: any;
  currentBookingType: string = 'Requested';
  playerProfilePicture: string;
  BookedByName: string = '';
  editingPlayerName: Array<boolean> = [false, false, false, false, false, false];
  @Input() modalMode: boolean = false;

  //  iab: any;
  constructor(
    private nav: NavController,
    private platform: Platform,
    private keyboard: Keyboard,
    private friendService: FriendService,
    private globalEventObserver: EventObserver,
    private navParams: NavParams,
    private loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    private modalCtl: ModalController,
    private renderer: Renderer2,
    private popoverCtl: PopoverController,
    private handicapService: HandicapService,
    private flightService: ClubFlightService,
    private alertCtrl: AlertController,
    private playerHomeService: PlayerHomeDataService,
    private playerService: PlayerService,
    private toastCtl: ToastController,
    private cdr: ChangeDetectorRef,
    private paymentService: PaymentService,
    private sha1: CustomSha1,
    private serverInfoService: ServerInfoService,
    private playerHomeActions: PlayerHomeActions,
    private router: Router,
    private location: Location,
    private mg2uUtil: mygolfUtils,
    private renderer2: Renderer2,
    private el: ElementRef,
    private iab: InAppBrowser,
    private sessionDataService: SessionDataService,
    private sessionActions: SessionActions,
    private clubService: ClubService,
    private normalGameService: NormalgameService,
    private currentScorecardActions: CurrentScorecardActions,
    private http: HttpClient,
    private websocketActions: WebsocketActions
  ) {
    this.isClubSpecific = this.mg2uUtil.getClubSpecific();
    this.modalMode = navParams.get('modalMode');
    if (navParams.get('modalMode')) {
      this.teeSlotNew = navParams.get('teeSlotNew');
      this.bookingType = navParams.get('type');
      if (!!navParams.get('userType')) this.userType = navParams.get('userType');
      else if (this.isBookingAgent()) this.userType = 'booking_agent';
      this.fromPartner = navParams.get('fromPartner');

      if (!!navParams.get('partnerInfo')) {
        this.partnerInfo = navParams.get('partnerInfo');
        this.fromPartner = true;
      }

      this.fromClub = navParams.get('fromClub');
      if (!!navParams.get('currSession')) this.currSession = navParams.get('currSession');

      this.teeTimeSlotDisplay = navParams.get('teeTimeSlotDisplay');
      this.clubInfo = navParams.get('clubInfo');
      this.clubs = navParams.get('clubs');
      this.bookingSlot = navParams.get('bookingSlot');
      this.fromClubList = navParams.get('fromClubList');
      this.playerVoucher = navParams.get('playerVoucher');
      this.voucherSeries = navParams.get('voucherSeries');
      this.clubDiscounts = navParams.get('clubDiscounts');
    }
    console.debug('modal mode : ', this.modalMode, navParams.get('modalMode'));
    if (!this.modalMode) {
      this.dataExtras = this.router.getCurrentNavigation().extras.state;
      if (!!this.dataExtras) {
        this.teeSlotNew = this.dataExtras.teeSlotNew;
        this.bookingType = this.dataExtras.type;
        if (!!this.dataExtras.userType) this.userType = this.dataExtras.userType;
        else if (this.isBookingAgent()) this.userType = 'booking_agent';
        this.fromPartner = this.dataExtras.fromPartner;

        if (!!this.dataExtras.partnerInfo) {
          this.partnerInfo = this.dataExtras.partnerInfo;
          this.fromPartner = true;
        }

        this.fromClub = this.dataExtras.fromClub;
        if (!!this.dataExtras.currSession) this.currSession = this.dataExtras.currSession;

        this.teeTimeSlotDisplay = this.dataExtras.teeTimeSlotDisplay;
        this.clubInfo = this.dataExtras.clubInfo;
        console.log('this.clubInfo: ', this.clubInfo);
        this.clubs = this.dataExtras.clubs;
        this.bookingSlot = this.dataExtras.bookingSlot;
        this.fromClubList = this.dataExtras.fromClubList;
        this.playerVoucher = this.dataExtras.playerVoucher;
        this.voucherSeries = this.dataExtras.voucherSeries;
        this.clubDiscounts = this.dataExtras.clubDiscounts;
      }
      if (this.dataExtras?.bookingSlot) {
        if (this.dataExtras?.bookingSlot?.bookedByUser?.profile?.photo) {
          this.playerProfilePicture = `https://${global.MygolfServerHost}/${this.dataExtras?.bookingSlot?.bookedByUser?.profile?.photo}`;
        } else {
          this.playerProfilePicture = `https://${global.MygolfServerHost}/${this.dataExtras?.bookingSlot?.bookedByUser?.profile?.profileImage}`;
        }
        this.BookedByName = this.dataExtras?.bookingSlot?.bookedByUser?.name;
      }
    }

    if (!this.bookingType) this.bookingType = 'active';
    if (this.fromClub) this.clubPayment = true;
    if (this.isBookingAgent()) this.clubPayment = false;
    if (this.bookingSlot?.bookingPlayers) {
      this.bookingSlot.bookingPlayers.forEach(() => {
        this.playerDetailsExpanded.push(false);
        this.aditionaleTypeArray.push('');
      });
    }
    this.tabs = [
      {
        header: 'Schedule',
        icon: 'calendar',
      },
      {
        header: 'Speakers',
        icon: 'contacts',
      },
      {
        header: 'Map',
        icon: 'map',
      },
      {
        header: 'About',
        icon: 'information-circle',
      },
    ];

    this.requestFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      friendRequests: new Array<FriendRequest>(),
    };
    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>(),
    };

    this.globalEventObserver.getObservable().subscribe(data => {
      if (data.chanel == 'FriendListUpdate') {
        this._refreshValues(null, null);
      }
      if (data.chanel == 'FriendRequestUpdate') {
        this.friends = 'request';
        this._refreshValues(null, null);
      }
    });
    this.playerList = createPlayerList();
    this.clubRatingItems[0] = {
      itemId: '',
      name: '',
      rating: 0,
    };
    this.buggyCaddyPreference.playerPairings = [
      {
        bookingPlayerId: 0,
        buggyRequired: true,
        buggyPairing: 0,
        driving: false,
        caddieAssigned: null,
        caddiePreferred: null,
        caddyPairing: 0,
        caddyRequired: true,
        caddyPreferred: {},
        caddyAssigned: {},
        buggyType: 'STANDARD',
      },
    ];
    let _mygolfServerHost = global.MygolfServerHost;
    if (_mygolfServerHost)
      this.paymentBackendURL = 'http://' + _mygolfServerHost + '/rest/payment/ipay88/backend';
    else this.paymentBackendURL = 'http://devlet.mygolf2u.com/rest/payment/ipay88/backend';
    if (_mygolfServerHost === 'devlet.mygolf2u.com')
      this.paymentRedirectURL = 'http://dev-play.mygolf2u.com/payment_redirect.html';
    else if (_mygolfServerHost === 'azulet.mygolf2u.com')
      this.paymentRedirectURL = 'http://azu-play.mygolf2u.com/payment_redirect.html';

    if (_mygolfServerHost === 'devlet.mygolf2u.com') this.goToPaymentURL = 'dev-play';
    else if (_mygolfServerHost === 'azulet.mygolf2u.com') this.goToPaymentURL = 'azu-play';

    if (!this.teeSlotNew) {
      this.appFooterHide = false;
      document.documentElement.style.setProperty('--new-height', 'calc(100% - 8em)', 'important');
    } else {
      document.documentElement.style.setProperty('--new-height', 'calc(100% - 3em)', 'important');
    }

    if (this.teeSlotNew) {
      if (this.fromClub) {
      } else if (this.userType !== 'player') {
      } else {
        this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
        this.player$ = this.playerHomeInfo$
          .pipe(filter(Boolean))
          .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
        this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
          this.currentPlayerId = player.playerId;
          this.currentPlayer = player;
        });
      }
      this.currency = this.teeTimeSlotDisplay?.currency;
      this.prices = this.teeTimeSlotDisplay?.originalPrices;
      this.promoPrices = this.teeTimeSlotDisplay?.displayPrices;
      let _eighteenHoles = this.teeTimeSlotDisplay?.slot?.eighteenHolesAllowed;
      let _nineHoles = this.teeTimeSlotDisplay?.slot?.nineHolesAllowed;
      if (_eighteenHoles && _nineHoles) {
        this.holesPlayed = '2';
        this.eighteenHolesAllowed = true;
        this.nineHolesAllowed = true;
      } else if (!_eighteenHoles && _nineHoles) {
        this.holesPlayed = '1';
      } else if (_eighteenHoles && !_nineHoles) {
        this.holesPlayed = '2';
        this.eighteenHolesAllowed = true;
        this.nineHolesAllowed = false;
      } else if (!_eighteenHoles && !_nineHoles) {
        this.holesPlayed = '1';
        this.eighteenHolesAllowed = false;
        this.nineHolesAllowed = false;
      }
      this.playerReq = this.teeTimeSlotDisplay?.slot?.minPlayers;
      if (
        this.teeTimeSlotDisplay?.slot?.pricingPlanPromotional &&
        this.teeTimeSlotDisplay?.slot?.pricingPlanPromotional.promotional
      )
        this.isPromo = true;
      this.buggyReq =
        this.teeTimeSlotDisplay?.slot && this.teeTimeSlotDisplay?.slot.allowWalking ? 0 : 1;
      this.caddyReq =
        this.teeTimeSlotDisplay?.slot && this.teeTimeSlotDisplay?.slot.caddyMandatory ? 1 : 0;
      if (this.teeTimeSlotDisplay) {
        this.caddyRequired = this.teeTimeSlotDisplay?.slot.caddyMandatory ? true : false;
        this.buggyRequired = !this.teeTimeSlotDisplay?.slot.allowWalking ? true : false;
      }

      if (this.teeTimeSlotDisplay?.slot?.minPlayers > 1) {
        let _minPlayers = this.teeTimeSlotDisplay?.slot?.minPlayers;
        for (let i = 1; i < _minPlayers; i++) {
          this.addBookingPlayers(1);
        }
      }
    } else {
      if (this.fromClub) {
      } else if (this.userType !== 'player') {
      } else {
        this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
        this.player$ = this.playerHomeInfo$
          .pipe(filter(Boolean))
          .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
        this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
          this.currentPlayerId = player.playerId;
          this.currentPlayer = player;
        });
      }

      if (!this.teeTimeSlotDisplay) this.teeTimeSlotDisplay = {};

      if (this.bookingSlot.bookingDiscounts && this.bookingSlot.bookingDiscounts.length > 0) {
        this.bookingDiscounts = this.bookingSlot.bookingDiscounts.filter(
          (d: TeeTimeBookingDiscount) => {
            if (d.voucherApplied) return d.voucherApplied.redeemed;
          }
        );
      } else this.bookingDiscounts = [];

      this.assignmentDone = this.bookingSlot.assignmentDone;
      this.teeTimeSlot = this.bookingSlot.slotAssigned;
      this.teeTimeSlotDisplay = {
        slot: this.teeTimeSlot,
      };

      let _eighteenHoles = this.bookingSlot.slotAssigned.eighteenHolesAllowed;
      let _nineHoles = this.bookingSlot.slotAssigned.nineHolesAllowed;
      if (_eighteenHoles && _nineHoles) {
        this.holesPlayed = '2';
        this.eighteenHolesAllowed = true;
        this.nineHolesAllowed = true;
      } else if (!_eighteenHoles && _nineHoles) {
        this.holesPlayed = '1';
      } else if (_eighteenHoles && !_nineHoles) {
        this.holesPlayed = '2';
        this.eighteenHolesAllowed = true;
        this.nineHolesAllowed = false;
      } else if (!_eighteenHoles && !_nineHoles) {
        this.holesPlayed = '1';
        this.eighteenHolesAllowed = false;
        this.nineHolesAllowed = false;
      }

      this.buggyReq = this.bookingSlot.buggyRequested;
      this.caddyReq = this.bookingSlot.caddyRequested;

      this.playerSlot.push(...this.bookingSlot.bookingPlayers);
      if (this.teeTimeSlotDisplay.currency) this.currency = this.teeTimeSlotDisplay.currency;
      if (this.teeTimeSlotDisplay.originalPrices)
        this.prices = this.teeTimeSlotDisplay.originalPrices;
      if (this.teeTimeSlotDisplay.displayPrices)
        this.promoPrices = this.teeTimeSlotDisplay.displayPrices;

      this.removedPlayers = this.bookingSlot.bookingPlayers.filter(p => {
        return p.playerRemoved;
      });
      this.bookingSlot.bookingPlayers = this.bookingSlot.bookingPlayers.filter(p => {
        return !p.playerRemoved;
      });

      for (let i = 1; i <= this.bookingSlot.slotAssigned.maxPlayers; i++) {
        this.slots.push(i);
        if (
          this.bookingSlot.bookingPlayers[i - 1] &&
          (this.bookingSlot.bookingPlayers[i - 1].caddyPreferred ||
            (this.bookingSlot.bookingPlayers[i - 1].caddySelectionCriteria &&
              this.bookingSlot.bookingPlayers[i - 1].caddySelectionCriteria.gender) ||
            this.bookingSlot.bookingPlayers[i - 1].caddyPairing > 0)
        )
          this.caddyReq += 1;
        if (
          this.bookingSlot.bookingPlayers[i - 1] &&
          this.bookingSlot.bookingPlayers[i - 1].pairingNo > 0
        )
          this.buggyReq += 1;
      }

      let _uniqBuggy = this.getUnique(this.bookingSlot.bookingPlayers, 'pairingNo');
      _uniqBuggy = _uniqBuggy.filter(ub => {
        return ub.pairingNo > 0;
      });
      let _uniqCaddy = this.getUnique(this.bookingSlot.bookingPlayers, 'caddyPairing');
      _uniqCaddy = _uniqCaddy.filter(uc => {
        return uc.caddyPairing > 0;
      });
      this.uniqBuggy = this.getUnique(this.bookingSlot.bookingPlayers, 'pairingNo');
      this.uniqBuggy = this.uniqBuggy.filter(ub => {
        return ub.pairingNo > 0;
      });
      this.uniqCaddy = this.getUnique(this.bookingSlot.bookingPlayers, 'caddyPairing');
      this.uniqCaddy = this.uniqCaddy.filter(uc => {
        return uc.caddyPairing > 0;
      });
      if (this.uniqBuggy) this.buggyReq = this.uniqBuggy.length;
      if (this.uniqCaddy) this.caddyReq = this.uniqCaddy.length;
      this.uniqCaddy.forEach((c: TeeTimeBookingPlayer) => {
        JsonService.deriveFulImageURL(c.caddyAssigned, 'caddyImage');
        JsonService.deriveFulImageURL(c.caddyPreferred, 'caddyImage');
      });

      for (let i = 0; i < this.uniqCaddy.length; i++) {
        this.caddyRating[i] = 0;
      }
      this.bookingSlot.bookingPlayers.sort((a, b) => {
        if (a.sequence < b.sequence) return -1;
        else if (a.sequence > b.sequence) return 1;
        else 0;
      });

      this.bookingSlot.bookingPlayers.forEach((p, i) => {
        this.buggyCaddyPreference.playerPairings.push(
          Object.assign({}, this.buggyCaddyPreference[i], {
            bookingPlayerId: p.id,
            buggyRequired: p.pairingNo !== 0 ? true : false,
            buggyPairing: p.pairingNo,
            driving: p.driving,
            caddiePreferred: p.caddyPreferred && p.caddyPreferred.id ? p.caddyPreferred.id : null,
            caddieAssigned: p.caddyAssigned && p.caddyAssigned.id ? p.caddyAssigned.id : null,
            caddyPairing: p.caddyPairing,
            caddyRequired: p.caddyPairing > 0 ? true : false,
            caddyPreferred: p.caddyPreferred,
            caddyAssigned: p.caddyAssigned,
            assignedBuggy: p.buggyId,
          })
        );
        let _caddyPairing = 0;
        if (p.caddyPairing > 0) {
          _caddyPairing = p.caddyPairing; // - 1
          if (!this.caddyPairing[_caddyPairing]) {
            this.caddyPairing[_caddyPairing] = {
              caddyPreferred: p.caddyPreferred,
              caddyPairing: p.caddyPairing,
              caddySelectionCriteria: p.caddySelectionCriteria ? p.caddySelectionCriteria : null,
              caddyRequired: p.caddyPreferred || p.caddyPairing > 0 ? true : false,
            };
          }
          if (!this.caddySlots[_caddyPairing]) {
            this.caddySlots[_caddyPairing] = {
              caddyPairing: p.caddyPairing ? p.caddyPairing : 0,
              caddyPreferred: p.caddyPreferred ? p.caddyPreferred : null,
              caddySelectionCriteria: p.caddySelectionCriteria ? p.caddySelectionCriteria : null,
              caddyRequired: p.caddyPreferred || p.caddyPairing > 0 ? true : false,
              caddyAssigned: p.caddyAssigned ? p.caddyAssigned : null,
            };
          }
        }
        if (p.player && p.player.id) if (this.fromClub) this.getPlayersCredits(999, p.player.id);
      });
      if (!this.fromClub && this.currentPlayerId) this.getPlayersCredits(999, this.currentPlayerId);
      this.depositAmount = this.bookingSlot.depositPayable
        ? this.bookingSlot.depositPayable
        : this.bookingOptions
          ? this.getDepositAmount()
          : 0;
      Number(this.depositAmount.toFixed(2));
      this.paymentStatus = this.bookingSlot.bookingStatus === 'PaymentFull' ? 'Paid' : 'Pending';
      this.buggyRequired = this.bookingSlot.buggyRequested === 0 ? false : true;
      this.caddyRequired = this.bookingSlot.caddyRequested === 0 ? false : true;
      this.playerReq = this.bookingSlot.totalPlayers;
      this.buggyCaddyPreference['bookingId'] = this.bookingSlot.id;
      this.buggyCaddyPreference.playerPairings.shift();
      this.buggyCaddyPreference.ignoreBuggyUpdate = true;
      this.buggyCaddyPreference.ignoreCaddieUpdate = true;
      this.newBuggyCaddyPreference = JSON.parse(JSON.stringify(this.buggyCaddyPreference));
      if (
        this.bookingSlot.assignmentDone &&
        this.bookingSlot.bookingStatus !== 'PaymentFull' &&
        this.bookingSlot.bookingStatus !== 'PaymentPartial' &&
        this.bookingType !== 'past'
      ) {
        this.toggleBookingClick(5);
        this.paymentMode = true;
        this.paymentClickedBoolean = true;
      }
      this.additionalItems = this.bookingSlot.additionalItems;
    }
    this.platform.ready().then(() => {});
    if (this.bookingType === 'past') {
      this.getClubRatingItems();
    }
    if (!this.fromClub) this.getApplicableClubPlayerType();
    this.getListBookingPlayerTypes();
    if (!this.teeSlotNew) this.initBuggyTypeList();

    if (this.isBookingAgent()) this.bookForOther = true;
    this.initBookingPanels();
  }
  isBookingAgent() {
    return this.mg2uUtil.getUserType() === 'booking_agent';
  }
  initBuggyTypeList() {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    this.buggyTypeList = [];
    this.refreshBuggyTypes();
    this.selectedBuggyType = []; // [null,null,null,null,null,null]
  }
  refreshBuggyTypes() {
    let _clubId = this.bookingSlot.clubData.id;
    this.flightService.getBuggyTypesList(_clubId).subscribe((data: Array<BuggyType>) => {
      if (data) {
        this.buggyTypeList = data;
      }
    });
  }
  initBookingPanels() {
    if (this.fromClub) {
      this.grpAdditionals = true;
      this.grpTeeSlotInfo = true;
      this.grpPlayerDetails = true;
      this.grpPairings = true;
      this.grpFood = true;
      this.grpPayment = true;
      this.grpCheckIn = true;
      this.grpFeedback = true;
    }
  }

  getListBookingPlayerTypes() {
    let _clubId;
    let _playerId;
    let _effectiveDate;
    this.bookingPlayerTypes = [];

    if (this.teeSlotNew) {
      _clubId = this.clubs ? this.clubs.club.id : this.clubInfo.clubId;
      _effectiveDate = this.teeTimeSlotDisplay.slot.teeOffDate;
    } else if (!this.teeSlotNew) {
      _clubId = this.bookingSlot.clubData.id;
      _effectiveDate = this.bookingSlot.slotAssigned.teeOffDate;
    }
    _playerId = this.currentPlayerId;
    this.flightService.listBookingPlayerType(_clubId).subscribe(data => {
      if (data) {
        this.bookingPlayerTypes = data;
      }
    });
  }
  getApplicableClubPlayerType() {
    let _clubId;
    let _playerId;
    let _effectiveDate;

    if (this.teeSlotNew) {
      _clubId = this.clubs ? this.clubs?.club?.id : this.clubInfo?.clubId;
      _effectiveDate = this.teeTimeSlotDisplay?.slot?.teeOffDate;
    } else if (!this.teeSlotNew) {
      _clubId = this.bookingSlot.clubData.id;
      _effectiveDate = this.bookingSlot.slotAssigned.teeOffDate;
    }
    _playerId = this.currentPlayerId;
    this.flightService
      .getApplicableClubPlayerTypes(_clubId, _playerId, _effectiveDate)
      .subscribe(data => {
        if (data) {
          this.applicablePlayerTypes = data;
        }
      });
  }
  async ngOnInit() {
    this.sessionStatusSubscription = this.sessionDataService.getNeedRefresh().subscribe(result => {
      console.debug('result ', result);
    });
    this.initSubWebsocket();
    if (this.platform.is('capacitor')) this.oneSignalListener();
    this.getAssignedPlayerTypes();
  }

  ionViewWillUnload() {
    // if (this.sessionStatusSubscription) {
    //   this.sessionStatusSubscription.unsubscribe();
    //   this.sessionStatusSubscription = null;
    // }
  }

  async ionViewDidEnter() {
    this.getAppAttribute();

    // this.sessionDataService.getNeedRefresh().subscribe(needRefresh => {
    //   console.debug("session view did enter ", needRefresh)
    //   if (needRefresh) {
    //       this.onRefreshClick();
    //   }
    // });
    if (this.dataExtras?.needRefresh) {
      this.refreshBookingDetails();
    }
    this.checkClubBookingOption();

    if (this.fromClub && !this.teeSlotNew) this.getBookingItemizedBill(false);
    if (this.teeSlotNew) this.initServerStatus();
    if (this.bookingType !== 'past') this.recalculateBookingPricing();
    if (this.refreshOnEnter) this._refreshValues(null, null);
    this.refreshOnEnter = false;

    this.sessionStatusSubscription = this.sessionDataService
      .getSessionStatus()
      .pipe(distinctUntilChanged())
      .subscribe((status: SessionState) => {
        this.sessionDataService
          .getSession()
          .pipe(take(1))
          .subscribe(
            (session: SessionInfo) => {
              if (status === SessionState.LoginFailed) {
                // let toast = this.toastCtl.create({
                //   message: session.exception,
                //   duration: 5000,
                //   showCloseButton: true,
                //   closeButtonText: 'OK'
                // });
                // toast.present().then(() => {
                //   this.sessionActions.clearLoginError();
                // });

                MessageDisplayUtil.showErrorToast(
                  session.exception,
                  this.platform,
                  this.toastCtl,
                  5000,
                  'bottom'
                );
              } else if (status === SessionState.LoggedIn) {
                this.currSession = session;
              } else {
                if (session) this.currSession = session;
              }
            },
            error => {}
          );
      });
    // if (this.bookingSlot) {
    //   this.bookingSlot.bookingConfirmationStatus = 'Pending';
    // }
  }

  ionViewWillEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  checkPlayerMaxBooking(clubId?: number) {
    if (!clubId) return;
    //
    let _clubId = clubId ? clubId : this.clubs.club.id; //this.clubInfo?this.clubInfo.clubId:this.clubs.club.id;
    let _playerId = this.currentPlayer ? this.currentPlayer.playerId : this.currentPlayerId;
    let _forDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate, 'YYYY-MM-DD').format(
      'YYYY-MM-DD'
    );
    this.flightService.getPlayerMaxBooking(_clubId, _playerId, _forDate).subscribe(data => {
      if (data) this.playerMaxBooking = data;
      //
    });
  }

  checkClubBookingOption() {
    let _bookingClubId;
    if (!this.teeSlotNew && this.bookingSlot && this.bookingSlot.clubData) {
      _bookingClubId = this.bookingSlot.clubData.id;
    } else if (this.clubs && this.clubs.club) {
      _bookingClubId = this.clubs.club.id;
    } else if (this.clubInfo && this.clubInfo.clubId) {
      _bookingClubId = this.clubInfo.clubId;
    } else if (this.clubInfo && this.clubInfo.id) {
      _bookingClubId = this.clubInfo.id;
    }
    let _forDate =
      this.bookingSlot && this.bookingSlot.slotAssigned.teeOffDate
        ? this.bookingSlot.slotAssigned.teeOffDate
        : this.teeTimeSlotDisplay.slot.teeOffDate;
    this.flightService
      .getClubBookingOptions(_bookingClubId, moment(_forDate).format('YYYY-MM-DD'))
      .subscribe(
        (bookOpts: TeeTimeBookingOptions) => {
          if (bookOpts) this.bookingOptions = bookOpts;
        },
        error => {},
        () => {
          if (this.teeSlotNew && !this.fromClub) this.checkPlayerMaxBooking(_bookingClubId);
        }
      );
  }

  public refreshOnViewEntered(refresh: boolean) {
    this.refreshOnEnter = refresh;
  }

  public refreshPage(pushData: any) {
    this._refreshValues(null, null);
  }

  public getNotifications(): Array<NotificationHandlerInfo> {
    let notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST,
      whenActive: 'showToast',
      whenInactive: 'none',
      needRefresh: true,
    });
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST_ACCEPTED,
      whenActive: 'showToast',
      whenInactive: 'none',
      needRefresh: true,
    });
    return notifications;
  }

  async getBookingPlayers(bookingSlot: TeeTimeBooking) {
    this.bookingSlot.bookingPlayers = await bookingSlot.bookingPlayers;
  }

  onSearchInput(searchbar) {
    this._refreshValues(null, null);
  }

  onSearchCancel() {
    //
  }

  onPlayerInput(searchbar) {
    this.playerList = createPlayerList();
    this._refreshPlayer(null, null);
  }

  onRefresh(refresher) {
    this._refreshValues(refresher, null);
  }

  onRefreshClick() {
    this.paymentMode = false;
    this.refreshBookingDetails();
    setTimeout(() => {
      if (this.bookingType !== 'past') this.recalculateBookingPricing(false, false);
    }, 500);
    if (!this.fromClub) this.getPendingPlayerDiscountCard();
    if (!this.teeSlotNew) this.initBuggyTypeList();
    if (!this.teeSlotNew) this.getAssignedPlayerTypes();
  }
  async recalculateBookingPricing(override: boolean = false, isLocader: boolean = true) {
    if (this.teeSlotNew) return false;
    if (this.bookingSlot) {
    }
    let _bookingId = this.bookingSlot.id;
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: isLocader ? 'Refreshing booking...' : '',
    });

    let _pricingIgnoreDate: boolean = this.pricingIgnoreDate;
    if (!override) _pricingIgnoreDate = false;

    if (!isLocader) {
      if (this.buggyCaddyPreference && !this.isBookingCancel()) {
        this.onProcessBuggyCaddyPref(this.buggyCaddyPreference)
          .then((res: any) => {
            if (res && res.status === 'success') {
              this.flightService
                .recalculateBookingPricing(_bookingId, _pricingIgnoreDate)
                .subscribe(
                  (data: TeeTimeBooking) => {
                    loader.dismiss().then(() => {
                      this.refreshBookingObject(data);
                    });
                  },
                  error => {
                    loader.dismiss();
                  },
                  () => {
                    this.getBookingItemizedBill(this.assignmentDone, false);
                  }
                );
            }
          })
          .catch(error => {
            if (!override) _pricingIgnoreDate = false;
            this.flightService.recalculateBookingPricing(_bookingId, _pricingIgnoreDate).subscribe(
              (data: TeeTimeBooking) => {
                loader.dismiss().then(() => {
                  this.refreshBookingObject(data);
                });
              },
              error => {
                loader.dismiss();
              },
              () => {
                this.getBookingItemizedBill(this.assignmentDone, false);
              }
            );
          });
      } else {
        this.flightService.recalculateBookingPricing(_bookingId, _pricingIgnoreDate).subscribe(
          (data: TeeTimeBooking) => {
            loader.dismiss().then(() => {
              this.refreshBookingObject(data);
              this.getBookingItemizedBill(this.assignmentDone, false);
            });
          },
          error => {
            loader.dismiss();
          },
          () => {
            this.getBookingItemizedBill(this.assignmentDone, false);
          }
        );
      }
    } else {
      loader.present().then(() => {
        if (this.buggyCaddyPreference && !this.isBookingCancel()) {
          this.onProcessBuggyCaddyPref(this.buggyCaddyPreference)
            .then((res: any) => {
              if (res && res.status === 'success') {
                this.flightService
                  .recalculateBookingPricing(_bookingId, _pricingIgnoreDate)
                  .subscribe(
                    (data: TeeTimeBooking) => {
                      loader.dismiss().then(() => {
                        this.refreshBookingObject(data);
                      });
                    },
                    error => {
                      loader.dismiss();
                    },
                    () => {
                      this.getBookingItemizedBill(this.assignmentDone, false);
                    }
                  );
              }
            })
            .catch(error => {
              if (!override) _pricingIgnoreDate = false;
              this.flightService
                .recalculateBookingPricing(_bookingId, _pricingIgnoreDate)
                .subscribe(
                  (data: TeeTimeBooking) => {
                    loader.dismiss().then(() => {
                      this.refreshBookingObject(data);
                    });
                  },
                  error => {
                    loader.dismiss();
                  },
                  () => {
                    this.getBookingItemizedBill(this.assignmentDone, false);
                  }
                );
            });
        } else {
          this.flightService.recalculateBookingPricing(_bookingId, _pricingIgnoreDate).subscribe(
            (data: TeeTimeBooking) => {
              loader.dismiss().then(() => {
                this.refreshBookingObject(data);
                this.getBookingItemizedBill(this.assignmentDone, false);
              });
            },
            error => {
              loader.dismiss();
            },
            () => {
              this.getBookingItemizedBill(this.assignmentDone, false);
            }
          );
        }
      });
    }
  }
  onProcessBuggyCaddyPref(buggyCaddyPref: any) {
    return new Promise((resolve, reject) => {
      this.flightService.updateBuggyCaddiePreference(buggyCaddyPref).subscribe(
        (data: any) => {
          resolve({
            status: 'success',
            statusCode: data.status,
            data: data,
          });
        },
        error => {
          reject({
            status: 'failed',
            error: error,
          });
        }
      );
    });
  }
  async openNewContact() {
    const modal = await this.modalCtl.create({
      component: NewContactPage,
      componentProps: {
        openedModal: true,
      },
    });

    modal.onDidDismiss().then(res => {
      this._refreshFriends(null, null);
    });
    return await modal.present();
  }

  searchNewContact() {
    this.router.navigate(['search-player-list']);
  }

  async friendSelected(item: PlayerInfo) {
    const modal = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        status: 'friend',
        type: 'friendProfile',
        player: of(item),
        openedModal: true,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      adjustViewZIndex(this.nav, this.renderer);
      if (data) {
        if (data.type == 'requestFriend') {
          this.friends = 'request';
          this._refreshValues(null, null);
        }
        if (data.type == 'acceptFriend') this._refreshValues(null, null);

        if (data.type == 'deleteFriend') {
          this._refreshValues(null, null);
        }
        if (data.type == 'deleteRequest') {
          this._refreshValues(null, null);
        }
      }
    });
    return await modal.present();
  }

  async requestSelected(item: FriendRequest) {
    const modal = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        requestByPlayer: item.requestByPlayer,
        status: 'pendingFriend',
        type: 'friendProfile',
        player: of(item.player),
        openedModal: true,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data) {
        if (data.type == 'requestFriend') {
          this.friends = 'request';
          this._refreshValues(null, null);
        }
        if (data.type == 'acceptFriend') {
          this.friends = 'friend';
          this._refreshValues(null, null);
        }
        if (data.type == 'deleteFriend') {
          this._refreshValues(null, null);
        }
        if (data.type == 'deleteRequest') {
          this._refreshValues(null, null);
        }
      }
    });
    return await modal.present();
  }

  doInfinite(infinite) {
    if (this.isMore()) {
      this._refreshPlayer(null, infinite);
    } else {
      infinite.target.complete();
      infinite.enable(false);
    }
  }

  public isMore() {
    return (
      this.playerList.totalPages > 0 && this.playerList.currentPage < this.playerList.totalPages
    );
  }

  receivedRequest() {
    this.receivedList = this.requestFriends.friendRequests.filter((req: FriendRequest) => {
      return !req.requestByPlayer;
    });
  }

  sentRequest() {
    this.sentList = this.requestFriends.friendRequests.filter((req: FriendRequest) => {
      return req.requestByPlayer;
    });
  }

  private _refreshValues(refresher, infinite) {
    if (this.friends == 'friend') {
      this._refreshFriends(refresher, infinite);
    }

    if (this.friends == 'request') {
      this._refreshRequest(refresher, infinite);
    }

    if (this.friends == 'find') {
      this.playerList = createPlayerList();
      this._refreshPlayer(refresher, infinite);
    }
  }

  private async _refreshRequest(refresher, infinite) {
    this.refreshAttempted = false;

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    loader.present().then(response => {
      response.present();
      this.refreshAttempted = false;
      this.friendService.searchFriendRequests().subscribe(
        (friendRequests: FriendRequestList) => {
          loader.dismiss(friendRequests).then(() => {
            this.refreshAttempted = true;

            if (friendRequests) {
              this.requestFriends = friendRequests;
              this.receivedRequest();
              this.sentRequest();
            }

            if (this.sentList.length > 0) {
              this.sentExist = true;
            }

            if (this.receivedList.length > 0) {
              this.receiveExist = true;
            }

            if (this.platform.is('ios') && this.platform.is('capacitor')) {
              this.keyboard.hide();
            }
          });
        },
        error => {
          loader.dismiss();
        },
        () => {
          if (refresher) {
            refresher.complete();
          }
          if (infinite) {
            infinite.target.complete();
          }
        }
      );
    });
  }

  private async _refreshFriends(refresher, infinite) {
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    loader.then(response => {
      response.present();
      this.refreshAttempted = false;
      this.friendService.searchFriends(this.searchFriend).subscribe(
        (friendRequests: PlayerList) => {
          loader.dismiss(friendRequests).then(() => {
            this.refreshAttempted = true;
            if (friendRequests) {
              this.listFriends = friendRequests;
            }
          });
        },
        error => {
          loader.dismiss();
        },
        () => {
          if (refresher) {
            refresher.complete();
          }
          if (infinite) {
            infinite.target.complete();
          }
        }
      );
    });
  }

  private async _refreshPlayer(refresher, infinite) {
    this.refreshPlayer = false;
    if (!this.searchPlayer || this.searchPlayer == '') {
      this.refreshPlayer = false;
      return false;
    }
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    loader.present().then(response => {
      this.friendService
        .searchNonFriends(this.searchPlayer, this.playerList.currentPage + 1)
        .subscribe(
          (playerList: PlayerList) => {
            loader.dismiss(playerList).then(() => {
              if (playerList.totalPages > 0) this.playerList.currentPage++;

              this.refreshPlayer = true;

              if (playerList) {
                this.playerList.currentPage = playerList.currentPage;
                this.playerList.totalPages = playerList.totalInPage;
                this.playerList.totalItems = playerList.totalItems;
                this.playerList.players.push(...playerList.players);
              }
              if (this.platform.is('ios') && this.platform.is('capacitor')) {
                this.keyboard.hide();
              }
            });
          },
          error => {
            loader.dismiss();
          },
          () => {
            if (refresher) {
              refresher.complete();
            }
            if (infinite) {
              infinite.target.complete();
            }
          }
        );
    });
  }

  async playerSelected(item: PlayerInfo) {
    const modal = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        status: 'notFriend',
        type: 'friendProfile',
        player: of(item),
        // homeInfo: this.homeInfo,
        openedModal: true,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      adjustViewZIndex(this.nav, this.renderer);
      if (data) {
        if (data.type == 'requestFriend') {
          this.friends = 'request';
          this._refreshValues(null, null);
        }
        if (data.type == 'acceptFriend') {
          this.friends = 'friend';
          this._refreshValues(null, null);
        }
        if (data.type == 'deleteFriend') {
          this._refreshValues(null, null);
        }
        if (data.type == 'deleteRequest') {
          this._refreshValues(null, null);
        }
      }
    });
    return await modal.present();
  }

  setFriendType(type: number) {
    if (type === 1) {
      this.friendType = 'friend';
      this.friendScreenName = 'Friends';
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
    if (type === 2) {
      this.friendType = 'request';
      this.friendScreenName = 'Requests';
      this._refreshRequest(null, null);
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
    if (type === 3) {
      this.friendType = 'find';
      this.friendScreenName = 'Find | Add';
      this.playerList = createPlayerList();
      this._refreshPlayer(null, null);
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
  }

  setBookingType(type: number) {
    if (type === 1) {
      this.friendType = 'search';
      this.friendScreenName = 'Search';
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
    if (type === 2) {
      this.friendType = 'mybookings';
      this.friendScreenName = 'My Bookings';
      this._refreshRequest(null, null);
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
  }

  toggleBookingClick(type: number) {
    if (this.paymentMode && type !== 5 && type !== 1) return false;
    if (this.grpPairings && type !== 3) {
      if (this.hasPreferenceChanges()) {
        this.onResetPreference();
        return false;
      }
    }
    if (type === 1) {
      this.grpTeeSlotInfo = !this.grpTeeSlotInfo;
      if (!this.fromClub) {
        this.grpPlayerDetails = false;
        this.grpPairings = false;
        this.grpFood = false;
        this.grpPayment = false;
        this.grpCheckIn = false;
        this.grpFeedback = false;
        this.grpAdditionals = false;
      }
    } else if (type === 2) {
      this.grpPlayerDetails = !this.grpPlayerDetails;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPairings = false;
        this.grpFood = false;
        this.grpPayment = false;
        this.grpCheckIn = false;
        this.grpFeedback = false;
        this.grpAdditionals = false;
      }
    } else if (type === 3) {
      this.grpPairings = !this.grpPairings;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPlayerDetails = false;
        this.grpFood = false;
        this.grpPayment = false;
        this.grpCheckIn = false;
        this.grpFeedback = false;
        this.grpAdditionals = false;
      }
    } else if (type === 4) {
      this.grpFood = !this.grpFood;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPlayerDetails = false;
        this.grpPairings = false;
        this.grpPayment = false;
        this.grpCheckIn = false;
        this.grpFeedback = false;
        this.grpAdditionals = false;
      }
    } else if (type === 5) {
      this.grpPayment = !this.grpPayment;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPlayerDetails = false;
        this.grpPairings = false;
        this.grpFood = false;
        this.grpCheckIn = false;
        this.grpFeedback = false;
        this.grpAdditionals = false;
      }
      if (this.grpPayment) {
        if (this.bookingType !== 'past') this.recalculateBookingPricing();
        this.getBookingItemizedBill(false);
      }
    } else if (type === 6) {
      this.grpCheckIn = !this.grpCheckIn;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPlayerDetails = false;
        this.grpPairings = false;
        this.grpFood = false;
        this.grpPayment = false;
        this.grpFeedback = false;
        this.grpAdditionals = false;
      }
    } else if (type === 7) {
      this.grpFeedback = !this.grpFeedback;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPlayerDetails = false;
        this.grpPairings = false;
        this.grpFood = false;
        this.grpPayment = false;
        this.grpCheckIn = false;
        this.grpAdditionals = false;
      }
    } else if (type === 8) {
      this.grpAdditionals = !this.grpAdditionals;
      if (!this.fromClub) {
        this.grpTeeSlotInfo = false;
        this.grpPlayerDetails = false;
        this.grpPairings = false;
        this.grpFood = false;
        this.grpPayment = false;
        this.grpCheckIn = false;
        this.grpFeedback = false;
      }
    }
  }

  async onChangeCourse(event) {
    const popover = await this.popoverCtl.create({
      component: CourseBox,
    });
    popover.onDidDismiss().then((data: any) => {
      if (data) {
        // this.gameInfo.courses.push(data);
      }
    });
    return await popover.present().then(res => {
      event;
    });
  }

  async addPlayerSlot() {
    const playerModal = await this.modalCtl.create({
      component: FriendListPage,
      componentProps: {
        openedModal: true,
        forBooking: true,
      },
    });
    playerModal.onDidDismiss().then((data: any) => {
      if (data) {
        let player = JsonService.clone(data);
      }
    });
    return await playerModal.present();
  }

  OLDgetSlotPrice(slot: TeeTimeSlotDisplay, attribute?: string) {
    if (!slot || slot === null) return '';
    let _slot = slot;
    let _currency = _slot.currency
      ? _slot.currency.symbol
      : _slot.slot?.currency
        ? _slot.slot?.currency?.symbol
        : '';
    let _price;
    let _promoPrice;

    let _testObj = {
      STD: 120,
      SENIOR: 95,
    };
    let _attribute = attribute;
    if (_attribute === 'STDX') {
      if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'P') {
        _attribute = 'PGUEST';
      } else if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'T') {
        _attribute = 'TMEMBER';
      } else if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'F') {
        _attribute = 'MEMBER';
      } else if (this.mg2uUtil.getClubSpecific() && !this.mg2uUtil.getClubParam()) {
        _attribute = 'MEMBER';
      } else _attribute = 'STD';
    }

    switch (_attribute) {
      case 'STD':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.STD : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.STD
            ? _slot.originalPrices.STD
            : _slot.displayPrices
              ? _slot.displayPrices.STD
              : '';
        break;
      case 'STAFF':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.STAFF : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.STAFF
            ? _slot.originalPrices.STAFF
            : _slot.displayPrices
              ? _slot.displayPrices.STAFF
              : '';
        break;
      case 'ARMY':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.ARMY : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.ARMY
            ? _slot.originalPrices.ARMY
            : _slot.displayPrices
              ? _slot.displayPrices.ARMY
              : '';
        break;
      case 'SENIOR':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.SENIOR : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.SENIOR
            ? _slot.originalPrices.SENIOR
            : _slot.displayPrices
              ? _slot.displayPrices.SENIOR
              : '';
        break;
      case 'WOMAN':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.WOMAN : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.WOMAN
            ? _slot.originalPrices.WOMAN
            : _slot.displayPrices
              ? _slot.displayPrices.WOMAN
              : '';
        break;
      case 'LADIES':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.LADIES : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.LADIES
            ? _slot.originalPrices.LADIES
            : _slot.displayPrices
              ? _slot.displayPrices.LADIES
              : '';
        break;
      case 'MEMBER':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.MEMBER : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.MEMBER
            ? _slot.originalPrices.MEMBER
            : _slot.displayPrices
              ? _slot.displayPrices.MEMBER
              : '';
        break;
      case 'TMEMBER':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.TMEMBER : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.TMEMBER
            ? _slot.originalPrices.TMEMBER
            : _slot.displayPrices
              ? _slot.displayPrices.TMEMBER
              : '';
        break;
      case 'GOVT':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.GOVT : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.GOVT
            ? _slot.originalPrices.GOVT
            : _slot.displayPrices
              ? _slot.displayPrices.GOVT
              : '';
        break;
      case 'GUEST':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.GUEST : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.GUEST
            ? _slot.originalPrices.GUEST
            : _slot.displayPrices
              ? _slot.displayPrices.GUEST
              : '';
        break;
      case 'JUNIOR':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.JUNIOR : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.JUNIOR
            ? _slot.originalPrices.JUNIOR
            : _slot.displayPrices
              ? _slot.displayPrices.JUNIOR
              : '';
        break;
      case 'POLICE':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.POLICE : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.POLICE
            ? _slot.originalPrices.POLICE
            : _slot.displayPrices
              ? _slot.displayPrices.POLICE
              : '';
        break;
      case 'PGUEST':
        _promoPrice = _slot.displayPrices ? _slot.displayPrices.PGUEST : '';
        _price =
          _slot.originalPrices && _slot.originalPrices.PGUEST
            ? _slot.originalPrices.PGUEST
            : _slot.displayPrices
              ? _slot.displayPrices.PGUEST
              : '';
        break;
      default:
        _promoPrice = _slot.displayPrices ? _slot.displayPrices[_attribute] : '';
        _price =
          _slot.originalPrices && _slot.originalPrices[_attribute]
            ? _slot.originalPrices[_attribute]
            : _slot.displayPrices
              ? _slot.displayPrices[_attribute]
              : '';
    }
    if (0 && this.isMember()) {
      // console.debug("is member slot price : ori ", _slot.originalPrices);
      // console.debug("is member slot price : displayPrices ", _slot.displayPrices);
      let memberKey = _slot.originalPrices
        ? Object.keys(_slot.originalPrices).find(key => key.toLowerCase().includes('member'))
        : Object.keys(_slot.displayPrices).find(key => key.toLowerCase().includes('member'));
      let memberPromoKey = _slot.displayPrices
        ? Object.keys(_slot.displayPrices).find(key => key.toLowerCase().includes('member'))
        : '';
      let memberPrice = _slot.originalPrices
        ? _slot.originalPrices[memberKey]
        : _slot.displayPrices
          ? _slot.displayPrices[memberPromoKey]
          : 0; // || '';
      let memberPromoPrice = _slot.displayPrices[memberPromoKey] || 0;
      let _subMemberTotal;
      let _subMemberTotalPromo;
      let _subGuestTotal;
      let _subGuestTotalPromo;
      if (this.memberReq > 1) {
        _subMemberTotal =
          memberPrice === 0 || !memberPrice
            ? Number(memberPromoPrice) * this.memberReq
            : Number(memberPrice) * this.memberReq;
        _subMemberTotalPromo =
          memberPromoPrice === 0 || !memberPromoPrice
            ? Number(memberPromoPrice) * this.memberReq
            : Number(memberPromoPrice) * this.memberReq;
      }
      if (this.guestReq > 0) {
        _subGuestTotal = _price === '' || !_price ? _price * this.guestReq : _price * this.guestReq;
        _subGuestTotalPromo =
          _promoPrice === '' || !_promoPrice
            ? _promoPrice * this.guestReq
            : _promoPrice * this.guestReq;
      }
      _price = _subMemberTotal + _subGuestTotal;
      _promoPrice = _subMemberTotalPromo + _subGuestTotalPromo;
      // console.debug("is member slot price : ", memberKey, memberPromoKey, memberPrice, memberPromoPrice, _price, _promoPrice, this.memberReq, this.guestReq, _subMemberTotal, _subMemberTotalPromo);
    } else {
      if (this.playerReq > 1) {
        _price = _price === '' || !_price ? _price * this.playerReq : _price * this.playerReq;
        _promoPrice =
          _promoPrice === '' || !_promoPrice
            ? _promoPrice * this.playerReq
            : _promoPrice * this.playerReq;
      } else {
        _price = _price === '' || !_price ? _price : _price;
        _promoPrice = _promoPrice === '' || !_promoPrice ? _promoPrice : _promoPrice;
      }
    }

    let _text =
      '<span class="promo-text">' +
      _currency +
      ' ' +
      this.numberWithCommas(_price.toFixed(2)) +
      `</span>&nbsp;&nbsp;&nbsp;<span class="promo-price">` +
      _currency +
      ' ' +
      this.numberWithCommas(_promoPrice.toFixed(2)) +
      '</span>';

    if (!_price || _price === undefined || _price === null) return '-';
    if (this.isPromo && _promoPrice && Number(_promoPrice) < Number(_price)) {
      return _text;
    } else return _currency + ' ' + _price.toFixed(2);
  }

  getIndividualSlotPrice(slot: any, attribute?: string) {
    if (!slot || slot === null) return '';

    let _slot = slot;
    let _currency = _slot.slot.currency
      ? _slot.slot.currency.symbol
      : this.currency
        ? this.currency.symbol
        : '$';
    // let _currency = _slot.currency
    //     ? _slot.currency.symbol
    //     : _slot.slot?.currency
    //         ? _slot.slot?.currency?.symbol
    //         : '$';
    // if(this.currencySymbol)
    //     _currency = this.currencySymbol;
    let _price;
    let _promoPrice;

    let _testObj = {
      STD: 120,
      SENIOR: 95,
    };

    let _attribute = attribute;
    if (_attribute === 'STDX') {
      if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'P') {
        _attribute = 'PGUEST';
      } else if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'T') {
        _attribute = 'TMEMBER';
      } else if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'F') {
        _attribute = 'MEMBER';
      } else if (this.mg2uUtil.getClubSpecific() && !this.mg2uUtil.getClubParam()) {
        _attribute = 'MEMBER';
      }
      // else if(this.isMember()) {
      //   _attribute = this.isMemberType();
      // }
      else _attribute = 'STD';
    }
    switch (_attribute) {
      default:
        if (this.isBookingAgent() && _slot.agentToPlayerPrices !== undefined) {
          _promoPrice = _slot.agentToPlayerPrices ? _slot.agentToPlayerPrices[_attribute] : '';
        } else {
          _promoPrice = _slot.displayPrices ? _slot.displayPrices[_attribute] : '';
        }
        _price =
          _slot.originalPrices && _slot.originalPrices[_attribute]
            ? _slot.originalPrices[_attribute]
            : _slot.displayPrices
              ? _slot.displayPrices[_attribute]
              : '';
    }

    _price = _price === '' || !_price ? _price : _price;
    _promoPrice = _promoPrice === '' || !_promoPrice ? _promoPrice : _promoPrice;
    // _price = _price===''||!_price?_price:_price; //this.numberWithCommas(_price);
    // _promoPrice = _promoPrice===''||!_promoPrice?_promoPrice:_promoPrice; //this.numberWithCommas(_promoPrice);

    let _text =
      '<span class="promo-text">' +
      _currency +
      ' ' +
      this.numberWithCommas(_price.toFixed(2)) +
      `</span>&nbsp;&nbsp;&nbsp;<span class="promo-price">` +
      _currency +
      ' ' +
      this.numberWithCommas(_promoPrice.toFixed(2)) +
      '</span>';
    // console.debug("prices ", _currency + " " + _price,Number(_price));
    // console.debug("promo prices ", this.isPromo,_currency + " " + _promoPrice, Number(_promoPrice));
    // console.warn("less prices : ", (Number(_promoPrice) < Number(_price)))
    // console.debug("prices", _text);
    if (!_price || _price === undefined || _price === null) return false;
    if (this.isPromo && _promoPrice && Number(_promoPrice) < Number(_price)) return _text;
    else if (this.isBookingAgent() && _promoPrice) {
      return _currency + ' ' + _promoPrice;
    } else return _currency + ' ' + _price.toFixed(2); //this.numberWithCommas(_price);

    // if (!this.isPromo) return _currency + " " + _price
    // else if(this.isPromo return _text;
  }

  getSlotPrice(slot: any, attribute?: string) {
    if (!slot || slot === null) return '';

    let _slot = slot;
    let _currency = _slot.slot.currency
      ? _slot.slot.currency.symbol
      : this.currency
        ? this.currency.symbol
        : '$';
    // let _currency = _slot.currency
    //     ? _slot.currency.symbol
    //     : _slot.slot?.currency
    //         ? _slot.slot?.currency?.symbol
    //         : '$';
    // if(this.currencySymbol)
    //     _currency = this.currencySymbol;
    let _price;
    let _promoPrice;

    let _testObj = {
      STD: 120,
      SENIOR: 95,
    };

    let _attribute = attribute;
    if (_attribute === 'STDX') {
      if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'P') {
        _attribute = 'PGUEST';
      } else if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'T') {
        _attribute = 'TMEMBER';
      } else if (this.mg2uUtil.getClubSpecific() && this.mg2uUtil.getMembershipType('id') === 'F') {
        _attribute = 'MEMBER';
      } else if (this.mg2uUtil.getClubSpecific() && !this.mg2uUtil.getClubParam()) {
        _attribute = 'MEMBER';
      }
      // else if(this.isMember()) {
      //   _attribute = this.isMemberType();
      // }
      else _attribute = 'STD';
    }
    switch (_attribute) {
      default:
        if (this.isBookingAgent() && _slot.agentToPlayerPrices !== undefined) {
          _promoPrice = _slot.agentToPlayerPrices ? _slot.agentToPlayerPrices[_attribute] : '';
        } else {
          _promoPrice = _slot.displayPrices ? _slot.displayPrices[_attribute] : '';
        }
        _price =
          _slot.originalPrices && _slot.originalPrices[_attribute]
            ? _slot.originalPrices[_attribute]
            : _slot.displayPrices
              ? _slot.displayPrices[_attribute]
              : '';
    }

    if (this.isMember()) {
      if (_promoPrice === '' || !_promoPrice) {
        _promoPrice = _slot.displayPrices ? _slot.displayPrices['STD'] : '';
      }
      if (_price === '' || !_price) {
        _price =
          _slot.originalPrices && _slot.originalPrices['STD']
            ? _slot.originalPrices['STD']
            : _slot.displayPrices
              ? _slot.displayPrices['STD']
              : '';
      }
    }

    if (this.isMember()) {
      // console.debug("is member slot price : ori ", _slot.originalPrices);
      // console.debug("is member slot price : displayPrices ", _slot.displayPrices);
      let memberKey = this.isMemberType(); // _slot.originalPrices ? Object.keys(_slot.originalPrices).find(key => key.toLowerCase().includes('member')) : Object.keys(_slot.displayPrices).find(key => key.toLowerCase().includes('member'));
      let memberPromoKey = this.isMemberType(); //_slot.displayPrices ? Object.keys(_slot.displayPrices).find(key => key.toLowerCase().includes('member')) : '';
      // let memberPrice = _slot.originalPrices ? _slot.originalPrices[memberKey] : _slot.displayPrices? _slot.displayPrices[memberPromoKey] : 0; // || '';
      // let memberPromoPrice = _slot.displayPrices[memberPromoKey] || 0;

      let memberPromoPrice = _slot.displayPrices ? _slot.displayPrices[memberKey] : '';
      let memberPrice =
        _slot.originalPrices && _slot.originalPrices[memberKey]
          ? _slot.originalPrices[memberKey]
          : _slot.displayPrices
            ? _slot.displayPrices[memberKey]
            : '';
      if (memberPromoPrice === '' || !memberPromoPrice) {
        memberPromoPrice = _slot.displayPrices ? _slot.displayPrices['STD'] : '';
      }
      if (memberPrice === '' || !memberPrice) {
        memberPrice =
          _slot.originalPrices && _slot.originalPrices['STD']
            ? _slot.originalPrices['STD']
            : _slot.displayPrices
              ? _slot.displayPrices['STD']
              : '';
      }
      let _subMemberTotal = 0;
      let _subMemberTotalPromo = 0;
      let _subGuestTotal = 0;
      let _subGuestTotalPromo = 0;
      if (this.memberReq > 0) {
        _subMemberTotal =
          memberPrice === '' || !memberPrice
            ? memberPromoPrice * this.memberReq
            : memberPrice * this.memberReq;
        _subMemberTotalPromo =
          memberPromoPrice === '' || !memberPromoPrice
            ? memberPromoPrice * this.memberReq
            : memberPromoPrice * this.memberReq;
      }
      if (this.guestReq > 0) {
        _subGuestTotal = _price === '' || !_price ? _price * this.guestReq : _price * this.guestReq;
        _subGuestTotalPromo =
          _promoPrice === '' || !_promoPrice
            ? _promoPrice * this.guestReq
            : _promoPrice * this.guestReq;
      }
      _price = Number(_subMemberTotal) + Number(_subGuestTotal);
      _promoPrice = Number(_subMemberTotalPromo) + Number(_subGuestTotalPromo);
      // console.debug("is member slot price : [0] ", memberKey, memberPromoKey, memberPrice, memberPromoPrice);
      // console.debug("is member slot price : [1] requested #", this.memberReq, this.guestReq)
      // console.debug("is member slot price : [2] total ", _price, _promoPrice);
      // console.debug("is member slot price : [3] member ", _subMemberTotal, _subMemberTotalPromo);
      // console.debug("is member slot price : [3] guest ", _subGuestTotal, _subGuestTotalPromo);
    } else {
      if (this.playerReq > 1) {
        _price = _price === '' || !_price ? _price * this.playerReq : _price * this.playerReq;
        _promoPrice =
          _promoPrice === '' || !_promoPrice
            ? _promoPrice * this.playerReq
            : _promoPrice * this.playerReq;
      } else {
        _price = _price === '' || !_price ? _price : _price;
        _promoPrice = _promoPrice === '' || !_promoPrice ? _promoPrice : _promoPrice;
      }
    }
    // _price = _price===''||!_price?_price:_price; //this.numberWithCommas(_price);
    // _promoPrice = _promoPrice===''||!_promoPrice?_promoPrice:_promoPrice; //this.numberWithCommas(_promoPrice);

    let _text =
      '<span class="promo-text">' +
      _currency +
      ' ' +
      this.numberWithCommas(_price.toFixed(2)) +
      `</span>&nbsp;&nbsp;&nbsp;<span class="promo-price">` +
      _currency +
      ' ' +
      this.numberWithCommas(_promoPrice.toFixed(2)) +
      '</span>';
    // console.debug("prices ", _currency + " " + _price,Number(_price));
    // console.debug("promo prices ", this.isPromo,_currency + " " + _promoPrice, Number(_promoPrice));
    // console.warn("less prices : ", (Number(_promoPrice) < Number(_price)))
    // console.debug("prices", _text);
    if (!_price || _price === undefined || _price === null) return false;
    if (this.isPromo && _promoPrice && Number(_promoPrice) < Number(_price)) return _text;
    else if (this.isBookingAgent() && _promoPrice) {
      return _currency + ' ' + this.numberWithCommas(_promoPrice);
    } else return _currency + ' ' + this.numberWithCommas(_price.toFixed(2)); //this.numberWithCommas(_price);

    // if (!this.isPromo) return _currency + " " + _price
    // else if(this.isPromo return _text;
  }

  numberWithCommas(x) {
    if (!x) return x;
    else return this.mg2uUtil.numberWithCommas(x);
  }

  getDisplayPrices(slot: TeeTimeSlotDisplay) {
    let _message = '';
    let _openRow = `<div class='row row-price' style='width:100%'>`;
    let _openColLeft = `<div class='column col-price-left' style='text-align:left;width:75%'>`;
    let _openColRight = `<div class='column col-price-right' style='text-align:right;width:25%'>`;
    let _closeCol = `</div>`;
    let _closeRow = `</div>`;
    _message += _openRow;
    slot.displayPrices.STD
      ? (_message +=
          _openColLeft +
          'Standard : ' +
          _closeCol +
          _openColRight +
          slot.currency.symbol +
          ' ' +
          slot.displayPrices.STD +
          _closeCol +
          '<br>')
      : '';
    _message += _closeRow;
    slot.displayPrices.STAFF
      ? (_message += 'Staff : ' + slot.currency.symbol + ' ' + slot.displayPrices.STAFF + '<br>')
      : '';
    slot.displayPrices.ARMY
      ? (_message += 'Army : ' + slot.currency.symbol + ' ' + slot.displayPrices.ARMY + '<br>')
      : '';
    slot.displayPrices.SENIOR
      ? (_message += 'Senior : ' + slot.currency.symbol + ' ' + slot.displayPrices.SENIOR + '<br>')
      : '';
    slot.displayPrices.WOMAN
      ? (_message += 'Woman : ' + slot.currency.symbol + ' ' + slot.displayPrices.WOMAN + '<br>')
      : '';
    slot.displayPrices.LADIES
      ? (_message += 'Ladies : ' + slot.currency.symbol + ' ' + slot.displayPrices.LADIES + '<br>')
      : '';
    slot.displayPrices.POLICE
      ? (_message += 'Police : ' + slot.currency.symbol + ' ' + slot.displayPrices.POLICE + '<br>')
      : '';
    slot.displayPrices.GOVT
      ? (_message +=
          'Government : ' + slot.currency.symbol + ' ' + slot.displayPrices.GOVT + '<br>')
      : '';
    slot.displayPrices.GUEST
      ? (_message += 'Guest : ' + slot.currency.symbol + ' ' + slot.displayPrices.GUEST + '<br>')
      : '';
    this.showAlert('Available Packages', _message);
  }

  async showAlert(hdr: any, msg: any) {
    const alert = await this.alertCtrl.create({
      header: hdr,
      message: msg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  onPlayerSelect(slot: number, isGroupSelect: boolean = false, isEditPlayer: boolean = false) {
    if (!this.getAllowUpdatePostPayment() && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Flight have started. Adding/Removing player is disabled. Please refer to club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    let playersToExclude = this.bookingSlot.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
      return !p.playerRemoved;
    });

    let _playerSlots = 1;
    if (!this.teeSlotNew) {
      _playerSlots =
        this.slots.length - (this.bookingSlot ? this.bookingSlot.bookingPlayers.length : 0);
    }
    console.debug('adding multi', _playerSlots, this.slots, this.bookingSlot);
    this.modaladdplayerList(playersToExclude, _playerSlots, slot, isGroupSelect, isEditPlayer);
  }

  async modaladdplayerList(
    playersToExclude: any,
    _playerSlots: any,
    slot: number,
    isGroupSelect: boolean = false,
    isEditPlayer: boolean = false
  ) {
    const modal = await this.modalCtl.create({
      component: ManagePlayerGroupPage,
      componentProps: {
        isGroupSelect: isGroupSelect,
        openedModal: true,
        playersToExclude: playersToExclude, //this.bookingSlot.bookingPlayers,
        fromClub: this.fromClub,
        maxPlayers: _playerSlots,
        teeSlotNew: this.teeSlotNew,
        forBooking: true,
        clubId: !this.teeSlotNew ? this.bookingSlot.clubData.id : this.clubs.club.id,
        partnerInfo: this.partnerInfo,
        currentDate: this.bookingSlot
          ? this.bookingSlot.slotAssigned.teeOffDate
          : this.teeTimeSlotDisplay.slot.teeOffDate,
        isEditPlayer: isEditPlayer,
      },
    });

    modal.onDidDismiss().then(async (data: any) => {
      slot;
      console.debug('dismiss add player ', data);

      if (data?.data?.friendList?.length > 0) {
        var i = 0;
        let playerList = [];
        playerList = data?.data?.friendList;

        this.goProcessAddPlayer(playerList, 0).then((result: any) => {
          console.debug('go process add player [0]', result);
          if (result?.done) {
            if (this.fromClub && !this.teeSlotNew) {
              this.getBookingItemizedBill(true, false);
              this.recalculateBookingPricing(false, false);
            }
          }
        });
      } else if (!!data?.data?.group) {
        this.flightService
          .addFromGroup(this.bookingSlot.id, data?.data.groupData.id)
          .subscribe(data => {
            console.debug('add from group : ', data);
            if (data) {
              let _bookingSlot = data;
              this.refreshBookingObject(_bookingSlot);
              this.getBookingItemizedBill(false);
              this.recalculateBookingPricing();
            }
          });
      } else {
        if (!!data?.data) {
          if (!data.data?.playerDetails) data.data.playerDetails = {};
          data.data.playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;
          data.data.playerDetails['caddySelectionCriteria'] = {};
          data.data.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
            ? this.caddyRequired
            : false;
          console.debug('dismiss add player [2] ', data?.data?.mulitPlayers);
        }
        if (data.data && data?.data?.newPlayer && !data.data?.multiPlayers) {
          console.debug('dismiss add players - registerNameOnly [0] ', data?.data);
          if (data?.data?.registerThisPlayer) {
            if (data?.data?.option === 'registerNameOnly') {
              if (data?.data?.playerDetailsList?.length > 0) {
                data.data.playerDetailsList.forEach(pd => {
                  pd.caddySelectionCriteria = {};
                  pd['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
                    ? this.caddyRequired
                    : false;
                });
              }

              if (!this.teeSlotNew) {
                this.goProcessAddAdditionalPlayers(
                  this.bookingSlot.id,
                  0,
                  data?.data?.playerDetailsList,
                  data?.data,
                  true
                ).then((result: any) => {
                  console.debug('go process add player [1]', result, data?.data?.playerDetailsList);
                  if (result?.success && result?.done) {
                    this.getBookingItemizedBill(true);
                    this.recalculateBookingPricing();
                  }
                });
                return;
              }
              // // for (let x = 0; x < data?.data?.playerDetailsList.length; x++) {
              // data?.data?.playerDetailsList.forEach((p: any, idx: number)=>{

              //   const element = data?.data?.playerDetailsList[idx];
              //   setTimeout(() => {
              //     this.addPlayerToBooking({
              //       new: true,
              //       playerContact: data.data?.playerContact,
              //       playerDetails: {
              //         playerName: element.playerName,
              //         gender: element.gender,
              //       },
              //       sequence: slot,
              //     });
              //   }, 2000);
              // })
              // // }
            } else {
              this.createContact(data.data?.playerDetails, data.data?.addThisMember);
              setTimeout(() => {
                this.addPlayerToBooking({
                  new: true,
                  playerContact: data.data?.playerContact,
                  playerDetails: data.data?.playerDetails,
                  sequence: slot,
                });
              }, 2000);
            }
          } else {
            this.addPlayerToBooking({
              new: true,
              playerContact: data.data?.playerContact,
              playerDetails: data.data?.playerDetails,
              sequence: slot,
            });
          }
          if (this.fromClub && !this.teeSlotNew) {
            this.getBookingItemizedBill(true);
            this.recalculateBookingPricing();
          }
        } else if (data.data && !data.data?.newPlayer && !data.data?.multiPlayers) {
          if (isEditPlayer) {
            let idx = slot - 1;
            let player = this.bookingSlot.bookingPlayers[idx];

            await this.deleteBookingPlayer(player, false);
            this.captchaResponse = null;

            setTimeout(async () => {
              await this.addPlayerToBooking({
                new: false,
                playerId: data?.data?.item.playerId
                  ? data?.data?.item.playerId
                  : data?.data.item.id,
                sequence: slot,
                playerDetails: data?.data?.playerDetails,
              });
            }, 2000);
          } else {
            this.addPlayerToBooking({
              new: false,
              playerId: data?.data?.item.playerId ? data?.data?.item.playerId : data?.data.item.id,
              sequence: slot,
              playerDetails: data?.data?.playerDetails,
            });
            if (this.fromClub && !this.teeSlotNew) {
              this.getBookingItemizedBill(true, false);
              this.recalculateBookingPricing(false, false);
            }
          }
        } else if (data.data && !data.data?.newPlayer && data?.data?.multiPlayers) {
          // multiplayers
          if (data?.data?.item && data?.data?.item.length > 0) {
            let _players = data?.data?.item;
            let i = 0;
            _players.forEach((p: any, idx: number) => {
              data.data.playerDetails['caddySelectionCriteria']['caddyRequired'] = this
                .caddyRequired
                ? this.caddyRequired
                : false;
              console.debug('adding players [0]', p, idx, data.data.playerDetails);
              console.debug('adding players [1]', data.data);
              this.addPlayerToBooking({
                new: false,
                playerId: p.playerId ? p.playerId : p.id,
                sequence: slot + idx,
                playerDetails: data?.data?.playerDetails,
              });
              if (idx === _players.length - 1) {
                this.getBookingItemizedBill(true);
                this.recalculateBookingPricing();
              }
            });
          }
        } else return false;
      }
    });
    return await modal.present();
  }

  // goProcessAddPlayer(playerList, counter) {
  //   return new Promise(async (resolve, reject) => {
  //     let i = counter;
  //     console.debug("go process add player [1]", playerList, i);
  //     let _player = playerList[i];
  //     if (!_player?.playerDetails) _player.playerDetails = {};
  //     _player.playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;

  //     _player.playerDetails['caddySelectionCriteria'] = {};
  //     _player.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired ? this.caddyRequired : false;

  //     try {
  //       const result = await this.addPlayerToBooking({
  //         new: false,
  //         playerId: _player?.item.playerId ? _player?.item.playerId : _player?.item.id,
  //         sequence: null, //i > 1 ? slot + 1 : slot,
  //         playerDetails: _player?.playerDetails,
  //       }, null, false);

  //       counter++;
  //       if (counter === playerList.length) {
  //         resolve({ done: true });
  //       } else {
  //         this.goProcessAddPlayer(playerList, counter).then(resolve).catch(reject);
  //       }
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }

  onProcessAddPlayer(counter: number) {
    return new Promise((resolve, reject) => {
      counter++;
      resolve({
        counter: counter,
      });
    });
  }

  private _gettingCourseHandicap(slot: number) {
    let idx = slot - 2;
    let teeBox: string;
    let playerId: number;

    let reducedTeebox = this._reducedTeebox();

    let _tbox = reducedTeebox
      .filter((t: TeeBox) => {
        if (slot === 1) return this.currentPlayer.teeOffFrom === t.name;
        else return this.otherPlayers[idx].teeOffFrom === t.name;
      })
      .map((t: TeeBox) => {
        return t.name;
      });
    if (_tbox.length === 1) {
      if (slot === 1) this.currentPlayer.teeOffFrom = String(_tbox);
      else this.otherPlayers[idx].teeOffFrom = String(_tbox);
    } else if (_tbox.length === 0) {
      if (slot === 1) this.currentPlayer.teeOffFrom = String(reducedTeebox[0].name);
      else this.otherPlayers[idx].teeOffFrom = String(reducedTeebox[0].name);
    }

    if (slot === 1) {
      playerId = this.currentPlayer.playerId;
      teeBox = this.currentPlayer.teeOffFrom;
    } else {
      playerId = this.otherPlayers[idx].playerId;
      teeBox = this.otherPlayers[idx].teeOffFrom;
    }
    let firstNineCourse: number;
    let secondNineCourse: number;
    //
    firstNineCourse = this.gameInfo.courses[0].courseId;
    if (this.gameInfo.courses[1]) secondNineCourse = this.gameInfo.courses[1].courseId;

    let player = this._playerInSlot(slot);
    this.handicapService
      .getCourseHandicap(playerId, teeBox, firstNineCourse, secondNineCourse)
      .subscribe(
        (handicap: number) => {
          player.handicap = handicap;
        },
        error => {}
      );
  }
  _playerInSlot(slot: number): PlayerInfo {
    if (slot === 1) return this.currentPlayer;
    else if (this.slotFilled(slot)) {
      return this.otherPlayers[slot - 2];
    } else return null;
  }
  _reducedTeebox() {
    let courses: Array<CourseInfo> = this.gameInfo.courses;
    let selCourse: CourseInfo;
    selCourse = courses.reduce((a: CourseInfo, b: CourseInfo): CourseInfo => {
      if (a.teeBoxes.length < b.teeBoxes.length) return a;
      else return b;
    });
    return selCourse.teeBoxes;
  }

  getClubCourseDetails(attribute?: string) {
    let _clubName;
    let _clubImage;
    if (!this.teeSlotNew) {
      if (this.bookingSlot && this.bookingSlot.clubData) {
        _clubName = this.bookingSlot.clubData.name;
        // if(this.bookingSlot.clubData?.clubThumbnail) _clubImage = this.bookingSlot.clubData?.clubThumbnail;
        if (this.bookingSlot.clubData?.clubImage) _clubImage = this.bookingSlot.clubData?.clubImage;
        else if (this.bookingSlot.clubData?.clubLogo)
          _clubImage = this.bookingSlot.clubData?.clubLogo;
        // _clubImage = this.bookingSlot.clubData.clubImage;
      }
    } else if (this.teeSlotNew) {
      if (this.clubs && this.clubs.club && !this.fromClub) {
        _clubName = this.clubs?.club?.name || this.clubs?.club?.clubName;
        // if(this.clubs.club?.clubThumbnail) _clubImage = this.clubs.club?.clubThumbnail;
        if (this.clubs.club?.clubImage) _clubImage = this.clubs.club?.clubImage;
        else if (this.clubs.club?.clubLogo) _clubImage = this.clubs.club?.clubLogo;
      } else if (this.clubInfo && !this.fromClub) {
        _clubName = this.clubInfo.clubName || this.clubInfo.name;
        // if(this.clubInfo?.clubThumbnail) _clubImage = this.clubInfo?.clubThumbnail;
        if (this.clubInfo?.clubImage) _clubImage = this.clubInfo?.clubImage;
        else if (this.clubInfo?.clubLogo) _clubImage = this.clubInfo?.clubLogo;
      } else if (this.clubInfo && this.fromClub) {
        _clubName = this.clubInfo.clubName || this.clubInfo.name;
        // if(this.clubInfo?.clubThumbnail) _clubImage = this.clubInfo?.clubThumbnail;
        if (this.clubInfo?.clubImage) _clubImage = this.clubInfo?.clubImage;
        else if (this.clubInfo?.clubLogo) _clubImage = this.clubInfo?.clubLogo;
      }
    }
    let _courseName =
      this.bookingSlot && this.bookingSlot.slotAssigned.startCourse
        ? this.bookingSlot.slotAssigned.startCourse.name
        : this.teeTimeSlotDisplay.slot.startCourse.name;
    switch (attribute) {
      case 'club':
        return _clubName;
      case 'course':
        return _courseName;
      case 'image':
        // console.debug("club image", _clubImage, this.teeSlotNew, this.clubs?.club, this.clubInfo)
        if (_clubImage?.toLowerCase().includes(global.MygolfServer.toLowerCase()))
          return _clubImage;
        else return global.MygolfServer + '/' + _clubImage;
    }
  }

  async showClubImage() {
    const imageZoom = await this.modalCtl.create({
      component: ImageZoomPage,
      componentProps: {
        image: this.getClubCourseDetails('image'),
      },
    });
    imageZoom.onDidDismiss().then((data: any) => {});
    imageZoom.present();
  }

  async showBookByImage() {
    const imageZoom = await this.modalCtl.create({
      component: ImageZoomPage,
      componentProps: {
        image: this.playerProfilePicture,
      },
    });
    imageZoom.onDidDismiss().then((data: any) => {});
    imageZoom.present();
  }

  allowPlayerMaxBookingsPerDay() {
    console.debug(
      'allow player max bookings per day : ',
      this.playerMaxBooking,
      this.bookingOptions,
      this.appAttribute
    );
    if (this.appAttribute && this.appAttribute.overrideMaxBookingsPerDay) return true;
    if (!this.playerMaxBooking) return true;
    else if (this.playerMaxBooking.totalBookings === 0) return true;
    if (
      this.bookingOptions &&
      this.bookingOptions.maxBookingsPerDay !== undefined &&
      this.bookingOptions.maxBookingsPerDay === 0
    )
      return true;
    else return this.playerMaxBooking.totalBookings < this.bookingOptions.maxBookingsPerDay;
  }

  async displayErrorModal(heading: string, message: string) {
    const modal = await this.modalCtl.create({
      component: TeeSlotSettingsComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        heading: heading,
        message: message,
        isErrorModal: true,
      },
      mode: 'ios',
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onBookNow() {
    if (1) {
      console.debug(
        'get addl booking players',
        this.getAddlBookingPlayers(),
        this.playerReq,
        this.memberReq,
        this.guestReq
      );
      // return;
    }
    if (!this.allowPlayerUnpaidBooking() && this.playerMaxBooking) {
      let _maxUnpaid = this.playerMaxBooking.maxUnpaidBookings;
      let _totalUnpaid = this.playerMaxBooking.totalUnpaidBookings;
      let _total = this.playerMaxBooking.totalBookings;
      let _message =
        `You already have <b>` +
        _maxUnpaid +
        `</b> or more unpaid bookings, which is the maximum this club allows.`;
      await this.displayErrorModal('Maximum Unpaid Bookings Allowed', _message);
      return;
    }
    if (!this.allowPlayerMaxBookingsPerDay() && this.playerMaxBooking) {
      let _maxBookingsPerDay = this.bookingOptions.maxBookingsPerDay;
      let _total = this.playerMaxBooking.totalBookings;
      let _message1;
      if (this.appAttribute && this.appAttribute.maxBookingsPerDayMessage)
        _message1 = this.appAttribute.maxBookingsPerDayMessage;
      let _message =
        `You already have <b>` +
        _maxBookingsPerDay +
        `</b> booking(s), which is the maximum this club allows.`;

      await this.displayErrorModal('Maximum Bookings Allowed Per Day', _message);
      return;
    }
    if (this.fromClub && !this.clubBookingPlayers) {
      MessageDisplayUtil.showMessageToast(
        'Please select a player to book',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _clubName;
    if (!this.teeSlotNew) {
      if (this.bookingSlot && this.bookingSlot.clubData) _clubName = this.bookingSlot.clubData.name;
    } else if (this.teeSlotNew) {
      if (this.clubs && this.clubs.club) _clubName = this.clubs.club.name;
      else if (this.clubInfo && !this.fromClub)
        _clubName = this.clubInfo.clubName || this.clubInfo.name;
      else if (this.clubInfo && this.fromClub)
        _clubName = this.clubInfo.clubName || this.clubInfo.name;
    }
    let _teeOffTime = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
    let __teeOffTime = this.teeTimeSlotDisplay.slot.teeOffTime;
    let _teeOffDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format('ddd, DD MMM YYYY');
    let _depositCutOffDays = this.bookingOptions.depositCutOffDays;
    let _holdDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate)
      .subtract(_depositCutOffDays, 'days')
      .format('ddd, DD MMM YYYY');
    let __holdDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate)
      .subtract(_depositCutOffDays, 'days')
      .format('YYYY-MM-DD');
    let _depositAmount = 'payment';
    let _currency = this.currency
      ? this.currency.symbol
      : this.teeTimeSlotDisplay.slot.currency.symbol;

    let _slotPrices;
    let _playerTypes;
    let _isMember: boolean = false;
    let _price;
    let _currentPlayerType;

    if (!this.fromClub && this.userType === 'player') {
      _slotPrices = this.getClubPackages('new');
      _playerTypes = this.applicablePlayerTypes;

      _playerTypes.forEach((playerType: string) => {
        if (playerType.toLowerCase() === 'member') {
          _isMember = true;
          _currentPlayerType = playerType;
        } else if (playerType.toLowerCase() === 'tmember') {
          _isMember = true;
          _currentPlayerType = playerType;
        }
      });
      if (_isMember && _slotPrices) {
        _slotPrices
          .filter(price => {
            return price.id.toLowerCase() === _currentPlayerType;
          })
          .map(price => {
            _price = price;
          });
      } else {
        _slotPrices
          .filter(price => {
            return price.id.toLowerCase() === 'std';
          })
          .map(price => {
            _price = price;
          });
      }
    }

    if (this.bookingOptions && this.appAttribute?.showDepoSecureMessage) {
      if (this.bookingOptions.depositAmountType.toLowerCase() === 'percentage') {
        if (this.bookingOptions.depositAmount === 100) {
          _depositAmount = '<b>Full Payment</b>';
        } else if (this.bookingOptions.depositAmount === 50) {
          _depositAmount = '<b>Half Payment</b>';
        } else
          _depositAmount =
            '<b>' + this.bookingOptions.depositAmount + '% Payment of the Booking Amount</b>';
      } else if (this.bookingOptions.depositAmountType.toLowerCase() === 'absolute') {
        _depositAmount =
          'Deposit of ' + '<b>' + _currency + this.bookingOptions.depositAmount + '</b>';
      } else _depositAmount = 'payment';
    }

    let _messagePayment = '';
    let _avoidCancelMessage = 'To avoid cancellation,';
    let _additionalChargesMessage = '';
    if (
      this.appAttribute &&
      this.appAttribute.bookingRequest &&
      this.appAttribute.bookingRequest.avoidCancelMessage
    )
      _avoidCancelMessage = this.appAttribute.bookingRequest.avoidCancelMessage;
    if (
      this.appAttribute &&
      this.appAttribute.bookingRequest &&
      this.appAttribute.bookingRequest.additionalChargesMessage
    )
      _additionalChargesMessage = this.appAttribute.bookingRequest.additionalChargesMessage;
    if (_additionalChargesMessage && _additionalChargesMessage.length > 0)
      _additionalChargesMessage += `<br>`;

    let __teeOffDate = this.teeTimeSlotDisplay.slot.teeOffDate;

    if (moment(__holdDate).diff(moment(), 'days', true) <= 0) {
      if (
        moment(__teeOffDate + ' ' + __teeOffTime, 'YYYY-MM-DD HH:mm:ss').diff(
          moment(),
          'minutes'
        ) <= 0
      ) {
        if (
          this.bookingOptions.fullPaymentCutOffHours <= 0 &&
          this.appAttribute.bookingCutOffValue
        ) {
          _messagePayment =
            _avoidCancelMessage +
            ` you have <b>` +
            this.appAttribute.bookingCutOffValue +
            ' ' +
            this.appAttribute.bookingCutOffValuePeriod +
            `</b> to make full payment`;
        } else {
          _messagePayment =
            _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
        }
      } else if (
        moment(__teeOffDate + ' ' + __teeOffTime, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'minutes') >
        0
      ) {
        if (this.bookingOptions.fullPaymentCutOffHours > 0) {
          _messagePayment =
            _avoidCancelMessage +
            ` you have <b>` +
            this.bookingOptions.fullPaymentCutOffHours +
            ` hour(s)</b> to make Full Payment before tee off time`;
        } else {
          _messagePayment =
            _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
        }
      } else {
        _messagePayment =
          _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
      }
    } else {
      _messagePayment =
        _avoidCancelMessage +
        ` you will need to make ` +
        _depositAmount +
        ` before <b style="color:green">` +
        _holdDate +
        `</b> at <b style="color:green">` +
        moment(_teeOffTime, 'hh:mm A')
          .subtract(this.bookingOptions.fullPaymentCutOffHours, 'hours')
          .format('hh:mm A') +
        `</b>.<br>`;
    }

    if (_price && _price.amount > 0) {
      if (this.fromClubList) {
        _messagePayment = _additionalChargesMessage + `<br>` + _messagePayment;
      } else {
        _messagePayment = _additionalChargesMessage + `<br>` + _messagePayment;
      }
    } else {
      if (this.fromClubList) {
        _messagePayment = _additionalChargesMessage + '<br>' + _messagePayment;
      } else {
        _messagePayment = _additionalChargesMessage + `<br>` + _messagePayment;
      }
    }

    if (this.fromClubList) {
      let _clubId =
        this.clubInfo?.clubId | this.clubInfo?.id | this.clubs?.club?.clubId | this.clubs?.club?.id;
      const confirmationModal = await this.modalCtl.create({
        component: BookingConfirmationComponent,
        cssClass: 'self-adjustable-modal',
        backdropDismiss: false,
        componentProps: {
          clubName: _clubName,
          courseName: this.getClubCourseDetails('course'),
          teeOffDate: _teeOffDate,
          teeOffTime: _teeOffTime,
          message: _messagePayment,
          teeTimeSlotDisplay: this.teeTimeSlotDisplay,
          playerReq: this.playerReq,
          holesPlayed: this.holesPlayed,
          buggyRequired: this.buggyRequired,
          caddyRequired: this.caddyRequired,
          fromClub: this.fromClub,
          clubBookingPlayers: this.clubBookingPlayers,
          userType: this.userType,
          playerHomeInfo$: this.playerHomeInfo$,
          player$: this.player$,
          bookForOther: this.bookForOther,
          captchaResponse: this.captchaResponse,
          afterBook: this.afterBook,
          currSession: this.currSession,
          clubInfo: this.clubInfo,
          appAttribute: this.appAttribute,
          addlBookingPlayers: this.addlBookingPlayers,
          clubId: _clubId,
          bookingOptions: this.bookingOptions,
        },
        mode: 'ios',
      });

      await confirmationModal.present().then(() => {
        const height = this.platform.height() - 180;
        if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });

      confirmationModal.onDidDismiss().then((data: any) => {
        console.debug('on dismiss ', data);
        if (data?.data?.success) {
          console.debug('on dismiss [0] ', data?.data);
          if (data?.data?.page === 'booking-list') {
            console.debug('on dismiss [1] ', data?.data?.page);
            this.modalCtl
              .dismiss({
                afterBook: true,
              })
              .then(() => {
                // this.router.navigate([data?.data?.page], data?.data?.params)
              });
          } else {
            console.debug('on dismiss [2] ', data?.data?.page);
            this.onNavigateBack(data?.data?.page, data?.data?.params);
          }
        } else {
          if (data?.data?.optionSelected === 'cancel') {
          } else {
            if (data?.data?.page === 'booking-list') {
              console.debug('on dismiss [1] ', data?.data?.page);
              this.modalCtl
                .dismiss({
                  afterBook: true,
                })
                .then(() => {
                  // this.router.navigate([data?.data?.page], data?.data?.params)
                });
            } else {
              console.debug('on dismiss [2] ', data?.data?.page);
              this.onNavigateBack(data?.data?.page, data?.data?.params);
            }
          }
        }
      });
    } else {
      let _message =
        _clubName +
        `<br>Date: <b>` +
        _teeOffDate +
        `</b><br>Time: <b>` +
        _teeOffTime +
        `</b>` +
        _messagePayment;

      let alert = await this.alertCtrl.create({
        header: 'Booking Confirmation',
        message: _message,
        cssClass: 'booking-alert',
        buttons: [
          {
            text: 'Not Now',
            role: 'cancel',
            handler: () => {},
          },
          {
            text: 'Confirm',
            handler: () => {
              this._goBookNow();
            },
          },
        ],
      });
      alert.present();
    }
  }

  _goBookNow() {
    let _courseId = this.teeTimeSlotDisplay.slot.startCourse.id;
    let _totalPlayers = this.playerReq; //this.teeTimeSlotDisplay.slot.maxPlayers;
    let _teeOffDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format('YYYY-MM-DD');
    let _fromTime = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('HH:mm');
    let _toTime = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('HH:mm');
    let _currDateTime = moment().toISOString();
    let _ninesPlaying = parseInt(this.holesPlayed);
    let _minPlayers = this.playerReq; //this.teeTimeSlotDisplay.slot.minPlayers;
    let _maxAllowedBuggy =
      Math.floor(this.playerReq / this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy) +
      (this.playerReq % this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy);
    let _maxAllowedCaddy =
      Math.floor(this.playerReq / this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy) +
      (this.playerReq % this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy);
    let _buggyReq = this.buggyRequired;
    let _caddyReq = this.caddyRequired;
    let _toHour = parseInt(moment(_fromTime).format('HH'));
    let _toMinute = parseInt(moment(_fromTime).format('mm'));
    let _bookingName;
    let _bookingEmail;
    let _bookingPhone;
    if (this.fromClub) {
      _bookingName = this.clubBookingPlayers.playerName;
      _bookingEmail = this.clubBookingPlayers.email;
      _bookingPhone = this.clubBookingPlayers.phone;
    } else if (this.userType !== 'player') {
    } else {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _bookingName = player.playerName;
        _bookingEmail = player.email;
        _bookingPhone = player.phone;
      });
    }

    let reqBookSlot = {
      courseId: _courseId,
      teeOffDate: _teeOffDate,
      teeOffTimeFrom: _fromTime,
      teeOffTimeTo: _toTime,
      totalPlayers: _totalPlayers,
      buggyRequired: _buggyReq ? _maxAllowedBuggy : 0,
      caddiesRequired: _caddyReq ? _maxAllowedCaddy : 0,
      ninesPlaying: _ninesPlaying,
      bookingName: _bookingName,
      bookingEmail: _bookingEmail,
      bookingPhone: _bookingPhone,
      bookingRequestedAt: null,
      addBookingPlayer: this.fromClub ? true : !this.bookForOther,
    };
    if (this.fromClub) {
      this.flightService.clubBookingSlot(reqBookSlot, true, this.captchaResponse).subscribe(
        async (data: any) => {
          let _body = data._body;
          let _message = `Before making payment you will need to add players and complete all mandatory options.`;
          if (data.status === 200) {
            let _booking: TeeTimeBooking = data;
            this.afterBook = true;
            let params: NavigationExtras = {
              // replaceUrl: false,
              state: {
                teeSlotNew: false,
                teeTimeSlotDisplay: this.teeTimeSlotDisplay,
                bookingSlot: _booking,
                clubInfo: _booking.clubData,
                fromClub: true,
                needRefresh: true,
                currSession: this.currSession,
              },
            };
            this.router.navigate(['booking-details'], params);
          } else if (data && data.status !== 200) {
            let _error = data;
            let _msg = 'Something has happened, please try again.';
            _msg =
              _error && _error.errors && _error.errors.length > 0 ? _error.errors[0] : _error.error;

            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          } else {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          }
        },
        async error => {
          let _error = error;
          this.captchaResponse = null;
          let _msg =
            _error && _error.errorCode
              ? _error.errorMessage
              : 'Something has happened, please try again or contact myGolf2u admin.';

          if (!_error.status) {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
          } else {
            let alert = await this.alertCtrl.create({
              header: _error && _error.errorCode ? _error.errorCode : 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
          }
        }
      );
    } else if (0 && this.userType === 'booking_agent') {
      this.flightService.bookTeeTimeSlot(reqBookSlot, false, this.captchaResponse).subscribe(
        async (data: any) => {
          let _body = data._body;
          let _message = `Before making payment you will need to add players and complete all mandatory options.`;
          if (data.status === 200) {
            let loader = await this.loadingCtrl.create({
              spinner: 'crescent',
              showBackdrop: false,
              duration: 30000,
              message: 'Getting booking info...',
            });
            loader.present().then(() => {
              setTimeout(() => {
                this.flightService
                  .getBookingByReference(this.clubInfo.clubId, _body)
                  .subscribe((resp: any) => {
                    let _booking: TeeTimeBooking = resp;
                    this.afterBook = true;
                    let params: NavigationExtras = {
                      replaceUrl: false,
                      state: {
                        teeSlotNew: false,
                        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
                        bookingSlot: _booking,
                        clubInfo: _booking.clubData,
                        fromClub: true,
                        needRefresh: true,
                        currSession: this.currSession,
                        userType: this.userType,
                      },
                    };
                    this.router.navigate(['booking-details'], params);
                  });
              }, 30000);
            });
          } else if (data && data.status !== 200) {
            let _error = data;
            let _msg = 'Something has happened, please try again.';
            _msg =
              _error && _error.errors && _error.errors.length > 0 ? _error.errors[0] : _error.error;

            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          } else {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          }
        },
        async error => {
          let _error = error;
          this.captchaResponse = null;
          let _msg =
            _error && _error.errorCode
              ? _error.errorMessage
              : 'Something has happened, please try again or contact myGolf2u admin.';

          if (!_error.status) {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
          } else {
            let alert = await this.alertCtrl.create({
              header: _error && _error.errorCode ? _error.errorCode : 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
          }
        }
      );
    } else {
      this.flightService
        .bookTeeTimeSlot(reqBookSlot, !this.bookForOther, this.captchaResponse)
        .subscribe(
          async (data: any) => {
            console.debug('booked a slot', reqBookSlot, data, this.addlBookingPlayers);
            let _body = data._body;
            let _message =
              `Thank you for booking with myGolf2u.<br> Please see 'My Bookings' for details.` +
              `<br>Your booking reference : <br><b>` +
              _body +
              `</b>` +
              `<br>
            Before making payment you will need to add players and complete all mandatory options.`;
            let _title = 'Booking In Process';
            let _okTxt = 'Go to My Bookings';
            let _closeTxt = 'Close';
            if (this.userType === 'booking_agent') _closeTxt = 'Continue Booking';
            if (this.appAttribute && this.appAttribute.bookingRequest) {
              let _bookingRequest = this.appAttribute.bookingRequest;
              _message = _bookingRequest.message;
              _title = _bookingRequest.title;
              _okTxt = _bookingRequest.Ok;
            }
            if (!!data) {
              let _buttons = [];
              if (this.fromClub) {
                _buttons = [
                  {
                    text: 'Close',
                    handler: () => {
                      this.afterBook = true;
                      this.nav.pop();
                    },
                  },
                ];
              } else {
                _buttons = [
                  {
                    text: _closeTxt,
                    handler: () => {
                      this.afterBook = true;
                      this.nav.pop();
                    },
                  },
                  {
                    text: _okTxt,
                    handler: async () => {
                      if (this.userType === 'booking_agent') {
                        //!! no agent
                        let _teeOffDate = this.teeTimeSlotDisplay.slot.teeOffDate;
                        let _teeOffTime = this.teeTimeSlotDisplay.slot.teeOffTime;
                        let _currentDate = moment().format('YYYY-MM-DD');
                        let _partnerInfo = this.mg2uUtil.getPartnerInfo();
                        let params: NavigationExtras = {
                          replaceUrl: false,
                          state: {
                            partnerId: _partnerInfo ? _partnerInfo.id : null,
                            partnerInfo: _partnerInfo ? _partnerInfo : null,
                            type: 'booking_agent',
                            startDate: _teeOffDate,
                            endDate: _teeOffDate,
                            slotFrom: _teeOffTime,
                            slotTo: _teeOffTime,
                            bookingStart: _currentDate,
                          },
                        };
                        this.router.navigate(['partner-booking-list'], params);
                      } else {
                        console.debug(
                          'booked a slot [1]',
                          reqBookSlot,
                          data,
                          this.addlBookingPlayers
                        );
                        let params: NavigationExtras = {
                          replaceUrl: false,
                          state: {
                            fromBookNow: true,
                            userType: 'player',
                            club: this.mg2uUtil.getSelectedClub()
                              ? this.mg2uUtil.getSelectedClub()
                              : null,
                          },
                        };
                        if (this.addlBookingPlayers?.length > 0) {
                          await this.checkExistingByBookingReference(data)
                            .then((result: any) => {
                              console.debug('booked a slot [2]', result);
                              if (result?.success) {
                                let _bookingId = result?.data?.id;
                                this.goProcessAddAdditionalPlayers(_bookingId, 0, data?.data).then(
                                  (result: any) => {
                                    console.debug('go process add additional players', result);
                                    if (result) {
                                      this.onNavigateBack('booking-home', params);
                                      // if(this.modalMode) {
                                      //   this.modalCtl.dismiss();
                                      // } else {
                                      //   this.router.navigate(['booking-home'], params);
                                      // }
                                    }
                                  }
                                );
                              } else {
                                this.onNavigateBack('booking-home', params);
                                // this.router.navigate(['booking-home'], params);
                              }
                            })
                            .catch(error => {
                              this.onNavigateBack('booking-home', params);
                              // this.router.navigate(['booking-home'], params);
                            });
                        }
                      }
                    },
                  },
                ];
              }
              let alert = await this.alertCtrl.create({
                header: _title,
                message: _message,
                buttons: _buttons,
              });
              alert.present();
            } else {
              this.captchaResponse = null;
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            }
          },
          async error => {
            let _error = error;
            this.captchaResponse = null;
            if (!error.status) {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            } else {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message:
                  _error && _error.errors[0]
                    ? _error.errors[0]
                    : 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            }
          }
        );
    }
  }

  togglePrices() {
    this.displayPrices = !this.displayPrices;
    if (!this.fromClub) this.getCurrentPlayerVoucher();
    if (!this.fromClub) this.getPendingPlayerDiscountCard();
    this.getActiveClubDiscounts();
    this.getPlayerVoucherSeries();
  }

  getProperTime(time) {
    return moment(time, 'HH:mm:ss').format('hh:mm A');
  }
  getProperDate(date) {
    return moment(date, 'YYYY-MM-DD').format("DD MMM 'YY");
  }

  getBookingDetails(attribute?: string) {
    let _statusText = '';
    let _amountChargable: number = 0;
    _amountChargable = this.bookingSlot.amountPayable - this.bookingSlot.totalDeductions;
    if (attribute === 'status') {
      let _bookingStatus = this.bookingSlot.bookingStatus;
      if (_bookingStatus === 'Booked') _statusText = 'Booked';
      else if (_bookingStatus === 'PaymentFull' && this.bookingSlot.amountPaid > 0)
        _statusText = 'Paid in Full';
      else if (_bookingStatus === 'PaymentFull' && this.bookingSlot.amountPaid === 0)
        _statusText =
          this.appAttribute && this.appAttribute.bookingStatus.noneToPay
            ? this.appAttribute.bookingStatus.noneToPay
            : 'Nothing to Pay';
      else if (_bookingStatus === 'PaymentPartial') _statusText = 'Partially Paid';
      else _statusText = _bookingStatus ? _bookingStatus : '';
    }
    switch (attribute) {
      case 'reference':
        return '#' + this.bookingSlot.bookingReference;
      case 'price':
        return _amountChargable;
      case 'currency':
        return this.bookingSlot.slotAssigned.currency.symbol;
      case 'status':
        return _statusText;
      case 'bookedOn':
        return moment(this.bookingSlot.bookingCreatedAt, 'YYYY-MM-DDTHH:mm:ss').format(
          "ddd, DD MMM 'YY hh:mm A"
        );
      case 'bookingMedium':
        return this.displayBookingMedium(this.bookingSlot);
      case 'pricingPlanApplied':
        return this.displayPricingPlanApplied(this.bookingSlot);
      case 'created':
        return moment(this.bookingSlot.bookingCreatedAt, 'YYYY-MM-DDTHH:mm:ss').format(
          'ddd, DD MMM YYYY'
        );
      case 'createdDay':
        return moment(this.bookingSlot?.slotAssigned?.teeOffDate, 'YYYY-MM-DDTHH:mm:ss').format(
          'DD'
        );
      case 'createdTime':
        return moment(this.bookingSlot?.slotAssigned?.teeOffDate, 'YYYY-MM-DDTHH:mm:ss').format(
          'hh:mm A'
        );
      case 'createdTimeHour':
        return moment(this.bookingSlot?.slotAssigned?.teeOffTime, 'HH:mm:ss').format('HH');
      case 'createdTimeMin':
        return moment(this.bookingSlot?.slotAssigned?.teeOffTime, 'HH:mm:ss').format('mm');
      case 'teeOffDate':
        return moment(this.bookingSlot?.slotAssigned?.teeOffDate, 'YYYY-MM-DDTHH:mm:ss').format(
          'ddd, DD MMM YYYY'
        );
      case 'teeOffTime':
        return moment(this.bookingSlot?.slotAssigned?.teeOffTime, 'HH:mm:ss').format('hh:mm A');
    }
  }

  getHourMin(pos: number, type: string) {
    var createdTime = this.getBookingDetails('teeOffTime').toString();
    const timeIn12HourFormat = moment(createdTime, ['h:mm A']).format('HH:mm');
    if (type == 'hour') {
      var hour = this.getBookingDetails('createdTimeHour').toString();
      if (pos == 1) return hour.substring(0, pos);
      else return hour.substring(1, pos);
    } else {
      var min = this.getBookingDetails('createdTimeMin').toString();
      if (pos == 1) return min.substring(0, pos);
      else return min.substring(1, pos);
    }
  }

  displayPricingPlanApplied(booking) {
    if (!booking) return;
    let _displayPricingPlanApplied = '';
    let _pricingPlanApplied = '';
    if (booking) _pricingPlanApplied = booking.pricingPlanApplied;
    switch (_pricingPlanApplied) {
      case 'S':
        _displayPricingPlanApplied = 'Regular';
        break;
      case 'P':
        _displayPricingPlanApplied = 'Promo';
        break;
      case 'J':
        _displayPricingPlanApplied = 'Jumbo';
        break;
      default:
        _displayPricingPlanApplied = 'N/A';
        break;
    }
    return _displayPricingPlanApplied;
  }

  displayBookingMedium(booking) {
    if (!booking) return;
    let _displayBookingMedium = '';
    let _bookingMedium = '';
    if (booking) _bookingMedium = booking.bookingMedium;
    switch (_bookingMedium) {
      case 'WALKIN':
        _displayBookingMedium = 'Walk-In';
        break;
      case 'ONLINE':
        _displayBookingMedium = 'Online';
        break;
    }
    return _displayBookingMedium;
  }

  minMax(items) {
    return items.reduce((acc, val) => {
      acc[0] = acc[0] === undefined || val < acc[0] ? val : acc[0];
      acc[1] = acc[1] === undefined || val > acc[1] ? val : acc[1];
      return acc;
    }, []);
  }

  async refreshBookingDetails(refreshBill?: boolean) {
    this.playersBalance = 0;
    if (!this.teeSlotNew) this.checkClubBookingOption();
    let _bookingId = this.bookingSlot.id;
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
    });

    loader.present().then(response => {
      this.flightService.getBookingById(this.bookingSlot.id).subscribe(
        (bookingByPlayer: TeeTimeBooking) => {
          loader.dismiss().then(() => {
            if (bookingByPlayer) {
              this.paymentClickedBoolean = false;
              this.buggyCaddyPreference = {};
              this.buggyCaddyPreference.bookingId = bookingByPlayer.id;
              this.buggyCaddyPreference.playerPairings = [
                {
                  bookingPlayerId: 0,
                  buggyRequired: true,
                  buggyPairing: 0,
                  driving: false,
                  caddiePreferred: 0,
                  caddieAssigned: 0,
                  caddyPairing: 0,
                  caddyPreferred: {},
                  caddyAssigned: {},
                  caddyRequired: true,
                  buggyType: 'STANDARD',
                },
              ];

              this.bookingSlot = bookingByPlayer;
              this.additionalItems = this.bookingSlot.additionalItems;
              this.bookingSlot.bookingPlayers = this.bookingSlot
                ? this.bookingSlot.bookingPlayers
                : null;
              this.assignmentDone = this.bookingSlot.assignmentDone;
              this.removedPlayers = this.bookingSlot.bookingPlayers.filter(p => {
                return p.playerRemoved;
              });
              this.bookingSlot.bookingPlayers = this.bookingSlot.bookingPlayers.filter(p => {
                return !p.playerRemoved;
              });
              this.bookingSlot.bookingPlayers.sort((a, b) => {
                if (a.sequence < b.sequence) return -1;
                else if (a.sequence > b.sequence) return 1;
                else 0;
              });
              let _eighteenHoles = this.bookingSlot.slotAssigned.eighteenHolesAllowed;
              let _nineHoles = this.bookingSlot.slotAssigned.nineHolesAllowed;
              if (_eighteenHoles && _nineHoles) {
                this.holesPlayed = '2';
                this.eighteenHolesAllowed = true;
                this.nineHolesAllowed = true;
              } else if (!_eighteenHoles && _nineHoles) {
                this.holesPlayed = '1';
              } else if (_eighteenHoles && !_nineHoles) {
                this.holesPlayed = '2';
                this.eighteenHolesAllowed = true;
                this.nineHolesAllowed = false;
              } else if (!_eighteenHoles && !_nineHoles) {
                this.holesPlayed = '1';
                this.eighteenHolesAllowed = false;
                this.nineHolesAllowed = false;
              }

              this.bookingSlot.bookingPlayers.forEach((p, i) => {
                let _caddyPairing = 0;
                if (p.caddyPairing > 0) {
                  _caddyPairing = p.caddyPairing;
                  if (!this.caddyPairing[_caddyPairing]) {
                    this.caddyPairing[_caddyPairing] = {
                      caddyPreferred: p.caddyPreferred,
                      caddyPairing: p.caddyPairing,
                      caddySelectionCriteria: p.caddySelectionCriteria
                        ? p.caddySelectionCriteria
                        : null,
                      caddyAssigned: p.caddyAssigned ? p.caddyAssigned : null,
                      caddyRequired: p.caddyPairing > 0 ? true : false,
                    };
                  }
                  if (!this.caddySlots[_caddyPairing]) {
                    this.caddySlots[_caddyPairing] = {
                      caddyPairing: p.caddyPairing ? p.caddyPairing : 0,
                      caddyPreferred: p.caddyPreferred ? p.caddyPreferred : null,
                      caddySelectionCriteria: p.caddySelectionCriteria
                        ? p.caddySelectionCriteria
                        : null,
                      caddyAssigned: p.caddyAssigned ? p.caddyAssigned : null,
                      caddyRequired: p.caddyPairing > 0 ? true : false,
                    };
                  }
                }

                this.buggyCaddyPreference.playerPairings.push(
                  Object.assign({}, this.buggyCaddyPreference[i], {
                    bookingPlayerId: p.id,
                    buggyRequired: p.pairingNo !== 0 ? true : false,
                    buggyPairing: p.pairingNo,
                    driving: p.driving,
                    caddiePreferred:
                      p.caddyPreferred && p.caddyPreferred.id ? p.caddyPreferred.id : null,
                    caddieAssigned:
                      p.caddyAssigned && p.caddyAssigned.id ? p.caddyAssigned.id : null,
                    caddyPairing: p.caddyPairing,
                    caddyPreferred: p.caddyPreferred,
                    caddyAssigned: p.caddyAssigned,
                    assignedBuggy: p.buggyId,
                    caddyRequired: p.caddyPairing > 0 ? true : false,
                    buggyType:
                      p.buggyCaddiePreference && p.buggyCaddiePreference.buggyType
                        ? p.buggyCaddiePreference.buggyType
                        : 'STANDARD',
                  })
                );

                if (p.buggyCaddiePreference)
                  if (this.fromClub && p.player && p.player.id)
                    //this.selectedBuggyType[i] = p.buggyCaddiePreference.buggyType;

                    this.getPlayersCredits(999, p.player.id);
              });

              if (!this.fromClub) this.getPlayersCredits(999, this.currentPlayerId);
              this.uniqBuggy = this.getUnique(this.bookingSlot.bookingPlayers, 'pairingNo');
              this.uniqBuggy = this.uniqBuggy.filter(ub => {
                return ub.pairingNo > 0;
              });
              this.uniqCaddy = this.getUnique(this.bookingSlot.bookingPlayers, 'caddyPairing');
              this.uniqCaddy = this.uniqCaddy.filter(uc => {
                return uc.caddyPairing > 0;
              });
              if (this.uniqBuggy) this.buggyReq = this.uniqBuggy.length;
              if (this.uniqCaddy) this.caddyReq = this.uniqCaddy.length;

              this.buggyCaddyPreference.playerPairings.shift();
              this.buggyCaddyPreference.ignoreBuggyUpdate = true;
              this.buggyCaddyPreference.ignoreCaddieUpdate = true;
              this.newBuggyCaddyPreference = JSON.parse(JSON.stringify(this.buggyCaddyPreference));

              this.paymentStatus =
                this.bookingSlot.bookingStatus === 'PaymentFull' ? 'Paid' : 'Pending';
              if (this.bookingSlot.bookingDiscounts && this.bookingSlot.bookingDiscounts.length > 0)
                this.bookingDiscounts = this.bookingSlot.bookingDiscounts.filter(
                  (d: TeeTimeBookingDiscount) => {
                    if (d.voucherApplied) return d.voucherApplied.redeemed;
                  }
                );
              else this.bookingDiscounts = [];

              if (refreshBill) this.getBookingItemizedBill(false);
              if (bookingByPlayer.amountPaid > 0) this.getBookingItemizedBill();
              this.buggyRequired = this.bookingSlot.buggyRequested === 0 ? false : true;
              this.caddyRequired = this.bookingSlot.caddyRequested === 0 ? false : true;
              this.getMg2uPlayerList();
            }
          });
        },
        error => {
          loader.dismiss();
        }
      );
    });
  }

  getMg2uPlayerList() {
    if (this.teeSlotNew) return;
    this.mg2uPlayerList = [];
    this.bookingSlot.bookingPlayers.forEach((bp: TeeTimeBookingPlayer) => {
      if (bp.player) this.mg2uPlayerList.push(bp.player);
    });

    if (this.fromClub)
      this.getBulkMembershipPromise()
        .then((data: any) => {
          if (data) {
            if (data.status === 'success') {
              if (data.clubMembership) this.filteredClubMembership = data.clubMembership;
              else this.filteredClubMembership = [];
            } else this.filteredClubMembership = [];
          } else this.filteredClubMembership = [];
        })
        .catch(error => {});
  }
  getBulkMembershipPromise() {
    return new Promise((resolve, reject) => {
      let _playerIds = [];
      if (this.billPlayerIds && this.billPlayerIds.length > 0)
        this.mg2uPlayerList.push(...this.billPlayerIds);
      this.mg2uPlayerList.forEach(p => {
        _playerIds.push(p.id);
      });
      this.mg2uPlayerList = this.mg2uPlayerList.filter(p => {
        return p;
      });

      let _clubId = this.bookingSlot.clubData.id;
      let _params = {
        playerId: _playerIds,
        pageSize: 200,
      };
      this.flightService.getFilteredClubMemberships(_clubId, _params).subscribe(
        async (data: any) => {
          if (data) {
            resolve({
              status: 'success',
              message: 'has membership',
              clubMembership: data.items,
            });
          } else {
            reject({
              status: 'failed',
              message: 'no club membership',
              clubMembership: null,
            });
          }
        },
        error => {
          reject({
            status: 'failed',
            message: 'no club membership',
            clubMembership: null,
          });
        },
        () => {}
      );
    });
  }

  checkBookingPlayer(playerInfo?: any): Promise<boolean> {
    let _playerOk: boolean;

    return new Promise<any>(resolve => {
      this.bookingSlot.bookingPlayers.forEach(async (tbp: TeeTimeBookingPlayer) => {
        if (tbp.player && tbp.player.id === playerInfo.id) {
          _playerOk = false;
          let alert = await this.alertCtrl
            .create({
              message: 'Player is already in the flight',
              buttons: ['Close'],
            })
            .then(res => {
              res.present();
              this.captchaResponse = null;
            });
        } else _playerOk = true;
      });
      resolve(_playerOk);
    });
  }
  addBulkPlayerToBooking(playerInfo?: any, sequence?: string, idx?: number) {
    let _players = playerInfo ? playerInfo.players : null;
    let slot = playerInfo ? playerInfo.slot : 0;
    let i = idx ? idx : 0;
    this.addMultiplayerToBooking({
      new: false,
      players: _players,
      playerId: _players[i].playerId,
      sequence: slot + i,
      playerDetails: playerInfo.playerDetails,
    })
      .then((result: any) => {
        if (result && result.status === 'success') {
          i++;
          if (i === _players.length - 1) {
            if (result.bookingSlot) {
              let _bookingSlot = result.bookingSlot;
              if (
                _bookingSlot.bookingStatus.toLowerCase() === 'paymentpartial' ||
                _bookingSlot.bookingStatus.toLowerCase() === 'paymentfull'
              ) {
                if (this.bookingType !== 'past') this.recalculateBookingPricing();
                this.getBookingItemizedBill(true);
                this.recalculateBookingPricing();
              } else {
                this.refreshBookingObject(_bookingSlot);
                this.recalculateBookingPricing();
              }
            }
          } else {
            this.addBulkPlayerToBooking(playerInfo, null, i);
          }
        }
      })
      .catch(() => {});
  }
  addMultiplayerToBooking(playerInfo?: any, sequence?: string) {
    return new Promise(async (resolve, reject) => {
      this.updatingPlayer = true;
      let loader = await this.loadingCtrl.create({
        showBackdrop: false,
        duration: 5000,
        message: 'Player found. Adding player...',
      });

      let _sequence = playerInfo ? playerInfo.sequence : null;
      let _bookingId = this.bookingSlot.id;
      let _playerInfo = playerInfo;
      let _currentPlayerId;
      loader.present().then(() => {
        this.flightService.addPlayerToBooking(_bookingId, _playerInfo, _sequence).subscribe(
          (data: any) => {
            if (!!data) {
              loader.dismiss().then(() => {
                let _bookingSlot = data;
                resolve({
                  status: 'success',
                  bookingSlot: _bookingSlot,
                  message: 'adding for ' + _bookingId,
                  data: data,
                });
              });
            }
          },
          error => {
            reject({
              status: 'failed',
              message: 'failed to add',
              error: error,
            });
          }
        );
      });
    });
  }

  async addPlayerToBooking(playerInfo?: any, sequence?: string, isLoader: boolean = true) {
    return new Promise(async (resolve, reject) => {
      this.updatingPlayer = true;
      let _sequence = playerInfo ? playerInfo.sequence : null;
      let _bookingId = this.bookingSlot.id;
      let _playerInfo = playerInfo;
      let _currentPlayerId;
      let loader = await this.loadingCtrl.create({
        showBackdrop: false,
        duration: 5000,
      });
      if (!isLoader) {
        this.flightService.addPlayerToBooking(_bookingId, _playerInfo, _sequence).subscribe(
          (data: any) => {
            if (data) {
              loader.dismiss().then(() => {
                let _bookingSlot = data;
                if (
                  _bookingSlot.bookingStatus.toLowerCase() === 'paymentpartial' ||
                  _bookingSlot.bookingStatus.toLowerCase() === 'paymentfull'
                ) {
                  if (this.bookingType !== 'past') this.recalculateBookingPricing(false, false);
                  this.getBookingItemizedBill(true);
                  this.recalculateBookingPricing(false, false);
                } else {
                  this.refreshBookingObject(data);
                  this.recalculateBookingPricing();
                }
              });
              resolve(true);
            }
          },
          error => {
            loader.dismiss();
            resolve(true);
          }
        );
      } else {
        loader.present().then(response => {
          this.flightService.addPlayerToBooking(_bookingId, _playerInfo, _sequence).subscribe(
            (data: any) => {
              if (data) {
                loader.dismiss().then(() => {
                  let _bookingSlot = data;
                  if (
                    _bookingSlot.bookingStatus.toLowerCase() === 'paymentpartial' ||
                    _bookingSlot.bookingStatus.toLowerCase() === 'paymentfull'
                  ) {
                    if (this.bookingType !== 'past') this.recalculateBookingPricing();
                    this.getBookingItemizedBill(true);
                    this.recalculateBookingPricing();
                  } else {
                    this.refreshBookingObject(data);
                    this.recalculateBookingPricing();
                  }
                });
                resolve(true);
              }
            },
            error => {
              loader.dismiss();
              resolve(true);
            }
          );
        });
      }
    });
  }

  getPlayerType(player: TeeTimeBookingPlayer) {
    if (player.playerType) return 'Player type here';
  }

  async onDeleteBookingPlayer(slot: number) {
    if (!this.getAllowUpdatePostPayment() && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Flight have started. Adding/Removing player is disabled.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.bookingSlot.bookingPlayers && this.bookingSlot.bookingPlayers.length === 1) {
      MessageDisplayUtil.showMessageToast(
        'Please add one or more players to the booking before removing this player.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _options = this.bookingOptions;
    let _currDate = moment();
    let _teeOffDate = moment(this.bookingSlot.slotAssigned.teeOffDate, 'YYYY-MM-DD'); ///.toDate()

    let _depositDone: boolean =
      this.bookingItemBill.totalPayment - this.bookingItemBill.totalRefund >=
      this.bookingSlot.depositPayable;
    let _beforeCutOff: boolean =
      _currDate < _teeOffDate.subtract(_options.depositCutOffDays, 'days');

    let _slotMinPlayers = this.bookingSlot.slotAssigned.minPlayers;
    let _isMinPlayers: boolean = this.bookingSlot.bookingPlayers.length <= _slotMinPlayers;
    if (!this.fromClub && _depositDone && !_beforeCutOff && _isMinPlayers) {
      let alert = await this.alertCtrl.create({
        header: 'Removing Player',
        message:
          'Slot needs min <b>' +
          _slotMinPlayers +
          '</b> players.<br>Please add another to the booking before removing this player.',
        buttons: [
          {
            text: 'Close',
          },
        ],
      });
      alert.present();
      return false;
    }
    let idx = slot - 1;
    let player = this.bookingSlot.bookingPlayers[idx];

    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'removePlayer',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('on dismiss ', data);
      if (data && data?.data === 'confirm') {
        // if(data?.data === 'success'){
        this.deleteBookingPlayer(player);
        this.captchaResponse = null;
        // }
      }
    });
  }

  async deleteBookingPlayer(player: TeeTimeBookingPlayer, isLodader: boolean = true) {
    this.updatingPlayer = true;
    let _bookingPlayerId = player.id;
    let _bookingId = this.bookingSlot.id;
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: isLodader ? 'Removing player...' : '',
    });

    if (!isLodader) {
      this.flightService.deletePlayerFromBooking(_bookingPlayerId).subscribe(
        (data: any) => {
          loader.dismiss().then(() => {
            if (data) {
              let _booking: TeeTimeBooking = data;
              let _isBookingPlayer;
              _isBookingPlayer = _booking.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
                if (p.player) return p.player.id === this.currentPlayerId;
                else return false;
              });
              if (
                _booking.bookingStatus.toLowerCase() === 'paymentpartial' ||
                _booking.bookingStatus.toLowerCase() === 'paymentfull'
              ) {
                this.getBookingItemizedBill(true, false);
                if (this.bookingType !== 'past') this.recalculateBookingPricing(false, false);
              } else {
                this.refreshBookingObject(data);
                this.recalculateBookingPricing(false, false);
              }
            }
          });
        },
        error => {
          let _error = error;
          let _msg;
          if (_error && _error.status === 500)
            _msg = 'Something went wrong with the server. If it insists, please contact admin.';
          MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
          return false;
        }
      );
    } else {
      loader.present().then(response => {
        this.flightService.deletePlayerFromBooking(_bookingPlayerId).subscribe(
          (data: any) => {
            loader.dismiss().then(() => {
              if (data) {
                let _booking: TeeTimeBooking = data;
                let _isBookingPlayer;
                _isBookingPlayer = _booking.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
                  if (p.player) return p.player.id === this.currentPlayerId;
                  else return false;
                });
                if (
                  _booking.bookingStatus.toLowerCase() === 'paymentpartial' ||
                  _booking.bookingStatus.toLowerCase() === 'paymentfull'
                ) {
                  this.getBookingItemizedBill(true, false);
                  if (this.bookingType !== 'past') this.recalculateBookingPricing(false, false);
                } else {
                  this.refreshBookingObject(data);
                  this.recalculateBookingPricing(false, false);
                }
              }
            });
          },
          error => {
            let _error = error;
            let _msg;
            if (_error && _error.status === 500)
              _msg = 'Something went wrong with the server. If it insists, please contact admin.';
            MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
            return false;
          }
        );
      });
    }
  }
  async deleteMultiBookingPlayer() {
    let _bookingId = this.bookingSlot.id;
    let _bookingPlayers = this.bookingSlot.bookingPlayers;
    let _playersCount = _bookingPlayers.length;
    let _deleteDone: boolean = false;
    _bookingPlayers.forEach((tbp: TeeTimeBookingPlayer, i: number) => {
      this.flightService.deletePlayerFromBooking(tbp.id).subscribe((data: any) => {
        if (data) _deleteDone = true;
      });
      if (_playersCount === i + 1) _deleteDone = true;
    });
    return await _deleteDone;
  }

  async onGetFlightClick() {
    let _bookingPlayers = this.bookingSlot.bookingPlayers;
    let _deleteMultiDone: boolean = false;
    const modal = await this.modalCtl.create({
      component: PlayerGroupsPage,
      componentProps: {
        selectAndReturn: true,
      },
    });
    modal.onDidDismiss().then((pg: any) => {
      if (pg) {
        this.flightService.addFromGroup(this.bookingSlot.id, pg.data.id).subscribe(data => {
          console.debug('add from group : ', data);
          if (data) {
            let _bookingSlot = data;
            this.refreshBookingObject(_bookingSlot);
            this.getBookingItemizedBill(false);
            this.recalculateBookingPricing();
          }
        });
      }
    });
    return await modal.present();
  }

  async onSaveFlightClick() {
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: SaveGroupPage,

      componentProps: {
        bookingPlayers: this.bookingSlot.bookingPlayers,
      },
    });

    await modal.present();

    modal.onDidDismiss().then(data => {
      if (data?.data) {
        if (data?.data?.groupName) this._createPlayerGroup(data?.data?.groupName);
        else {
          let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Group name');
          MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
        }
      } else {
        let _msg = 'Something went wrong with the server. If it insists, please contact admin.';
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
      }
    });
  }

  getPlayerSlotDetails(slot: number, attribute: string) {
    let _currentPlayer = this.bookingSlot.bookingPlayers;
    let idx = slot - 1;
    let _id;
    let _isMe: boolean =
      _currentPlayer[idx] &&
      _currentPlayer[idx].player &&
      _currentPlayer[idx].player.id === this.currentPlayerId
        ? true
        : false;
    if (_currentPlayer[idx] && _currentPlayer[idx].player)
      _id = '(#' + _currentPlayer[idx].player.id + ')';
    else _id = '';
    if (this.slotFilled(slot)) {
      switch (attribute) {
        case 'name':
          return _currentPlayer[idx].playerName;
        case 'isMe':
          return _isMe;
        case 'id':
          return _id;
        case 'image':
          if (_currentPlayer[idx] && !_currentPlayer[idx].player) return null;
          else
            return _currentPlayer[idx].player && _currentPlayer[idx].player.profile
              ? _currentPlayer[idx].player.profile
              : _currentPlayer[idx].player.image
                ? _currentPlayer[idx].player.image
                : null;
        case 'isContactComplete':
          let _newPlayer = _currentPlayer[idx].player ? false : true;
          if (_newPlayer)
            return (
              _currentPlayer[idx].playerContact && _currentPlayer[idx].playerContact.length > 0
            );
          else {
            let _currPlAddress = _currentPlayer[idx].player.address;
            if (!_currPlAddress) return;

            if (
              _currPlAddress.address1 &&
              _currPlAddress.state &&
              _currPlAddress.city &&
              _currPlAddress.postCode &&
              _currPlAddress.phone1
            )
              return true;
            else return false;
          }
        case 'discount':
          if (!_currentPlayer[idx].playerTypeUsed && _currentPlayer[idx].playerType) {
            if (0 && _currentPlayer[idx].playerType.id === 'MEMBER' && _currentPlayer[idx].player)
              return (
                '<span style="color:red">Rate: <b>' +
                _currentPlayer[idx].playerType.name +
                '</b> (' +
                this.getMembershipNumber(_currentPlayer[idx].player.playerId) +
                ')</span>'
              );
            else
              return (
                '<span style="color:red">Rate: <b>' +
                _currentPlayer[idx].playerType.name +
                '</b></span>'
              );
          } else if (_currentPlayer[idx].playerTypeUsed) {
            if (0 && _currentPlayer[idx].playerTypeUsed.id === 'MEMBER')
              return (
                '<span style="color:red">Rate: <b>' +
                _currentPlayer[idx].playerTypeUsed.name +
                '</b> (' +
                this.getMembershipNumber(_currentPlayer[idx].player.playerId) +
                ')</span>'
              );
            else
              return (
                '<span style="color:red">Rate: <b>' +
                _currentPlayer[idx].playerTypeUsed.name +
                '</b></span>'
              );
          } else return '<span style="color:red">No promotion</span>';
        case 'membershipNumber':
          if (_currentPlayer[idx] && _currentPlayer[idx].player)
            return this.getPlayerMembership(_currentPlayer[idx]);
          else return '';
        case 'affiliateMember':
          // console.debug("affiliate? ", idx, _currentPlayer, _currentPlayer[idx].affiliateMember?.membership)
          if (_currentPlayer[idx]?.affiliateMember)
            return (
              'Affiliate Member' + ' (' + _currentPlayer[idx].affiliateMember?.membership + ') '
            );
          else return '';
        case 'checkedInBy':
          if (_currentPlayer[idx] && _currentPlayer[idx].checkedInBy) {
            let _checkedInBy = _currentPlayer[idx].checkedInBy;
            let _checkedInAt = _currentPlayer[idx].checkedInAt;
            // + ' (#'+ _checkedInBy.id + ')'
            let _txt = '';
            _txt = 'Checked In By : ' + _checkedInBy.name;
            if (_checkedInAt)
              _txt +=
                '<br>Checked In At : ' +
                moment(_checkedInAt, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm A');
            return _txt;
          } else return '';
      }
    } else {
      switch (attribute) {
        case 'name':
          return 'Tap + or enter Mship / myG2u #';
        case 'id':
          return '';
        case 'isContactComplete':
          return false;
        case 'image':
          return '';
        case 'membershipNumber':
          if (_currentPlayer[idx] && _currentPlayer[idx].player)
            return this.getPlayerMembership(_currentPlayer[idx]);
          else return '';
        case 'affiliateMember':
          return '';
        case 'checkedInBy':
          return '-';
      }
    }
  }
  getPlayerMembership(bp: TeeTimeBookingPlayer) {
    if (!bp) return;
    if (bp && !bp.player) return;
    let _membershipNumber: string = '';
    if (this.filteredClubMembership)
      if (this.filteredClubMembership)
        this.filteredClubMembership
          .filter(cm => {
            return cm && cm.player && cm.player.id === bp.player.id;
          })
          .map(cm => {
            _membershipNumber = '(' + cm.membershipNo + ')';
          });
    return _membershipNumber;
  }
  getMembershipNumber(playerId: number) {
    let _clubMembership: ClubMembershipExtended = null;
    this.flightService.getPlayerMemberships(playerId).subscribe(
      async (membershipList: Array<ClubMembership>) => {
        if (membershipList) {
          membershipList
            .filter((ms: ClubMembershipExtended) => {
              return ms.club && ms.club.id === this.bookingSlot.clubData.id;
            })
            .map((ms: ClubMembershipExtended) => {
              _clubMembership = ms;
            });
        }
      },
      error => {
        if (error) return null;
      },
      () => {}
    );
    if (_clubMembership) return _clubMembership.membershipNumber;
  }
  slotFilled(slot: number) {
    let idx = slot - 1;
    return (
      this.bookingSlot.bookingPlayers.length > idx &&
      isPresent(this.bookingSlot.bookingPlayers[idx]) &&
      !this.bookingSlot.bookingPlayers[idx].playerRemoved
    );
  }
  canSaveFlight(): boolean {
    let count = this.bookingSlot?.bookingPlayers.length;
    return !this.groupSelected && count > 0;
  }

  private async _createPlayerGroup(groupName: string) {
    let playerIds = this.bookingSlot?.bookingPlayers
      .filter(p => {
        if (p.player && p.player.id) return p.player.id !== this.currentPlayerId;
        else return false;
      })
      .map(p => p.player.id);

    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      message: 'Saving player group...',
    });
    loader.present().then(response => {
      this.playerService.savePlayerGroup(groupName, playerIds).subscribe(
        (result: boolean) => {
          loader.dismiss(true).then(() => {
            let msg = 'The player group ' + groupName + ' saved successfully';
            MessageDisplayUtil.showMessageToast(msg, this.platform, this.toastCtl, 2000, 'bottom');
          });
        },
        error => {
          loader.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, 'Error saving player group');
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          });
        }
      );
    });
  }

  selectBuggy(b: BookingBuggy, playerIdx: number, buggyIdx: number) {
    this.bookingSlot.bookingPlayers[playerIdx].pairingNo = b.pairingNo;
    if (buggyIdx === 0) this.bookingSlot.bookingPlayers[playerIdx].walking = true;
    else this.bookingSlot.bookingPlayers[playerIdx].walking = false;
    this.flightService
      .updateBookingPlayerDetails(
        this.bookingSlot.id,
        this.bookingSlot.bookingPlayers[playerIdx],
        'pairing'
      )
      .subscribe((data: any) => {
        this.refreshBookingDetails();
      });
  }

  setBuggySeatings(b?: any) {
    let _maxAllowed = this.bookingSlot.slotAssigned.maxPlayersPerBuggy;
    let _prevBuggySlots: Array<BookingBuggy>;
    if (this.buggySlots.length > 1) _prevBuggySlots = [...this.buggySlots];
    this.buggySlots = [];
    this.buggySlots[0] = {
      buggySlot: 0,
      driving: false,
      pairingNo: 0,
      walking: true,
      maxAllowed: 99,
      totalPlayers: 0,
    };
    for (var i = 1; i <= this.buggyReq; i++) {
      this.buggySlots.push(
        Object.assign({}, this.buggySlots[i], {
          buggySlot: i,
          pairingNo: i,
          walking: false,
          driving: false,
          maxAllowed: _maxAllowed,
          totalPlayers: 0,
        })
      );
    }
    //
  }

  setCaddyPairings(c?: any) {
    this.caddySlots = [];
    this.caddySlots[0] = {
      caddyPairing: 0,
      caddyRequired: false,
      caddyPreferred: null,
      caddyRequested: false,
      caddySelectionCriteria: null,
    };

    for (var i = 1; i <= this.caddyReq; i++) {
      this.caddySlots.push(
        Object.assign({}, this.caddySlots[0], {
          caddyRequired: false,
          caddyPreferred: null,
          caddyRequested: false,
          caddySelectionCriteria: null,
          caddyPairing: i,
          caddyAssigned: null,
        })
      );
    }

    this.caddySlots.forEach(c => {
      this.caddyPairing
        .filter(cp => {
          return cp.caddyPairing === c.caddyPairing;
        })
        .map(cp => {
          c.caddyPreferred = cp.caddyPreferred;
        });
    });
  }

  async setCaddyPairing(b: any, event) {
    if (
      this.bookingSlot &&
      !this.bookingSlot.slotAssigned.allowWalking &&
      this.bookingSlot.bookingPlayers[b] &&
      (this.bookingSlot.bookingPlayers[b].pairingNo === 0 ||
        !this.bookingSlot.bookingPlayers[b].pairingNo)
    ) {
      let msg = MessageDisplayUtil.getErrorMessage('', 'Please select a buggy first');
      MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
      return false;
    }
    this.caddySlots = [];
    this.caddySlots[0] = {
      caddyPairing: 0,
      caddyRequired: false,
      caddyPreferred: null,
      caddyRequested: false,
      caddySelectionCriteria: null,
      caddyAssigned: null,
    };

    for (var i = 1; i <= this.caddyReq; i++) {
      this.caddySlots.push(
        Object.assign({}, this.caddySlots[i], {
          caddyRequired: false,
          caddyPreferred: null,
          caddyRequested: false,
          caddySelectionCriteria: null,
          caddyPairing: i,
          caddyAssigned: null,
        })
      );
    }

    this.caddySlots.forEach(c => {
      this.caddyPairing
        .filter(cp => {
          return cp.caddyPairing === c.caddyPairing;
        })
        .map(cp => {
          c.caddyPreferred = cp.caddyPreferred;
        });
    });
    const popover: any = await this.popoverCtl.create({
      component: BuggySeatingPage,
      componentProps: {
        type: 'caddy',
        headerName: 'Caddy Pairing',
        caddies: this.caddySlots,
        pairing: this.caddyPairing,
      },
      showBackdrop: true,
    });
    popover.onDidDismiss().then((data: any) => {
      let _currentCaddy;
      let _currentBuggy;
      _currentBuggy = this.bookingSlot.bookingPlayers[b].pairingNo;
      _currentCaddy = this.bookingSlot.bookingPlayers[b].caddyPairing;
      let _caddyNo;
      let _caddyCount;
      let _maxAllowedCaddy = this.bookingSlot.slotAssigned.maxPlayersPerCaddy;
      let _caddyBuggySuccess = true;

      if (!!data?.data && data?.data?.selected) {
        if (data?.data?.caddy?.caddyPairing !== 0) {
          _caddyBuggySuccess = this.bookingSlot.bookingPlayers
            .filter((player: TeeTimeBookingPlayer, idx: number) => {
              return player.caddyPairing === data.caddy.caddyPairing;
            })
            .every((p: TeeTimeBookingPlayer, currIdx, nextP: Array<TeeTimeBookingPlayer>) => {
              if (p.pairingNo !== _currentBuggy) return false;
              else return true;
            });

          _caddyCount = this.bookingSlot.bookingPlayers.filter(
            (player: TeeTimeBookingPlayer, idx: number) => {
              return player.caddyPairing === data.caddy.caddyPairing && idx !== b;
            }
          ).length;
          if (_caddyCount >= _maxAllowedCaddy) {
            MessageDisplayUtil.showMessageToast(
              'Selected Caddie is fully utilized',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
          if (!_caddyBuggySuccess) {
            MessageDisplayUtil.showMessageToast(
              'Caddy is paired in different bugggy',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        }
        let i = data?.data?.caddy?.caddyPairing;
        this.bookingSlot.bookingPlayers[b].caddyPairing = i;
        this.bookingSlot.bookingPlayers.forEach((p, idx) => {
          if (p.caddyPairing === data?.data?.caddy?.caddyPairing)
            this.setCaddySlot(idx, p.caddyPairing);
        });
      }
    });
    popover.present({
      ev: event,
    });
  }

  setCaddySlot(playerIdx: number, i: number) {
    let _caddyRequired: boolean = true;
    if (this.caddyRemoveFlag) _caddyRequired = false;
    this.buggyCaddyPreference.ignoreBuggyUpdate = true;
    this.buggyCaddyPreference.ignoreCaddieUpdate = false;
    this.buggyCaddyPreference.playerPairings
      .filter((p: PlayerBuggyCaddiePreference) => {
        return p.bookingPlayerId === this.bookingSlot.bookingPlayers[playerIdx].id;
      })
      .map((p: PlayerBuggyCaddiePreference) => {
        p.caddyPairing = i;
        if (i > 0) p.caddyRequired = _caddyRequired;
        else p.caddyRequired = false;
        p.caddiePreferred =
          this.caddyPairing[i] && this.caddyPairing[i].caddyPreferred
            ? this.caddyPairing[i].caddyPreferred.id
            : null;
      });

    this.onProcessBuggyCaddyPref(this.buggyCaddyPreference)
      .then((res: any) => {
        if (res && res.status === 'success') {
          this.refreshBookingObject(res.data);
          this.caddyRemoveFlag = false;
        }
      })
      .catch(error => {});
  }

  getBuggySlot(b: BookingBuggy, i: number) {
    let _textWalk = 'Walking';
    if (this.getWalkingOrOwnBuggyNaming('walking'))
      _textWalk = this.getWalkingOrOwnBuggyNaming('walking');
    if (i === 0) return _textWalk;
    else return 'Buggy #' + b.buggySlot;
  }
  getBuggySlotDisplay(playeridx: number) {
    let _textWalk = 'Walking';
    if (this.getWalkingOrOwnBuggyNaming('walking'))
      _textWalk = this.getWalkingOrOwnBuggyNaming('walking');
    let i = this.bookingSlot.bookingPlayers[playeridx].pairingNo;
    if (i === 0 || i === null || !i) return _textWalk;
    else return 'Buggy #' + i;
  }
  getCaddySlot(c: BookingCaddy, i: number, playerIdx: number, attribute: string) {
    switch (attribute) {
      case 'slot':
        return '#' + (i + 1);
      case 'name':
        let _name;
        let _id;
        if (this.caddyPairing[i] && this.caddyPairing[i].caddyPreferred) {
          _name = ' - ' + this.caddyPairing[i].caddyPreferred.firstName;
        } else _name = '';
        if (this.caddyPairing[i] && this.caddyPairing[i].caddyPreferred) {
          _id = ' (' + this.caddyPairing[i].caddyPreferred.id + ')';
        } else _id = '';
        return _name + _id;
    }
  }

  async removeCaddyPairing(i: number, playerIdx: number) {
    let alert = await this.alertCtrl
      .create({
        header: 'Remove Caddy Pairing from Player',
        message: 'This will remove caddy pairing from player.',
        buttons: [
          {
            text: 'Cancel',
          },
          {
            text: 'Remove caddy',
            handler: () => {
              this.flightService
                .updateBookingPlayerDetails(
                  this.bookingSlot.id,
                  this.bookingSlot.bookingPlayers[playerIdx],
                  'removeCaddy'
                )
                .subscribe((updatePlayerDetails: any) => {
                  this.refreshBookingDetails();
                });
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  async setBuggySeating(b: any, event) {
    const popover: any = await this.popoverCtl.create({
      component: BuggySeatingPage,
      // cssClass: 'popover_setting',
      componentProps: {
        type: 'buggy',
        headerName: 'Buggy Seating',
        buggies: this.buggySlots,
        slot: this.bookingSlot,
        bookingOptions: this.bookingOptions ? this.bookingOptions : null,
      },
      showBackdrop: true,
    });
    popover.onDidDismiss().then((data: any) => {
      let _buggyNo;
      let _buggyCount;
      let _maxAllowedBuggy = this.bookingSlot.slotAssigned.maxPlayersPerBuggy;
      let _currentPairingNo;
      if (data?.data && data?.data?.selected) {
        _buggyCount = this.bookingSlot.bookingPlayers.filter(
          (player: TeeTimeBookingPlayer, idx: number) => {
            return player.pairingNo === data?.data?.buggy.pairingNo && idx !== b;
          }
        ).length;
        if (data?.data?.buggy.pairingNo !== 0 && _buggyCount >= _maxAllowedBuggy) {
          MessageDisplayUtil.showMessageToast(
            'Selected Buggy is fully utilized',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          return false;
        }
        _buggyNo = data?.data?.buggy.buggySlot;
        this.buggySlots[_buggyNo].totalPlayers += 1;
        this.bookingSlot.bookingPlayers[b].buggyId = _buggyNo;
        this.bookingSlot.bookingPlayers[b].pairingNo = _buggyNo;
        if (data?.data?.buggy.pairingNo === 0) this.bookingSlot.bookingPlayers[b].driving = false;
        this.buggyCaddyPreference.ignoreBuggyUpdate = false;
        this.buggyCaddyPreference.ignoreCaddieUpdate = true;
        this.buggyCaddyPreference.playerPairings
          .filter((p: PlayerBuggyCaddiePreference) => {
            return p.bookingPlayerId === this.bookingSlot.bookingPlayers[b].id;
          })
          .map((p: PlayerBuggyCaddiePreference) => {
            p.buggyPairing = data?.data?.buggy.pairingNo;
            p.buggyRequired = data?.data?.buggy.pairingNo > 0 ? true : false;
            p.caddiePreferred = this.bookingSlot.bookingPlayers[b].caddyPreferred
              ? this.bookingSlot.bookingPlayers[b].caddyPreferred.id
              : null;
            p.caddieAssigned = this.bookingSlot.bookingPlayers[b].caddyAssigned
              ? this.bookingSlot.bookingPlayers[b].caddyAssigned.id
              : null;
            if (this.bookingSlot.bookingPlayers[b].caddyPairing > 0) p.caddyRequired = true;
            else p.caddyRequired = false;
            p.caddyPairing = this.bookingSlot.bookingPlayers[b].caddyPairing;
            if (data?.data?.buggy.pairingNo === 0) p.driving = false;
          });

        this.onProcessBuggyCaddyPref(this.buggyCaddyPreference)
          .then((res: any) => {
            if (res && res.status === 'success') {
              this.refreshBookingObject(res.data);
            }
          })
          .catch(error => {});
      }
    });
    popover.present({
      ev: event,
    });
  }

  addBuggy(x: number) {
    if (this.teeSlotNew) {
      if (x < 0 && this.buggyReq === 0) return false;
      else if (x > 0 && this.buggyReq == this.playerReq) return false;
      else this.buggyReq += x;
    } else {
      let _uniqBuggy = this.getUnique(this.bookingSlot.bookingPlayers, 'pairingNo');
      _uniqBuggy = _uniqBuggy.filter(ub => {
        return ub.pairingNo > 0;
      });
      if (x < 0 && this.buggyReq === 0) return false;
      else if (x > 0 && this.buggyReq == this.bookingSlot.bookingPlayers.length) return false;
      else this.buggyReq += x;
      this.setBuggySeatings();
      this.onUpdateBuggyCaddyPrefence('buggy');
    }
  }
  onUpdateBuggyCaddyPrefence(attribute?: string) {
    let _maxBuggyPlayers = this.bookingOptions.maxPlayersPerBuggy;
    let _maxCaddyPlayers = this.bookingOptions.maxPlayersPerCaddy;
    let _preference = this.newBuggyCaddyPreference;
    let _playerCount = this.bookingSlot.bookingPlayers.length;
    if (attribute === 'buggy') {
      _preference.ignoreBuggyUpdate = false;
      if (this.buggyReq === _playerCount) {
        this.bookingSlot.bookingPlayers.forEach((bp, i) => {
          bp.pairingNo = 0;
          bp.buggyCaddiePreference.buggyType = null;
          this.selectedBuggyType[i] = null;
        });
        _preference.playerPairings.forEach(pp => {
          pp.buggyPairing = 0;
          pp.buggyRequired = false;
          pp.buggyType = null;
        });
        for (let i = 1; i <= this.buggyReq; i++) {
          this.bookingSlot.bookingPlayers.forEach((bp, idx) => {
            if (bp.pairingNo === 0) {
              if (idx + 1 === i) {
                _preference.playerPairings[idx].buggyPairing = i;
                _preference.playerPairings[idx].buggyRequired = true;
                bp.pairingNo = i;
              }
            }
          });
        }
      } else {
        let _count = [];
        let _xxx = Math.floor(_playerCount / _maxBuggyPlayers);
        let _zzz = _playerCount % _maxBuggyPlayers;
        for (let ii = 0; ii < _xxx; ii++) {
          _count.push(_maxBuggyPlayers);
        }
        if (_zzz > 0) _count.push(1);
        if (Math.floor(_playerCount / _maxBuggyPlayers) < this.buggyReq) {
          let _div = Math.floor(_playerCount / _maxBuggyPlayers);

          let _remaining = this.buggyReq - _div;

          for (let r = 0; r < _remaining; r++) {
            this.bookingSlot.bookingPlayers
              .slice()
              .reverse()
              .forEach((bp, idx, arr) => {
                if (idx === r) {
                  let _newIdx = arr.length - idx - 1;

                  _preference.playerPairings[_newIdx].buggyPairing = this.buggyReq - r;
                  _preference.playerPairings[_newIdx].buggyRequired = true;
                  bp.pairingNo = this.buggyReq - r;
                }
              });
          }
        } else {
          this.bookingSlot.bookingPlayers.forEach((bp, i) => {
            bp.pairingNo = 0;
            bp.buggyCaddiePreference.buggyType = null;
            this.selectedBuggyType[i] = null;
          });
          _preference.playerPairings.forEach(pp => {
            pp.buggyPairing = 0;
            pp.buggyRequired = false;
            pp.buggyType = null;
          });
          _count.forEach((c, index) => {
            for (let i = 1; i <= this.buggyReq; i++) {
              this.bookingSlot.bookingPlayers.forEach((bp, idx) => {
                if (bp.pairingNo === 0) {
                  if (idx < i * c) {
                    _preference.playerPairings[idx].buggyPairing = i;
                    _preference.playerPairings[idx].buggyRequired = true;
                    bp.pairingNo = i;
                  }
                }
              });
            }
          });
        }
      }
    } else if (attribute === 'caddy') {
      _preference.ignoreCaddieUpdate = false;
      if (this.caddyReq === _playerCount) {
        this.bookingSlot.bookingPlayers.forEach(bp => {
          bp.caddyPairing = 0;
        });
        _preference.playerPairings.forEach(pp => {
          pp.caddyPairing = 0;
          pp.caddyRequired = false;
        });
        for (let i = 1; i <= this.caddyReq; i++) {
          this.bookingSlot.bookingPlayers.forEach((bp, idx) => {
            if (bp.caddyPairing === 0) {
              if (idx + 1 === i) {
                _preference.playerPairings[idx].caddyPairing = i;
                _preference.playerPairings[idx].caddyRequired = true;
                bp.caddyPairing = i;
              }
            }
          });
        }
      } else {
        let _count = [];
        let _xxx = Math.floor(_playerCount / _maxCaddyPlayers);
        let _zzz = _playerCount % _maxCaddyPlayers;
        for (let ii = 0; ii < _xxx; ii++) {
          _count.push(_maxCaddyPlayers);
        }
        if (_zzz > 0) _count.push(1);
        if (Math.floor(_playerCount / _maxCaddyPlayers) < this.caddyReq) {
          let _div = Math.floor(_playerCount / _maxCaddyPlayers);

          let _remaining = this.caddyReq - _div;

          for (let r = 0; r < _remaining; r++) {
            this.bookingSlot.bookingPlayers
              .slice()
              .reverse()
              .forEach((bp, idx) => {
                if (idx === r) {
                  _preference.playerPairings[idx].caddyPairing = this.caddyReq - r;
                  _preference.playerPairings[idx].caddyRequired = true;
                  if (this.assignmentDone) {
                    _preference.playerPairings[idx].caddyAssigned = null;
                    _preference.playerPairings[idx].caddieAssigned = null;
                  }
                  bp.caddyPairing = this.caddyReq - r;
                }
              });
          }
        } else {
          this.bookingSlot.bookingPlayers.forEach(bp => {
            bp.caddyPairing = 0;
          });
          _preference.playerPairings.forEach(pp => {
            pp.caddyPairing = 0;
            pp.caddyRequired = false;
          });
          _count.forEach((c, index) => {
            for (let i = 1; i <= this.caddyReq; i++) {
              this.bookingSlot.bookingPlayers.forEach((bp, idx) => {
                if (bp.caddyPairing === 0) {
                  if (idx < i * c) {
                    _preference.playerPairings[idx].caddyPairing = i;
                    _preference.playerPairings[idx].caddyRequired = true;
                    if (this.assignmentDone) {
                      _preference.playerPairings[idx].caddyAssigned = null;
                      _preference.playerPairings[idx].caddieAssigned = null;
                    }
                    bp.caddyPairing = i;
                  }
                }
              });
            }
          });
        }
      }
    }
  }

  isClubDisableCaddies(attribute?: string) {
    if (!this.appAttribute) return;
    if (this.appAttribute && !this.appAttribute.clubDisableCaddies) return;
    if (this.fromClub) return;
    if (!attribute) return;
    let _clubDisableCaddies: boolean = false;
    let _clubMessage: string =
      'Club currently disables caddies selection. Please contact club for further information';
    let _requiredOrWarning: string;
    let _clubId;
    if (!this.teeSlotNew) _clubId = this.bookingSlot.clubData.id;
    else if (this.teeSlotNew)
      _clubId =
        this.clubs && this.clubs.club && this.clubs.club.id
          ? this.clubs.club.id
          : this.clubInfo.clubId;
    this.appAttribute.clubDisableCaddies
      .filter(cdc => {
        return cdc && cdc.clubId === _clubId;
      })
      .map(cdc => {
        if (cdc && cdc.clubId === _clubId) _clubDisableCaddies = true;
        _clubMessage = cdc.message;
        _requiredOrWarning = cdc.requiredOrWarning;
      });
    if (attribute === 'isDisable') return _clubDisableCaddies;
    else if (attribute === 'message') return _clubMessage;
    else if (attribute === 'requiredOrWarning') return _requiredOrWarning;
  }

  addCaddy(x: number) {
    if (!this.fromClub && this.isClubDisableCaddies('isDisable')) {
      let _msg;
      if (!this.isClubDisableCaddies('message'))
        _msg =
          'Club currently disables caddies selection. Please contact club for further information';
      else _msg = this.isClubDisableCaddies('message');
      MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }
    if (this.teeSlotNew) {
      if (x < 0 && this.caddyReq === 0) return false;
      else if (x > 0 && this.caddyReq == this.playerReq) return false;
      else this.caddyReq += x;
    } else {
      let _uniqCaddy = this.getUnique(this.bookingSlot.bookingPlayers, 'caddyPairing');
      _uniqCaddy = _uniqCaddy.filter(uc => {
        return uc.caddyPairing > 0;
      });
      if (x < 0 && this.caddyReq === 0) return false;
      else if (x > 0 && this.caddyReq === this.bookingSlot.bookingPlayers.length) return false;
      else this.caddyReq += x;
      this.setCaddyPairings();
      this.onUpdateBuggyCaddyPrefence('caddy');
    }
  }

  addPlayers(x: number) {
    if (x < 0 && this.playerReq === this.teeTimeSlotDisplay.slot.minPlayers) return false;
    else if (x > 0 && this.playerReq == this.teeTimeSlotDisplay.slot.maxPlayers) return false;
    else this.playerReq += x;
    this.addBookingPlayers(x);
  }

  memberReq: number = 1;
  guestReq: number = 0;
  addNewPlayers(x: number, member: boolean = false) {
    console.debug('adding new players ', x, member, this.guestReq, this.memberReq);
    if (!member && this.guestReq === 0 && x < 0) return false;
    else if (member && this.memberReq === 1 && x < 0) return false;
    if (x < 0 && this.playerReq === this.teeTimeSlotDisplay.slot.minPlayers) return false;
    else if (x > 0 && this.playerReq == this.teeTimeSlotDisplay.slot.maxPlayers) return false;
    else {
      if (member) this.memberReq += x;
      else this.guestReq += x;
      this.playerReq = this.memberReq + this.guestReq;
    }
    this.addBookingPlayers(x, member);
  }

  onSelectCaddy(playerIdx: number, _caddyNo?: number) {
    if (
      this.bookingSlot.bookingPlayers[playerIdx].caddyPairing === 0 ||
      this.bookingSlot.bookingPlayers[playerIdx].caddyPairing === null
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please select Caddy Pairing first',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    this.selectCaddy(playerIdx, _caddyNo);
  }

  async selectCaddy(playerIdx: number, caddyNo?: number) {
    let caddiesToExclude = this.caddyPairing;
    let _caddyNo = caddyNo;

    if (this.caddyReq === 0) {
      let alert = await this.alertCtrl
        .create({
          header: 'Preferred Caddy',
          message: 'Please add a caddy number above.',
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
          this.captchaResponse = null;
        });
      return false;
    }
    const modal = await this.modalCtl.create({
      component: CaddyListPage,
      componentProps: {
        clubId: this.bookingSlot.clubData.id,
        fromBooking: true,
        bookingCurrDate: this.bookingSlot.slotAssigned.teeOffDate,
        caddiesToExclude: caddiesToExclude,
        bookingId: this.bookingSlot.id,
      },
    });
    let _bookingPlayers = this.bookingSlot.bookingPlayers;
    modal.onDidDismiss().then((data: any) => {
      if (!!data?.data && data?.data?.selected) {
        if (data?.data?.caddy && !data?.data?.caddySelectionCriteria) {
          this.bookingSlot.bookingPlayers[playerIdx].caddyPreferred = data?.data?.caddy;
          this.bookingSlot.bookingPlayers[playerIdx].caddyPairing = _caddyNo;
          this.caddyPairing[_caddyNo] = {
            caddyPreferred: data?.data?.caddy,
            caddyPairing: _caddyNo,
            caddySelectionCriteria: data?.data?.caddySelectionCriteria,
            caddyRequired: _caddyNo > 0 ? true : false,
          };
          this.bookingSlot.bookingPlayers.forEach((p, i) => {
            if (p.caddyPairing === this.caddyPairing[_caddyNo].caddyPairing)
              this.setCaddySlot(i, p.caddyPairing);
          });
        } else if (!data?.data?.caddy && data?.data?.caddySelectionCriteria) {
          this.bookingSlot.bookingPlayers[playerIdx].caddyPairing = _caddyNo;
          this.bookingSlot.bookingPlayers[playerIdx].caddyPreferred = data?.data?.caddy;
          this.bookingSlot.bookingPlayers[playerIdx].caddySelectionCriteria =
            data?.data?.caddySelectionCriteria;

          this.caddyPairing[_caddyNo] = {
            caddyPreferred: data?.data?.caddy,
            caddyPairing: _caddyNo,
            caddySelectionCriteria: data?.data?.caddySelectionCriteria,
            caddyRequired: _caddyNo > 0 ? true : false,
          };
          this.bookingSlot.bookingPlayers.forEach((p, i) => {
            if (p.caddyPairing === this.caddyPairing[_caddyNo].caddyPairing)
              this.setCaddySlot(i, p.caddyPairing);
          });
        }
      } else if (!!data?.data && !data?.data?.selected) {
        this.caddyPairing[_caddyNo] = {
          caddyPreferred: null,
          caddySelectionCriteria: null,
        };
        this.bookingSlot.bookingPlayers.forEach((p, i) => {
          if (p.caddyPairing === this.caddyPairing[_caddyNo].caddyPairing)
            this.setCaddySlot(i, p.caddyPairing);
        });
      }
    });
  }

  removeCaddy(playerIdx?: number, caddyNo?: number) {
    //
    this.caddyRemoveFlag = true;
    this.caddyPairing
      .filter((cp: BookingCaddy) => {
        return cp.caddyPairing === caddyNo;
      })
      .map(cp => {
        cp.caddyPairing = 1;
        cp.caddyPreferred = null;
        cp.caddySelectionCriteria = null;
        cp.caddyRequired = false;
      });

    this.bookingSlot.bookingPlayers[playerIdx].caddyPairing = caddyNo;
    this.bookingSlot.bookingPlayers.forEach((p, idx) => {
      if (this.caddyPairing[caddyNo] && p.caddyPairing === this.caddyPairing[caddyNo].caddyPairing)
        p.caddyPreferred = null;
      p.caddySelectionCriteria = null;
      this.setCaddySlot(idx, p.caddyPairing);
    });
  }

  getCaddyAssigned(x: number, attribute?: string) {
    if (
      !this.bookingSlot ||
      (this.bookingSlot && !this.bookingSlot.bookingPlayers[x].caddyAssigned)
    )
      return false;
    let _name;
    if (
      this.bookingSlot &&
      this.bookingSlot.bookingPlayers[x].caddyAssigned &&
      this.bookingSlot.bookingPlayers[x].caddyAssigned.firstName
    )
      _name = this.bookingSlot.bookingPlayers[x].caddyAssigned.firstName;
    else _name = '';
    switch (attribute) {
      case 'name':
        return _name + ' #' + this.bookingSlot.bookingPlayers[x].caddyAssigned.staffId;
      case 'has':
        if (this.bookingSlot && this.bookingSlot.bookingPlayers[x].caddyAssigned) return true;
    }
  }

  getCaddyPreferred(b: number, attribute?: string) {
    let _caddy;
    let _caddyDisplay: Array<CaddyData>;
    let _caddyType;
    let _caddyDisplayCriteria: Array<CaddySelectionCriteria>;
    if (this.bookingSlot.bookingPlayers[b].caddyPreferred) {
      _caddyType = 'favourite';
    } else if (
      this.bookingSlot.bookingPlayers[b].caddySelectionCriteria &&
      this.bookingSlot.bookingPlayers[b].caddySelectionCriteria.gender &&
      !this.bookingSlot.bookingPlayers[b].caddyPreferred
    ) {
      _caddyType = 'criteria';
    }
    let _caddyPairing;
    let __caddy;
    let _name;
    let _playerPairings = this.newBuggyCaddyPreference.playerPairings
      .map(p => {
        return p;
      })
      .filter(pp => {
        return pp.bookingPlayerId === this.bookingSlot.bookingPlayers[b].id;
      });
    switch (attribute) {
      case 'hasCaddy':
        _caddyPairing = this.bookingSlot.bookingPlayers[b].caddyPairing;
        if (
          _playerPairings[0].caddyPairing === _caddyPairing &&
          this.bookingSlot.bookingPlayers[b].caddyPreferred
        )
          _caddy = true;
        else _caddy = false;
        if (!this.caddyPairing[_caddyPairing].caddyPreferred) return false;
        return _caddy;
      case 'name':
        _caddyPairing = this.bookingSlot.bookingPlayers[b].caddyPairing;
        if (
          this.bookingSlot &&
          this.bookingSlot.bookingPlayers[b].caddyPreferred &&
          this.bookingSlot.bookingPlayers[b].caddyPreferred.firstName
        )
          _name = this.bookingSlot.bookingPlayers[b].caddyPreferred.firstName;
        else _name = '';
        if (
          _playerPairings[0].caddyPairing === _caddyPairing &&
          this.bookingSlot.bookingPlayers[b].caddyPreferred
        )
          _caddy = _name + ' #' + this.bookingSlot.bookingPlayers[b].caddyPreferred.staffId;
        else _caddy = 'Select Favourite Caddy';
        return _caddy;
      case 'pairing':
        if (this.bookingSlot.bookingPlayers[b].caddyPairing) {
          return 'Caddy #' + this.bookingSlot.bookingPlayers[b].caddyPairing;
        } else if (this.bookingSlot.bookingPlayers[b].caddyPairing === 0) return 'No Caddy';
        else return 'Tap here to select';
      case 'pairing_no':
        if (this.bookingSlot.bookingPlayers[b].caddyPairing) {
          return '# ' + this.bookingSlot.bookingPlayers[b].caddyPairing;
        } else if (this.bookingSlot.bookingPlayers[b].caddyPairing === 0) return 'No Caddy';
        else return 'Tap here to select';
      case 'slot_pairing':
        if (_caddyType === 'favourite') {
          _caddyDisplay = this.caddyPairing
            .filter((c: CaddyPairing) => {
              return this.bookingSlot.bookingPlayers[b].caddyPairing === c.caddyPairing;
            })
            .map((c: CaddyPairing) => {
              if (c.caddyPreferred) return c.caddyPreferred;
              else return null;
            });
          if (
            this.bookingSlot.bookingPlayers[b].caddyPairing &&
            _caddyDisplay[0] &&
            _caddyDisplay[0].firstName
          )
            return (
              '(' +
              this.bookingSlot.bookingPlayers[b].caddyPairing +
              ') ' +
              _caddyDisplay[0].firstName
            );
          else return '';
        } else if (_caddyType === 'criteria') {
          _caddyDisplayCriteria = this.caddyPairing
            .filter((c: CaddyPairing) => {
              return this.bookingSlot.bookingPlayers[b].caddyPairing === c.caddyPairing;
            })
            .map((c: CaddyPairing) => {
              if (c.caddySelectionCriteria) return c.caddySelectionCriteria;
              else return null;
            });
          if (
            this.bookingSlot.bookingPlayers[b].caddySelectionCriteria &&
            _caddyDisplayCriteria[0] &&
            _caddyDisplayCriteria[0].gender
          )
            return _caddyDisplayCriteria[0].gender === 'F'
              ? 'Female'
              : 'Male' +
                  ', Age btwn ' +
                  _caddyDisplayCriteria[0].minAge +
                  ' and ' +
                  _caddyDisplayCriteria[0].maxAge;
          else return '';
        }
      case 'id':
        return this.bookingSlot.bookingPlayers[b] &&
          this.bookingSlot.bookingPlayers[b].caddyPreferred.staffId
          ? '#' + this.bookingSlot.bookingPlayers[b].caddyPreferred.staffId
          : '';
      case 'slot_pairing_id':
        _caddyDisplay = this.caddyPairing
          .filter((c: CaddyPairing) => {
            return this.bookingSlot.bookingPlayers[b].caddyPairing === c.caddyPairing;
          })
          .map((c: CaddyPairing) => {
            if (c.caddyPreferred) return c.caddyPreferred;
            else return null;
          });
        if (
          this.bookingSlot.bookingPlayers[b].caddyPairing &&
          _caddyDisplay[0] &&
          _caddyDisplay[0].firstName
        )
          return '(#' + _caddyDisplay[0].staffId + ')';
        else return '';
      default:
        if (this.bookingSlot.bookingPlayers[b].caddyPairing) {
          return '# ' + this.bookingSlot.bookingPlayers[b].caddyPairing;
        } else return 'No';
    }
  }

  checkBuggyCaddyInfo(playerIdx: number, slot?: number) {
    if (
      this.bookingSlot.bookingPlayers[playerIdx] &&
      this.bookingSlot.bookingPlayers[playerIdx].pairingNo
    )
      return true;
    else if (
      this.bookingSlot.bookingPlayers[playerIdx] &&
      this.bookingSlot.bookingPlayers[playerIdx].caddyPairing
    )
      return true;
    else if (
      this.bookingSlot.bookingPlayers[playerIdx] &&
      (this.bookingSlot.bookingPlayers[playerIdx].caddyPreferred ||
        this.bookingSlot.bookingPlayers[playerIdx].caddySelectionCriteria)
    )
      return true;
    else return false;
  }

  tPD(event) {
    //
  }
  togglePlayerDriving(b: any, p: TeeTimeBookingPlayer, driving?: string) {
    this.playerDriving[b] = driving;
  }

  setPlayerDriving(b: any, p: TeeTimeBookingPlayer, driving?: string) {
    if (
      this.bookingSlot &&
      this.bookingSlot.slotAssigned.allowWalking &&
      this.bookingSlot.bookingPlayers[b].pairingNo === 0
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please select a buggy first',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else if (
      this.bookingSlot &&
      !this.bookingSlot.slotAssigned.allowWalking &&
      this.bookingSlot.bookingPlayers[b].pairingNo === 0
    ) {
      MessageDisplayUtil.showMessageToast(
        'Buggy is required for this slot. Please select a buggy.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.bookingType === 'past') return false;
    let _playerIsDriving;
    let _otherPlayer = this.bookingSlot.bookingPlayers.filter((pd: TeeTimeBookingPlayer) => {
      if (
        pd.pairingNo === this.bookingSlot.bookingPlayers[b].pairingNo &&
        this.bookingSlot.bookingPlayers[b].id !== pd.id
      )
        return true;
    });
    if (driving === 'me') {
      _playerIsDriving = true;
      this.bookingSlot.bookingPlayers[b].driving = _playerIsDriving;
    } else if (driving === 'other') {
      _playerIsDriving = false;
      this.bookingSlot.bookingPlayers[b].driving = _playerIsDriving;
    } else {
      _playerIsDriving = this.bookingSlot.bookingPlayers[b].driving;
      if (_otherPlayer && _otherPlayer[0]) _otherPlayer[0].driving = _playerIsDriving;
      this.bookingSlot.bookingPlayers[b].driving = !_playerIsDriving;
    }
    this.buggyCaddyPreference.ignoreBuggyUpdate = false;
    this.buggyCaddyPreference.ignoreCaddieUpdate = true;
    this.buggyCaddyPreference.playerPairings
      .filter((p: PlayerBuggyCaddiePreference) => {
        return p.bookingPlayerId === this.bookingSlot.bookingPlayers[b].id;
      })
      .map((p: PlayerBuggyCaddiePreference) => {
        p.driving = !_playerIsDriving;
      });

    if (_otherPlayer && _otherPlayer[0]) {
      this.buggyCaddyPreference.playerPairings
        .filter((p: PlayerBuggyCaddiePreference) => {
          return p.bookingPlayerId === _otherPlayer[0].id;
        })
        .map((p: PlayerBuggyCaddiePreference) => {
          p.driving = _playerIsDriving;
        });
    }

    this.onProcessBuggyCaddyPref(this.buggyCaddyPreference)
      .then((res: any) => {
        if (res && res.status === 'success') {
          this.refreshBookingObject(res.data);
        }
      })
      .catch(error => {});
  }
  getPlayerDriving(b: any) {
    this.playerDriving[b] = this.bookingSlot.bookingPlayers[b].driving ? 'me' : 'other';
    this.driverAssginged = this.bookingSlot.bookingPlayers[b].driving ? 'Yes' : 'No';
    return this.bookingSlot.bookingPlayers[b].driving ? 'Yes' : 'No';
  }

  async searchBookingPlayer(slot: number) {
    if (!this.getAllowUpdatePostPayment() && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Flight have started. Adding/Removing player is disabled. Please refer to club',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (!this.searchById[slot] && !this.searchByMembership[slot]) {
      let alert = await this.alertCtrl
        .create({
          header: 'Adding player',
          message: 'Tap + or Enter membership / myG2u ID',
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
          this.captchaResponse = null;
        });
      return false;
    }
    let _searchBy;
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: 'Getting player...',
    });
    loader.present().then(response => {
      if (this.searchById[slot] && this.searchById[slot] > 0) {
        _searchBy = this.searchById[slot];
        this.flightService.getPlayerById(_searchBy).subscribe(
          (response: any) => {
            loader.dismiss().then(
              async () => {
                let player = response;
                let _playerDetails: TeeTimeBookingPlayer = {};
                _playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;
                _playerDetails['caddySelectionCriteria'] = {};
                _playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
                  ? this.caddyRequired
                  : false;
                if (response && player) {
                  this.checkBookingPlayer(player).then(
                    playerOk => {
                      if (playerOk)
                        this.addPlayerToBooking({
                          playerId: player.id,
                          sequence: slot,
                          playerDetails: _playerDetails,
                        });
                    },
                    error => {}
                  );
                  this.clearSearchPlayer(slot);
                } else {
                  let alert = await this.alertCtrl
                    .create({
                      header: 'MyGolf2u ID',
                      message: 'No player found for MG2U ID : <br>' + _searchBy,
                      buttons: ['Close'],
                    })
                    .then(res => {
                      res.present();
                      this.captchaResponse = null;
                    });
                }
              },
              error => {
                loader.dismiss().then(async () => {
                  if (error.status !== 200) {
                    let alert = await this.alertCtrl
                      .create({
                        header: 'MyGolf2u ID',
                        message: 'No player found for MG2U ID : <br>' + _searchBy,
                        buttons: ['Close'],
                      })
                      .then(res => {
                        res.present();
                        this.captchaResponse = null;
                      });
                  }
                });
              }
            );
          },
          error => {
            loader.dismiss().then(async () => {
              if (error.status !== 200) {
                let alert = await this.alertCtrl
                  .create({
                    header: 'MyGolf2u ID',
                    message: 'No player found for MG2U ID : <br>' + _searchBy,
                    buttons: ['Close'],
                  })
                  .then(res => {
                    res.present();
                    this.captchaResponse = null;
                  });
              }
            });
          },
          () => {}
        );
      } else if (this.searchByMembership[slot] && this.searchByMembership[slot].length > 0) {
        _searchBy = this.searchByMembership[slot];
        this.flightService
          .searchPlayerByMembership(_searchBy, this.bookingSlot.clubData.id)
          .subscribe(
            (player: Array<PlayerData>) => {
              loader.dismiss().then(async () => {
                let _playerDetails: TeeTimeBookingPlayer = {};
                _playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;
                _playerDetails['caddySelectionCriteria'] = {};
                _playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
                  ? this.caddyRequired
                  : false;
                if (player && player.length > 0) {
                  const popover: any = await this.popoverCtl.create({
                    component: PlayerListPage,
                    componentProps: {
                      headerName: 'Players by Membership',
                      playerList: player,
                      forResultOnly: true,
                    },
                    showBackdrop: true,
                  });
                  popover.onDidDismiss().then((data: any) => {
                    if (!!data.data && data?.data?.selected) {
                      this.checkBookingPlayer(data?.data?.player).then(playerOk => {
                        if (playerOk)
                          this.addPlayerToBooking({
                            playerId: data?.data?.player.id,
                            sequence: slot,
                            playerDetails: _playerDetails,
                          });
                      });
                    }
                  });
                  popover.present({
                    ev: event,
                  });
                  this.clearSearchPlayer(slot);
                } else {
                  let alert = await this.alertCtrl
                    .create({
                      header: this.bookingSlot.clubData.name,
                      message:
                        'Club membership number ' + _searchBy + ' does not exist for this club',
                      buttons: ['Close'],
                    })
                    .then(res => {
                      res.present();
                      this.captchaResponse = null;
                    });
                }
              });
            },
            error => {},
            () => {}
          );
      }
    });
  }

  clearSearchPlayer(slot: number) {
    this.searchByMembership[slot] = null;
    this.searchById[slot] = null;
  }

  async goUpdatePlayerContact(p: TeeTimeBookingPlayer) {
    if (this.bookingType === 'past') return false;
    const modal = await this.modalCtl.create({
      component: PlayerAddressPage,
      componentProps: {
        player: p,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (!!data?.data && data?.data?.save) {
        if (!data.data?.newPlayer) {
          this.flightService
            .updateBookingPlayerContact(p.id, {
              playerDetails: data?.data?.player.player,
              playerContact: data?.data?.player.playerContact,
              new: data?.data?.newPlayer,
            })
            .subscribe((data: any) => {
              this.refreshBookingDetails();
            });
        } else {
          this.flightService
            .updateBookingPlayerContact(p.id, {
              playerDetails: {
                address: data?.data?.address,
              },
              playerContact: data?.data?.playerContact,
              new: data?.data?.newPlayer,
            })
            .subscribe((data: any) => {
              this.refreshBookingDetails();
            });
        }
      }
    });
    return await modal.present();
  }

  expandDetails(slot: number, type?: string) {
    if (this.isBookingCancel()) return;
    if (!this.getAllowUpdatePostPayment() && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Flight have started. Buggy/Caddy pairing is disabled.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _current = this.expandPlayers[slot];
    switch (type) {
      case 'toggle':
        this.expandPlayers.forEach(expand => {
          expand = false;
        });
        this.expandPlayers[slot] = !_current;
        break;
      default:
        this.expandPlayers.forEach(expand => {
          expand = false;
        });
        if (this.expandPlayers[slot] === true) this.expandPlayers[slot] = false;
        else this.expandPlayers[slot] = true;
        break;
    }
    this.setBuggySeatings();
    this.setCaddyPairings();
  }

  async onCheckInPlayer(idx: number, p: TeeTimeBookingPlayer) {
    let alert = await this.alertCtrl
      .create({
        header: 'Check-In Player',
        message: 'Do you want to check-in for the player?',
        buttons: [
          {
            text: 'Not yet',
            handler: () => {},
          },
          {
            text: 'Check-in',
            handler: () => {
              p.confirmed = true;
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  async onCancelPlayer(idx: number, p: TeeTimeBookingPlayer) {
    let alert = await this.alertCtrl
      .create({
        header: 'Cancel Player',
        message: 'Do you want to cancel the player?',
        buttons: [
          {
            text: 'No',
            handler: () => {},
          },
          {
            text: 'Yes',
            handler: () => {
              p.confirmed = false;
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  async onBillFullDetails() {
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: PricesDisplayPage,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        headerName: 'Bill Details',
        slot: this.bookingSlot,
        type: 'payment_details',
        itemBill: this.bookingItemBill,
      },
      backdropDismiss: true,
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onViewAssignmentDetails() {
    const modal = await this.modalCtl.create({
      component: PricesDisplayPage,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        headerName: 'Assignment Details',
        slot: this.bookingSlot,
        type: 'assignment_details',
        itemBill: this.bookingItemBill,
        caddyAssignmentInfo:
          this.appAttribute && this.appAttribute.caddyAssignment
            ? this.appAttribute.caddyAssignment
            : null,
        bookingOptions: this.bookingOptions,
        fromClub: this.fromClub,
      },
    });

    return await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onCheckBuggyCaddyAssignment() {
    this.paymentMode = false;
    if (!this.checkBookingTabsComplete('2')) {
      const msg =
        'Minimum number of players for this slot is <b>' +
        this.bookingSlot.slotAssigned.minPlayers +
        '</b>. Please add players before payment';
      const modal = await this.modalCtl.create({
        component: ChangesHolesComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          header: 'Minimum Players check',
          message: msg,
          showConfirmBtn: false,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      return false;
    } else if (!this.checkBookingTabsComplete('3')) {
      this.checkExclamationInfo('3');
      return false;
    } else {
      this.caddyDiff = [];
      this.buggyDiff = [];
      this.buggiesAssigned = [];
      let _bookingDiff;
      let _caddyDiff;
      let _buggyDiff;

      let _buggyBoolean;
      let _caddyBoolean;
      let loader: any = await this.loadingCtrl.create({
        message: 'Processing Booking...',
        showBackdrop: false,
      });

      await loader.present().then(response => {
        this.flightService.processBookingAssignments(this.bookingSlot.id).subscribe(
          (processData: any) => {
            console.debug('[process] check buggy caddy');
            loader.dismiss().then(() => {
              let _processBooking: TeeTimeBooking = processData;
              let _filteredBooking: TeeTimeBooking;
              this.flightService
                .recalculateBookingPricing(this.bookingSlot.id, this.pricingIgnoreDate)
                .subscribe((data: TeeTimeBooking) => {
                  this.refreshBookingObject(data);
                  _processBooking = data;
                });
              this.flightService.getBookingItemizedBill(this.bookingSlot.id, true).subscribe(
                async (data: Response) => {
                  this.bookingItemBill = {};
                  let _bookingItemBill;
                  this.refresherBill = false;
                  if (data) {
                    _bookingItemBill = data;
                    this.bookingItemBill = _bookingItemBill;
                    if (this.bookingItemBill.changes && this.bookingItemBill.changes.length > 0) {
                      this.paymentMode = true;
                      this.asgmtDiff = true;
                      this.paymentClickedBoolean = true;
                      let _msg;
                      if (this.bookingItemBill.changes) {
                        _msg = 'We were not able to fulfill all your requests : <br>';
                        _msg += '<br><b>' + this.bookingItemBill.changes.join('<br>') + '</b><br>';
                        _msg += '<br>Your bill has been adjusted accordingly.';

                        let alert = await this.alertCtrl.create({
                          header: 'Adjusted Bill',
                          message: _msg,
                          cssClass: 'booking-alert',
                          buttons: [
                            {
                              text: 'Cancel',
                              handler: () => {
                                this.onCancelAssignment()
                                  .then((res: any) => {})
                                  .catch(() => {});
                              },
                            },
                            {
                              text: 'Continue',
                              handler: () => {
                                this.onPayNow();
                              },
                            },
                          ],
                          backdropDismiss: false,
                        });
                        alert.present();
                      }
                    } else {
                      if (this.paymentAmountType === 'deposit') {
                        this.onPayNow();
                        return false;
                      } else {
                        this.paymentClickedBoolean = true;
                        this.onPayNow();
                        return false;
                      }
                    }
                  }
                },
                error => {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable at the moment. Please try again.',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                  this.refresherBill = false;
                  this.bookingItemBill = {};
                }
              );
              _caddyDiff = _processBooking.bookingPlayers
                .filter((player: TeeTimeBookingPlayer) => {
                  return player.caddyPairing !== 0;
                })
                .filter((player: TeeTimeBookingPlayer) => {
                  if (player.caddyAssigned && player.caddyPreferred)
                    if (player.caddyAssigned.id !== player.caddyPreferred.id) return true;
                });
              let _uniqBuggy = this.getUnique(_processBooking.bookingPlayers, 'pairingNo');
              _buggyDiff = _processBooking.bookingPlayers.filter((player: TeeTimeBookingPlayer) => {
                return player.pairingNo !== 0;
              });
              if (_processBooking.buggiesAssigned)
                this.buggiesAssigned = _processBooking.buggiesAssigned;

              _caddyDiff = this.getUnique(_caddyDiff, 'caddyPairing');
              _buggyDiff = this.getUnique(_buggyDiff, 'pairingNo');
              if (_processBooking.buggiesAssigned && _buggyDiff)
                if (_processBooking.buggiesAssigned.length !== _uniqBuggy.length)
                  _buggyBoolean = true;
                else _buggyBoolean = false;
              else _buggyBoolean = false;

              if (_caddyDiff && _caddyDiff.length === 0) {
              } else if (_caddyDiff && _caddyDiff.length > 0) {
              }
              this.caddyDiff = _caddyDiff;
              this.buggyDiff = _buggyDiff;

              if (
                (this.caddyDiff && this.caddyDiff.length > 0) ||
                (this.buggyDiff && this.buggyDiff.length > 0)
              )
                this.asgmtDiff = true;
              else this.asgmtDiff = false;
            });
          },
          error => {
            MessageDisplayUtil.showMessageToast(
              'Server Unreachable at the moment. Please try again.',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            loader
              .dismiss()
              .then(response => {})
              .catch(err => {});
          }
        );
      });
    }
  }
  async onPayNow() {
    if (await this.blockPayment()) return false;
    if (!this.fromClub && !this.checkBookingTabsComplete('2')) {
      let alert = await this.alertCtrl.create({
        header: 'Minimum Players check',
        message:
          'Minimum number of players for this slot is <b>' +
          this.bookingSlot.slotAssigned.minPlayers +
          '</b>. <br>Please add players before payment',
        buttons: [
          {
            text: 'Close',
            handler: () => {},
          },
        ],
      });
      alert.present();
      return false;
    }
    if (this.bookingSlot && this.bookingSlot.bookingStatus === 'PaymentFull') {
      this.onRefreshClick();
      return false;
    }

    this.getPaymentGateway(this.bookingSlot.clubData.address.countryData.id);
    let loader = await this.loadingCtrl.create({
      message: 'Processing Booking...',
      showBackdrop: false,
    });
    let _playerAmount;
    let _playerCharges: Array<BookingPlayerCharges>;
    let _currPlayer;

    if (
      this.paymentAmountType === 'mine' &&
      this.bookingItemBill &&
      this.bookingItemBill.playerCharges.length > 0
    ) {
      _currPlayer = this.bookingSlot.bookingPlayers.filter((tp: TeeTimeBookingPlayer) => {
        if (tp.player) return tp.player.id === this.currentPlayer.playerId;
        else return false;
      });

      _playerCharges = this.bookingItemBill.playerCharges.filter((p: BookingPlayerCharges) => {
        if (p.bookingPlayerId && _currPlayer.length > 0 && _currPlayer[0].id)
          return p.bookingPlayerId === _currPlayer[0].id;
        else return false;
      });

      if (!_playerCharges || (_playerCharges && _playerCharges.length === 0)) {
        MessageDisplayUtil.showMessageToast(
          'You are not a player in the flight, please choose Full or Deposit payment type to proceed',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
      _playerAmount = _playerCharges[0].billItems.reduce((a, b) => (a += b.itemPrice), 0);

      this.playerChargeAmount = Number(_playerAmount.toFixed(2));
    }
    let _depositAmount;
    let _totalDeductions = this.bookingSlot.totalDeductions;
    let _toPay = this.getBookingBalance(true);

    if (this.depositAmount > _toPay && this.paymentAmountType !== 'mine') _depositAmount = _toPay;
    else {
      if (this.paymentAmountType === 'mine') {
        if (_playerAmount > _toPay) {
          _depositAmount = _toPay;
        } else _depositAmount = _playerAmount;
      } else _depositAmount = this.depositAmount;
    }
    Number(_depositAmount.toFixed(2));
    const itemizedBill = await this.modalCtl.create({
      component: PricesDisplayPage,
      componentProps: {
        headerName: 'Itemized Bill',
        slot: this.bookingSlot,
        type: 'payment_confirm',
        paymentAmountType: this.paymentAmountType,
        depositAmount: _depositAmount,
        itemBill: this.bookingItemBill,
        paymentGatewayList: this.paymentGatewayList,
        clubPayment: this.clubPayment,
        voucherApplied: this.bookingDiscounts,
        currentPlayer: this.currentPlayer,
        bookingOptions: this.bookingOptions,
      },
    });
    itemizedBill.onDidDismiss().then((data: any) => {
      if (!!data?.data && data?.data?.confirm) {
        if (!!data?.data && data?.data?.chargeToAccount) {
          this.onProcessAssignment();
          let params: NavigationExtras = {
            // replaceUrl: false,
            state: {
              currentSlot: this.bookingSlot,
              clubId: this.bookingSlot.clubData.id,
              forDate: this.bookingSlot.slotAssigned.teeOffDate,
              courseId: this.bookingSlot.slotAssigned.startCourse.id,
              changeType: 'course',
              currency: this.currency ? this.currency : this.bookingSlot.slotAssigned.currency,
              fromClub: this.fromClub,
              itemizedBill: this.bookingItemBill,
              currentPlayerId: this.currentPlayerId ? this.currentPlayerId : null,
              paymentType: 'chgacc',
            },
          };
          this.router.navigate(['redeem-player-club-credits'], params);
          return;
        }
        this.depositAmount = data?.data?.depositAmount
          ? data?.data?.depositAmount
          : this.bookingOptions
            ? this.getDepositAmount()
            : 0;
        this.selectPaymentMethod = data?.data?.selectPaymentMethod;
        this.paymentConfirmClickedBoolean = true;
        this.paymentClickedBoolean = true;
        if (this.clubPayment === true) {
          let _payments: Array<OfflinePayment> =
            data?.data && data?.data?.offlinePayments ? data?.data?.offlinePayments : [];
          this.clubPayNow(_payments);
        } else if (this.selectPaymentMethod === 'chgacc') {
          let _amountPayable = this.getBookingBalance(true); // - _discountAmount;
          let _paymentType = this.paymentAmountType;
          let _amountPay: number =
            _paymentType === 'full'
              ? _amountPayable
              : this.depositAmount
                ? this.depositAmount
                : this.bookingSlot.depositPayable;
          let _playerId = this.currentPlayer.playerId;
          let _params = {
            amount: data?.data?.depositAmount,
            playerId: _playerId,
          };
          this.goChargeToClubAccount(_params);
        } else this.goPayNow();
      } else if (data?.data && !data?.data?.confirm) {
        this.paymentClickedBoolean = false;
        console.debug('[cancel] on pay now');
        this.onCancelAssignment()
          .then((res: any) => {})
          .catch(() => {});
      }
    });
    itemizedBill.present();
    return false;
  }
  goChargeToClubAccount(params: any) {
    if (this.teeSlotNew) return;
    let _bookingId = this.bookingSlot.id;
    let _playerId = params['playerId'];
    let _redeemAmount = params['amount'];
    let _bypassWallet = true;
    this.flightService
      .bookingChargeToClub(_bookingId, _playerId, _redeemAmount, _bypassWallet)
      .subscribe(
        (data: any) => {
          MessageDisplayUtil.showMessageToast(
            'Successfully charge to club account.',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          this.recalculateBookingPricing();
        },
        async error => {
          let _error = error;
          let _msg = _error.errorMessage;
          let alert = await this.alertCtrl.create({
            header: 'Charge amount exceeded',
            cssClass: 'booking-error',
            message: _msg,
            buttons: ['Close'],
          });
          alert.present();
        }
      );
  }

  onProcessAssignment() {
    this.flightService.processBookingAssignments(this.bookingSlot.id).subscribe(
      processData => {
        console.debug('[process] process');
        let _processBooking: TeeTimeBooking = processData;
        this.refreshBookingObject(_processBooking);
      },
      error => {},
      () => {
        if (this.assignmentDone) this.getBookingItemizedBill(true);
      }
    );
  }

  async EditProfilePage(homeInfo: any, player: any, type: string) {
    let params: any;
    if (homeInfo) {
      params = {
        homeInfo: homeInfo,
        player: player,
        type: type,
      };
    } else {
      params = {
        player: player,
        type: type,
      };
    }

    const modal = await this.modalCtl.create({
      component: EditProfilePage,
      componentProps: params,
    });

    modal.onDidDismiss().then(res => {
      this.refreshBookingDetails();
      this.refreshPlayerInfo();
      this.refreshBookingDetails();
    });
    return await modal.present();
  }
  async goPayNow(collectionId?: string, priceInfo?: PremiumFeaturePrice) {
    let _paymentType = this.paymentAmountType;
    let _discountAmount;
    if (
      this.bookingItemBill &&
      this.bookingItemBill.discounts &&
      this.bookingItemBill.discounts.length > 0
    ) {
      _discountAmount = this.bookingItemBill.discounts
        .map((a: BookingDiscountBillItem) => {
          return a.amount;
        })
        .reduce((a, b) => {
          return a + b;
        });
    }
    let _amountPayable = this.getBookingBalance(true);
    let _amountPay: number =
      _paymentType === 'full'
        ? _amountPayable
        : this.depositAmount
          ? this.depositAmount
          : this.bookingSlot.depositPayable;
    _amountPay = Number(_amountPay.toFixed(2));
    let _collectionId: string = 'q70lo0l_';
    if (collectionId) _collectionId = 'q70lo0l_';
    let loder = await this.loadingCtrl.create({
      message: 'Redirecting to payment page...A',
      showBackdrop: false,
      duration: 5000,
    });
    priceInfo = {
      country: this.bookingSlot.clubData.address.countryData.currencyCode,
      currency: this.bookingSlot.slotAssigned.currency.id,
      endDate: moment('2020-06-30T00:00:00').toDate(),
      id: 2,
      price: this.bookingSlot.depositPayable,
      pricingType: 'F',
      startDate: moment('2020-01-01T00:00:00').toDate(),
    };
    let _description =
      _paymentType === 'full' ? 'Full Payment for Booking ' : 'Deposit Payment for Booking ';
    let paymentDetails: any;
    let paymentDetailsPage: any;
    let _paymentGateway = this.selectPaymentMethod.includes('ipay88') ? 'ipay88' : 'billplz';
    let _url =
      this.selectPaymentMethod === 'ipay88fpx'
        ? 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-fpx.html'
        : 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment.html';
    if (this.selectPaymentMethod === 'ipay88fpx')
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-fpx.html';
    else if (
      this.selectPaymentMethod !== 'ipay88fpx' &&
      this.bookingSlot.clubData.address.countryData.id === 'IDN'
    ) {
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-id.html';
    } else {
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment.html';
    }
    let _signature;
    let _pgRegion;
    let _countryId;
    let _type;
    let _selPM;
    if (_paymentGateway === 'ipay88' && this.selectPaymentMethod === 'ipay88fpx') {
      _selPM = 'ipay88-fpx';
    } else if (_paymentGateway === 'ipay88' && this.selectPaymentMethod !== 'ipay88fpx') {
      if (this.bookingSlot.clubData.address.countryData.id === 'IDN') {
        _selPM = 'ipay88-id';
      } else _selPM = 'ipay88';
    } else _selPM = 'billplz';
    let _mobile;
    if (!this.fromClub) {
      let _bookingPlayers = this.bookingSlot.bookingPlayers
        .filter(bp => {
          if (bp.player && bp.player.id) return bp.player.id === this.currentPlayer.playerId;
          else return false;
        })
        .map(p => {
          if (p.player && p.player.address) {
            _mobile = p.player.address.phone1;
            this.currentPlayer.addressInfo = p.player.address;
          }
        });
      if (!_bookingPlayers || _bookingPlayers.length === 0) {
        if (this.bookingSlot && this.bookingSlot.bookedByPlayer) {
          if (this.bookingSlot.bookedByPlayer.phone)
            _mobile = this.bookingSlot.bookedByPlayer.phone;
          else if (
            this.bookingSlot.bookedByPlayer.userProfile &&
            this.bookingSlot.bookedByPlayer.userProfile.phoneNumber &&
            this.bookingSlot.bookedByPlayer.userProfile.phoneNumber.length > 0
          )
            _mobile = this.bookingSlot.bookedByPlayer.userProfile.phoneNumber;
          else if (
            this.bookingSlot.bookedByPlayer.address &&
            this.bookingSlot.bookedByPlayer.address.phone1
          )
            _mobile = this.bookingSlot.bookedByPlayer.address.phone1;
          else if (
            this.bookingSlot.bookedByPlayer.address &&
            this.bookingSlot.bookedByPlayer.address.phone2
          )
            _mobile = this.bookingSlot.bookedByPlayer.address.phone2;
        }
      }
    } else if (this.fromClub) {
      if (this.bookingSlot.bookedByPlayer) _mobile = this.bookingSlot.bookedByPlayer.phone;
      else if (this.bookingSlot.bookingPlayers[0].phone)
        _mobile = this.bookingSlot.bookingPlayers[0].phone;
      else if (this.bookingSlot.clubData.contactPerson)
        _mobile = this.bookingSlot.clubData.contactPerson;
      else if (this.bookingSlot.clubData.address.phone1)
        _mobile = this.bookingSlot.clubData.address.phone1;
      else if (this.bookingSlot.clubData.address.phone2)
        _mobile = this.bookingSlot.clubData.address.phone2;
      else _mobile = '';
      if (_mobile && _mobile.startsWith('60') && (_mobile.length === 0 || _mobile.length < 11)) {
        _mobile = this.bookingSlot.clubData.address.phone1
          ? this.bookingSlot.clubData.address.phone1
          : this.bookingSlot.clubData.address.phone2;
      } else if (
        _mobile &&
        !_mobile.startsWith('60') &&
        (_mobile.length === 0 || _mobile.length < 10)
      ) {
        _mobile = this.bookingSlot.clubData.address.phone1
          ? this.bookingSlot.clubData.address.phone1
          : this.bookingSlot.clubData.address.phone2;
      }
    }
    let _phoneLength;
    if (!this.fromClub && _mobile && _mobile.startsWith('60')) _phoneLength = 11;
    else if (!this.fromClub && _mobile && !_mobile.startsWith('0')) _phoneLength = 11;
    else _phoneLength = 10;
    if (
      !this.fromClub &&
      this.selectPaymentMethod.includes('billplz') &&
      (!_mobile || _mobile.length === 0 || _mobile.length < _phoneLength) &&
      !this.dummyPhoneNumber
    ) {
      let _bookedPlayer = this.bookingSlot.bookingPlayers.filter(bp => {
        if (bp.player) return bp.player.id === this.currentPlayer.playerId;
      });
      if (_bookedPlayer && _bookedPlayer.length > 0) {
        let modal = await this.modalCtl.create({
          component: DeleteRoomModalComponent,
          showBackdrop: true,
          backdropDismiss: false,
          mode: 'ios',
          cssClass: this.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            mode: 'InsufficientPlayerInfo',
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 180;
          if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then(data => {
          if (data) {
            if (data?.data === 'success') {
              this.EditProfilePage(this.playerHomeInfo$, this.player$, 'playerProfile');
            }
          }
        });
      } else if (!this.dummyPhoneNumber) {
        let alert: any = await this.alertCtrl.create({
          header: 'Insufficient Player Info',
          message:
            'This Payment Gateway needs a valid phone number to proceed. Do you want to add different phone number?',
          inputs: [
            {
              name: 'phone',
              placeholder: 'Phone Number (min length 11)',
              type: 'number',
            },
          ],
          buttons: [
            {
              text: 'No',
            },
            {
              text: 'Update',
              handler: data => {
                this.dummyPhoneNumber = data.phone;
              },
            },
          ],
        });
        alert
          .onDidDismiss(() => {
            this.goPayNow();
          })
          .then(res => {
            res.present();
            this.captchaResponse = null;
          });
      }
      return false;
    }
    if (this.paymentGatewayList)
      this.paymentGatewayList
        .filter((pg: PaymentGatewayInfo) => {
          return pg.type === _paymentGateway && pg.id === this.selectPaymentMethod;
        })
        .map(pg => {
          _pgRegion = pg.id;
          _countryId = pg.country_id;
          _type = pg.type;
          this.ipay88Details = {
            merchantCode: pg.merchant_code,
            merchantKey: pg.merchant_key,
          };
          this.paymentBackendURL = pg.callback_url;
          this.paymentRedirectURL = pg.redirect_url;
          this.paymentInternalURL = pg.internal_payment_url;
          this.paymentPageURL = pg.http_server + pg.payment_url;
          this.pgDescription = pg.description;
          if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
            this.paymentSignAlgo = pg.signature_algorithm;
          if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
            this.paymentSignAlgo = this.paymentSignAlgo.replace('-', '');
          _url = this.paymentInternalURL ? this.paymentInternalURL : pg.internal_payment_url;
        });
    if (this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())) _amountPay = 10000;

    if (this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
      let _amount;
      if (
        _pgRegion.toLowerCase().includes('ipay88-id') &&
        !this.pgDescription.toLowerCase().includes('sandbox')
      )
        _amount = _amountPay * 100;
      else if (
        _pgRegion.toLowerCase().includes('ipay88-id') &&
        this.pgDescription.toLowerCase().includes('sandbox')
      )
        _amount = _amountPay;
      else if (
        _type.toLowerCase().includes('ipay88') &&
        _countryId.toLowerCase() === 'mys' &&
        !this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
      )
        _amount = _amountPay * 100;
      else if (
        _type.toLowerCase().includes('ipay88') &&
        _countryId.toLowerCase() === 'mys' &&
        this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
      )
        _amount = 100;
      else _amount = _amountPay * 100;
      let _userEmail;
      let _userName;
      let _userContact;
      if (this.fromClub) {
        if (this.bookingSlot.bookedByPlayer && this.bookingSlot.bookedByPlayer.id) {
          _userEmail = this.bookingSlot.bookedByPlayer.email;
          _userName = this.bookingSlot.bookedByPlayer.playerName;
          _userContact = this.bookingSlot.bookedByPlayer.phone;
        } else if (!this.bookingSlot.bookedByPlayer) {
          let _player = this.bookingSlot.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
            return p.email;
          });
          if (_player && _player.length > 0) {
            _userEmail = _player[0].email;
            _userName = _player[0].playerName;
            _userContact = _player[0].phone;
          } else if (this.bookingSlot.clubData && this.bookingSlot.clubData.contactEmail) {
            _userEmail = this.bookingSlot.clubData.contactEmail;
            _userName = this.bookingSlot.clubData.contactPerson;
          } else if (this.bookingSlot.clubData.address && this.bookingSlot.clubData.address.email) {
            _userEmail = this.bookingSlot.clubData.address.email;
            _userName = this.bookingSlot.clubData.name;
            if (this.bookingSlot.clubData.address.phone1)
              _userContact = this.bookingSlot.clubData.address.phone1;
            else if (this.bookingSlot.clubData.address.phone2)
              _userContact = this.bookingSlot.clubData.address.phone2;
            else if (this.bookingSlot.clubData.address.fax)
              _userContact = this.bookingSlot.clubData.address.fax;
          }
        }
      } else {
        if (this.currentPlayer) {
          _userEmail = this.currentPlayer.email;
          _userName = this.currentPlayer.playerName;
          _userContact = this.currentPlayer.phone;
        } else if (!this.currentPlayer && this.bookingSlot.bookedByPlayer) {
          _userEmail = this.bookingSlot.bookedByPlayer.email;
          _userName = this.bookingSlot.bookedByPlayer.playerName;
          _userContact = this.bookingSlot.bookedByPlayer.phone;
        }
      }
      _amount = Number(_amount).toFixed(0);
      let _paidBy;
      let _payerType;
      if (this.userType === 'player' && !this.fromClub) _payerType = 'R';
      else if (this.userType === 'booking_agent') _payerType = 'C';
      else if (this.fromClub) _payerType = 'C';
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount,
        email: _userEmail,
        name: _userName,
        mobile: _userContact,
        description: _description + this.bookingSlot.bookingReference,
        currency: this.bookingSlot.slotAssigned.currency.id,
        callback_url: this.paymentBackendURL,
        redirect_url: this.paymentRedirectURL,
        bill_type: 'booking',
        bill_type_id: this.bookingSlot.id,
        paid_by: this.fromClub
          ? this.currSession && this.currSession.user.userId
            ? this.currSession.user.userId
            : this.currentPlayerId
          : this.currentPlayerId,
        payer_type: _payerType,
        payment_type: _paymentType === 'full' ? 'B' : 'D',
        payment_gateway: _pgRegion,
      };
    } else if (this.selectPaymentMethod.toLowerCase().includes('billplz')) {
      let _userEmail;
      let _userName;
      let _userContact;
      if (this.fromClub) {
        if (this.bookingSlot.bookedByPlayer && this.bookingSlot.bookedByPlayer.id) {
          _userEmail = this.bookingSlot.bookedByPlayer.email;
          _userName = this.bookingSlot.bookedByPlayer.playerName;
          _userContact = this.bookingSlot.bookedByPlayer.phone;
        } else if (!this.bookingSlot.bookedByPlayer) {
          let _player = this.bookingSlot.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
            return p.email;
          });
          if (_player && _player.length > 0) {
            _userEmail = _player[0].email;
            _userName = _player[0].playerName;
            _userContact = _player[0].phone;
          } else if (this.bookingSlot.clubData && this.bookingSlot.clubData.contactEmail) {
            _userEmail = this.bookingSlot.clubData.contactEmail;
            _userName = this.bookingSlot.clubData.contactPerson;
          } else if (this.bookingSlot.clubData.address && this.bookingSlot.clubData.address.email) {
            _userEmail = this.bookingSlot.clubData.address.email;
            _userName = this.bookingSlot.clubData.name;
            if (this.bookingSlot.clubData.address.phone1)
              _userContact = this.bookingSlot.clubData.address.phone1;
            else if (this.bookingSlot.clubData.address.phone2)
              _userContact = this.bookingSlot.clubData.address.phone2;
            else if (this.bookingSlot.clubData.address.fax)
              _userContact = this.bookingSlot.clubData.address.fax;
          }
        }
      } else {
        if (this.currentPlayer) {
          _userEmail = this.currentPlayer.email;
          _userName = this.currentPlayer.playerName;
          _userContact = this.currentPlayer.phone;
        } else if (!this.currentPlayer && this.bookingSlot.bookedByPlayer) {
          _userEmail = this.bookingSlot.bookedByPlayer.email;
          _userName = this.bookingSlot.bookedByPlayer.playerName;
          if (this.bookingSlot && this.bookingSlot.bookedByPlayer) {
            if (this.bookingSlot.bookedByPlayer.phone)
              _userContact = this.bookingSlot.bookedByPlayer.phone;
            else if (
              this.bookingSlot.bookedByPlayer.userProfile &&
              this.bookingSlot.bookedByPlayer.userProfile.phoneNumber &&
              this.bookingSlot.bookedByPlayer.userProfile.phoneNumber.length > 0
            )
              _userContact = this.bookingSlot.bookedByPlayer.userProfile.phoneNumber;
            else if (
              this.bookingSlot.bookedByPlayer.address &&
              this.bookingSlot.bookedByPlayer.address.phone1
            )
              _userContact = this.bookingSlot.bookedByPlayer.address.phone1;
            else if (
              this.bookingSlot.bookedByPlayer.address &&
              this.bookingSlot.bookedByPlayer.address.phone2
            )
              _userContact = this.bookingSlot.bookedByPlayer.address.phone2;
            else if (this.dummyPhoneNumber) _userContact = this.dummyPhoneNumber;
          }
        }
      }
      /////// billplz
      let _amount = Number(_amountPay * 100).toFixed(0);
      let _phoneNumber = _mobile ? _mobile : _userContact ? _userContact : this.dummyPhoneNumber;
      let _paidBy;
      let _payerType;
      if (this.userType === 'player' && !this.fromClub) _payerType = 'R';
      else if (this.userType === 'booking_agent') _payerType = 'C';
      else if (this.fromClub) _payerType = 'C';
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount,
        email: _userEmail,
        name: _userName,
        mobile: '60123456789',
        description: _description + this.bookingSlot.bookingReference,
        currency: this.bookingSlot.slotAssigned.currency.id,
        callback_url: this.paymentCallbackURL,
        redirect_url: this.paymentRedirectURL,
        bill_type: 'booking',
        bill_type_id: this.bookingSlot.id,
        paid_by: this.fromClub
          ? this.currSession && this.currSession.user.userId
            ? this.currSession.user.userId
            : this.currentPlayerId
          : this.currentPlayerId,
        payer_type: _payerType,
        payment_type: _paymentType === 'full' ? 'B' : 'D',
        payment_gateway: 'billplz',
      };
    } else {
      let _userEmail;
      let _userName;
      let _userContact;
      if (this.fromClub) {
        if (this.bookingSlot.bookedByPlayer && this.bookingSlot.bookedByPlayer.id) {
          _userEmail = this.bookingSlot.bookedByPlayer.email;
          _userName = this.bookingSlot.bookedByPlayer.playerName;
          _userContact = this.bookingSlot.bookedByPlayer.phone;
        } else if (!this.bookingSlot.bookedByPlayer) {
          let _player = this.bookingSlot.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
            return p.email;
          });
          if (_player && _player.length > 0) {
            _userEmail = _player[0].email;
            _userName = _player[0].playerName;
            _userContact = _player[0].phone;
          } else if (this.bookingSlot.clubData && this.bookingSlot.clubData.contactEmail) {
            _userEmail = this.bookingSlot.clubData.contactEmail;
            _userName = this.bookingSlot.clubData.contactPerson;
          } else if (this.bookingSlot.clubData.address && this.bookingSlot.clubData.address.email) {
            _userEmail = this.bookingSlot.clubData.address.email;
            _userName = this.bookingSlot.clubData.name;
            if (this.bookingSlot.clubData.address.phone1)
              _userContact = this.bookingSlot.clubData.address.phone1;
            else if (this.bookingSlot.clubData.address.phone2)
              _userContact = this.bookingSlot.clubData.address.phone2;
            else if (this.bookingSlot.clubData.address.fax)
              _userContact = this.bookingSlot.clubData.address.fax;
          }
        }
      } else {
        if (this.currentPlayer) {
          _userEmail = this.currentPlayer.email;
          _userName = this.currentPlayer.playerName;
          _userContact = this.currentPlayer.phone;
        } else if (!this.currentPlayer && this.bookingSlot.bookedByPlayer) {
          _userEmail = this.bookingSlot.bookedByPlayer.email;
          _userName = this.bookingSlot.bookedByPlayer.playerName;
          _userContact = this.bookingSlot.bookedByPlayer.phone;
        }
      }
      /////// billplz
      let _amount = Number(_amountPay * 100).toFixed(0);
      let _paidBy;
      let _payerType;
      if (this.userType === 'player' && !this.fromClub) _payerType = 'R';
      else if (this.userType === 'booking_agent') _payerType = 'C';
      else if (this.fromClub) _payerType = 'C';
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount,
        email: _userEmail,
        name: _userName,
        mobile: '60123456789',
        description: _description + this.bookingSlot.bookingReference,
        currency: this.bookingSlot.slotAssigned.currency.id,
        callback_url: this.paymentCallbackURL,
        redirect_url: this.paymentRedirectURL,
        bill_type: 'booking',
        bill_type_id: this.bookingSlot.id,
        paid_by: this.currentPlayerId
          ? this.currentPlayerId
          : this.currSession && this.currSession.user.userId
            ? this.currSession.user.userId
            : this.currentPlayerId,
        payer_type: _payerType,
        payment_type: _paymentType === 'full' ? 'B' : 'D',
        payment_gateway: 'billplz',
      };
    }

    loder.present().then(() => {
      this.paymentService.createBill(_collectionId, paymentDetails, _paymentGateway).subscribe(
        (data: any) => {
          loder.dismiss().then(
            () => {
              if (data.url && this.selectPaymentMethod.toLowerCase().includes('billplz')) {
                if (this.platform.is('capacitor')) {
                  this.openWithInAppBrowser(data.url, null, 'getBill', data);
                } else {
                  let win = window.open(data.url, '_system');
                  let winTick = setInterval(() => {
                    if (win && win.closed) {
                      clearInterval(winTick);
                      this.getBill(data.id, 'billplz');
                    }
                  }, 500);
                }
              } else if (data && this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
                let _data = data;
                let _amount;
                if (_pgRegion.toLowerCase().includes('ipay88-id')) _amount = _amountPay * 100;
                else if (
                  _type.toLowerCase().includes('ipay88') &&
                  _countryId.toLowerCase() === 'mys' &&
                  !this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
                )
                  _amount = _amountPay.toFixed(2);
                else if (
                  _type.toLowerCase().includes('ipay88') &&
                  _countryId.toLowerCase() === 'mys' &&
                  this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
                )
                  _amount = 100;
                else _amount = _amountPay * 100;

                let _ipayUrl;
                if (this.selectPaymentMethod === 'ipay88fpx')
                  _ipayUrl = 'https://dvl3.ipay88.com/epayment/entry.asp';
                else {
                  if (_pgRegion.toLowerCase().includes('ipay88-id'))
                    // _pgRegion === 'ipay88-id'
                    _ipayUrl = this.paymentPageURL;
                  //'https://sandbox.ipay88.co.id/epayment/entry.asp';
                  else _ipayUrl = 'https://payment.ipay88.com.my/epayment/entry.asp';
                }
                // https://dvl3.ipay88.com/epayment/entry.asp
                this.localBill = _data.bill;
                if (this.selectPaymentMethod === 'ipay88fpx') {
                  _signature =
                    'YaYNkBlUnq' +
                    'M15668' +
                    _data.bill +
                    _amount * 100 +
                    this.bookingSlot.slotAssigned.currency.id;

                  let _userEmail;
                  let _userName;
                  let _userContact;

                  if (this.fromClub) {
                    if (this.bookingSlot.bookedByPlayer && this.bookingSlot.bookedByPlayer.id) {
                      _userEmail = this.bookingSlot.bookedByPlayer.email;
                      _userName = this.bookingSlot.bookedByPlayer.playerName;
                      _userContact = this.bookingSlot.bookedByPlayer.phone;
                    } else if (!this.bookingSlot.bookedByPlayer) {
                      let _player = this.bookingSlot.bookingPlayers.filter(
                        (p: TeeTimeBookingPlayer) => {
                          return p.email;
                        }
                      );
                      if (_player && _player.length > 0) {
                        _userEmail = _player[0].email;
                        _userName = _player[0].playerName;
                        _userContact = _player[0].phone;
                      } else if (
                        this.bookingSlot.clubData &&
                        this.bookingSlot.clubData.contactEmail
                      ) {
                        _userEmail = this.bookingSlot.clubData.contactEmail;
                        _userName = this.bookingSlot.clubData.contactPerson;
                      } else if (
                        this.bookingSlot.clubData.address &&
                        this.bookingSlot.clubData.address.email
                      ) {
                        _userEmail = this.bookingSlot.clubData.address.email;
                        _userName = this.bookingSlot.clubData.name;
                        if (this.bookingSlot.clubData.address.phone1)
                          _userContact = this.bookingSlot.clubData.address.phone1;
                        else if (this.bookingSlot.clubData.address.phone2)
                          _userContact = this.bookingSlot.clubData.address.phone2;
                        else if (this.bookingSlot.clubData.address.fax)
                          _userContact = this.bookingSlot.clubData.address.fax;
                      }
                    }
                  } else {
                    if (this.currentPlayer) {
                      _userEmail = this.currentPlayer.email;
                      _userName = this.currentPlayer.playerName;
                      _userContact = this.currentPlayer.phone;
                    } else if (!this.currentPlayer && this.bookingSlot.bookedByPlayer) {
                      _userEmail = this.bookingSlot.bookedByPlayer.email;
                      _userName = this.bookingSlot.bookedByPlayer.playerName;
                      _userContact = this.bookingSlot.bookedByPlayer.phone;
                    }
                  }

                  let sha256_signature = this.mg2uUtil.generateHashSignature('sha256', _signature); //sha256(_signature);
                  paymentDetailsPage = {
                    MerchantCode: 'M15668',
                    PaymentId: '',
                    RefNo: _data.bill,
                    Amount: _amount,
                    Currency: this.bookingSlot.slotAssigned.currency.id,
                    ProdDesc: _description + this.bookingSlot.bookingReference,
                    UserEmail: _userEmail,
                    UserName: _userName,
                    UserContact: _userContact,
                    Remark: _description + this.bookingSlot.bookingReference,
                    SignatureType: 'SHA256',
                    Signature: sha256_signature,
                    ResponseURL: this.paymentRedirectURL,
                    BackendURL: this.paymentBackendURL,
                  };
                } else {
                  if (
                    _pgRegion.toLowerCase().includes('ipay88-id') &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amount).toFixed(0) +
                      this.bookingSlot.slotAssigned.currency.id;
                  else if (
                    _pgRegion.toLowerCase().includes('ipay88-id') &&
                    !this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amountPay * 100).toFixed(0) +
                      this.bookingSlot.slotAssigned.currency.id;
                  else if (
                    _pgRegion.toLowerCase() === 'ipay88' &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(100).toFixed(0) +
                      this.bookingSlot.slotAssigned.currency.id;
                  else if (
                    _pgRegion.toLowerCase().includes('ipay88-my') &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(1).toFixed(0) +
                      this.bookingSlot.slotAssigned.currency.id;
                  else
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amount * 100).toFixed(0) +
                      this.bookingSlot.slotAssigned.currency.id;

                  let sha256_signature = this.mg2uUtil.generateHashSignature('sha256', _signature); // sha256(_signature);
                  let sha1_signature = this.mg2uUtil.generateHashSignature('sha1', _signature); //this.sha1.iPay88Signature(_signature);
                  let ipay88_signature;
                  ipay88_signature = _pgRegion.toLowerCase().includes('ipay88-id')
                    ? sha1_signature
                    : sha256_signature;
                  let _userEmail;
                  let _userName;
                  let _userContact;

                  if (this.fromClub) {
                    if (this.bookingSlot.bookedByPlayer && this.bookingSlot.bookedByPlayer.id) {
                      _userEmail = this.bookingSlot.bookedByPlayer.email;
                      _userName = this.bookingSlot.bookedByPlayer.playerName;
                      _userContact = this.bookingSlot.bookedByPlayer.phone;
                    } else if (!this.bookingSlot.bookedByPlayer) {
                      let _player = this.bookingSlot.bookingPlayers.filter(
                        (p: TeeTimeBookingPlayer) => {
                          return p.email;
                        }
                      );
                      if (_player && _player.length > 0) {
                        _userEmail = _player[0].email;
                        _userName = _player[0].playerName;
                        _userContact = _player[0].phone;
                      } else if (
                        this.bookingSlot.clubData &&
                        this.bookingSlot.clubData.contactEmail
                      ) {
                        _userEmail = this.bookingSlot.clubData.contactEmail;
                        _userName = this.bookingSlot.clubData.contactPerson;
                      } else if (
                        this.bookingSlot.clubData.address &&
                        this.bookingSlot.clubData.address.email
                      ) {
                        _userEmail = this.bookingSlot.clubData.address.email;
                        _userName = this.bookingSlot.clubData.name;
                        if (this.bookingSlot.clubData.address.phone1)
                          _userContact = this.bookingSlot.clubData.address.phone1;
                        else if (this.bookingSlot.clubData.address.phone2)
                          _userContact = this.bookingSlot.clubData.address.phone2;
                        else if (this.bookingSlot.clubData.address.fax)
                          _userContact = this.bookingSlot.clubData.address.fax;
                      }
                    }
                  } else {
                    if (this.currentPlayer) {
                      _userEmail = this.currentPlayer.email;
                      _userName = this.currentPlayer.playerName;
                      _userContact = this.currentPlayer.phone;
                    } else if (!this.currentPlayer && this.bookingSlot.bookedByPlayer) {
                      _userEmail = this.bookingSlot.bookedByPlayer.email;
                      _userName = this.bookingSlot.bookedByPlayer.playerName;
                      _userContact = this.bookingSlot.bookedByPlayer.phone;
                    }
                  }
                  if (this.fromClub) {
                    if (this.bookingSlot.bookedByPlayer && this.bookingSlot.bookedByPlayer.id) {
                      _userEmail = this.bookingSlot.bookedByPlayer.email;
                      _userName = this.bookingSlot.bookedByPlayer.playerName;
                      _userContact = this.bookingSlot.bookedByPlayer.phone; //?this.bookingSlot.bookedByPlayer.phone:_mobile;
                    } else if (!this.bookingSlot.bookedByPlayer) {
                      let _player = this.bookingSlot.bookingPlayers.filter(
                        (p: TeeTimeBookingPlayer) => {
                          return p.email;
                        }
                      );
                      if (_player && _player.length > 0) {
                        _userEmail = _player[0].email;
                        _userName = _player[0].playerName;
                        _userContact = _player[0].phone; //?this.bookingSlot.bookingPlayers[0].phone:_mobile;
                      } else if (
                        this.bookingSlot.clubData &&
                        this.bookingSlot.clubData.contactEmail
                      ) {
                        _userEmail = this.bookingSlot.clubData.contactEmail;
                        _userName = this.bookingSlot.clubData.contactPerson;
                        // _userContact = this.bookingSlot
                      } else if (
                        this.bookingSlot.clubData.address &&
                        this.bookingSlot.clubData.address.email
                      ) {
                        _userEmail = this.bookingSlot.clubData.address.email;
                        _userName = this.bookingSlot.clubData.name;
                        if (this.bookingSlot.clubData.address.phone1)
                          _userContact = this.bookingSlot.clubData.address.phone1;
                        else if (this.bookingSlot.clubData.address.phone2)
                          _userContact = this.bookingSlot.clubData.address.phone2;
                        else if (this.bookingSlot.clubData.address.fax)
                          _userContact = this.bookingSlot.clubData.address.fax;
                      }
                    }
                  } else {
                    if (this.currentPlayer) {
                      _userEmail = this.currentPlayer.email;
                      _userName = this.currentPlayer.playerName;
                      _userContact = this.currentPlayer.phone;
                    } else if (!this.currentPlayer && this.bookingSlot.bookedByPlayer) {
                      _userEmail = this.bookingSlot.bookedByPlayer.email;
                      _userName = this.bookingSlot.bookedByPlayer.playerName;
                      _userContact = this.bookingSlot.bookedByPlayer.phone;
                    }
                  }

                  paymentDetailsPage = {
                    MerchantCode: this.ipay88Details.merchantCode,
                    PaymentId: '',
                    RefNo: _data.bill,
                    Amount: this.sandboxPayment ? 1 : _amount,
                    Currency: this.bookingSlot.slotAssigned.currency.id,
                    ProdDesc: _description + this.bookingSlot.bookingReference,
                    UserEmail: _userEmail,
                    UserName: _userName,
                    UserContact: _userContact,
                    Remark: _description + this.bookingSlot.bookingReference,
                    SignatureType: this.paymentSignAlgo,
                    Signature: ipay88_signature,
                    ResponseURL: this.paymentRedirectURL,
                    BackendURL: this.paymentBackendURL,
                    PaymentURL: this.paymentPageURL,
                  };
                }

                let _MerchantCode = paymentDetailsPage['MerchantCode'];
                let _PaymentId = paymentDetailsPage['PaymentId'];
                let _RefNo = _data.bill;
                let _Amount = paymentDetailsPage['Amount'];
                let _Currency = paymentDetailsPage['Currency'];
                let _ProdDesc = paymentDetailsPage['ProdDesc'];
                let _UserName = paymentDetailsPage['UserName'];
                let _UserEmail = paymentDetailsPage['UserEmail'];
                let _UserContact = paymentDetailsPage['UserContact'];
                let _Remark = paymentDetailsPage['Remark'];
                let _SignatureType = paymentDetailsPage['SignatureType'];
                let _Signature = paymentDetailsPage['Signature'];
                let _ResponseURL = paymentDetailsPage['ResponseURL'];
                let _BackendURL = paymentDetailsPage['BackendURL'];

                let _params =
                  'MerchantCode=' +
                  _MerchantCode +
                  '&PaymentId=' +
                  _PaymentId +
                  '&RefNo=' +
                  _RefNo +
                  '&Amount=' +
                  _Amount +
                  '&Currency=' +
                  _Currency +
                  '&ProdDesc=' +
                  _ProdDesc +
                  '&UserName=' +
                  _UserName +
                  '&UserEmail=' +
                  _UserEmail +
                  '&UserContact=' +
                  _UserContact +
                  '&Remark=' +
                  _Remark +
                  '&SignatureType=' +
                  _SignatureType +
                  '&Signature=' +
                  _Signature +
                  '&ResponseURL=' +
                  _ResponseURL +
                  '&BackendURL=' +
                  _BackendURL;
                let map;

                var form = document.createElement('form');
                form.target = '_system';
                form.method = 'GET';
                form.action = _url;
                form.style.display = 'none';

                for (var key in paymentDetailsPage) {
                  var input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = key;
                  input.value = paymentDetailsPage[key];
                  form.appendChild(input);
                }

                let _ipay88Header = `<html>
                            <head>
                            </head>`;

                let _ipay88Body =
                  `<body >
    <form id="loginForm" action="` +
                  this.paymentInternalURL +
                  `" method="get">
        <span style="font-size:5vw;">Redirecting to payment page ...</span><br>`;

                for (var key in paymentDetailsPage) {
                  _ipay88Body +=
                    '<input type="hidden" name="' +
                    key +
                    '" value="' +
                    paymentDetailsPage[key] +
                    '">';
                }

                let _ipay88end = `<script type="text/javascript">
        setTimeout("document.getElementById('loginForm').submit()", 500);
        </script>
    </body>

    </html>`;

                let _ipay88content = _ipay88Header + _ipay88Body + _ipay88end;

                let _ipay88ContentUrl =
                  'data:text/html;base64,' + this.mg2uUtil._btoa(_ipay88content);
                let win;
                if (this.platform.is('capacitor')) {
                  this.openWithInAppBrowser(_ipay88ContentUrl, null, 'getBill', data);
                } else {
                  win = window.open('', '_system');
                  document.body.appendChild(form);
                  form.submit();
                  document.body.removeChild(form);
                }

                let winTick = setInterval(() => {
                  if (win && win.closed) {
                    clearInterval(winTick);
                    this.getBill(data.bill, 'ipay88');
                    //
                  }
                }, 500);
              }
            },
            error => {
              if (error) {
                let _error = error;
                if (_error.status === '500' || _error.status === '404') {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                } else if (_error.status === 500 || _error.status === 404) {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                }
              }
            }
          );
        },
        async error => {
          if (this.loadingCtrl) this.loadingCtrl.dismiss();
          let _msg = error;
          if (_msg.toLowerCase().includes('mobile is invalid')) {
            _msg = 'Mobile phone is invalid. Please update profile and retry payment.';
            if (!this.fromClub) {
              let modal = await this.modalCtl.create({
                component: DeleteRoomModalComponent,
                showBackdrop: true,
                backdropDismiss: false,
                mode: 'ios',
                cssClass: this.platform.is('mobile')
                  ? 'self-adjustable-modal'
                  : 'self-adjustable-modal-desktop',
                componentProps: {
                  mode: 'InsufficientPlayerInfo',
                },
              });
              await modal.present().then(() => {
                const height = this.platform.height() - 180;
                if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
                  document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                    `${height}px`;
              });
              modal.onDidDismiss().then(data => {
                if (data) {
                  if (data?.data === 'success') {
                    this.EditProfilePage(this.playerHomeInfo$, this.player$, 'playerProfile');
                  }
                }
              });
            }
          } else {
            _msg = 'Something wrong going with payment server. Please try again.';
          }
          MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        }
      );
    });
    setTimeout(() => {
      loder.dismiss().then(() => {});
    }, 300000);
  }

  public getBill(billId?: string, paymentGateway?: string) {
    this.paymentService.getBill(billId, paymentGateway).subscribe(
      async (data: any) => {
        if (
          (data.status && data.paid === 'true' && data.status.toLowerCase() === 'p') ||
          (data.state && data.state.toLowerCase() === 'paid' && paymentGateway === 'billplz')
        ) {
          this.paymentMode = false;
          this.paymentStatus = 'Paid';
          let modal = await this.modalCtl.create({
            component: DeleteRoomModalComponent,
            showBackdrop: true,
            backdropDismiss: false,
            mode: 'ios',
            cssClass: this.platform.is('mobile')
              ? 'self-adjustable-modal'
              : 'self-adjustable-modal-desktop',
            componentProps: {
              mode: 'bookingAlert',
              msg: 'Thank you for the payment.Booking receipt will be sent to you via email.',
              header: 'Payment successful',
            },
          });
          await modal.present().then(() => {
            const height = this.platform.height() - 180;
            if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
              document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                `${height}px`;
          });
          modal.onDidDismiss().then(data => {
            console.debug('get bill ', data);
            if (data) {
              if (data?.data === 'success') {
                this.refreshBookingDetails();
                this.recalculateBookingPricing();
                this.paymentAmountType = 'full';
              }
            }
          });
          this.paymentFailed = false;
          this.paymentDateTime = null;
        } else if (
          (data.status && data.status.toLowerCase() === 'p') ||
          (data.state && data.state.toLowerCase() === '1' && paymentGateway === 'ipay88')
        ) {
          this.paymentMode = false;
          this.paymentStatus = 'Paid';
          let alert = await this.alertCtrl
            .create({
              header: 'Payment successful',
              message:
                'Thank you for the payment.<br>Booking receipt will be sent to you via email.',
              buttons: [
                {
                  text: 'Close',
                  handler: () => {
                    console.debug('get bill alert');
                    this.refreshBookingDetails();
                    this.recalculateBookingPricing();
                    this.paymentAmountType = 'full';
                  },
                },
              ],
              backdropDismiss: false,
            })
            .then(res => {
              res.present();
              this.captchaResponse = null;
            });
          this.paymentFailed = false;
          this.paymentDateTime = null;
        } else if (
          (data.state && data.state.toLowerCase() === 'due') ||
          (data.status && data.status.toLowerCase() === 'd')
        ) {
          this.paymentStatus = 'Due';
          let modal = await this.modalCtl.create({
            component: DeleteRoomModalComponent,
            showBackdrop: true,
            backdropDismiss: false,
            mode: 'ios',
            cssClass: this.platform.is('mobile')
              ? 'self-adjustable-modal'
              : 'self-adjustable-modal-desktop',
            componentProps: {
              mode: 'bookingAlert',
              msg: 'Something went wrong with payment. Please refresh and try again in few minutes.',
              header: 'Payment not successful',
            },
          });
          await modal.present().then(() => {
            const height = this.platform.height() - 180;
            if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
              document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                `${height}px`;
          });
          modal.onDidDismiss().then(data => {
            console.debug('get bill [2]', data);
            if (data) {
              if (data?.data === 'success') {
                this.refreshBookingDetails();
                this.recalculateBookingPricing();
              }
            }
          });
          if (this.enablePaymentTimer) {
            this.paymentFailed = true;
            this.paymentDateTime = moment();
          }
        } else {
          if (this.enablePaymentTimer) {
            this.paymentFailed = true;
            this.paymentDateTime = moment();
          }
          {
            this.onCancelAssignment()
              .then((res: any) => {})
              .catch(() => {});
            console.debug('[cancel] get bill');
          }
        }
      },
      async error => {
        this.paymentStatus = 'Pending';

        let modal = await this.modalCtl.create({
          component: DeleteRoomModalComponent,
          showBackdrop: true,
          backdropDismiss: false,
          mode: 'ios',
          cssClass: this.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            mode: 'bookingAlert',
            msg: 'Something went wrong with payment. Please refresh and try again in few minutes.',
            header: 'Ooops',
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 180;
          if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then(data => {
          console.debug('get bill [3]', data);
          if (data) {
            if (data?.data === 'success') {
              this.refreshBookingDetails();
              this.recalculateBookingPricing();
            }
          }
        });
        if (this.enablePaymentTimer) {
          this.paymentFailed = true;
          this.paymentDateTime = moment();
        }
      }
    );
  }
  public openWithSystemBrowser(url: string) {
    let target = '_system';
    this.iab.create(url, target, this.options);
  }
  public openWithInAppBrowser(url: string, target?: string, attribute?: string, data?: any) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL.toLowerCase())) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    } else {
      _iab.on('loadstop').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL)) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    }
    _iab.on('exit').subscribe(
      () => {
        if (attribute === 'getBill') {
          if (this.selectPaymentMethod.toLowerCase().includes('billplz')) {
            this.getBill(data.id, 'billplz');
          } else if (this.selectPaymentMethod.toLowerCase().includes('ipay88'))
            this.getBill(data.bill, 'ipay88');
        }
      },
      err => {}
    );
  }
  public openWithCordovaBrowser(url: string) {
    let target = '_system';
    this.iab.create(url, target, this.options);
  }

  checkBookingTabsComplete(tabs: string) {
    if (this.teeSlotNew || !this.bookingSlot) return false;
    let _complete: boolean = true;
    let _balance =
      this.bookingItemBill && this.getBookingBalance(true) ? this.getBookingBalance(true) : 0;
    switch (tabs) {
      case '1':
        if (this.bookingSlot.bookingPlayers.length > 0) return true;
        else return false;
      case '2':
        if (this.bookingSlot.bookingPlayers.length >= this.bookingSlot.slotAssigned.minPlayers)
          return true;
        else return false;
      case '3':
        if (!this.bookingOptions) return false;
        let _buggyMandatory = this.bookingOptions.buggyMandatory;
        let _caddyMandatory = this.bookingOptions.caddyMandatory;
        let _slotBuggy = null;
        let _slotCaddy = null;
        _slotBuggy = this.bookingSlot.bookingPlayers.filter(p => {
          if (p.pairingNo === 0) return true;
          else return false;
        });
        _slotCaddy = this.bookingSlot.bookingPlayers.filter(p => {
          if (p.caddyPairing === 0) return true;
          else return false;
        });
        let _buggy: boolean = false;
        _buggy = _buggyMandatory && _slotBuggy && _slotBuggy.length > 0 ? false : true;
        let _caddy: boolean = false;
        _caddy = _caddyMandatory && _slotCaddy && _slotCaddy.length > 0 ? false : true;
        return _buggy && _caddy;
      case '4':
        return true;
      case '5':
        if (this.bookingSlot.amountPayable === this.bookingSlot.amountPaid || _balance <= 0)
          return true;
        else return false;
      case '6':
        this.bookingSlot.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
          if (!p.confirmed) {
            _complete = false;
          }
        });
        return _complete;
    }
  }

  async checkExclamationInfo(tabs: string, forPayment?: boolean) {
    let _message;
    switch (tabs) {
      case '1':
        _message = 'At least one (1) player needs to be added';
        break;
      case '2':
        if (forPayment) {
          _message =
            'Minimum number of players for this slot is <b>' +
            this.bookingSlot.slotAssigned.minPlayers +
            '</b>. <br>Please add players before payment';
        } else
          _message =
            'At least ' + this.bookingSlot.slotAssigned.minPlayers + ' player(s) need to be added';
        break;
      case '3':
        _message = 'Select buggy seating/walking option and caddy pairing';
        break;
      case '4':
        break;
      case '5':
        _message = 'Please make a deposit or full payment';
        break;
      case '6':
        _message = 'Please check-in all confirmed players';
        break;
    }

    let alert: any = await this.alertCtrl.create({
      header: 'Booking Validation',
      message: _message,
      buttons: ['Close'],
    });
    await alert.present();
  }

  counterDisplay() {
    this.getTimer();
  }

  getTimer() {
    let _date = moment(this.bookingSlot.slotAssigned.teeOffDate).format('YYYY-MM-DD');
    let _time = moment(this.bookingSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm:ss');
    const deadline = moment(_date + ' ' + _time);
    return (
      this.getTimeRemaining(deadline).minutes +
      ' m,' +
      this.getTimeRemaining(deadline).seconds +
      ' secs'
    );
  }

  getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date().toString());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
      total,
      days,
      hours,
      minutes,
      seconds,
    };
  }
  countdownTeeTime() {
    return (
      moment(this.bookingSlot.slotAssigned.teeOffDate).format('YYYY-MM-DD') +
      ' ' +
      moment(this.bookingSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm:ss')
    );
  }
  onCheckInAll() {
    if (this.checkInAllPlayers) {
      this.checkInPlayers = [true, true, true, true, true, true];
    } else {
      this.checkInPlayers = [false, false, false, false, false, false];
    }
  }

  addETAcounter(type: number) {
    if (type > 0 && this.etaCounter === 60) return false;
    else if (type < 0 && this.etaCounter === 0) return false;
    if (type === 1) this.etaCounter += 5;
    else if (type === -1) this.etaCounter -= 5;
  }

  toggleETAoption() {
    if (this.arrivalOption.toLowerCase() === 'arrived') {
      this.arrivalOption = 'eta';
      this.etaCounter = 30;
    } else if (this.arrivalOption.toLowerCase() === 'eta') {
      this.arrivalOption = 'arrived';
      this.etaCounter = 0;
    } else if (this.arrivalOption.toLowerCase() === 'select') {
      this.arrivalOption = 'arrived';
      this.etaCounter = 0;
    }
  }

  displayArrivalOpt() {
    if (this.arrivalOption.toLowerCase() === 'arrived') {
      return 'I have arrived';
    } else if (this.arrivalOption.toLowerCase() === 'eta') {
      return 'On the way, ETA<br>(in mins)';
    } else if (this.arrivalOption.toLowerCase() === 'select') {
      return 'Tap here to notify club';
    }
  }

  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map(e => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter(e => arr[e])
      .map(e => arr[e]);

    return unique;
  }

  async onEstimatePriceClick() {
    let _message =
      'This is only an estimated visitor price. As you select players and options, an accurate price will be displayed. ';

    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'estimatedCost',
        msg: _message,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onCheckInClick() {
    if (!this.checkBookingTabsComplete('5')) {
      MessageDisplayUtil.showMessageToast(
        'Please make full payment to proceed with check-in',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _checkInMsg;
    this.checkInPlayers
      .filter(i => {
        return i === true;
      })
      .map(p => (_checkInMsg = true));

    if (!this.fromClub && !this.checkBookingTabsComplete('2')) {
      _checkInMsg = true;
      let alert = await this.alertCtrl.create({
        header: 'Minimum Players check',
        message: 'Please check Players tab to proceed',
        buttons: [
          {
            text: 'Close',
            handler: () => {},
          },
        ],
      });
      alert.present();
      return false;
    } else if (!this.checkBookingTabsComplete('3')) {
      _checkInMsg = true;
      let alert = await this.alertCtrl.create({
        header: 'Mandatory Buggy / Caddy check',
        message: 'Please check Buggy & Caddie Pairing tab to proceed',
        buttons: [
          {
            text: 'Close',
            handler: () => {},
          },
        ],
      });
      alert.present();
      return false;
    }
    if (!_checkInMsg) {
      MessageDisplayUtil.showMessageToast(
        'Please select at least one (1) player to check-in',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let alert = await this.alertCtrl
      .create({
        header: 'Check-In Booking Players',
        message: 'Do you want to check-in for selected players?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
          },
          {
            text: 'Check-in',
            handler: () => {
              this.goCheckInBooking();
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  goCheckInBooking(override?: boolean) {
    let _byClub = true;
    let _arrivingIn = this.etaCounter;
    let _bookingId = this.bookingSlot.id;
    let _bookingPlayerId = [];
    this.bookingSlot.bookingPlayers.forEach((b: TeeTimeBookingPlayer, playerIdx: number) => {
      if (override) _bookingPlayerId.push(b.id);
      else {
        this.checkInPlayers.forEach((checkIn, idx) => {
          if (idx === playerIdx && checkIn && b) _bookingPlayerId.push(b.id);
        });
      }
    });
    this.flightService.checkinBooking(_bookingId, _arrivingIn, _bookingPlayerId, _byClub).subscribe(
      data => {
        if (!!data) {
          this.onRefreshClick();
          // this.refreshBookingObject(data);
        } else if (data && data?.status === 0) {
          MessageDisplayUtil.showMessageToast(
            'Error ' + data.status + ' : Please check-in again',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        } else {
          MessageDisplayUtil.showMessageToast(
            'Error : Please check-in again',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      },
      error => {
        console.debug('check in : ', error);
        let _error;
        if (error) _error = error;
        let _errorMessage;
        if (_error && _error.errorMessage) {
          _errorMessage = _error.errorMessage;
          if (_error && _error.errorCode === 'TeeTimeBooking.FlightCanBeCreatedOnTeeOffDate') {
            let _checkinMinutes = this.bookingOptions ? this.bookingOptions.checkinMinutes : 60;
            let _checkinMessage = this.appAttribute.checkinMessage
              ? this.appAttribute.checkinMessage
              : 'The tee-off date for this booking is {teeOffDate} @ {teeOffTime}. The Club only allows check-in {chkinMins} minutes before tee-off time';

            let reDate = /{teeOffDate}/gi;
            let _teeOffDate = moment(this.bookingSlot.slotAssigned.teeOffDate, 'YYYY-MM-DD').format(
              'dddd, DD MMM YYYY'
            );
            let reTime = /{teeOffTime}/gi;
            let _teeOffTime = moment(this.bookingSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format(
              'hh:mm a'
            );

            let reMinutes = /{chkinMins}/gi;

            _checkinMessage = _checkinMessage.replace(reDate, _teeOffDate);
            _checkinMessage = _checkinMessage.replace(reTime, _teeOffTime);
            _checkinMessage = _checkinMessage.replace(reMinutes, String(_checkinMinutes));
            _errorMessage = _checkinMessage;
          }
        } else _errorMessage = error || 'Error check-in, please try again later.';
        MessageDisplayUtil.showMessageToast(
          _errorMessage,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      }
    );
  }

  // async onCancelBooking() {
  //   if (
  //     (!this.fromClub || this.isBookingAgent()) &&
  //     this.bookingSlot.bookingStatus === 'PaymentFull' &&
  //     this.bookingSlot.amountPaid > 0
  //   ) {
  //     MessageDisplayUtil.showMessageToast(
  //       'Full Payment have been made. Booking cancellation is disabled. Please refer to the club.',
  //       this.platform,
  //       this.toastCtl,
  //       3000,
  //       'bottom'
  //     );
  //     return false;
  //   }

  //   if (
  //     (!this.fromClub || this.isBookingAgent()) &&
  //     (this.bookingSlot.bookingStatus === 'PaymentPartial' ||
  //       (this.bookingItemBill && this.bookingItemBill.totalPayment > 0))
  //   ) {
  //     MessageDisplayUtil.showMessageToast(
  //       'Partial Payment have been made. Booking cancellation is disabled. Please refer to the club.',
  //       this.platform,
  //       this.toastCtl,
  //       3000,
  //       'bottom'
  //     );
  //     return false;
  //   }
  //   let _paidStatus: boolean = false;
  //   if (this.bookingSlot.bookingStatus === 'PaymentPartial') _paidStatus = true;
  //   else if (this.bookingSlot.bookingStatus === 'PaymentFull')
  //     _paidStatus = true;
  //   else if (this.bookingItemBill && this.bookingItemBill.totalPayment > 0)
  //     _paidStatus = true;

  //   let alert;
  //   if (
  //     _paidStatus &&
  //     this.fromClub &&
  //     !this.isBookingAgent() &&
  //     this.bookingSlot.amountPaid > 0
  //   ) {
  //     alert = await this.alertCtrl.create({
  //       header: 'Paid Booking',
  //       message:
  //         'Payment has been made, please make a refund (if needed) before cancellation. This will open the refund/adjustment page.',
  //       buttons: [
  //         {
  //           text: 'Dismiss',
  //           role: 'cancel',
  //         },
  //         {
  //           text: 'Ok',
  //           handler: (data) => {
  //             this.onRefundClick('cancel');
  //           },
  //         },
  //       ],
  //     });
  //   } else if (this.fromClub && !this.isBookingAgent()) {
  //     this.onRefundClick('cancel');
  //   } else {
  //     const modal = await this.modalCtl.create({
  //       component: UpdateNhsModalComponent,
  //       cssClass: 'self-adjustable-modal',
  //       mode: 'ios',
  //       componentProps: {
  //         header: 'Booking Cancellation',
  //         message: 'Are you sure you want to cancel this booking?',
  //         mode: 'cancelBooking',
  //       },
  //     });

  //     modal.onDidDismiss().then((data) => {
  //       if (data.data) {
  //         if (this.platform.is('ios') && this.platform.is('capacitor'))
  //           this.keyboard.hide();
  //         this.goCancelBooking(data);
  //       }
  //     });

  //     await modal.present().then(() => {
  //       const height = this.platform.height() - 250;
  //       document.getElementsByClassName('inner-content')[0][
  //         'style'
  //       ].maxHeight = `${height}px`;
  //     });
  //   }
  //   if (alert) await alert.present();
  // }

  async onCancelBooking() {
    if (
      (!this.fromClub || this.isBookingAgent()) &&
      this.bookingSlot.bookingStatus === 'PaymentFull' &&
      this.bookingSlot.amountPaid > 0
    ) {
      MessageDisplayUtil.showMessageToast(
        'Full Payment have been made. Booking cancellation is disabled. Please refer to the club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    if (
      (!this.fromClub || this.isBookingAgent()) &&
      (this.bookingSlot.bookingStatus === 'PaymentPartial' ||
        (this.bookingItemBill && this.bookingItemBill.totalPayment > 0))
    ) {
      MessageDisplayUtil.showMessageToast(
        'Partial Payment have been made. Booking cancellation is disabled. Please refer to the club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _paidStatus: boolean = false;
    if (this.bookingSlot.bookingStatus === 'PaymentPartial') _paidStatus = true;
    else if (this.bookingSlot.bookingStatus === 'PaymentFull') _paidStatus = true;
    else if (this.bookingItemBill && this.bookingItemBill.totalPayment > 0) _paidStatus = true;
    // || (this.bookingItemBill && this.bookingItemBill.totalPayment > 0);

    let alert;
    if (_paidStatus && this.fromClub && !this.isBookingAgent() && this.bookingSlot.amountPaid > 0) {
      alert = await this.alertCtrl.create({
        header: 'Paid Booking',
        // subTitle: 'Selected date is '+ _date,
        message:
          'Payment has been made, please make a refund (if needed) before cancellation. This will open the refund/adjustment page.', //'Selected date is ' + '<b>' + _date + '</b>',
        // inputs: [{
        //     name: 'reason',
        //     placeholder: 'Reason for cancellation (optional)'
        // }, ],
        buttons: [
          {
            text: 'Dismiss',
            role: 'cancel',
          },
          {
            text: 'Ok',
            handler: data => {
              this.onRefundClick('cancel');
            },
          },
        ],
      });
    } else if (this.fromClub && !this.isBookingAgent()) {
      this.onRefundClick('cancel');
    } else {
      const modal = await this.modalCtl.create({
        component: UpdateNhsModalComponent,
        cssClass: 'self-adjustable-modal',
        mode: 'ios',
        componentProps: {
          header: 'Booking Cancellation',
          message: 'Are you sure you want to cancel this booking?',
          mode: 'cancelBooking',
        },
      });

      modal.onDidDismiss().then(data => {
        console.debug('on dimiss ', data);
        if (data) {
          if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
          this.goCancelBooking(data);
        } else {
          this.goCancelBooking(null);
        }
      });

      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
    }
    if (alert) await alert.present();
    // alert = this.alertCtrl.create({
    //     title: 'Booking Cancellation',
    //     // subTitle: 'Selected date is '+ _date,
    //     message: 'Are you sure you want to cancel this booking?', //'Selected date is ' + '<b>' + _date + '</b>',
    //     inputs: [{
    //         name: 'reason',
    //         placeholder: 'Reason for cancellation (optional)'
    //     }, ],
    //     buttons: [ {
    //         text: 'No',
    //         role: 'cancel'
    //     },
    //     {
    //         text: 'Yes',
    //         handler: (data) => {
    //             this.goCancelBooking(data);
    //         }
    //     },]
    // });
    // if(alert) alert.present();
  }
  goCancelBooking(data: any) {
    let _reason = data ? data.data : '';
    let _bookingId = this.bookingSlot.id;
    let _cancelledByClub = this.fromClub ? this.fromClub : false;

    this.flightService
      .cancelBooking(this.bookingSlot.id, _cancelledByClub, _reason)
      .subscribe(data => {
        if (data) {
          let params: NavigationExtras = {
            replaceUrl: false,
            state: {
              fromBookNow: true,
              cancelBooking: true,
              userType: 'player',
            },
          };

          this.onNavigateBack('booking-home', params);
          // this.router.navigate(['booking-home'], params);
        }
        //
      });
  }
  public ionViewWillLeave() {
    //sm comment
    //if(this.afterBook) this.nav.getPrevious().data.afterBook = true;
    //
    //this.nav.getPrevious().data.cancelBooking = true;
    if (
      !this.teeSlotNew &&
      this.bookingSlot.bookingStatus !== 'PaymentFull' &&
      !this.bookingSlot.assignmentDone
    ) {
      console.debug('[cancel] will leave');
      this.onCancelAssignment(true)
        .then((res: any) => {})
        .catch(() => {});
    }
  }

  ionViewCanLeave() {
    if (!this.teeSlotNew && this.hasPreferenceChanges()) {
      this.onResetPreference('leave');
      return false;
    }
  }

  myCallbackFunction = function (_params) {
    return new Promise((resolve: any, reject) => {
      resolve();
    });
  };

  async onClearPlayerDetails(playerIdx: number) {
    let alert = await this.alertCtrl
      .create({
        header: 'Clear all details',
        message: 'Do you want to clear all details for the player?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
          },
          {
            text: 'Clear',
            handler: () => {
              this.clearPlayerDetails(playerIdx);
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  clearPlayerDetails(playerIdx: number) {
    this.buggyCaddyPreference.ignoreBuggyUpdate = false;
    this.buggyCaddyPreference.ignoreCaddieUpdate = false;
    this.buggyCaddyPreference.playerPairings
      .filter((p: PlayerBuggyCaddiePreference) => {
        return p.bookingPlayerId === this.bookingSlot.bookingPlayers[playerIdx].id;
      })
      .map((p: PlayerBuggyCaddiePreference) => {
        if (this.bookingSlot && this.bookingSlot.slotAssigned.allowWalking) {
          p.buggyPairing = 0;
          p.buggyRequired = false;
        }
        if (this.bookingSlot && !this.bookingSlot.slotAssigned.caddyMandatory) {
          p.caddyPairing = 0;
          p.caddyRequired = false;
        }
        p.driving = false;
        p.caddiePreferred = null;
        p.caddieAssigned = null;
      });

    this.onProcessBuggyCaddyPref(this.buggyCaddyPreference)
      .then((res: any) => {
        if (res && res.status === 'success') {
          this.refreshBookingDetails();
        }
      })
      .catch(error => {});
  }

  refreshBookingObject(bookingByPlayer: TeeTimeBooking) {
    let _bookingSlot = bookingByPlayer;
    this.bookingCancelGuard = false;
    this.playersBalance = 0;
    this.paymentClickedBoolean = false;
    if (bookingByPlayer) {
      this.bookingSlot = bookingByPlayer;
      this.additionalItems = this.bookingSlot.additionalItems;
      this.bookingCancelGuard = this.bookingSlot.cancellationGuard;
      this.bookingSlot.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
        JsonService.deriveFulImageURL(player.player, 'image');
        JsonService.deriveFulImageURL(player.player, 'profile');
        JsonService.deriveFulImageURL(player.caddyPreferred, 'caddyImage');
        JsonService.deriveFulImageURL(player.caddyAssigned, 'caddyImage');
      });

      this.assignmentDone = this.bookingSlot.assignmentDone;

      this.buggyCaddyPreference = {};
      this.buggyCaddyPreference.bookingId = bookingByPlayer.id;
      this.buggyCaddyPreference.playerPairings = [
        {
          bookingPlayerId: 0,
          buggyRequired: true,
          buggyPairing: 0,
          driving: false,
          caddieAssigned: null,
          caddiePreferred: null,
          caddyPairing: 0,
          caddyRequired: false,
          buggyType: 'STANDARD',
        },
      ];

      if (this.bookingSlot.bookingDiscounts && this.bookingSlot.bookingDiscounts.length > 0)
        this.bookingDiscounts = this.bookingSlot.bookingDiscounts.filter(
          (d: TeeTimeBookingDiscount) => {
            if (d.voucherApplied) return d.voucherApplied.redeemed;
          }
        );
      else this.bookingDiscounts = [];

      this.removedPlayers = this.bookingSlot.bookingPlayers.filter(p => {
        return p.playerRemoved;
      });
      this.bookingSlot.bookingPlayers = this.bookingSlot.bookingPlayers.filter(p => {
        return !p.playerRemoved;
      });
      this.bookingSlot.bookingPlayers.sort((a, b) => {
        if (a.sequence < b.sequence) return -1;
        else if (a.sequence > b.sequence) return 1;
        else 0;
      });
      let _eighteenHoles = this.bookingSlot.slotAssigned.eighteenHolesAllowed;
      let _nineHoles = this.bookingSlot.slotAssigned.nineHolesAllowed;
      if (_eighteenHoles && _nineHoles) {
        this.holesPlayed = '2';
        this.eighteenHolesAllowed = true;
        this.nineHolesAllowed = true;
      } else if (!_eighteenHoles && _nineHoles) {
        this.holesPlayed = '1';
      } else if (_eighteenHoles && !_nineHoles) {
        this.holesPlayed = '2';
        this.eighteenHolesAllowed = true;
        this.nineHolesAllowed = false;
      } else if (!_eighteenHoles && !_nineHoles) {
        this.holesPlayed = '1';
        this.eighteenHolesAllowed = false;
        this.nineHolesAllowed = false;
      }

      this.bookingSlot.bookingPlayers.forEach((p, i) => {
        let _caddyPairing = 0;
        if (p.caddyPairing > 0) {
          _caddyPairing = p.caddyPairing; // - 1
          if (!this.caddyPairing[_caddyPairing]) {
            this.caddyPairing[_caddyPairing] = {
              caddyPreferred: p.caddyPreferred,
              caddyPairing: p.caddyPairing,
              caddySelectionCriteria: p.caddySelectionCriteria ? p.caddySelectionCriteria : null,
              caddyAssigned: p.caddyAssigned ? p.caddyAssigned : null,
              caddyRequired: p.caddyPairing > 0 ? true : false,
            };
          }
          if (!this.caddySlots[_caddyPairing]) {
            this.caddySlots[_caddyPairing] = {
              caddyPairing: p.caddyPairing ? p.caddyPairing : 0,
              caddyPreferred: p.caddyPreferred ? p.caddyPreferred : null,
              caddySelectionCriteria: p.caddySelectionCriteria ? p.caddySelectionCriteria : null,
              caddyAssigned: p.caddyAssigned ? p.caddyAssigned : null,
              caddyRequired: p.caddyPairing > 0 ? true : false,
            };
          }
        }
        this.buggyCaddyPreference.playerPairings.push(
          Object.assign({}, this.buggyCaddyPreference[i], {
            bookingPlayerId: p.id,
            buggyRequired: p.pairingNo !== 0 ? true : false,
            buggyPairing: p.pairingNo,
            driving: p.driving,
            caddiePreferred: p.caddyPreferred && p.caddyPreferred.id ? p.caddyPreferred.id : null,
            caddieAssigned: p.caddyAssigned && p.caddyAssigned.id ? p.caddyAssigned.id : null,
            caddyPairing: p.caddyPairing,
            caddyRequired: p.caddyPairing > 0 ? true : false,
            caddyPreferred: p.caddyPreferred,
            caddyAssigned: p.caddyAssigned,
            assignedBuggy: p.buggyId,
            buggyType:
              p.buggyCaddiePreference && p.buggyCaddiePreference.buggyType
                ? p.buggyCaddiePreference.buggyType
                : 'STANDARD',
          })
        );
        if (p.buggyCaddiePreference)
          if (p.player && p.player.id)
            if (this.fromClub)
              //this.selectedBuggyType[i] = p.buggyCaddiePreference.buggyType;
              this.getPlayersCredits(999, p.player.id);
      });
      if (!this.fromClub && this.currentPlayerId) this.getPlayersCredits(999, this.currentPlayerId);

      this.uniqBuggy = this.getUnique(this.bookingSlot.bookingPlayers, 'pairingNo');
      this.uniqBuggy = this.uniqBuggy.filter(ub => {
        return ub.pairingNo > 0;
      });
      this.uniqCaddy = this.getUnique(this.bookingSlot.bookingPlayers, 'caddyPairing');
      this.uniqCaddy = this.uniqCaddy.filter(uc => {
        return uc.caddyPairing > 0;
      });
      if (this.uniqBuggy) this.buggyReq = this.uniqBuggy.length;
      if (this.uniqCaddy) this.caddyReq = this.uniqCaddy.length;
      if (this.uniqCaddy)
        this.uniqCaddy.forEach((c: TeeTimeBookingPlayer, idx: number) => {
          this.caddyRatingCommentOn[idx] = false;
        });
      this.buggyCaddyPreference.playerPairings.shift();
      this.buggyCaddyPreference.ignoreBuggyUpdate = true;
      this.buggyCaddyPreference.ignoreCaddieUpdate = true;
      this.newBuggyCaddyPreference = JSON.parse(JSON.stringify(this.buggyCaddyPreference));
      this.paymentStatus = this.bookingSlot.bookingStatus === 'PaymentFull' ? 'Paid' : 'Pending';
      this.buggyRequired = this.bookingSlot.buggyRequested === 0 ? false : true;
      this.caddyRequired = this.bookingSlot.caddyRequested === 0 ? false : true;
      setTimeout(() => {
        if (this.updatingPlayer && this.assignmentDone) {
          this.updatePreference();
        }
        this.getMg2uPlayerList();
      }, 500);
    }
  }

  async getBookingItemizedBill(afterAssignment?: boolean, isLoader: boolean = true) {
    this.refresherBill = true;
    let _afterAssignment = this.assignmentDone;
    let _bookingItemBill;
    const loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: isLoader ? 'Refreshing bill...' : '',
    });

    if (!isLoader) {
      this.flightService.getBookingItemizedBill(this.bookingSlot.id, _afterAssignment).subscribe(
        (data: Response) => {
          this.bookingItemBill = {};
          loader.dismiss().then(() => {
            this.billPlayerIds = [];
            this.refresherBill = false;
            if (data) {
              _bookingItemBill = data;
              this.bookingItemBill = _bookingItemBill;
              if (this.bookingItemBill.payments) {
                this.bookingItemBill.payments.forEach(p => {
                  if (p.paymentMethod.toLowerCase().includes('charge to account') && p.playerId)
                    this.billPlayerIds.push(p.playerId);
                });
              }
              this.bookingItemBill.payments.sort((a, b) => {
                if (a.datePaid < b.datePaid) return 1;
                else if (a.datePaid > b.datePaid) return -1;
                else return 0;
              });
              if (this.bookingItemBill.changes && this.bookingItemBill.changes.length > 0)
                this.asgmtDiff = true;
              if (!afterAssignment) this.paymentStatus = '';
            }
          });
        },
        error => {
          this.refresherBill = false;
          this.bookingItemBill = {};
        },
        () => {
          if (this.grpPayment)
            this.getPaymentGateway(this.bookingSlot.clubData.address.countryData.id);
          // this.updatingPlayer = false;
        }
      );
    } else {
      await loader.present().then(response => {
        this.flightService.getBookingItemizedBill(this.bookingSlot.id, _afterAssignment).subscribe(
          (data: Response) => {
            this.bookingItemBill = {};
            loader.dismiss().then(() => {
              this.billPlayerIds = [];
              this.refresherBill = false;
              if (data) {
                _bookingItemBill = data;
                this.bookingItemBill = _bookingItemBill;
                if (this.bookingItemBill.payments) {
                  this.bookingItemBill.payments.forEach(p => {
                    if (p.paymentMethod.toLowerCase().includes('charge to account') && p.playerId)
                      this.billPlayerIds.push(p.playerId);
                  });
                }
                this.bookingItemBill.payments.sort((a, b) => {
                  if (a.datePaid < b.datePaid) return 1;
                  else if (a.datePaid > b.datePaid) return -1;
                  else return 0;
                });
                if (this.bookingItemBill.changes && this.bookingItemBill.changes.length > 0)
                  this.asgmtDiff = true;
                if (!afterAssignment) this.paymentStatus = '';
              }
            });
          },
          error => {
            this.refresherBill = false;
            this.bookingItemBill = {};
          },
          () => {
            if (this.grpPayment)
              this.getPaymentGateway(this.bookingSlot.clubData.address.countryData.id);
            // this.updatingPlayer = false;
          }
        );
      });
    }
  }

  async onMoreTeeSlotSettings() {
    let _minPlayers;
    let _buggyMax;
    let _maxPlayers;
    let _buggyMandatory;
    let _caddyMandatory;
    let _caddyMax;
    let _buggyMaxJumbo;
    let _caddyMaxJumbo;
    let _slotHasJumbo: boolean = false;

    if (this.teeSlotNew) {
      _minPlayers = this.teeTimeSlotDisplay.slot.minPlayers;
      _buggyMax =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy
          ? this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy
          : 'n/a';
      _maxPlayers = this.teeTimeSlotDisplay.slot.maxPlayers
        ? this.teeTimeSlotDisplay.slot.maxPlayers
        : 'n/a';
      _buggyMandatory =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.allowWalking ? 'No' : 'Yes';
      _caddyMandatory =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.caddyMandatory ? 'Yes' : 'No';
      _caddyMax =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy
          ? this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy
          : 'n/a';
      _buggyMaxJumbo =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.maxPlayersPerBuggyJumbo
          ? this.teeTimeSlotDisplay.slot.maxPlayersPerBuggyJumbo
          : 'n/a';
      _caddyMaxJumbo =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.maxPlayersPerCaddyJumbo
          ? this.teeTimeSlotDisplay.slot.maxPlayersPerCaddyJumbo
          : 'n/a';
      _slotHasJumbo =
        this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot.pricingPlanJumbo ? true : false;
    } else if (!this.teeSlotNew) {
      _minPlayers = this.bookingSlot.slotAssigned.minPlayers;
      _buggyMax = this.bookingSlot.slotAssigned.maxPlayersPerBuggy
        ? this.bookingSlot.slotAssigned.maxPlayersPerBuggy
        : 'n/a';
      _maxPlayers = this.bookingSlot.slotAssigned.maxPlayers
        ? this.bookingSlot.slotAssigned.maxPlayers
        : 'n/a';
      _buggyMandatory =
        this.bookingSlot && this.bookingSlot.slotAssigned.allowWalking ? 'No' : 'Yes';
      _caddyMandatory =
        this.bookingSlot && this.bookingSlot.slotAssigned.caddyMandatory ? 'Yes' : 'No';
      _caddyMax = this.bookingSlot.slotAssigned.maxPlayersPerCaddy
        ? this.bookingSlot.slotAssigned.maxPlayersPerCaddy
        : 'n/a';
      _buggyMaxJumbo = this.bookingSlot.slotAssigned.maxPlayersPerBuggyJumbo
        ? this.bookingSlot.slotAssigned.maxPlayersPerBuggyJumbo
        : 'n/a';
      _caddyMaxJumbo = this.bookingSlot.slotAssigned.maxPlayersPerCaddyJumbo
        ? this.bookingSlot.slotAssigned.maxPlayersPerCaddyJumbo
        : 'n/a';
      _slotHasJumbo =
        this.bookingSlot && this.bookingSlot.slotAssigned.pricingPlanJumbo ? true : false;
    }

    // let _cancelText = this.bookingOptions.cancelBeforeHours
    //   ? 'Cancellation before <b>' +
    //   this.bookingOptions.cancelBeforeHours +
    //   ' hours</b>'
    //   : '';
    // let _playersAllowedText =
    //   'Min <b>' +
    //   _minPlayers +
    //   '</b> / Max <b>' +
    //   _maxPlayers +
    //   '</b> players allowed';
    // let _checkInText =
    //   'Check in before <b>' +
    //   this.bookingOptions.checkinMinutes +
    //   ' minutes</b>';
    // let _maxUnpaidBookings =
    //   'Max. Unpaid bookings : <b>' +
    //   this.bookingOptions.maxUnpaidBookings +
    //   '</b>';
    // let _allowCaddieBooking =
    //   'Caddie Booking : <b>' +
    //   (this.bookingOptions.allowCaddiePreference ? 'Allowed' : 'Not allowed') +
    //   '</b>';
    // let _jumboPerPlayers = '';
    // if (_slotHasJumbo)
    //   _jumboPerPlayers =
    //     '<br>Max players per buggy (jumbo): <b>' +
    //     _buggyMaxJumbo +
    //     '</b>' +
    //     '<br>Max players per caddy (jumbo): <b>' +
    //     _caddyMaxJumbo +
    //     '</b>';

    // let _message =
    //   _playersAllowedText +
    //   '<br>' +
    //   _cancelText +
    //   '<br>' +
    //   _checkInText +
    //   '<br>Buggy mandatory? <b>' +
    //   _buggyMandatory +
    //   '</b><br>Max players per buggy : <b>' +
    //   _buggyMax +
    //   '<br></b>Caddy mandatory? <b>' +
    //   _caddyMandatory +
    //   '<br></b>Max players per caddy : <b>' +
    //   _caddyMax +
    //   '</b>' +
    //   '<br>' +
    //   _maxUnpaidBookings +
    //   '<br>' +
    //   _allowCaddieBooking +
    //   _jumboPerPlayers;
    let _buttons = [];
    _buttons.push('Close');
    if (this.fromClub && this.getVisibleMode('teeTimeSettings'))
      _buttons.push({
        text: 'Update',
        handler: async data => {
          const editTeeTimeSettings = await this.modalCtl.create({
            component: EditTeeTimeSettingsPage,
            componentProps: {
              bookingOptions: this.bookingOptions,
              bookingSlot: !this.teeSlotNew ? this.bookingSlot : null,
              teeTimeSlotDisplay: this.teeSlotNew ? this.teeTimeSlotDisplay : null,
              teeSlotNew: this.teeSlotNew,
              singleMode: true,
              totalSlotsSelected: 1,
            },
          });
          editTeeTimeSettings.onDidDismiss().then((data: any) => {
            if (!!data?.data) {
              this.updateTeeTimeSettings(data?.data);
              this.recalculateBookingPricing(true);
            }
          });
          editTeeTimeSettings.present();
        },
      });

    console.debug('open modal tee slot settings : ', this.bookingOptions);
    const modal = await this.modalCtl.create({
      component: TeeSlotSettingsComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        bookingOptions: this.bookingOptions,
        maxPlayers: _maxPlayers,
        minPlayers: _minPlayers,
        buggyMandatory: _buggyMandatory,
        buggyMax: _buggyMax,
        caddyMandatory: _caddyMandatory,
        caddyMax: _caddyMax,
        slotHasJumbo: _slotHasJumbo,
        caddyMaxJumbo: _caddyMaxJumbo,
        buggyMaxJumbo: _buggyMaxJumbo,
      },
      mode: 'ios',
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    // let alert = await this.alertCtrl
    //   .create({
    //     header: 'Tee Slot Settings',
    //     message: _message,
    //     buttons: _buttons,
    //   })
    //   .then((res) => {
    //     res.present();
    //     this.captchaResponse = null;
    //   });
  }

  getEstimatedPrice(attribute: string) {
    let _reqPlayers =
      this.bookingSlot && this.bookingSlot.totalPlayers ? this.bookingSlot.totalPlayers : 0;
    let _cost;
    if (!this.fromClub && this.isClubSpecific) {
      if (this.mg2uUtil.getMembershipType('id') === 'P')
        _cost = this.bookingSlot.priceMap['PGUEST'];
      else if (this.mg2uUtil.getMembershipType('id') === 'T')
        _cost = this.bookingSlot.priceMap['TMEMBER'];
      else if (this.mg2uUtil.getMembershipType('id') === 'F')
        _cost = this.bookingSlot.priceMap['MEMBER'];
      else _cost = this.bookingSlot.priceMap['MEMBER'];
    } else {
      let _key;
      let value;
      let _min;
      let _displayPrice;
      if (this.bookingSlot.priceMap['STD']) _cost = this.bookingSlot.priceMap['STD'];
      else {
        if (this.bookingSlot && this.bookingSlot.priceMap) {
          for (let key in this.bookingSlot.priceMap) {
            if (key.toLowerCase() === 'member') continue;
            if (!key.toLowerCase().includes('member') && !key.toLowerCase().includes('guest')) {
              value = this.bookingSlot.priceMap[key];
              if (!_min) _min = value;
              _min = value < _min ? value : _min;
              _key = value < _min ? key : key;
            } else {
              value = this.bookingSlot.priceMap[key];
              if (!_min) _min = value;
              _min = value < _min ? value : _min;
              _key = value < _min ? key : key;
            }
          }
        }
        _displayPrice = _min;
        _cost = _displayPrice;
      }
    }
    let _players =
      this.bookingSlot && this.bookingSlot.bookingPlayers.length
        ? this.bookingSlot.bookingPlayers.length
        : this.playerReq;
    let _costText = this.bookingSlot.slotAssigned.currency.symbol + ' ';
    switch (attribute) {
      case 'requested':
        return _reqPlayers * _cost;
      case 'actual':
        return this.bookingSlot.amountPayable - this.bookingSlot.totalDeductions;
    }
  }

  getBookingTotalAmount() {
    let _amountPayable;
    if (this.getBookingBalance(true) > 0) _amountPayable = this.getBookingBalance(true);
    else if (this.getBookingBalance(true) < 0) _amountPayable = this.getBookingBalance(true);
    else if (this.getBookingBalance(true) === 0) _amountPayable = this.bookingItemBill.totalPayment;
  }

  async togglePayHistory() {
    console.log('this.fromClub: ', this.fromClub);

    this.displayPayHistory = !this.displayPayHistory;
    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'payment_history',
        paymentData: this.bookingItemBill.payments,
        bookingItemBill: this.bookingItemBill,
        bookingSlot: this.bookingSlot,
        fromClub: this.fromClub,
        filteredClubMembership: this.filteredClubMembership,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  toggleRefundHistory() {
    this.displayRefundHistory = !this.displayRefundHistory;
  }

  logRatingChange(rating) {
    //
  }

  logClubRating(rating) {}

  logBookingRating(rating) {}

  resize() {
    this.myInput.nativeElement.style.height = this.myInput.nativeElement.scrollHeight + 'px';
  }

  getAsgmtDiffDetails(type: string, attribute: string) {
    let _caddyPlayers = this.getUnique(this.bookingSlot.bookingPlayers, 'caddyPairing');
    let _caddyPaired = _caddyPlayers.filter((player: TeeTimeBookingPlayer) => {
      return player.caddyPairing !== 0 && player.caddyPreferred;
    });
    let _caddyAvailable = _caddyPlayers.filter((player: TeeTimeBookingPlayer) => {
      return player.caddyPairing !== 0 && player.caddyAssigned;
    });
    if (type === 'caddies') {
      switch (attribute) {
        case 'req':
          return _caddyPaired ? _caddyPaired.length : 0;
        case 'avl':
          return _caddyAvailable ? _caddyAvailable.length : 0;
      }
    } else if (type === 'buggies') {
      switch (attribute) {
        case 'req':
          return this.buggyDiff ? this.buggyDiff.length : 0;
        case 'avl':
          return this.buggiesAssigned ? this.buggiesAssigned.length : 0;
      }
    }
  }

  onCancelAssignment(exit: boolean = false, override: boolean = false) {
    return new Promise((resolve, reject) => {
      console.debug('[cancel] promise', exit, override);
      let _bookingId;
      this.paymentClickedBoolean = false;
      this.paymentMode = false;

      if (this.bookingSlot && this.bookingSlot.bookingStatus === 'PaymentFull' && !override) {
        resolve({
          status: 'success',
        });
        return;
      }
      if (this.bookingSlot && this.bookingSlot.bookingStatus === 'PaymentPartial' && !override) {
        resolve({
          status: 'success',
        });
        return;
      }
      if (this.bookingSlot && this.bookingSlot.id) _bookingId = this.bookingSlot.id;
      this.flightService.cancelBookingAssignments(this.bookingSlot.id).subscribe(
        (data: any) => {
          if (!!data) {
            if (!exit) this.getBookingItemizedBill(false);
            if (override) this.refreshBookingObject(data);
            resolve({
              status: 'success',
            });
          }
        },
        error => {
          reject({
            status: 'failed',
            error: error,
          });
        }
      );
    });
  }

  setStar(type: string, x: number, attribute: string, idx?: number) {
    if (type === 'club') this.clubRating = x;
    else if (type === 'booking') this.bookingRating = x;
    else if (type === 'caddy' + idx) this.caddyRating[idx] = x;
    else if (type === 'clubItem' + idx) this.clubRatingItems[idx]['rating'] = x;
    //
  }

  getStar(type: string, x: number, attribute: string, idx?: number) {
    let _rating;
    if (type === 'club') _rating = this.clubRating;
    else if (type === 'booking') _rating = this.bookingRating;
    else if (type === 'caddy' + idx) _rating = this.caddyRating[idx];
    else if (type === 'clubItem' + idx) _rating = this.clubRatingItems[idx]['rating'];

    if (attribute === 'set') return x <= _rating;
    if (attribute === 'unset') return x > _rating;
  }
  onRateApp() {
    window.open('https://play.google.com/store/apps/details?id=com.brite.mygolf2u', '_system');
    if (1) return false;
    if (
      (this.platform.is('ios') ||
        this.platform.is('android') ||
        this.platform.is('ipad') ||
        this.platform.is('iphone')) &&
      this.platform.is('capacitor')
    ) {
    } else if (this.platform) {
      window.open('https://play.google.com/store/apps/details?id=com.brite.mygolf2u', '_system');
    } else if (
      this.platform.is('android') &&
      (this.isMobileLayout() || this.platform.is('mobileweb'))
    ) {
    } else {
      window.open('https://play.google.com/store/apps/details?id=com.brite.mygolf2u', '_system');
    }
  }
  getCaddy() {}
  async onZoomImageCaddy(player: TeeTimeBookingPlayer) {
    let _caddy: CaddyData = player.caddyAssigned;
    const modal = await this.modalCtl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: _caddy.caddyImage ? _caddy.caddyImage : '',
      },
    });
    modal.onDidDismiss().then(res => {
      if (res !== null) {
      }
    });
    return await modal.present();
  }

  async onRateSubmit() {
    let _caddyRateEmpty;
    _caddyRateEmpty = this.caddyRating.filter(a => {
      return a === 0;
    });
    let _hasCaddy;
    _hasCaddy = this.uniqCaddy.filter((a: TeeTimeBookingPlayer) => {
      return a.caddyAssigned;
    });
    if (this.clubRating === 0) {
      MessageDisplayUtil.showMessageToast(
        'Please rate for Club Experience',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else if (_caddyRateEmpty && _caddyRateEmpty.length > 0 && _hasCaddy && _hasCaddy.length > 0) {
      MessageDisplayUtil.showMessageToast(
        'Please rate for each Caddy Experience',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else {
      let _clubRating = {};
      let _currentPlayer = this.bookingSlot.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
        if (p.player) return p.player.id === this.currentPlayerId;
        else return false;
      });
      this.clubRatingItems.shift();
      _clubRating['playerName'] = this.currentPlayer.playerName;
      _clubRating['playerEmail'] = this.currentPlayer.email;
      _clubRating['playerPhone'] = this.currentPlayer.phone;
      _clubRating['overallRating'] = this.clubRating;
      _clubRating['player'] = _currentPlayer[0].player;
      _clubRating['itemizedRatings'] = this.clubRatingItems;
      _clubRating['overallRating'] = this.clubRating;
      _clubRating['review'] = this.myStuff;
      let loader: any = await this.loadingCtrl.create({
        showBackdrop: false,
      });

      loader.present().then(response => {
        this.flightService
          .rateForClub(this.bookingSlot.clubData.id, _clubRating)
          .subscribe(data => {
            if (this.hasCaddyAssigned()) {
              this.uniqCaddy.forEach((c: TeeTimeBookingPlayer, idx: number) => {
                if (c.caddyAssigned) {
                  this.flightService
                    .rateForCaddy(
                      c.caddyAssigned.id,
                      this.caddyRating[idx],
                      this.currentPlayerId,
                      this.caddyRatingComment[idx]
                    )
                    .subscribe(dataCaddy => {
                      if (dataCaddy && dataCaddy.status === 200) {
                      }
                    });
                }
              });
            }
            loader.dismiss().then(() => {
              if (!!data) {
                MessageDisplayUtil.showMessageToast(
                  'Thank you for rating us!',
                  this.platform,
                  this.toastCtl,
                  5000,
                  'bottom'
                );
                this.doneRating = true;
              }
            });
          });
      });
    }
  }

  getClubRatingItems() {
    this.clubRatingItems[0] = {
      itemId: '',
      name: '',
      rating: 0,
    };
    this.flightService
      .getClubRatingItems(this.bookingSlot.clubData.id)
      .subscribe((data: Array<any>) => {
        if (data) {
          data.forEach((d, idx) => {
            this.clubRatingItems.push(
              Object.assign({}, this.clubRatingItems[idx], {
                itemId: d.id,
                name: d.name,
                rating: 0,
              })
            );
          });
        }
      });
  }
  async onLocalBill() {
    let prompt: any = await this.alertCtrl
      .create({
        header: 'Enter a bill id',
        message: '',
        inputs: [
          {
            name: 'title',
            placeholder: 'Bill Id',
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              prompt.dismiss().then(() => {
                this.keyboard.hide();
              });
              return false;
            },
          },
          {
            text: 'Get',
            handler: data => {
              if (data.title)
                prompt.dismiss().then(() => {
                  this.getBill(data.title, 'ipay88');
                });
              else {
                let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter bill id');
                MessageDisplayUtil.showErrorToast(
                  msg,
                  this.platform,
                  this.toastCtl,
                  5000,
                  'bottom'
                );
              }
              return false;
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  getPaymentGateway(countryId?: string, paymentGatewayId?: string) {
    let _paymentGateway;
    let _countryId = countryId ? countryId : null;
    this.paymentService
      .getPaymentGateway(_countryId, _paymentGateway)
      .subscribe((pgList: Array<PaymentGatewayInfo>) => {
        if (pgList && pgList.length > 0) this.paymentGatewayList = pgList;
      });
  }

  onCheckDeposit(init?: boolean) {
    let _init: boolean = false;
    if (init) _init = true;
    if (_init) {
      this.depositAmount = this.getDepositAmount();
      if (
        this.bookingItemBill.totalPayment > 0 &&
        this.getBookingBalance(true) < this.getDepositAmount()
      )
        this.depositAmount = this.getBookingBalance(true);
    }
    if (
      this.bookingItemBill.totalPayment > 0 &&
      this.bookingItemBill.totalPayment > this.getDepositAmount()
    )
      return;
    if (!this.depositAmount || this.depositAmount === 0)
      this.depositAmount = this.getDepositAmount();
    if (this.depositAmount > this.bookingSlot.amountPayable)
      this.depositAmount = Number(this.getBookingBalance(true).toFixed(2));
    else if (this.depositAmount > this.getBookingBalance(true))
      this.depositAmount = this.getBookingBalance(true);
    else if (this.depositAmount < this.getDepositAmount())
      this.depositAmount = this.getDepositAmount();
    else return false;
  }
  getClubPlayerDetails(attribute: string) {
    let _currentPlayer = this.clubBookingPlayers;
    let _id;
    if (this.clubBookingPlayers) {
      switch (attribute) {
        case 'name':
          return _currentPlayer && _currentPlayer.playerName ? _currentPlayer.playerName : '';
        case 'id':
          return _currentPlayer && _currentPlayer.playerId
            ? '(#' + _currentPlayer.playerId + ')'
            : _currentPlayer && _currentPlayer.id
              ? '(#' + _currentPlayer.id + ')'
              : '';
        case 'image':
          return _currentPlayer && _currentPlayer.image
            ? _currentPlayer.image
            : _currentPlayer.profile
              ? _currentPlayer.profile
              : '';
        case 'discount':
          return '<span style="color:red">No promotion</span>';
      }
    } else {
      switch (attribute) {
        case 'name':
          return 'Tap + or enter Mship / myG2u #';
        case 'id':
          return '';
        case 'isContactComplete':
          return false;
        case 'image':
          return '';
      }
    }
  }

  async searchClubBookingPlayer() {
    if (this.clubSearchById <= 0) {
      // this.searchByMembership[slot].length === 0
      let alert = await this.alertCtrl.create({
        header: 'Adding player',
        // subTitle: 'Selected date is '+ _date,
        message: 'Please enter valid myG2u ID', //'Selected date is ' + '<b>' + _date + '</b>',
        buttons: ['Close'],
      });
      alert.present();

      return false;
    }
    if (!this.clubSearchById && !this.clubSearchByMembership) {
      // this.searchByMembership[slot].length === 0
      let alert = await this.alertCtrl.create({
        header: 'Adding player',
        // subTitle: 'Selected date is '+ _date,
        message: 'Tap + or Enter membership / myG2u ID', //'Selected date is ' + '<b>' + _date + '</b>',
        buttons: ['Close'],
      });
      alert.present();

      return false;
    }

    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: 'Getting player...',
    });

    let _searchBy;

    //
    loader.present().then(() => {
      if (this.clubSearchById && this.clubSearchById > 0) {
        _searchBy = this.clubSearchById;

        this.flightService.getPlayerById(_searchBy).subscribe(
          (response: any) => {
            loader.dismiss().then(
              async () => {
                let player = response;
                JsonService.deriveFulImageURL(player, 'image');
                JsonService.deriveFulImageURL(player, 'profile');
                let _playerDetails: TeeTimeBookingPlayer = {};
                _playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;
                _playerDetails['caddySelectionCriteria'] = {};
                _playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
                  ? this.caddyRequired
                  : false;

                if (response.status === 200 && player) {
                  this.clubBookingPlayers = player;
                } else {
                  let alert = await this.alertCtrl.create({
                    header: 'MyGolf2u ID',
                    // subTitle: 'Selected date is '+ _date,
                    message: 'No player found for MG2U ID : <br>' + _searchBy, //'Selected date is ' + '<b>' + _date + '</b>',
                    buttons: ['Close'],
                  });
                  alert.present();
                }
              },
              error => {
                loader.dismiss().then(async () => {
                  if (error.status !== 200) {
                    let alert = await this.alertCtrl.create({
                      header: 'MyGolf2u ID',
                      // subTitle: 'Selected date is '+ _date,
                      message: 'No player found for MG2U ID : <br>' + _searchBy, //'Selected date is ' + '<b>' + _date + '</b>',
                      buttons: ['Close'],
                    });
                    alert.present();
                  }
                });
                //
              }
            );
          },
          error => {
            loader.dismiss().then(async () => {
              if (error.status !== 200) {
                let alert = await this.alertCtrl.create({
                  header: 'MyGolf2u ID',
                  // subTitle: 'Selected date is '+ _date,
                  message: 'No player found for MG2U ID : <br>' + _searchBy, //'Selected date is ' + '<b>' + _date + '</b>',
                  buttons: ['Close'],
                });
                alert.present();
              }
            });
            //
          }
        );
      } else if (this.clubSearchByMembership && this.clubSearchByMembership.length > 0) {
        _searchBy = this.clubSearchByMembership;
        //

        this.flightService
          .searchPlayerByMembership(_searchBy, this.clubInfo.clubId)
          .subscribe((player: Array<PlayerData>) => {
            loader.dismiss().then(async () => {
              let _playerDetails: TeeTimeBookingPlayer = {};
              _playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;
              _playerDetails['caddySelectionCriteria'] = {};
              _playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
                ? this.caddyRequired
                : false;
              //
              if (player && player.length > 0) {
                let popover: any = await this.popoverCtl.create({
                  component: PlayerListPage,
                  componentProps: {
                    // slot: slot,
                    headerName: 'Players by Membership',
                    playerList: player,
                    forResultOnly: true,
                    // buggies: this.buggySlots,
                    // courses: this.courses
                  },
                  showBackdrop: true,
                });
                popover.onDidDismiss().then((data: any) => {
                  if (data && data.selected) {
                    this.clubBookingPlayers = data.player;
                    // this.checkBookingPlayer(data.player).then((playerOk) => {
                    //   //
                    //     if (playerOk) this.addPlayerToBooking({
                    //         playerId: data.player.id,
                    //         sequence: slot,
                    //         playerDetails: _playerDetails,
                    //     });
                    // })
                  }
                });
                popover.present({
                  ev: event,
                });
              } else {
                let alert = await this.alertCtrl.create({
                  header: this.clubInfo.clubName,
                  // subTitle: 'Selected date is '+ _date,
                  message: 'Club membership number ' + _searchBy + ' does not exist for this club', //'Selected date is ' + '<b>' + _date + '</b>',
                  buttons: ['Close'],
                });
                alert.present();
              }
            });
          });
      }
    });
  }
  clearClubSearchPlayer() {
    this.clubSearchByMembership = null;
    this.clubSearchById = null;
  }
  async onClubPlayerSelect() {
    let _playerSlots = 1;
    _playerSlots =
      this.slots.length - (this.bookingSlot ? this.bookingSlot.bookingPlayers.length : 0);
    const modal = await this.modalCtl.create({
      component: AddPlayerListPage,
      componentProps: {
        openedModal: true,
        fromClub: true,
        maxPlayers: _playerSlots,
        teeSlotNew: this.teeSlotNew,
        forBooking: true,
        clubId: this.clubInfo ? this.clubInfo.clubId : this.clubs.club.id,
        partnerInfo: this.partnerInfo,
        currentDate: this.bookingSlot
          ? this.bookingSlot.slotAssigned.teeOffDate
          : this.teeTimeSlotDisplay.slot.teeOffDate,
      },
    });

    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.clubBookingPlayers = {
          playerName: '',
          email: '',
        };
      } else this.clubBookingPlayers = null;
      if (data.data && data?.data?.newPlayer) {
        this.clubBookingPlayers.playerName = data?.data?.playerDetails.playerName;
        this.clubBookingPlayers.email = data?.data?.playerDetails.email;
        this.clubBookingPlayers.address = {};
        this.clubBookingPlayers.address.phone1 = data?.data?.playerDetails.phone
          ? data?.data?.playerDetails.phone
          : '';
        this.clubBookingPlayers.phone = data?.data?.playerDetails.phone
          ? data?.data?.playerDetails.phone
          : '';
        if (data?.data?.registerThisPlayer)
          this.createContact(data?.data?.playerDetails, data?.data?.addThisMember);
      } else if (data.data && !data.data?.newPlayer) {
        this.clubBookingPlayers = data?.data?.item;
        this.clubBookingPlayers.playerName = data?.data?.item.playerName;
        this.clubBookingPlayers.email = data?.data?.item.email;
        this.clubBookingPlayers.image = data?.data?.item.photoUrl;
        this.clubBookingPlayers.profile = data?.data?.item.thumbnail;
        this.clubBookingPlayers.phone = data?.data?.item.phone;
      } else return false;
    });
    return await modal.present();
  }
  async onClubDeleteBookingPlayer() {
    let player = this.clubBookingPlayers;
    // let alert = await this.alertCtrl
    //   .create({
    //     header: 'Remove Player',
    //     message:
    //       'Removing selected player from booking. Do you want to proceed?',
    //     buttons: [
    //       {
    //         text: 'Close',
    //       },
    //       {
    //         text: 'Remove player',
    //         handler: () => {
    //           this.clubBookingPlayers = null;
    //         },
    //       },
    //     ],
    //   })
    //   .then((res) => {
    //     res.present();
    //     this.captchaResponse = null;
    //   });

    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'removePlayer',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('on dismiss ', data);
      if (data && data?.data === 'confirm') {
        // if(data?.data === 'success'){
        this.clubBookingPlayers = null;
        this.captchaResponse = null;
        // }
      }
    });
  }
  clubPayNow(offlinePayments?: Array<OfflinePayment>) {
    let _payments: Array<OfflinePayment> = offlinePayments;
    let _data: BookingOfflinePayment = {
      bookingId: this.bookingSlot.id,
      paidFor: this.bookingSlot.bookingPlayers[0].playerName,
      payments: _payments,
    };
    this.flightService.processBookingAssignments(this.bookingSlot.id).subscribe(processData => {
      console.debug('[process] club pay now');
      if (processData) {
        this.flightService.clubCapturePayment(_data).subscribe(
          (resp: any) => {
            let _data = resp;
            if (resp && _data) {
              this.refreshBookingObject(_data);
              this.getBookingItemizedBill(false);
            }
          },
          error => {
            let _error = error;
            let msg = 'Oops. You have encountered an error, please contact our support';
            if (_error && _error.errorMessage) msg = _error.errorMessage;
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          }
        );
      }
    });
    return false;
  }

  createContact(playerDetails: any, addClubMember?: boolean) {
    let _firstName;
    let _lastName;
    let _gender;
    let _phone;
    let _email;
    let _handicap;
    let _teeOffFrom;
    let _countryId;
    let _clubId;
    let _nationalityId;
    if (this.teeSlotNew) _clubId = this.clubInfo.id | this.clubInfo.clubId;
    else _clubId = this.bookingSlot.clubData.clubId | this.bookingSlot.clubData.id;

    if (playerDetails) {
      console.debug('create contact : ', playerDetails);
      _firstName = playerDetails.playerName;
      _lastName = ' ';
      _gender = playerDetails.gender;
      _phone = playerDetails.phone;
      _email = playerDetails.email;
      _handicap = _gender === 'M' ? 24 : 36;
      _teeOffFrom = _gender === 'M' ? 'Blue' : 'Red';
      _countryId = this.teeSlotNew
        ? this.clubInfo.countryId
        : this.bookingSlot.clubData.address.countryData.id;
      _nationalityId = playerDetails?.nationality;
      if (!this.fromClub)
        this.playerService
          .addContact(
            _firstName,
            _lastName,
            _gender,
            _email,
            _phone,
            _handicap,
            _teeOffFrom,
            _countryId,
            _nationalityId
          )
          .subscribe(
            (player: PlayerInfo) => {},
            error => {
              let _error = error;
            },
            () => {}
          );
      else if (this.fromClub) {
        this.flightService
          .registerNewPlayer(
            _firstName,
            _lastName,
            _gender,
            _email,
            _phone,
            _handicap,
            _teeOffFrom,
            _countryId,
            null,
            _clubId
          )
          .subscribe(
            (player: any) => {
              if (player) this.clubBookingPlayers = player;

              if (player && addClubMember) {
                let _playerId = player.playerId;
                let _membershipNo =
                  playerDetails && playerDetails.membershipNo ? playerDetails.membershipNo : null;
                this.createClubmembership(_clubId, _playerId, _membershipNo);
              }
              let _params;
              let _currentTime = moment().format('YYYY-MM-DD HH:mm');
              if (playerDetails.nric !== undefined || playerDetails.passport !== undefined) {
                if (playerDetails.nric) {
                  _params = {
                    name: 'NRIC_' + player.playerId + '_' + _currentTime,
                    documentNumber: playerDetails.nric,
                    documentType: 'NRIC',
                  };
                  this.flightService.addUserDocument(player.userId, _params).subscribe(data => {});
                }
                if (playerDetails.passport) {
                  _params = {
                    name: 'PASSPORT_' + player.playerId + '_' + _currentTime,
                    documentNumber: playerDetails.passport,
                    documentType: 'PASSPORT',
                  };
                  this.flightService.addUserDocument(player.userId, _params).subscribe(data => {});
                }
              }
            },
            error => {
              let _error = error;
            },
            () => {}
          );
      }
    } else return false;
  }
  createClubmembership(clubId, playerId, membershipNo, params?) {
    if (!membershipNo) {
      let _msg = 'Invalid Club Membership Number';
      MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }
    let _params;
    let _currDate = moment().format('YYYY-MM-DD');
    _params = {
      membershipNo: membershipNo,
      membershipType: 'FULL',
      joinedOn: _currDate,
    };
    this.flightService.createUpdatePrimaryMembership(clubId, playerId, _params).subscribe(
      (clubMembership: ClubMembershipExtended) => {
        if (clubMembership) {
          let _clubId = clubMembership.club.clubId | clubMembership.club.id;
          let _memberParams = {
            playerId: clubMembership.player.id,
            clubId: _clubId,
            membership: clubMembership.membershipNo,
          };
          this.flightService
            .updatePlayerClubMembership('approve', _memberParams)
            .subscribe(data => {});
        }
      },
      error => {
        let _error = error;
        let _msg = _error.errorMessage;
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        return false;
      }
    );
  }

  async changeStartCourse() {
    if (!this.fromClub) return false;
    const changeSlot = await this.modalCtl.create({
      component: TeeSlotListModal,
      componentProps: {
        currentSlot: this.bookingSlot,
        clubId: this.bookingSlot.clubData.id,
        forDate: this.bookingSlot.slotAssigned.teeOffDate,
        courseId: this.bookingSlot.slotAssigned.startCourse.id,
        changeType: 'course',
      },
    });
    changeSlot.onDidDismiss().then((data: any) => {
      if (data) {
        this.onChangeSlot(data.currentSlot.id, data.newSlot);
      }
    });
    return await changeSlot.present();
  }

  onChangeSlot(bookingId: number, newSlot: TeeTimeSlotDisplay) {
    this.flightService.changeSlot(bookingId, newSlot).subscribe(
      data => {
        if (!!data) {
          this.refreshBookingObject(data);
          MessageDisplayUtil.showMessageToast(
            'Successfully changed booking slot',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        } else if (data) {
        }
      },
      error => {
        let _errorBody = error;
        if (error.status !== 200) {
          let _message =
            _errorBody.errors.length > 0
              ? _errorBody.errors[0]
              : 'This slot cannot be selected (e.g Flights checked-in, dispatched, started or finished)';
          MessageDisplayUtil.showMessageToast(
            _message,
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      }
    );
  }

  async changeFlight() {
    if (!this.fromClub) return false;
    const changeFlight = await this.modalCtl.create({
      component: TeeSlotListModal,
      componentProps: {
        currentSlot: this.bookingSlot,
        clubId: this.bookingSlot.clubData.id,
        forDate: this.bookingSlot.slotAssigned.teeOffDate,
        courseId: this.bookingSlot.slotAssigned.startCourse.id,
        changeType: 'slotDate',
      },
    });
    changeFlight.onDidDismiss().then((data: any) => {
      if (!!data && data?.data) {
        this.onChangeFlight(data?.data?.currentSlot.id, data?.data?.newSlot);
      }
    });
    changeFlight.present();
  }
  onChangeFlight(bookingId: number, newSlot: TeeTimeSlotDisplay) {
    this.flightService.changeSlot(bookingId, newSlot).subscribe(
      data => {
        if (data) {
          this.refreshBookingObject(data);
          this.recalculateBookingPricing(true);
          MessageDisplayUtil.showMessageToast(
            'Successfully changed booking slot',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        } else if (data) {
        }
      },
      error => {
        let _errorBody = error;
        if (error.status !== 200) {
          let _message =
            _errorBody.errors.length > 0
              ? _errorBody.errors[0]
              : 'This slot cannot be selected (e.g Flights checked-in, dispatched, started or finished)';
          MessageDisplayUtil.showMessageToast(
            _message,
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      }
    );
  }

  async goVoucherList(who: string, type?: string) {
    if (this.bookingSlot.bookingStatus === 'PaymentFull' && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Full Payment have been made. Adding voucher is disabled. Please refer to club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (who === 'player') {
      let _club: ClubData = this.bookingSlot.clubData;
      let _player: TeeTimeBookingPlayer = this.bookingSlot.bookingPlayers.find(p => {
        if (p.player) return p.player.id === this.currentPlayerId;
        else return;
      });
      const _playerVoucher = await this.modalCtl.create({
        component: PlayerVoucherPage,
        componentProps: {
          type: 'voucher',
          mode: 'apply',
          fromClub: this.fromClub,
          forBooking: true,
          player: _player.player ? _player.player : null,
          clubInfo: _club,
          who: who,
          bookingId: this.bookingSlot.id,
          appliedVouchers: this.bookingDiscounts,
          currentSlot: this.bookingSlot,
          bookingPlayer: _player,
          bookingDiscounts: this.bookingSlot.bookingDiscounts,
          playerTypes: this.bookingPlayerTypes,
          partnerInfo: this.partnerInfo ? this.partnerInfo : null,
        },
      });

      _playerVoucher.onDidDismiss().then((data: any) => {
        //
        if (!!data) {
          if (data?.data?.needRefresh) this.refreshBookingDetails(true);
        }
      });
      return await _playerVoucher.present();
    } else if (who === 'club') {
      const _playerVoucher = await this.modalCtl.create({
        component: VoucherListModal,
        componentProps: {
          who: who,
          forBooking: true,
          player: null,
          mode: 'apply',
          clubInfo: this.bookingSlot.clubData,
          bookingId: this.bookingSlot.id,
          players: this.bookingSlot.bookingPlayers,
          type: 'voucher',
          bookingDiscounts: this.bookingSlot.bookingDiscounts,
          fromClub: this.fromClub,
        },
      });
      _playerVoucher.onDidDismiss().then((data: any) => {
        if (!!data) {
          if (data?.data.needRefresh) this.refreshBookingDetails(true);
        }
      });
      return await _playerVoucher.present();
    }
  }
  getInitials(name: string) {
    var names = name.split(' '),
      initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }

  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
  async onTooltipRecaptcha() {
    let _message =
      'This ensures that computers / robots are unable to access our system and conduct block bookings.';
    let alert = await this.alertCtrl
      .create({
        header: 'Recaptcha Verification',
        message: _message,
        buttons: ['Close'],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  async onPlayerVoucher(slot: number, who?: string, type?: string) {
    if (!this.getAllowUpdatePostPayment() && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Flight have started. Adding voucher is disabled. Please refer to club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _slot = slot - 1;
    let _club: ClubData = this.bookingSlot.clubData;
    let _player: TeeTimeBookingPlayer = this.bookingSlot.bookingPlayers[_slot];
    if (who === 'player' && !this.fromClub) {
      let _isMe: boolean = false;
      _isMe =
        _player && _player.player && _player.player.id === this.currentPlayerId ? true : false;

      let _imBooker: boolean = false;
      _imBooker =
        this.bookingSlot.bookedByPlayer &&
        this.bookingSlot.bookedByPlayer.id === this.currentPlayerId
          ? true
          : false;

      if (!_isMe) {
        let _msg =
          'Players must choose their own vouchers or discounts. Please ask the player to login or contact the club.';
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        return false;
      }
    }

    const _playerVoucher = await this.modalCtl.create({
      component: PlayerVoucherPage,
      componentProps: {
        type: type ? type : 'voucher',
        mode: 'apply',
        fromClub: this.fromClub,
        forBooking: true,
        player: _player.player ? _player.player : null,
        clubInfo: _club,
        who: who,
        bookingId: this.bookingSlot.id,
        appliedVouchers: this.bookingDiscounts,
        currentSlot: this.bookingSlot,
        bookingPlayer: this.bookingSlot.bookingPlayers[_slot],
        bookingDiscounts: this.bookingSlot.bookingDiscounts,
        playerTypes: this.bookingPlayerTypes,
      },
    });
    _playerVoucher.onDidDismiss().then((data: any) => {
      if (!!data) {
        if (data?.data?.needRefresh) this.refreshBookingDetails(true);
      }
    });
    return await _playerVoucher.present();
  }

  hasCaddyAssigned() {
    let _hasCaddy: any = null;
    _hasCaddy = this.uniqCaddy
      .filter((p: TeeTimeBookingPlayer) => {
        return p.caddyAssigned;
      })
      .map((p: TeeTimeBookingPlayer) => {
        return p.caddyAssigned;
      });
    if (_hasCaddy && _hasCaddy.length > 0) return true;
    else false;
  }

  async onManageVoucher() {
    const _playerVoucher = await this.modalCtl.create({
      component: ManageVoucherPage,
      componentProps: {
        fromClub: this.fromClub,
        clubInfo: this.bookingSlot.clubData,
        clubId: this.bookingSlot.clubData.id,
        currencySymbol: this.bookingSlot.clubData.address.countryData.currencySymbol,
      },
    });

    _playerVoucher.onDidDismiss().then((data: any) => {
      //
      if (data) {
        if (data.needRefresh) this.refreshBookingDetails(true);
      }
    });
    return await _playerVoucher.present();

    // this.nav.push(ManageVoucherModal, {
    //     fromClub: this.fromClub,
    //     clubInfo: this.bookingSlot.clubData,
    //     clubId: this.bookingSlot.clubData.id,
    //     currencySymbol: this.bookingSlot.clubData.address.countryData.currencySymbol,
    // });

    //sm comment
  }

  getVoucherAppliedAmount(voucher: TeeTimeBookingDiscount, amountOnly?: boolean) {
    let _currency = this.currency
      ? this.currency.symbol
      : this.bookingSlot.slotAssigned.currency.symbol;
    let _amount = voucher ? voucher.amountDeducted : '-';
    if (amountOnly) return _amount;
    else return _currency + ' ' + _amount;
  }
  async onRemoveThisVoucher(voucher: TeeTimeClubVoucher) {
    if (this.bookingSlot.bookingStatus === 'PaymentFull' && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Full Payment have been made. Removing voucher is disabled. Please refer to club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let prompt: any = await this.alertCtrl
      .create({
        header: 'Remove Voucher',
        message: 'This will remove voucher from current booking flight. Do you want to proceed?',
        buttons: [
          {
            text: 'No',
          },
          {
            text: 'Yes',
            handler: () => {
              this.goRemoveThisVoucher(voucher);
              prompt.dismiss();
              return false;
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  goRemoveThisVoucher(voucher: TeeTimeClubVoucher) {
    this.flightService.removePlayerBookingVoucher(this.bookingSlot.id, voucher.id).subscribe(
      (data: any) => {
        if (data) {
          this.refreshBookingObject(data);
          MessageDisplayUtil.showMessageToast(
            'Successfully removed voucher',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      },
      async error => {
        let _error = error;
        let alert = await this.alertCtrl
          .create({
            header: 'Issue removing voucher',
            message:
              _error && _error.message
                ? _error.message
                : "There's an issue removing voucher. Please try again",
            buttons: ['Close'],
          })
          .then(res => {
            res.present();
            this.captchaResponse = null;
          });
      }
    );
  }
  async onRefundClick(mode?: string) {
    if (!this.fromClub) return;
    const _playerVoucher = await this.modalCtl.create({
      component: RefundBookingPlayersModal,
      componentProps: {
        currentSlot: this.bookingSlot,
        clubId: this.bookingSlot.clubData.id,
        forDate: this.bookingSlot.slotAssigned.teeOffDate,
        courseId: this.bookingSlot.slotAssigned.startCourse.id,
        changeType: 'course',
        currency: this.currency ? this.currency : this.bookingSlot.slotAssigned.currency,
        fromClub: this.fromClub,
        mode: mode ? mode : null,
      },
    });
    _playerVoucher.onDidDismiss().then((data: any) => {
      //
      if (data) {
        if (data.needRefresh) this.refreshBookingDetails(true);
      }
    });
    return await _playerVoucher.present();
    // sm comment
    // let _callRefund = this.nav.push(RefundBookingPlayersModal, {
    //   currentSlot: this.bookingSlot,
    //   clubId: this.bookingSlot.clubData.id,
    //   forDate: this.bookingSlot.slotAssigned.teeOffDate,
    //   courseId: this.bookingSlot.slotAssigned.startCourse.id,
    //   changeType: 'course',
    //   currency: this.currency ? this.currency : this.bookingSlot.slotAssigned.currency,
    //   fromClub: this.fromClub,
    //   mode: mode ? mode : null,
    // })
  }

  async onRecaptchaToolTip() {
    let _message = `This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.`;
    let alert = await this.alertCtrl
      .create({
        header: 'Google reCAPTCHA info',
        message: _message,
        buttons: ['Close'],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  getPlayerVoucherApplied(slot: number, type?: string): any {
    let _slot = slot - 1;
    let _bookingDiscounts = this.bookingSlot.bookingDiscounts;
    if (!_bookingDiscounts || _bookingDiscounts.length === 0) return null;
    if (!this.bookingSlot.bookingPlayers || this.bookingSlot.bookingPlayers.length === 0)
      return null;
    let _players: Array<TeeTimeBookingPlayer> = this.bookingSlot.bookingPlayers; //
    if (!_players[_slot]) return null;
    let _voucherNames: Array<string> = new Array();
    let _voucherApplied = _bookingDiscounts.filter((discount: TeeTimeBookingDiscount) => {
      if (
        discount &&
        discount.voucherApplied &&
        discount.voucherApplied.playerAssigned &&
        _players[_slot].player
      )
        if (
          discount.voucherApplied.voucherAmountType.toLowerCase() === 'fixed' ||
          discount.voucherApplied.voucherAmountType.toLowerCase() === 'package'
        ) {
          if (
            discount.voucherApplied.playerAssigned.id === _players[_slot].player.id &&
            discount.voucherApplied
          )
            _voucherNames.push(discount.voucherApplied.name);
          return (
            discount.voucherApplied.playerAssigned.id === _players[_slot].player.id &&
            discount.voucherApplied
          );
        } else {
          if (
            discount.voucherApplied.playerAssigned.id === _players[_slot].player.id &&
            discount.voucherApplied &&
            discount.amountDeducted > 0
          )
            _voucherNames.push(discount.voucherApplied.name);
          return (
            discount.voucherApplied.playerAssigned.id === _players[_slot].player.id &&
            discount.voucherApplied &&
            discount.amountDeducted > 0
          );
        }
    });
    switch (type) {
      case 'amount':
        return _voucherApplied;
      case 'name':
        if (_voucherNames && _voucherNames.length > 0) return _voucherNames.join(', ');
        else return 'No voucher applied';
      default:
        return _voucherApplied;
    }
  }

  getPlayerCardsApplied(slot: number): Array<TeeTimeBookingDiscount> {
    let _slot = slot - 1;
    // console.debug("get player cards applied [0] ", slot, this.bookingSlot)
    let _bookingDiscounts = this.bookingSlot.bookingDiscounts;
    if (!_bookingDiscounts || _bookingDiscounts.length === 0) return null;
    if (!this.bookingSlot.bookingPlayers || this.bookingSlot.bookingPlayers.length === 0)
      return null;
    let _players: Array<TeeTimeBookingPlayer> = this.bookingSlot.bookingPlayers;
    // console.debug("get player cards applied ", slot, _players, _bookingDiscounts)
    if (!_players[_slot]) return null;
    let _voucherApplied = _bookingDiscounts.filter((discount: TeeTimeBookingDiscount) => {
      let _isPlayer;
      let _playerApplied: boolean = false;
      if (discount.discountAudit) {
        _isPlayer = discount.discountAudit.discountsByPlayer.filter(dp => {
          return (
            dp.bookingPlayerId === _players[_slot].id && dp.discounts && dp.discounts.length > 0
          );
        });
      } else if (!discount.discountAudit && discount.bookingPlayerId === _players[_slot].id) {
        _playerApplied = true;
      }
      return discount.discountApplied && ((_isPlayer && _isPlayer.length > 0) || _playerApplied);
    });
    return _voucherApplied;
  }

  getPlayerDiscountName(slot) {
    let _slot = slot - 1;
    let _bookingDiscounts = this.bookingSlot.bookingDiscounts;
    if (!_bookingDiscounts || _bookingDiscounts.length === 0) return null;
    if (!this.bookingSlot.bookingPlayers || this.bookingSlot.bookingPlayers.length === 0)
      return null;
    let _players: Array<TeeTimeBookingPlayer> = this.bookingSlot.bookingPlayers;
    if (!_players[_slot]) return null;
    let _voucherApplied = _bookingDiscounts.filter((discount: TeeTimeBookingDiscount) => {
      let _isPlayer;
      let _playerApplied;
      if (discount.discountAudit) {
        _isPlayer = discount.discountAudit.discountsByPlayer.filter(dp => {
          return (
            dp.bookingPlayerId === _players[_slot].id && dp.discounts && dp.discounts.length > 0
          );
        });
      } else if (!discount.discountAudit && discount.bookingPlayerId === _players[_slot].id) {
        _playerApplied = true;
      }
      return discount.discountApplied && ((_isPlayer && _isPlayer.length > 0) || _playerApplied);
    });
    let _discountCardText = '';
    if (!_voucherApplied || (_voucherApplied && _voucherApplied.length === 0)) return '';
    _discountCardText += _voucherApplied
      .map(a => {
        return a.discountApplied.name;
      })
      .reduce((a, b) => {
        return a + ', ' + b;
      });
    return _discountCardText;
  }

  checkPlayerVoucherApplied() {
    if (!this.bookingDiscounts || this.bookingDiscounts.length === 0) return false;
    else return true;
  }

  getNormalPlan(slot: TeeTimeSlot, attribute?: string) {
    let _normalPlan: TeeTimePricingPlan;
    _normalPlan = slot && slot.pricingPlan ? slot.pricingPlan : null;
    if (_normalPlan) {
      switch (attribute) {
        case 'name':
          return _normalPlan.name;
        case 'description':
          return this.escapeCRLF(_normalPlan.description);
        case 'discounts':
          return _normalPlan.discountsApplicable;
        case 'addCharges':
          return _normalPlan.additionalCharges;
        case 'promo':
          return _normalPlan.promotional;
        case 'prices':
          return _normalPlan.prices;
        case 'currency':
          return _normalPlan.currency.symbol;
      }
    } else return '';
  }

  getPromoPlan(slot: TeeTimeSlot, attribute?: string) {
    let _promoPlan: TeeTimePricingPlan;
    _promoPlan = slot && slot.pricingPlanPromotional ? slot.pricingPlanPromotional : null;
    if (_promoPlan) {
      switch (attribute) {
        case 'name':
          return _promoPlan.name;
        case 'description':
          return this.escapeCRLF(_promoPlan.description);
        case 'discounts':
          return _promoPlan.discountsApplicable;
        case 'addCharges':
          return _promoPlan.additionalCharges;
        case 'promo':
          return _promoPlan.promotional;
        case 'prices':
          return _promoPlan.prices;
        case 'currency':
          return _promoPlan.currency.symbol;
      }
    } else return '';
  }
  getDepositAmount() {
    let _deposit = 0;
    if (this.bookingOptions) {
      if (this.bookingOptions.depositAmountType.toLowerCase() === 'percentage') {
        _deposit = this.bookingSlot.amountPayable * (this.bookingOptions.depositAmount / 100);
      } else if (this.bookingOptions.depositAmountType.toLowerCase() === 'absolute') {
        _deposit = this.bookingSlot.amountPayable - this.bookingOptions.depositAmount;
      } else if (this.bookingOptions.depositAmountType.toLowerCase() === 'fixed') {
        _deposit = this.bookingOptions.depositAmount;
      }
    }
    return Number(_deposit.toFixed(2));
  }

  getVoucherApplicableText(voucher: any, type: string) {
    if (!voucher) return false;
    let _allowText;
    let _applicableStart = 'Applicable on';
    let _allowWeekdays;
    let _allowWeekends;
    let _allowHolidays;
    let _applicableEnd = '';
    let _voucherDetails = voucher;
    if (type === 'allowDays') {
      _allowWeekdays =
        voucher &&
        voucher.allowOnWeekdays &&
        voucher.allowOnWeekends &&
        voucher.allowOnPublicHolidays
          ? 'Weekdays' + ', '
          : voucher && voucher.allowOnWeekdays
            ? 'Weekdays'
            : '';
      _allowWeekends =
        voucher &&
        voucher.allowOnWeekends &&
        voucher.allowOnWeekdays &&
        voucher.allowOnPublicHolidays
          ? 'Weekends'
          : voucher &&
              voucher.allowOnWeekdays &&
              voucher.allowOnWeekends &&
              !voucher.allowOnPublicHolidays
            ? ' and ' + 'Weekends'
            : voucher && !voucher.allowOnWeekdays && voucher.allowOnWeekends
              ? 'Weekends'
              : '';
      _allowHolidays =
        voucher &&
        (voucher.allowOnWeekdays || voucher.allowOnWeekends) &&
        voucher.allowOnPublicHolidays
          ? ' and ' + 'Public Holidays'
          : voucher && voucher.allowOnPublicHolidays
            ? 'Public Holidays'
            : '';
      _allowText = _applicableStart + ' ' + _allowWeekdays + _allowWeekends + _allowHolidays;
    } else if (type === 'bookingAmount') {
      _allowText = 'Covers Booking Amount';
    } else if (type === 'flight') {
      if (voucher.appliesToFlight) _allowText = 'Applicable for this flight';
      else if (!voucher.appliesToFlight) _allowText = 'Applicable for 1 person';
    } else if (type === 'appliesFor') {
      _allowText = 'Covers ';
      let _buggyFee = _voucherDetails.priceComps.filter(price => {
        if (price.priceComponent.id.toLowerCase() === 'buggyfee') return true;
        if (price.priceComponent.id.toLowerCase() === 'hbuggyfee') return true;
        else return false;
      });

      let _caddyFee = _voucherDetails.priceComps.filter(price => {
        if (price.priceComponent.id.toLowerCase() === 'caddyfee') return true;
        if (price.priceComponent.id.toLowerCase() === 'hcaddyfee') return true;
        else return false;
      });
      _voucherDetails.priceComps = _voucherDetails.priceComps.filter(price => {
        if (_buggyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hbuggyfee';
        if (_caddyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hcaddyfee';
        else return true;
      });
      if (!_voucherDetails.priceComps || _voucherDetails.priceComps.length === 0)
        _allowText += 'Booking Amount';
      else if (
        _voucherDetails &&
        _voucherDetails.priceComponents &&
        _voucherDetails.priceComponents.length > 0
      ) {
        _allowText += _voucherDetails.priceComponents
          .map(a => {
            return a.priceComponent.name;
          })
          .reduce((a, b) => {
            return a + ', ' + b;
          });
      }
    }
    return _allowText;
  }
  getBookerPlayerDetails(attribute: string) {
    if (this.teeSlotNew) return;
    if (this.fromClub) return;
    let _player = this.currentPlayer;
    switch (attribute) {
      case 'phone':
        return _player && _player.phone;
      default:
        return;
    }
  }

  getClubPhoneMandatory(attribute?: string) {
    if (!this.appAttribute) return;
    if (!this.appAttribute.clubPhoneMandatory || this.appAttribute.clubPhoneMandatory.length === 0)
      return;
    let _clubPhoneMandatory;
    let _clubId = this.bookingSlot.clubData.id;
    if (this.appAttribute && this.appAttribute.clubPhoneMandatory) {
      this.appAttribute.clubPhoneMandatory
        .filter(cpm => {
          return _clubId === cpm.clubId;
        })
        .map(cpm => {
          _clubPhoneMandatory = cpm;
        });
    }
    let _clubMembership = this.mg2uUtil.getPlayerClubMembership();
    let _isMember: boolean = false;
    if (_clubMembership && _clubMembership.length > 0) {
      _clubMembership
        .filter(cm => {
          return cm.club.clubId === _clubId;
        })
        .map(cm => {
          _isMember = true;
        });
    }
    if (attribute && !_clubPhoneMandatory) return false;
    else if (
      !attribute &&
      _isMember &&
      _clubPhoneMandatory &&
      _clubPhoneMandatory.nonMembersOnly === false
    )
      return true;
    else if (
      !attribute &&
      _isMember &&
      _clubPhoneMandatory &&
      _clubPhoneMandatory.nonMembersOnly === true
    )
      return false;
    else if (!attribute && _clubPhoneMandatory) return true;
    switch (attribute) {
      case 'message':
        let _message = 'Club needs phone number. Tap here to update your phone number';
        _message = _clubPhoneMandatory.message;
        return _message;
      case 'requiredOrWarning':
        return _clubPhoneMandatory.requiredOrWarning;
      case 'nonMembersOnly':
        return _clubPhoneMandatory.nonMembersOnly;
      default:
        return;
    }
  }
  async checkClubPhoneMandatory() {
    return new Promise(async (resolve, reject) => {
      let _checkGood: boolean = true;

      if (
        !this.fromClub &&
        !this.getBookerPlayerDetails('phone') &&
        this.getClubPhoneMandatory('requiredOrWarning') === 'required'
      ) {
        let alert = await this.alertCtrl.create({
          header: 'Club requires phone number',
          message: 'This Club a valid phone number to proceed. Do you want to update profile?',
          buttons: [
            {
              text: 'No',
            },
            {
              text: 'Update',
              handler: async () => {
                const modal = await this.modalCtl.create({
                  component: EditProfilePage,
                  componentProps: {
                    homeInfo: this.playerHomeInfo$,
                    player: this.player$,
                    type: 'playerProfile',
                  },
                });
                modal.onDidDismiss().then((data?: any) => {
                  this.refreshPlayerInfo();
                  this.refreshBookingDetails();
                });
                modal.present();
              },
            },
          ],
        });
        alert.present();
        _checkGood = false;
      } else _checkGood = true;
      resolve(_checkGood);
    });
  }
  refreshPlayerInfo() {
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$
      .pipe(filter(Boolean))
      .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      this.currentPlayerId = player.playerId;
      this.currentPlayer = player;
    });
  }

  async goRedeemPlayerCredits() {
    let _checkFailed: boolean = false;
    this.checkClubPhoneMandatory().then(result => {
      if (!result) _checkFailed = true;
      if (result) {
        this.onProcessAssignment();

        let params: NavigationExtras = {
          // replaceUrl: false,
          state: {
            currentSlot: this.bookingSlot,
            clubId: this.bookingSlot.clubData.id,
            forDate: this.bookingSlot.slotAssigned.teeOffDate,
            courseId: this.bookingSlot.slotAssigned.startCourse.id,
            changeType: 'course',
            currency: this.currency ? this.currency : this.bookingSlot.slotAssigned.currency,
            fromClub: this.fromClub,
            itemizedBill: this.bookingItemBill,
            currentPlayerId: this.currentPlayerId ? this.currentPlayerId : null,
            paymentType: 'redeem',
          },
        };
        this.router.navigate(['redeem-player-club-credits'], params);
      }
    });
  }

  getPlayerClubCredits() {
    if (1) return false;
    let _playerBalances = 0;
    let _totalPlayers =
      this.bookingSlot && this.bookingSlot.bookingPlayers.length > 0
        ? this.bookingSlot.bookingPlayers.length
        : 0;
    if (this.fromClub) {
      if (_totalPlayers > 0) {
        this.bookingSlot.bookingPlayers.forEach((p, i) => {
          let _balance = this.getPlayersCredits(i);
          if (_balance >= 0) _playerBalances += _balance;
          if (i === _totalPlayers - 1) return _playerBalances;
        });
      } else return _playerBalances;
    } else if (!this.fromClub) {
      _playerBalances = this.getPlayersCredits(999, this.currentPlayerId);
      if (_playerBalances > 0) return true;
      else return false;
    } else return false;
  }
  getPlayersCredits(slot: number, playerId?: number) {
    let _clubId = this.bookingSlot.clubData.id;
    let _slot = slot;
    let _player;
    if (slot !== 999) _player = this.bookingSlot.bookingPlayers[_slot].player;
    let _balance;
    let _playerId;
    if (playerId) _playerId = playerId;
    this.flightService.getPlayerClubCredits(_playerId, _clubId).subscribe((data: any) => {
      if (data) {
        _balance = data.balance;
        if (this.fromClub) {
          this.playersBalance += data.balance;
          if (data.walletBalance) this.playersBalance += data.walletBalance;
        } else if (!this.fromClub) {
          this.playersBalance = data.balance;
          if (data.walletBalance) this.playersBalance += data.walletBalance;
        }
      }
    });
    return _balance;
  }
  getDealsAmount(amount: any, amountType: string, currency?: any, item?: any, type?: string) {
    if (!amount && type !== 'privilege') return '';
    let _currency;
    if (this.teeSlotNew) {
      _currency =
        this.teeTimeSlotDisplay.currency && this.teeTimeSlotDisplay.currency.symbol
          ? this.teeTimeSlotDisplay.currency.symbol
          : this.teeTimeSlotDisplay.slot.currency.symbol;
    } else _currency = this.bookingSlot.clubData.address.countryData.currencySymbol;
    let _amount = amount;
    let _amountType = amountType;
    let _flightApply;
    let _bookingApply;
    let _amPMtype;

    if (type === 'privilege' && item.applicableRate) {
      if (this.teeSlotNew) {
        _amPMtype = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('a');
      } else if (!this.teeSlotNew) {
        _amPMtype = moment(this.bookingSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('a');
      }
      if (_amPMtype === 'am') {
        _amount = item.applicableRate.amRate;
        _amountType = item.applicableRate.amRateType;
      } else if (_amPMtype === 'pm') {
        _amount = item.applicableRate.pmRate;
        _amountType = item.applicableRate.pmRateType;
      }
    }
    if (type === 'privilege') {
      _bookingApply = item.appliesToBooking;
    } else {
      _flightApply = item.appliesToFlight;
      _bookingApply = item.appliesToBookingAmount;
    }
    let _amountText;
    let _flightTxt;
    let _maxFlightSize = item && item.maxFlightSize ? item.maxFlightSize : 4;
    if (type === 'voucher') {
      if (_flightApply) _flightTxt = 'for flight of ' + _maxFlightSize;
      else _flightTxt = 'for 1 person';
    } else if (type === 'privilege') {
      if (_bookingApply) _flightTxt = 'for booking amount';
      else _flightTxt = 'for covered items';
    }
    if (_amountType === 'Absolute') {
      _amountText = 'Save ' + _currency + '&nbsp;' + _amount;
    } else if (_amountType === 'Fixed' || _amountType === 'Package') {
      _amountText = 'Pay up to ' + _currency + '&nbsp;' + _amount;
    } else if (_amountType === 'Percentage') {
      _amountText = _amount + '% off';
    }
    if (type === 'voucher') return _amountText + ' ' + _flightTxt;
    else if (type === 'privilege') return _amountText + ' ' + _flightTxt;
    else return _amountText;
  }

  getPlayerVoucherSeries() {
    this.voucherSeries = [];
    if (!this.teeSlotNew) {
      if (!this.bookingSlot) return false;
      if (
        this.bookingSlot.slotAssigned &&
        this.bookingSlot.slotAssigned.pricingPlanPromotional &&
        !this.bookingSlot.slotAssigned.pricingPlanPromotional.discountsApplicable
      )
        return false;
    } else {
      if (!this.teeTimeSlotDisplay) return false;
      if (
        this.teeTimeSlotDisplay &&
        this.teeTimeSlotDisplay.slot &&
        this.teeTimeSlotDisplay.slot.pricingPlanPromotional &&
        !this.teeTimeSlotDisplay.slot.pricingPlanPromotional.discountsApplicable
      )
        return false;
    }
    let _clubId;
    if (!this.teeSlotNew)
      _clubId =
        this.bookingSlot && this.bookingSlot.clubData.id
          ? this.bookingSlot.clubData.id
          : this.clubs.club.id;
    else {
      if (this.fromClub) _clubId = this.clubInfo.clubId;
      else if (!this.fromClub) _clubId = this.clubInfo ? this.clubInfo.clubId : this.clubs.club.id;
    }
    let voucherSeries: Array<TeeTimeClubVoucherSeries> = [];
    this.flightService.getClubVoucherSeries(1, _clubId).subscribe((data: any) => {
      if (data.totalInPage > 0 && data.items && data.items.length > 0) {
        voucherSeries = data.items;
        if (voucherSeries) {
          this.voucherSeries.push(...voucherSeries);
        }
      }
    });
  }

  playerActiveClubDiscount: Array<any>;
  getActiveClubDiscounts() {
    this.playerActiveClubDiscount = [];
    if (!this.teeSlotNew) {
      if (!this.bookingSlot) return false;
      if (
        this.bookingSlot.slotAssigned &&
        this.bookingSlot.slotAssigned.pricingPlanPromotional &&
        !this.bookingSlot.slotAssigned.pricingPlanPromotional.discountsApplicable
      )
        return false;
    } else {
      if (!this.teeTimeSlotDisplay) return false;
      if (
        this.teeTimeSlotDisplay &&
        this.teeTimeSlotDisplay.slot &&
        this.teeTimeSlotDisplay.slot.pricingPlanPromotional &&
        !this.teeTimeSlotDisplay.slot.pricingPlanPromotional.discountsApplicable
      )
        return false;
    }
    let _clubId;
    if (!this.fromClub)
      if (this.teeSlotNew)
        _clubId = this.clubs && this.clubs.club ? this.clubs.club.id : this.clubInfo.clubId;
      else if (!this.teeSlotNew)
        _clubId = this.clubInfo ? this.clubInfo.clubId : this.bookingSlot.clubData.id;
      else if (this.fromClub)
        _clubId =
          this.clubInfo && this.clubInfo.clubId
            ? this.clubInfo.clubId
            : this.bookingSlot.clubData.id;
    if (!_clubId) return false;
    let _playerId;
    if (!this.fromClub) _playerId = this.currentPlayerId;
    else if (this.fromClub && !this.teeSlotNew)
      _playerId =
        this.bookingSlot && this.bookingSlot.bookingPlayers.length > 0
          ? this.bookingSlot.bookingPlayers[0].player.id
          : null;
    let _currentDate;
    if (!this.teeSlotNew)
      _currentDate = moment(this.bookingSlot.slotAssigned.teeOffDate).format('YYYY-MM-DD');
    else if (this.teeSlotNew)
      _currentDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format('YYYY-MM-DD');
    if (!this.fromClub) {
      this.flightService
        .getApplicableDiscountsForPlayer(_clubId, _playerId, _currentDate)
        .subscribe(applicableDiscounts => {
          if (applicableDiscounts) {
            let _appDiscounts = applicableDiscounts.filter((ad: TeeTimeDiscount) => {
              return !ad.availableForClubOnly;
            });
            this.playerActiveClubDiscount.push(..._appDiscounts);
            this.playerActiveClubDiscount = this.playerActiveClubDiscount
              .filter(pcd => {
                return pcd.active;
              })
              .sort((a, b) => {
                if (a.discountProgram) {
                  if (a.name < b.name) return -1;
                  else if (a.name > b.name) return 1;
                  else return -1;
                } else if (b.discountProgram) {
                  if (a.name < b.name) return -1;
                  else if (a.name > b.name) return 1;
                  else return -1;
                } else return 0;
              });
          }
        });
    }
    if (this.fromClub) {
      this.flightService
        .getActiveListClubDiscounts(_clubId, _currentDate)
        .subscribe((activeClubDiscounts: Array<TeeTimeDiscount>) => {
          if (activeClubDiscounts) {
            this.playerActiveClubDiscount.push(...activeClubDiscounts);
            this.playerActiveClubDiscount = this.playerActiveClubDiscount
              .filter(pcd => {
                return pcd.active;
              })
              .sort((a, b) => {
                if (a.discountProgram) {
                  if (a.name < b.name) return -1;
                  else if (a.name > b.name) return 1;
                  else return -1;
                } else if (b.discountProgram) {
                  if (a.name < b.name) return -1;
                  else if (a.name > b.name) return 1;
                  else return -1;
                } else return 0;
              });
          }
        });
    }
  }

  onRecaptchaClick() {
    let _url = 'http://dev-play.mygolf2u.com/plain-recaptcha.html';
    let win = window.open(_url, '_system');
    win.location.href = _url;
    let winTick = setInterval(() => {
      if (win.closed) {
        clearInterval(winTick);
      }
    }, 500);
  }

  initServerStatus() {
    this.serverInfoService.serverInfo().subscribe((data: ServerInfo) => {
      if (data) {
        this.botsOut = data.botsOut;
      }
    });
  }

  getDiscountText(discount: TeeTimeDiscount, type?: string) {
    if (!discount) return false;
    let _currency;
    let _discountDetails = discount;
    if (!_discountDetails) return false;
    _currency = discount.club.address.countryData.currencySymbol;
    let _applies;
    if (type === 'amount') {
      if (discount.amountType.toLowerCase() === 'percentage') return discount.discount + '% off';
      else if (discount.amountType.toLowerCase() === 'absolute')
        return 'Less ' + _currency + ' ' + discount.discount;
      else if (
        discount.amountType.toLowerCase() === 'fixed' ||
        discount.amountType.toLowerCase() === 'package'
      )
        return _currency + ' ' + discount.discount;
    } else if (type === 'appliesFor') {
      let _appliesFor = 'Covers ';
      let _priceComponents;
      if (!_discountDetails.priceComponents || _discountDetails.priceComponents.length === 0)
        return '';
      let _buggyFee = _discountDetails.priceComponents.filter(price => {
        if (price.priceComponent.id.toLowerCase() === 'buggyfee') return true;
        if (price.priceComponent.id.toLowerCase() === 'hbuggyfee') return true;
        else return false;
      });

      let _caddyFee = _discountDetails.priceComponents.filter(price => {
        if (price.priceComponent.id.toLowerCase() === 'caddyfee') return true;
        if (price.priceComponent.id.toLowerCase() === 'hcaddyfee') return true;
        else return false;
      });

      _priceComponents = _discountDetails.priceComponents
        .filter(price => {
          if (_buggyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hbuggyfee';
          else return true;
        })
        .filter(price => {
          if (_caddyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hcaddyfee';
          else return true;
        });
      if (_priceComponents && _priceComponents.length > 0) {
        _appliesFor += _priceComponents
          .sort((a, b) => {
            if (a.priceComponent.name < b.priceComponent.name) return -1;
            else if (a.priceComponent.name < b.priceComponent.name) return 1;
            else return 0;
          })
          .map(a => {
            return a.priceComponent.name;
          })
          .reduce((a, b) => {
            return a + ', ' + b;
          });
      }
      return _appliesFor;
    } else if (type === 'appliesTo') {
      let _appliesTo = 'Applies to ';
      _appliesTo = 'Applies to ';
      if (!_discountDetails.playerTypes || _discountDetails.playerTypes.length === 0) return '';
      _appliesTo += _discountDetails.playerTypes
        .map(a => {
          return a.bookingPlayerType.name;
        })
        .reduce((a, b) => {
          return a + ', ' + b;
        });
      return _appliesTo;
    }
    if (1) return;
    switch (type) {
      case 'amount':
        if (discount.amountType.toLowerCase() === 'percentage') return discount.discount + '% off';
        else if (discount.amountType.toLowerCase() === 'absolute')
          return 'Less ' + _currency + ' ' + discount.discount;
        else if (
          discount.amountType.toLowerCase() === 'fixed' ||
          discount.amountType.toLowerCase() === 'package'
        )
          return _currency + ' ' + discount.discount;
      case 'appliesFor':
        _applies = 'Covers ';
        let _buggyFee = _discountDetails.priceComponents.filter(price => {
          if (price.priceComponent.id.toLowerCase() === 'buggyfee') return true;
          if (price.priceComponent.id.toLowerCase() === 'hbuggyfee') return true;
          else return false;
        });
        let _caddyFee = _discountDetails.priceComponents.filter(price => {
          if (price.priceComponent.id.toLowerCase() === 'caddyfee') return true;
          if (price.priceComponent.id.toLowerCase() === 'hcaddyfee') return true;
          else return false;
        });
        _discountDetails.priceComponents = _discountDetails.priceComponents.filter(price => {
          if (_buggyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hbuggyfee';
          if (_caddyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hcaddyfee';
          else return true;
        });
        if (!_discountDetails.priceComponents || _discountDetails.priceComponents.length === 0)
          return '';
        if (
          _discountDetails &&
          _discountDetails.priceComponents &&
          _discountDetails.priceComponents.length > 0
        )
          _applies += _discountDetails.priceComponents
            .map(a => {
              return a.priceComponent.name;
            })
            .reduce((a, b) => {
              return a + ', ' + b;
            });
        break;
      case 'appliesTo':
        _applies = 'Applies to ';
        if (!_discountDetails.playerTypes || _discountDetails.playerTypes.length === 0) return '';
        _applies += _discountDetails.playerTypes
          .map(a => {
            return a.bookingPlayerType.name;
          })
          .reduce((a, b) => {
            return a + ', ' + b;
          });
        break;
    }
    return _applies;
  }

  getDateText(date: string, type?: string) {
    if (!date) return false;
    if (date.length === 0) return false;
    let _date = date;
    if (type === 'datetime') {
      return moment(_date).format('DD MMM YYYY HH:mm:ss');
    } else return moment(_date, 'YYYY-MM-DD').format('DD MMM YYYY');
  }
  getClubPackages(type?: string) {
    let _packages = [];
    let _promo = [];
    let _key;
    let _min;
    let value;
    switch (type) {
      case 'new':
        if (!this.teeSlotNew) return;
        if (!this.teeTimeSlotDisplay.displayPrices) return;
        if (this.teeTimeSlotDisplay.originalPrices && this.teeTimeSlotDisplay.displayPrices) {
          for (let key in this.teeTimeSlotDisplay.originalPrices) {
            _promo.push({
              id: key,
              name: this.getBookingPlayerTypesDetail(key, 'name'),
              amount: this.teeTimeSlotDisplay.originalPrices[key],
            });
            _packages.push({
              id: key,
              name: this.getBookingPlayerTypesDetail(key, 'name'),
              amount: this.teeTimeSlotDisplay.originalPrices[key],
            });
          }
          for (let key in this.teeTimeSlotDisplay.displayPrices) {
            _packages
              .filter(p => {
                return p.id === key;
              })
              .map(p => {
                p.promo = this.teeTimeSlotDisplay.displayPrices[key];
              });
          }
          _packages = _packages.sort((a, b) => {
            if (a.amount < b.amount) return -1;
            else if (a.amount > b.amount) return 1;
            else return 0;
          });
          return _packages;
        } else if (
          this.teeTimeSlotDisplay.displayPrices &&
          !this.teeTimeSlotDisplay.originalPrices
        ) {
          for (let key in this.teeTimeSlotDisplay.displayPrices) {
            _packages.push({
              id: key,
              name: this.getBookingPlayerTypesDetail(key, 'name'),
              amount: this.teeTimeSlotDisplay.displayPrices[key],
            });
          }
          _packages = _packages.sort((a, b) => {
            if (a.amount < b.amount) return -1;
            else if (a.amount > b.amount) return 1;
            else return 0;
          });
          return _packages;
        }
      default:
        if (this.teeSlotNew) return;
        for (let key in this.bookingSlot.priceMap) {
          _packages.push({
            id: key,
            name: this.getBookingPlayerTypesDetail(key, 'name'),
            amount: this.bookingSlot.priceMap[key],
          });
        }
        _packages = _packages.sort((a, b) => {
          if (a.amount < b.amount) return -1;
          else if (a.amount > b.amount) return 1;
          else return 0;
        });
        _packages = this.getUnique(_packages, 'name');
        return _packages;
    }
  }

  getBookingPlayerTypesDetail(key: string, attribute?: string) {
    if (!this.bookingPlayerTypes) return;
    let _playerType: BookingPlayerType;
    this.bookingPlayerTypes
      .filter((pt: BookingPlayerType) => {
        return pt.id === key;
      })
      .map((pt: BookingPlayerType) => {
        _playerType = pt;
      });
    switch (attribute) {
      default:
        return _playerType.name;
    }
  }

  activeClubDiscounts: Array<any>;
  getApplicableDiscountsForPlayer() {
    if (this.bookingSlot && this.bookingSlot.bookingPlayers.length === 0) return false;
    let _clubId = this.bookingSlot.clubData.id;
    if (!_clubId) return false;
    let _playerId = this.currentPlayerId
      ? this.currentPlayerId
      : this.bookingSlot.bookingPlayers[0].player.id;
    let _effectiveDate = moment(this.bookingSlot.slotAssigned.teeOffDate).format('YYYY-MM-DD');
    this.flightService
      .getApplicableDiscountsForPlayer(_clubId, _playerId, _effectiveDate)
      .subscribe(
        (activeClubDiscounts: Array<TeeTimeDiscount>) => {
          this.playerActiveClubDiscount = activeClubDiscounts;
        },
        error => {},
        () => {}
      );
  }

  getCurrentPlayerVoucher() {
    let _playerId;
    let _clubId;
    if (this.teeSlotNew) _clubId = this.clubs ? this.clubs.club.id : this.clubInfo.clubId;
    else if (!this.teeSlotNew) _clubId = this.bookingSlot.clubData.id;
    if (!this.fromClub) {
      _playerId = this.currentPlayerId;
    }
    this.flightService
      .getListPlayerVouchers(_playerId)
      .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
        this.playerVoucher = playerVoucher.filter(pv => {
          return pv.club.id === _clubId && !pv.redeemed;
        });
      });
  }

  getAllowUpdatePostPayment(type?: string) {
    let _allow: boolean = false;
    let _flightStatusAllowed;
    if (this.bookingSlot && this.bookingSlot.flight && !type)
      _flightStatusAllowed =
        this.bookingSlot.flight.status === 'Created' ||
        this.bookingSlot.flight.status === 'Assigned';
    else if (this.bookingSlot && this.bookingSlot.flight && type === 'deals')
      _flightStatusAllowed =
        this.bookingSlot.flight.status !== 'PlayFinished' &&
        this.bookingSlot.flight.status !== 'Abandoned';
    else _flightStatusAllowed = true;
    _allow = (_flightStatusAllowed && this.bookingType !== 'past') || this.fromClub;
    return _allow;
  }

  playerDP;
  getPendingPlayerDiscountCard() {
    let _isEligible;
    let _pendingPDP = [];
    let _approvedPDP = [];
    let _pendingDiscountCards = [];
    let _playerId = this.currentPlayerId;
    let _clubId;
    if (!this.teeSlotNew) _clubId = this.bookingSlot.clubData.id;
    else if (this.teeSlotNew) _clubId = this.clubs ? this.clubs.club.id : this.clubInfo.clubId;
    this.flightService.getListAllPlayersCardDiscount(_clubId).subscribe(
      data => {
        let _pdp: Array<DiscountPlayerClub>;
        if (data) _pdp = data;
        if (_pdp && _pdp.length > 0) {
          this.playerDP = _isEligible = _pdp.filter((p: DiscountPlayerClub) => {
            return (
              p.club.id === _clubId && p.verified && p.playerDiscountProgram.player.id === _playerId
            );
          });
        }
      },
      error => {},
      () => {}
    );
  }

  getEligibleDiscount(discount, status?: string) {
    if (!this.playerDP || (this.playerDP && this.playerDP.length === 0)) return false;
    let _isEligible = this.playerDP.filter((dp: DiscountPlayerClub) => {
      if (discount.discountProgram && discount.discountProgram.id)
        return dp.playerDiscountProgram.discountProgram.id === discount.discountProgram.id;
      else if (!discount.discountProgram) return true;
    });
    if (_isEligible && _isEligible.length > 0) return false;
    else return true;
  }

  async onEligibleClick(type?: string) {
    let _playerName = this.currentPlayer.playerName + ' [You]';
    let _msg;
    _msg = _playerName;
    if (type.toLowerCase() === 'yes') _msg += ' are eligible to use this discount';
    else if (type.toLowerCase() === 'no') _msg += ' are not eligible to use this discount';
    let alert = await this.alertCtrl
      .create({
        header: 'Discount Applicable',
        message: _msg,
        buttons: ['Close'],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  getBookingBalance(inNumber?: boolean) {
    if (this.teeSlotNew) return;
    let _balance;
    _balance =
      this.bookingItemBill.totalPayable -
      this.bookingItemBill.totalPayment -
      this.bookingItemBill.totalDeductions +
      this.bookingItemBill.totalRefund;
    if (inNumber) {
      return Number(_balance.toFixed(2));
    } else return this.numberWithCommas(_balance.toFixed(2));
  }

  getBookingPayment(inNumber?: boolean) {
    if (this.teeSlotNew) return;
    let _payment;
    _payment = this.bookingItemBill.totalPayment ? this.bookingItemBill.totalPayment : 0;
    if (inNumber) return Number(_payment.toFixed(2));
    else return this.numberWithCommas(Number(_payment.toFixed(2)));
  }

  hasRedeemedAmount() {
    if (this.teeSlotNew) return;
    if (!this.bookingItemBill) return;
    if (this.bookingItemBill && this.bookingItemBill.payments.length === 0) return;
    let _hasRedeem: boolean = false;
    this.bookingItemBill.payments.filter((p: BookingPayment) => {
      if (p.paymentMethod.toLowerCase().includes('redeem')) _hasRedeem = true;
    });
    return _hasRedeem;
  }

  getTotalRedeemAmount() {
    if (this.teeSlotNew) return;
    if (!this.bookingItemBill) return;
    if (this.bookingItemBill && this.bookingItemBill.payments.length === 0) return;
    let _redeemAmount;
    _redeemAmount = this.bookingItemBill.payments
      .filter((p: BookingPayment) => {
        if (p.paymentMethod.toLowerCase().includes('redeem')) return true;
        else return false;
      })
      .map(a => {
        return a.amountPaid;
      })
      .reduce((a, b) => {
        return a + b;
      });
    return _redeemAmount.toFixed(2);
  }

  isRedeemAmount(p: BookingPayment) {
    if (!p) return;
    if (p.paymentMethod.toLowerCase().includes('redeem')) return '(R)';
    else return;
  }

  isBookingCancel() {
    if (this.teeSlotNew) return false;
    if (!this.bookingSlot) return false;
    if (this.bookingSlot && !this.bookingSlot.bookingStatus) return false;
    return (
      this.bookingSlot.bookingStatus === 'CancelledByPlayer' ||
      this.bookingSlot.bookingStatus === 'CancelledByClub'
    );
  }

  newClearPreference(i: number, type?: string) {
    let _preference = this.newBuggyCaddyPreference;
    let _bookingPlayer;
    _bookingPlayer = this.bookingSlot.bookingPlayers[i];

    switch (type) {
      case 'buggyPairing':
        _preference.ignoreBuggyUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.buggyPairing = 0;
            p.buggyRequired = false;
          }
        });
        this.bookingSlot.bookingPlayers[i].pairingNo = 0;
        break;
      case 'caddyPairing':
        _preference.ignoreCaddieUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.caddyPairing = 0;
            p.caddyRequired = false;
            p.caddiePreferred = null;
            p.caddieAssigned = null;
            p.caddyAssigned = null;
            p.caddyPreferred = null;
          }
        });
        this.bookingSlot.bookingPlayers[i].caddyPairing = 0;
        this.bookingSlot.bookingPlayers[i].caddyPreferred = null;
        this.bookingSlot.bookingPlayers[i].caddyAssigned = null;
        break;
      case 'caddyPreferred':
        _preference.ignoreCaddieUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.caddyPairing = 0;
            p.caddyRequired = false;
            p.caddiePreferred = null;
            p.caddieAssigned = null;
            p.caddyAssigned = null;
            p.caddyPreferred = null;
          }
        });
        this.bookingSlot.bookingPlayers[i].caddyPreferred = null;
        this.bookingSlot.bookingPlayers[i].caddyAssigned = null;
        break;
      case 'playerDriving':
        _preference.ignoreBuggyUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.driving = false;
          }
        });
        this.bookingSlot.bookingPlayers[i].driving = false;
        break;
      case 'buggyType':
        _preference.ignoreBuggyUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.buggyType = 'STANDARD';
          }
        });
        this.bookingSlot.bookingPlayers[i].buggyCaddiePreference.buggyType = 'STANDARD';
        break;
    }
  }

  async newSetBuggySeating(b: any, event) {
    this.expandDetails(b, 'toggle');
    const popover: any = await this.popoverCtl.create({
      component: BuggySeatingPage,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      event: event,
      componentProps: {
        type: 'buggy',
        headerName: 'Buggy Seating',
        buggies: this.buggySlots,
        slot: this.bookingSlot,
        bookingOptions: this.bookingOptions ? this.bookingOptions : null,
        override: true,
      },
      showBackdrop: true,
    });

    popover.onDidDismiss().then((data: any) => {
      let _buggyNo;
      let _buggyCount;
      let _maxAllowedBuggy = this.bookingSlot.slotAssigned.maxPlayersPerBuggy;
      let _currentPairingNo;
      var data = data?.data;
      if (data?.data && data?.data?.selected) {
        let i = b;
        let _preference = this.newBuggyCaddyPreference;
        let _bookingPlayer;
        let _pairingNo = data.data.buggy.pairingNo;
        _bookingPlayer = this.bookingSlot.bookingPlayers[i];
        _preference.ignoreBuggyUpdate = false;
        _preference.playerPairings.filter((p: PlayerBuggyCaddiePreference) => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.buggyPairing = _pairingNo;
            p.buggyRequired = _pairingNo > 0 ? true : false;
            if (p.buggyPairing === 0) p.driving = false;
            p.assignedBuggy = null;
          }
        });
        this.bookingSlot.bookingPlayers[i].pairingNo = _pairingNo;
        if (_pairingNo === 0) this.bookingSlot.bookingPlayers[i].driving = false;
      }
    });
    popover.present({
      ev: event,
    });
  }

  async newSetCaddyPairing(b: any, event) {
    // if(this.bookingOptions && this.bookingOptions.buggyMandatory &&
    if (
      this.bookingSlot &&
      !this.bookingSlot.slotAssigned.allowWalking &&
      this.bookingSlot.bookingPlayers[b] &&
      (this.bookingSlot.bookingPlayers[b].pairingNo === 0 ||
        !this.bookingSlot.bookingPlayers[b].pairingNo)
    ) {
      let msg = MessageDisplayUtil.getErrorMessage('', 'Please select a buggy first');
      MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
      return false;
    }
    this.caddySlots = [];
    this.caddySlots[0] = {
      caddyPairing: 0,
      caddyRequired: false,
      caddyPreferred: null,
      caddyRequested: false,
      caddySelectionCriteria: null,
      caddyAssigned: null,
    };

    for (var i = 1; i <= this.caddyReq; i++) {
      this.caddySlots.push(
        Object.assign({}, this.caddySlots[i], {
          caddyRequired: false,
          caddyPreferred: null,
          caddyRequested: false,
          caddySelectionCriteria: null,
          caddyPairing: i,
          caddyAssigned: null,
        })
      );
    }
    this.caddySlots.forEach(c => {
      this.caddyPairing
        .filter(cp => {
          return cp.caddyPairing === c.caddyPairing;
        })
        .map(cp => {
          c.caddyPreferred = cp.caddyPreferred;
        });
    });
    const popover: any = await this.popoverCtl.create({
      component: BuggySeatingPage,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        type: 'caddy',
        headerName: 'Caddy Pairing',
        caddies: this.caddySlots,
        pairing: this.caddyPairing,
      },
      showBackdrop: true,
    });

    popover.onDidDismiss().then((data: any) => {
      let _currentCaddy;
      let _currentBuggy;
      _currentBuggy = this.bookingSlot.bookingPlayers[b].pairingNo;
      _currentCaddy = this.bookingSlot.bookingPlayers[b].caddyPairing;
      let _caddyNo;
      let _caddyCount;
      let _maxAllowedCaddy = this.bookingSlot.slotAssigned.maxPlayersPerCaddy;
      let _caddyBuggySuccess = true;
      if (data?.data && data?.data?.selected) {
        let i = b;
        let _preference = this.newBuggyCaddyPreference;
        let _bookingPlayer;
        let _pairingNo = data?.data?.caddy.caddyPairing;

        _caddyBuggySuccess = this.bookingSlot.bookingPlayers
          .filter((player: TeeTimeBookingPlayer, idx: number) => {
            if (data?.data?.caddy.caddyPairing > 0)
              return player.caddyPairing === data?.data?.caddy.caddyPairing;
          })
          .every((p: TeeTimeBookingPlayer, currIdx, nextP: Array<TeeTimeBookingPlayer>) => {
            if (p.pairingNo !== _currentBuggy) return false;
            else return true;
          });
        // if (!_caddyBuggySuccess) {
        //   MessageDisplayUtil.showMessageToast(
        //     'Caddy is paired in different buggy',
        //     this.platform,
        //     this.toastCtl,
        //     3000,
        //     'bottom'
        //   );
        //   return false;
        // }
        _bookingPlayer = this.bookingSlot.bookingPlayers[i];
        _preference.ignoreCaddieUpdate = false;
        let _caddyPreferred;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            this.bookingSlot.bookingPlayers[i].caddyPairing = _pairingNo;
            p.caddyPairing = _pairingNo;
            p.caddyRequired = _pairingNo > 0 ? true : false;
            p.caddieAssigned = null;
            if (data.data && data?.data?.caddy && data?.data?.caddy.caddyPreferred) {
              p.caddyPreferred = data?.data?.caddy.caddyPreferred;
              p.caddiePreferred = data?.data?.caddy.id;
              this.bookingSlot.bookingPlayers[i].caddyPreferred = data?.data?.caddy.caddyPreferred;
            } else if (!data.data?.caddy.caddyPreferred) {
              this.bookingSlot.bookingPlayers.filter(bp => {
                if (bp.id !== _bookingPlayer.id) {
                  if (bp.caddyPairing === _pairingNo) {
                    p.caddyPreferred = bp.caddyPreferred;
                    if (bp.caddyPreferred) p.caddiePreferred = bp.caddyPreferred.id;
                  }
                }
              });
              this.bookingSlot.bookingPlayers[i].caddyPreferred = null;
            }
          }
        });
      }
    });
    popover.present({
      ev: event,
    });
  }

  newUpdatePreference(i: number, type?: string) {
    let _preference = this.newBuggyCaddyPreference;
    let _bookingPlayer;
    _bookingPlayer = this.bookingSlot.bookingPlayers[i];

    switch (type) {
      case 'buggyPairing':
        _preference.ignoreBuggyUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.buggyPairing = 0;
            p.buggyRequired = false;
          }
        });
        break;
      case 'caddyPairing':
        _preference.ignoreCaddieUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.caddyPairing = 0;
            p.caddyRequired = false;
            p.caddiePreferred = null;
            p.caddieAssigned = null;
          }
        });
        break;
      case 'caddyPreferred':
        _preference.ignoreCaddieUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.caddyPairing = 0;
            p.caddyRequired = false;
            p.caddiePreferred = null;
            p.caddieAssigned = null;
          }
        });
        break;
    }
  }

  onNewSelectCaddy(playerIdx: number, _caddyNo?: number) {
    if (!this.fromClub && !this.bookingOptions.allowCaddiePreference) {
      MessageDisplayUtil.showMessageToast(
        "This club currently doesn't allow Caddie booking",
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (
      this.bookingSlot.bookingPlayers[playerIdx].caddyPairing === 0 ||
      this.bookingSlot.bookingPlayers[playerIdx].caddyPairing === null
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please select Caddy Pairing first',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    this.newSelectCaddy(playerIdx, _caddyNo);
  }

  async newSelectCaddy(playerIdx: number, caddyNo?: number) {
    let caddiesToExclude = this.caddyPairing;
    let _caddyNo = caddyNo;
    if (this.caddyReq === 0) {
      let alert = await this.alertCtrl
        .create({
          header: 'Preferred Caddy',
          message: 'Please add a caddy number above.',
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
          this.captchaResponse = null;
        });
      return false;
    }
    const caddyModal = await this.modalCtl.create({
      component: CaddyListPage,
      // cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        clubId: this.bookingSlot.clubData.id,
        fromBooking: true,
        bookingCurrDate: this.bookingSlot.slotAssigned.teeOffDate,
        currentDate: this.bookingSlot.slotAssigned.teeOffDate,
        caddiesToExclude: caddiesToExclude,
        bookingId: this.bookingSlot.id,
      },
    });
    let _bookingPlayers = this.bookingSlot.bookingPlayers;
    caddyModal.onDidDismiss().then((data: any) => {
      let _preference = this.newBuggyCaddyPreference;
      let _bookingPlayer;
      let i = playerIdx;
      let _caddy;
      console.debug(
        'caddy modal dismiss : ',
        data,
        this.newBuggyCaddyPreference,
        this.buggyCaddyPreference
      ); //
      _bookingPlayer = this.bookingSlot.bookingPlayers[i];
      if (data.data && data?.data?.selected) {
        _preference.ignoreCaddieUpdate = false;
        _preference.playerPairings.filter(p => {
          if (p.bookingPlayerId === _bookingPlayer.id) {
            p.caddiePreferred = data?.data?.caddy.id;
            p.caddyPreferred = data?.data?.caddy;
            p.caddyAssigned = null;
            p.caddieAssigned = null;
          }
          if (p.caddyPairing === _bookingPlayer.caddyPairing) {
            p.caddiePreferred = data?.data?.caddy.id;
            p.caddyPreferred = data?.data?.caddy;
            p.caddyAssigned = null;
            p.caddieAssigned = null;

            this.caddySlots.filter(cs => {
              if (cs.caddyPairing === p.caddyPairing) {
                cs.caddyPreferred = data?.data?.caddy;
                cs.caddiePreferred = data?.data?.caddy.id;
              }
            });

            this.caddyPairing.filter(cp => {
              if (cp.caddyPairing === p.caddyPairing) {
                cp.caddyPreferred = data?.data?.caddy;
                cp.caddiePreferred = data?.data?.caddy.id;
              }
            });
          }

          this.bookingSlot.bookingPlayers.filter(bp => {
            if (bp.caddyPairing === _bookingPlayer.caddyPairing) {
              bp.caddyPreferred = data?.data?.caddy;
              p.caddyAssigned = null;
            }
          });
        });
        _caddy = data?.data?.caddy;
        _bookingPlayer.caddyPreferred = _caddy;
        console.debug(
          'caddy modal dismiss : ',
          _preference,
          this.newBuggyCaddyPreference,
          _preference
        );
      }
    });
    return await caddyModal.present();
  }

  newSetPlayerDriving(b: any, p: TeeTimeBookingPlayer, driving?: string) {
    // if(this.bookingOptions && !this.bookingOptions.buggyMandatory && this.bookingSlot.bookingPlayers[b].pairingNo===0) {
    if (
      this.bookingSlot &&
      this.bookingSlot.slotAssigned.allowWalking &&
      this.bookingSlot.bookingPlayers[b].pairingNo === 0
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please select a buggy first',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else if (
      this.bookingSlot &&
      !this.bookingSlot.slotAssigned.allowWalking &&
      this.bookingSlot.bookingPlayers[b].pairingNo === 0
    ) {
      MessageDisplayUtil.showMessageToast(
        'Buggy is required for this slot. Please select a buggy.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.bookingType === 'past') return false;
    let _playerIsDriving;
    let _otherPlayer = this.bookingSlot.bookingPlayers.filter((pd: TeeTimeBookingPlayer) => {
      if (
        pd.pairingNo === this.bookingSlot.bookingPlayers[b].pairingNo &&
        this.bookingSlot.bookingPlayers[b].id !== pd.id
      )
        return true;
    });
    if (driving === 'me') {
      _playerIsDriving = true;
      this.bookingSlot.bookingPlayers[b].driving = _playerIsDriving;
    } else if (driving === 'other') {
      _playerIsDriving = false;
      this.bookingSlot.bookingPlayers[b].driving = _playerIsDriving;
    } else {
      _playerIsDriving = this.bookingSlot.bookingPlayers[b].driving;
      if (_otherPlayer && _otherPlayer[0]) {
        _otherPlayer[0].driving = _playerIsDriving;
        this.bookingSlot.bookingPlayers[b].driving = !_playerIsDriving;
      } else {
        this.bookingSlot.bookingPlayers[b].driving = driving == 'No' ? false : true;
      }
    }
    let _preference = this.newBuggyCaddyPreference;
    console.debug('new set player driving : ', _preference);
    _preference.ignoreBuggyUpdate = false;
    // _preference.ignoreCaddieUpdate = true;
    _preference.playerPairings
      .filter((p: PlayerBuggyCaddiePreference) => {
        return p.bookingPlayerId === this.bookingSlot.bookingPlayers[b].id;
      })
      .map((p: PlayerBuggyCaddiePreference) => {
        p.driving = !_playerIsDriving;
      });
    if (_otherPlayer && _otherPlayer[0]) {
      _preference.playerPairings
        .filter((p: PlayerBuggyCaddiePreference) => {
          return p.bookingPlayerId === _otherPlayer[0].id;
        })
        .map((p: PlayerBuggyCaddiePreference) => {
          p.driving = _playerIsDriving;
        });
    }
  }

  // Method for the reset preference
  async onResetPreference(mode?: string) {
    let _title;
    let _message;
    if (mode === 'leave') {
      _title = 'Buggy Caddy Pairings';
      _message = 'This will discard any Buggy/Caddie Pairings. Do you want to proceed?';
    } else {
      _title = 'Reset Buggy Caddy Pairings';
      _message =
        'This will Reset Buggy/Caddie Pairings to previous settings. Do you want to proceed?';
    }
    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'notification',
        header: _title,
        msg: _message,
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      if (data) {
        if (data?.data === 'confirm') {
          if (mode === 'leave') {
            this.resetPreference();
            setTimeout(() => {
              this.nav.pop();
            }, 500);
          } else this.resetPreference();
          this.captchaResponse = null;
        }
      }
    });
  }

  resetPreference() {
    this.buggyReq = 0;
    this.caddyReq = 0;
    let _bookingPlayers = this.bookingSlot.bookingPlayers;
    let _uniqBuggy = this.getUnique(this.buggyCaddyPreference.playerPairings, 'buggyPairing');
    let _uniqCaddy = this.getUnique(this.buggyCaddyPreference.playerPairings, 'caddyPairing');
    this.newBuggyCaddyPreference = JSON.parse(JSON.stringify(this.buggyCaddyPreference));

    if (_uniqBuggy)
      this.buggyReq = _uniqBuggy.filter((p: PlayerBuggyCaddiePreference) => {
        return p.buggyPairing;
      }).length;
    if (_uniqCaddy)
      this.caddyReq = _uniqCaddy.filter((p: PlayerBuggyCaddiePreference) => {
        return p.caddyPairing;
      }).length;

    this.bookingSlot.bookingPlayers.forEach((bp, idx) => {
      this.newBuggyCaddyPreference.playerPairings.filter((p: PlayerBuggyCaddiePreference) => {
        if (p.bookingPlayerId === bp.id) {
          this.bookingSlot.bookingPlayers[idx].driving = p.driving;
          this.bookingSlot.bookingPlayers[idx].pairingNo = p.buggyPairing;
          this.bookingSlot.bookingPlayers[idx].caddyPairing = p.caddyPairing;
          this.bookingSlot.bookingPlayers[idx].caddyPreferred = p.caddyPreferred;
          this.bookingSlot.bookingPlayers[idx].caddyAssigned = p.caddyAssigned;
          this.bookingSlot.bookingPlayers[idx].buggyCaddiePreference.buggyType = p.buggyType;
          //this.selectedBuggyType[idx] = p.buggyType;
        }
      });
    });
    this.expandPlayers.forEach((expand, idx) => {
      this.expandPlayers[idx] = false;
    });
  }

  newRemoveCaddy(playerIdx?: number, caddyNo?: number) {
    this.caddyRemoveFlag = true;
    this.caddyPairing[caddyNo].caddyPreferred = null;
    this.caddyPairing[caddyNo].caddyAssigned = null;
    this.caddySlots[caddyNo].caddyPreferred = null;
    this.caddySlots[caddyNo].caddyAssigned = null;

    this.bookingSlot.bookingPlayers[playerIdx].caddyPairing = caddyNo;
    let _bookingPlayer = this.bookingSlot.bookingPlayers[playerIdx];
    this.bookingSlot.bookingPlayers.forEach((p, idx) => {
      if (p.id === _bookingPlayer.id && p.caddyPairing === caddyNo) {
        p.caddyPreferred = null;
        p.caddySelectionCriteria = null;
        p.caddyAssigned = null;
      } else if (p.caddyPairing === caddyNo) {
        p.caddyPreferred = null;
        p.caddySelectionCriteria = null;
        p.caddyAssigned = null;
      }
    });

    let _preference = this.newBuggyCaddyPreference;
    _preference.ignoreCaddieUpdate = false;
    _preference.playerPairings.filter((p: PlayerBuggyCaddiePreference) => {
      if (p.bookingPlayerId === _bookingPlayer.id) {
        p.caddyPreferred = null;
        p.caddyRequired = p.caddyPairing > 0 ? true : false;
        p.caddiePreferred = null;
        p.caddieAssigned = null;
        p.caddyAssigned = null;
      } else if (p.caddyPairing === _bookingPlayer.caddyPairing) {
        p.caddyPreferred = null;
        p.caddyRequired = p.caddyPairing > 0 ? true : false;
        p.caddiePreferred = null;
        p.caddieAssigned = null;
        p.caddyAssigned = null;
      }
    });
  }

  async onUpdatePreference() {
    let _hasChanges: boolean = false;
    if (
      JSON.stringify(this.buggyCaddyPreference) !== JSON.stringify(this.newBuggyCaddyPreference)
    ) {
      _hasChanges = true;
    }
    let _changesTxt = 'There is ' + (_hasChanges ? 'changes' : 'no changes') + '. ';
    let _validation = this.onValidatePreference();
    if (_validation && _validation.valid) {
      let alert = await this.alertCtrl
        .create({
          header: 'Update Buggy Caddy Pairings',
          message:
            'This will Update Buggy/Caddie Pairings to new settings. Do you want to proceed?',
          buttons: [
            {
              text: 'No',
              handler: () => {},
            },
            {
              text: 'Yes',
              handler: () => {
                this.updatePreference();
              },
            },
          ],
        })
        .then(res => {
          res.present();
          this.captchaResponse = null;
        });
    } else if (_validation && !_validation.valid) {
      let _reasonTxt = _validation.reason.filter(this.onlyUnique);
      let _msg = _reasonTxt.join('<br>');
      let alert = await this.alertCtrl
        .create({
          header: 'Buggy & Caddie Pairings Validation',
          message: _msg,
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
          this.captchaResponse = null;
        });
      return false;
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  onValidatePreference() {
    if (!this.newBuggyCaddyPreference.bookingId) return;
    let _hasInvalid;
    let _buggy;
    let _caddy;
    let _caddyMandatory = this.bookingSlot.slotAssigned.caddyMandatory;
    let _buggyMandatory = !this.bookingSlot.slotAssigned.allowWalking;
    let _maxPlayersPerBuggy = this.bookingSlot.slotAssigned.maxPlayersPerBuggy;
    let _maxPlayersPerCaddy = this.bookingSlot.slotAssigned.maxPlayersPerCaddy;

    if (this.bookingSlot && this.bookingSlot.pricingPlanApplied === 'J') {
      if (this.bookingSlot.slotAssigned.maxPlayersPerBuggyJumbo)
        _maxPlayersPerBuggy = this.bookingSlot.slotAssigned.maxPlayersPerBuggyJumbo;
      else _maxPlayersPerBuggy = 1;
      if (this.bookingSlot.slotAssigned.maxPlayersPerCaddyJumbo)
        _maxPlayersPerCaddy = this.bookingSlot.slotAssigned.maxPlayersPerCaddyJumbo;
      else _maxPlayersPerCaddy = 1;
    }
    let _buggyCount;
    let _caddyCount;
    let _caddyPreferredCount;
    let _reasonTxt = [];
    this.newBuggyCaddyPreference.playerPairings.filter(pp => {
      if (pp.buggyPairing === 0 && _buggyMandatory) {
        _reasonTxt.push('Buggy is mandatory');
        _hasInvalid = true;
      }
      if (pp.caddyPairing === 0 && _caddyMandatory) {
        _reasonTxt.push('Caddy is mandatory');
        _hasInvalid = true;
      }
    });
    for (let pp of this.newBuggyCaddyPreference.playerPairings) {
      _buggyCount = this.newBuggyCaddyPreference.playerPairings.filter(fpp => {
        if (fpp.buggyPairing === pp.buggyPairing && pp.buggyPairing > 0) return true;
      });
      if (
        _buggyCount &&
        _buggyCount.length > _maxPlayersPerBuggy &&
        this.bookingSlot.pricingPlanApplied !== 'J'
      ) {
        _reasonTxt.push('You can only have ' + _maxPlayersPerBuggy + ' player(s) per buggy');
        _hasInvalid = true;
      }

      _caddyCount = this.newBuggyCaddyPreference.playerPairings.filter(fpp => {
        if (fpp.caddyPairing === pp.caddyPairing && pp.caddyPairing > 0) return true;
      });
      if (_caddyCount && _caddyCount.length > _maxPlayersPerCaddy) {
        _reasonTxt.push(
          'One of the caddie is fully utilized (max: ' + _maxPlayersPerCaddy + ' players)'
        );
        _hasInvalid = true;
      }
      _caddyPreferredCount = this.newBuggyCaddyPreference.playerPairings.filter(fpp => {
        if (
          !fpp.caddiePreferred ||
          !pp.caddiePreferred ||
          pp.caddiePreferred > 0 ||
          fpp.caddiePreferred > 0
        )
          return false;
        if (
          fpp.caddiePreferred === pp.caddiePreferred &&
          pp.caddyPairing > 0 &&
          fpp.caddyPairing > 0
        )
          return true;
      });
      if (_caddyPreferredCount && _caddyPreferredCount.length > _maxPlayersPerCaddy) {
        _reasonTxt.push(
          'One of the preferred caddie is fully utilized (max: ' + _maxPlayersPerCaddy + ' players)'
        );
        _hasInvalid = true;
      }
    }
    return {
      valid: !_hasInvalid,
      reason: _reasonTxt,
    };
  }

  async continuePreference() {
    let _content = !this.updatingPlayer ? 'Updating preferences...' : '';
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: _content,
    });

    let _preference = JSON.parse(JSON.stringify(this.newBuggyCaddyPreference));
    if (this.updatingPlayer) {
      _preference.playerPairings.forEach(pp => {
        if (this.assignmentDone && pp.caddyPairing > 0 && !pp.caddiePreferred) {
          let _caddy = this.newBuggyCaddyPreference.playerPairings.filter(npp => {
            if (npp.caddyPairing === pp.caddyPairing && npp.caddiePreferred) {
              _preference.ignoreCaddieUpdate = false;
              return true;
            }
          });
          if (_caddy && _caddy.length > 0) {
            pp.caddyPreferred = _caddy[0].caddyPreferred;
            pp.caddiePreferred = _caddy[0].caddyPreferred.id;
          }
        }
        if (this.assignmentDone && pp.buggyPairing > 0 && !pp.assignedBuggy) {
          let _buggy = this.newBuggyCaddyPreference.playerPairings.filter(npp => {
            if (npp.buggyPairing === pp.buggyPairing && npp.assignedBuggy) {
              _preference.ignoreBuggyUpdate = false;
              return true;
            }
          });
          if (_buggy && _buggy.length > 0) {
            pp.assignedBuggy = _buggy[0].assignedBuggy;
          }
        }
      });
    }
    loader.present().then(() => {
      console.debug(
        'updating preference : ',
        this.buggyCaddyPreference,
        this.newBuggyCaddyPreference,
        _preference
      );

      this.onProcessBuggyCaddyPref(this.newBuggyCaddyPreference)
        .then((res: any) => {
          if (res && res.status === 'success') {
            this.expandPlayers.forEach((expand, idx) => {
              this.expandPlayers[idx] = false;
            });
            if (this.updatingPlayer) this.updatingPlayer = false;
            if (this.fromClub && this.bookingSlot && this.bookingSlot.amountPaid > 0) {
              this.recalculateBookingPricing();
              this.onProcessAssignment();
            } else if (this.assignmentDone) {
              this.recalculateBookingPricing();
              this.onProcessAssignment();
            } else this.recalculateBookingPricing();
          }
        })
        .catch(async error => {
          let _error;
          if (error) _error = error.error;
          let _msg;
          if (_error.errorMessage) _msg = _error.errorMessage;
          if (this.isBookingCancel()) return;
          let alert = await this.alertCtrl.create({
            header: 'Update Buggy/Caddie Preference',
            message: _msg,
            buttons: [
              {
                text: 'Ok',
                role: 'cancel',
              },
            ],
          });
          alert.present();
          loader.dismiss();
        });
    });
  }

  updatePreference() {
    if (1) {
      this.continuePreference();
      return;
    }
    // if (this.appAttribute && this.appAttribute.overrideUpdatePrefCancel) {
    //   this.onCancelAssignment(false)
    //     .then((res: any) => {
    //       if (res && res.status === 'success') {
    //         this.continuePreference();
    //       }
    //     })
    //     .catch(() => {});
    // } else if (this.fromClub) {
    //   this.onCancelAssignment(false)
    //     .then((res: any) => {
    //       if (res && res.status === 'success') {
    //         this.continuePreference();
    //       }
    //     })
    //     .catch(() => {});
    // } else if (
    //   this.appAttribute &&
    //   this.appAttribute.overrideUpdatePrefCancel === undefined
    // ) {
    //   if (this.assignmentDone) {
    //     this.onCancelAssignment(false)
    //       .then((res: any) => {
    //         if (res && res.status === 'success') {
    //           this.continuePreference();
    //         }
    //       })
    //       .catch(() => {});
    //   } else this.continuePreference();
    // }
  }

  hasPreferenceChanges(i?: number) {
    let _hasChanges: boolean = false;
    let _bookingPlayer = this.bookingSlot.bookingPlayers[i];
    if (!i) {
      if (
        JSON.stringify(this.buggyCaddyPreference) !== JSON.stringify(this.newBuggyCaddyPreference)
      ) {
        _hasChanges = true;
      }
    } else {
      this.newBuggyCaddyPreference.playerPairings.filter(pp => {
        if (pp.bookingPlayerId === _bookingPlayer.id) {
          this.buggyCaddyPreference.playerPairings.filter(opp => {
            if (opp.bookingPlayerId === pp.bookingPlayerId)
              if (JSON.stringify(opp) !== JSON.stringify(pp)) {
                _hasChanges = true;
              }
          });
        }
      });
    }
    return _hasChanges;
  }

  async onNewClearPlayerDetails(playerIdx: number) {
    let alert = await this.alertCtrl
      .create({
        header: 'Clear all details',
        message: 'Do you want to clear all details for the player?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
          },
          {
            text: 'Clear',
            handler: () => {
              this.newClearPlayerDetails(playerIdx);
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  newClearPlayerDetails(playerIdx: number) {
    let _preference = this.newBuggyCaddyPreference;
    _preference.ignoreBuggyUpdate = false;
    _preference.ignoreCaddieUpdate = false;
    _preference.playerPairings
      .filter((p: PlayerBuggyCaddiePreference) => {
        return p.bookingPlayerId === this.bookingSlot.bookingPlayers[playerIdx].id;
      })
      .map((p: PlayerBuggyCaddiePreference) => {
        if (this.bookingSlot && this.bookingSlot.slotAssigned.allowWalking) {
          p.buggyPairing = 0;
          p.buggyRequired = false;
          p.assignedBuggy = null;
        } else if (this.bookingSlot && !this.bookingSlot.slotAssigned.allowWalking) {
          p.buggyPairing = 1;
          p.buggyRequired = true;
          p.assignedBuggy = null;
        }
        if (this.bookingSlot && !this.bookingSlot.slotAssigned.caddyMandatory) {
          p.caddyPairing = 0;
          p.caddyRequired = false;
        } else if (this.bookingSlot && this.bookingSlot.slotAssigned.caddyMandatory) {
          p.caddyPairing = 1;
          p.caddyRequired = true;
        }
        p.driving = false;
        p.caddyPreferred = null;
        p.caddyAssigned = null;
        p.caddiePreferred = null;
        p.caddieAssigned = null;
      });
  }

  checkOverpayment() {
    let _balance =
      this.bookingSlot.amountPayable -
      this.bookingSlot.totalDeductions -
      this.bookingSlot.amountPaid +
      this.bookingSlot.totalRefund;
    if (_balance < 0) return true;
    else return false;
  }

  async checkOverpaymentInfo() {
    let _message = 'You have overpaid amount';
    let alert = await this.alertCtrl
      .create({
        header: 'Booking Validation',
        message: _message,
        buttons: ['Close'],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  getPricingPlan(type?: string, attribute?: string) {
    let _currentSlot;
    let _pricingPlan;
    if (this.teeSlotNew && this.teeTimeSlotDisplay.slot.pricingPlan && type === 'normal')
      _pricingPlan = this.teeTimeSlotDisplay.slot.pricingPlan;
    else if (
      this.teeSlotNew &&
      this.teeTimeSlotDisplay.slot.pricingPlanPromotional &&
      type === 'promo'
    )
      _pricingPlan = this.teeTimeSlotDisplay.slot.pricingPlanPromotional;
    else if (this.teeSlotNew && this.teeTimeSlotDisplay.slot.pricingPlanJumbo && type === 'jumbo')
      _pricingPlan = this.teeTimeSlotDisplay.slot.pricingPlanJumbo;

    if (!this.teeSlotNew && this.bookingSlot.slotAssigned.pricingPlan && type === 'normal')
      _pricingPlan = this.bookingSlot.slotAssigned.pricingPlan;
    else if (
      !this.teeSlotNew &&
      this.bookingSlot.slotAssigned.pricingPlanPromotional &&
      type === 'promo'
    )
      _pricingPlan = this.bookingSlot.slotAssigned.pricingPlanPromotional;
    else if (!this.teeSlotNew && this.bookingSlot.slotAssigned.pricingPlanJumbo && type === 'jumbo')
      _pricingPlan = this.bookingSlot.slotAssigned.pricingPlanJumbo;
    switch (attribute) {
      case 'name':
        return _pricingPlan?.name;
      case 'currency':
        return _pricingPlan?.currency?.symbol;
      case 'description':
        return _pricingPlan?.description;
      case 'dicounts':
        let _discounts = _pricingPlan?.discountsApplicable ? 'Yes' : 'No';
        return _discounts;
      case 'promotional':
        let _promo = _pricingPlan?.promotional ? 'Yes' : 'No';
        return _promo;
    }
  }

  setTogglePromoDetails(type?: string) {
    if (type === 'promo') this.togglePlanPromoDetails = !this.togglePlanPromoDetails;
    else this.togglePlanDetails = !this.togglePlanDetails;
  }

  escapeCRLF(value) {
    return JsonService.escapeCRLF(value);
  }

  allowPlayerUnpaidBooking() {
    if (!this.playerMaxBooking) return true;
    else if (this.playerMaxBooking.totalBookings === 0) return true;
    else if (this.playerMaxBooking.maxUnpaidBookings <= 0) return true;
    return this.playerMaxBooking.totalUnpaidBookings < this.playerMaxBooking.maxUnpaidBookings;
  }

  onBookingCancelGuard() {
    let _msg;
    let _resetGuard;
    let _bookingId = this.bookingSlot.id;
    // _msg = this.bookingSlot.cancelGuardBy;
    _resetGuard = this.bookingSlot.cancellationGuard;
    this.flightService.setBookingCancelGuard(_bookingId, _resetGuard).subscribe(
      (data: TeeTimeBooking) => {
        if (data) {
          this.refreshBookingObject(data);
          let _msg;
          if (_resetGuard) _msg = 'Successfully reset guard this booking from auto-cancellation.';
          else if (!_resetGuard) _msg = 'Successfully guard this booking from auto-cancellation.';
          MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        }
      },
      error => {
        if (error) {
          let _error = error;
          let _msg;
          if (_error.errorMessage) _msg = _error.errorMessage;
          else _msg = 'There is something wrong with the server. Please try again.';
          MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
          this.refreshBookingObject(this.bookingSlot);
        }
      }
    );
  }

  checkHolesAllowedEnable() {
    let _eighteenHolesAllowed;
    let _nineHolesAllowed;
    if (this.bookingSlot) {
      _eighteenHolesAllowed = this.bookingSlot.slotAssigned.eighteenHolesAllowed;
      _nineHolesAllowed = this.bookingSlot.slotAssigned.nineHolesAllowed;
    } else {
      _eighteenHolesAllowed = this.teeTimeSlotDisplay.slot.eighteenHolesAllowed;
      _nineHolesAllowed = this.teeTimeSlotDisplay.slot.nineHolesAllowed;
    }
    return _eighteenHolesAllowed || _nineHolesAllowed;
  }
  getMembershipNumberPromise(playerId: number) {
    let _clubMembership: ClubMembershipExtended = null;
    return new Promise((resolve, reject) => {
      if (!playerId) {
        reject({
          status: 'failed',
          message: 'No Player Id',
        });
      } else if (playerId) {
        this.flightService.getPlayerMemberships(playerId).subscribe(
          async (membershipList: Array<ClubMembership>) => {
            if (membershipList) {
              membershipList
                .filter((ms: ClubMembershipExtended) => {
                  return (
                    ms.club &&
                    (ms.club.clubId === this.bookingSlot.clubData.id ||
                      ms.club.id === this.bookingSlot.clubData.id)
                  );
                })
                .map((ms: ClubMembershipExtended) => {
                  _clubMembership = ms;
                });
              if (_clubMembership) {
                resolve({
                  status: 'success',
                  message: 'has membership',
                  clubMembership: _clubMembership,
                });
              } else {
                resolve({
                  status: 'failed',
                  message: 'no club membership',
                });
              }
            } else {
              resolve({
                status: 'failed',
                message: 'no club membership',
              });
            }
          },
          error => {
            reject({
              status: 'failed',
              message: 'no club membership',
            });
          },
          () => {}
        );
      }
    });
  }
  doAsyncTask() {
    var promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
        reject(false);
      }, 1000);
    });
    return promise;
  }

  async getContactInfo(
    type?: string,
    slot?: number,
    membershipNumber?: number,
    membershipType?: string
  ) {
    if (this.teeSlotNew) return;
    if (!this.fromClub) return;
    let hasPlayer = this.bookingSlot.bookingPlayers[slot - 1];
    if (
      type === 'player' &&
      hasPlayer &&
      hasPlayer.player &&
      hasPlayer.player.userProfile &&
      !hasPlayer.player.userProfile.shareWithClub
    ) {
      MessageDisplayUtil.showMessageToast(
        "Player doesn't allow to share information with club",
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    } else if (
      type === 'bookingInfo' &&
      this.bookingSlot.bookedByPlayer &&
      this.bookingSlot.bookedByPlayer.userProfile &&
      !this.bookingSlot.bookedByPlayer.userProfile.shareWithClub
    ) {
      MessageDisplayUtil.showMessageToast(
        "Player doesn't allow to share information with club",
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    let _membershipNumber;
    let _membershipType;
    let _playerId;
    if (type === 'bookingInfo') {
      if (this.bookingSlot.bookedByPlayer) _playerId = this.bookingSlot.bookedByPlayer.id;
      else return;
    } else if (type === 'player') {
      if (hasPlayer && hasPlayer.player) _playerId = hasPlayer.player.id;
      else _playerId = null;
    }
    if (_playerId) {
      _membershipType = this.getPlayerMembershipOther(_playerId, 'typeName');
      this.getMembershipNumberPromise(_playerId)
        .then((data: any) => {
          if (data) {
            if (data.status === 'success') {
              _membershipNumber = data.clubMembership.membershipNumber;
            }

            this.getFurtherContactInfo(type, slot, _membershipNumber, _membershipType);
            // alert.present();
          }
        })
        .catch(error => {
          _membershipNumber = null;

          // alert.present();
          this.getFurtherContactInfo(type, slot, _membershipNumber, _membershipType);
        });
    } else {
      this.getFurtherContactInfo(type, slot, null, null);
    }
  }
  async getFurtherContactInfo(
    type?: string,
    slot?: number,
    membershipNumber?: number,
    membershipType?: string
  ) {
    if (this.teeSlotNew) return;
    if (!this.fromClub) return;
    let hasPlayer = this.bookingSlot.bookingPlayers[slot - 1];

    if (
      hasPlayer &&
      hasPlayer.player &&
      hasPlayer.player.userProfile &&
      !hasPlayer.player.userProfile.shareWithClub
    ) {
      MessageDisplayUtil.showMessageToast(
        "Player doesn't allow to share information with club",
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    let _membershipNumber = membershipNumber;
    let _membershipType = membershipType;
    let _getNumber;
    let _message = '';
    let _name = '';
    let _phone = '';
    let _email = '';
    let _membership = '';

    let _gender = '<i class="fas fa-fw fa-user"></i>';

    let _title = 'Contact Info';
    switch (type) {
      case 'bookingInfo':
        if (this.bookingSlot.bookedByPlayer) {
          if (this.bookingSlot.bookedByPlayer.gender === 'M') {
            _gender = '<i class="fa fa-fw fa-mars"></i>';
          } else if (this.bookingSlot.bookedByPlayer.gender === 'F') {
            _gender = '<i class="fa fa-fw fa-venus"></i>';
          }
          if (this.bookingSlot.bookedByPlayer.playerName)
            _name = _gender + '&nbsp;' + this.bookingSlot.bookedByPlayer.playerName;
          if (
            this.bookingSlot.bookedByPlayer.address &&
            this.bookingSlot.bookedByPlayer.address.phone1
          )
            _phone =
              '<br><i class="fas  fa-fw fa-phone-alt"></i>&nbsp;' +
              this.bookingSlot.bookedByPlayer.address.phone1;
          if (this.bookingSlot.bookedByPlayer.email)
            _email =
              '<br><i class="fas fa-fw fa-at"></i>&nbsp;' + this.bookingSlot.bookedByPlayer.email;
          if (_membershipType) {
            _membership = '<br>' + _membershipType;
          }
          if (_membershipNumber) {
            _membership +=
              '<br><i class="fas fa-fw fa-hashtag"></i>&nbsp;Membership # ' + _membershipNumber;
          }
          _message = _name + _phone + _email + _membership;
        } else if (this.bookingSlot.bookedByUser) {
          if (this.bookingSlot.bookedByUser.name)
            _name = '<i class="fas fa-fw fa-user"></i>&nbsp;' + this.bookingSlot.bookedByUser.name;
          if (this.bookingSlot.bookedByUser.phone)
            _phone =
              '<br><i class="fas  fa-fw fa-phone-alt"></i>&nbsp;' +
              this.bookingSlot.bookedByUser.phone;
          _message = _name + _phone;
        }
        break;
      case 'player':
        if (!hasPlayer) return;
        let _player = this.bookingSlot.bookingPlayers[slot - 1];
        if (_player.gender === 'M') {
          _gender = '<i class="fa fa-fw fa-mars"></i>';
        } else if (_player.gender === 'F') {
          _gender = '<i class="fa fa-fw fa-venus"></i>';
        }
        if (_player.playerName) _name = _gender + '&nbsp;' + _player.playerName;
        if (_player.phone)
          _phone = '<br><i class="fas fa-fw fa-phone-alt"></i>&nbsp;' + _player.phone;
        else if (_player.player && _player.player.address && _player.player.address.phone1)
          _phone =
            '<br><i class="fas fa-fw fa-phone-alt"></i>&nbsp;' + _player.player.address.phone1;
        if (_player.email) _email = '<br><i class="fas fa-fw fa-at"></i>&nbsp;' + _player.email;
        if (_player && _membershipType) _membership = '<br>' + _membershipType;
        if (_player && _membershipNumber)
          _membership +=
            '<br><i class="fas fa-fw fa-hashtag"></i>&nbsp;Membership #' + _membershipNumber;
        if (_player) {
          _message = _name + _phone + _email + _membership;
        }
        break;

      case 'affiliateMember':
        if (!hasPlayer) return;
        _player = this.bookingSlot.bookingPlayers[slot - 1];
        _title = 'Affiliate Info';
        let _affiliateMember = _player.affiliateMember;
        _message += 'Club : ' + _affiliateMember.affiliatedClubName;
        _message += '<br>Membership Number : ' + _affiliateMember.membership;
        _message += '<br>Membership Type : ' + _affiliateMember.membershipTypeName;
        break;
    }
    let alert = await this.alertCtrl.create({
      header: 'Contact Info',
      message: _message,
      buttons: ['Close'],
    });
    alert.present();
  }
  getPlayerMembershipOther(playerId: number, attribute?: string) {
    if (!playerId) return;
    // if(bp && !bp.player) return;
    let _membershipNumber: string = '';
    let _membershipTypeName: string = '';
    if (this.filteredClubMembership)
      this.filteredClubMembership
        .filter(cm => {
          return cm && cm.player && cm.player.id === playerId;
        })
        .map(cm => {
          _membershipTypeName = cm.membershipType.typeName;
          _membershipNumber = '(' + cm.membershipNo + ')';
        });
    if (attribute === 'typeName') return _membershipTypeName;
    else return _membershipNumber;
  }

  allowClubManualRecalculate() {
    if (!this.fromClub) return false;
    if (this.teeSlotNew) return false;
    if (!this.showRecalculate) return false;
    if (
      !this.teeSlotNew &&
      this.bookingSlot &&
      (this.bookingSlot.bookingStatus === 'CancelledByClub' ||
        this.bookingSlot.bookingStatus === 'CancelledByPlayer')
    )
      return false;
    if (this.bookingSlot) {
      let _bookingDate = moment(this.bookingSlot.slotAssigned.teeOffDate);
      let _currentDate = moment();
      if (this.appAttribute && this.appAttribute.overrideAssignment) {
        if (_bookingDate.diff(_currentDate, 'days') < 0) {
          return true;
        } else return true;
      } else if (_bookingDate.diff(_currentDate, 'days') < 0) {
        return false;
      } else return true;
    } else return false;
  }

  async onClubManualRecalculate() {
    let alert = await this.alertCtrl
      .create({
        header: 'Manual Re-Calculate Pricing',
        cssClass: 'booking-error',
        message:
          'This will manually re-calculate pricing for this booking. Do you want to proceed?',
        buttons: [
          {
            text: 'No',
          },
          {
            text: 'Yes',
            handler: () => {
              this.recalculateBookingPricing(true);
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }
  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter(d => {
            return d.page === 'bookingDetails';
          })
          .map(d => {
            this.appAttribute = d;
          });

        if (this.appAttribute) {
          if (this.appAttribute.showConsoleLog)
            this.showConsoleLog = this.appAttribute.showConsoleLog;
          if (this.appAttribute.enablePaymentTimer)
            this.enablePaymentTimer = this.appAttribute.enablePaymentTimer;
          if (this.appAttribute.showRecalculate)
            this.showRecalculate = this.appAttribute.showRecalculate;
          if (this.appAttribute.paymentTimerDuration)
            this.paymentTimerDuration = this.appAttribute.paymentTimerDuration;
        }
      }
    });
  }

  async blockPayment() {
    let _block: boolean = false;
    if (this.enablePaymentTimer) {
      if (this.paymentFailed && this.paymentDateTime) {
        let _currTime = moment();
        let _diffMinutes = _currTime.diff(this.paymentDateTime, 'minutes');
        if (_diffMinutes >= 0 && _diffMinutes < this.paymentTimerDuration) {
          let modal = await this.modalCtl.create({
            component: DeleteRoomModalComponent,
            showBackdrop: true,
            backdropDismiss: false,
            mode: 'ios',
            cssClass: this.platform.is('mobile')
              ? 'self-adjustable-modal'
              : 'self-adjustable-modal-desktop',
            componentProps: {
              mode: 'bookingAlert',
              msg:
                'Your previous payment was not successful, please try again after ' +
                (this.paymentTimerDuration - _diffMinutes) +
                ' minute(s)',
              header: 'Payment',
            },
          });
          await modal.present().then(() => {
            const height = this.platform.height() - 180;
            if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
              document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                `${height}px`;
          });
          modal.onDidDismiss().then(data => {
            if (data) {
              if (data?.data === 'success') {
                this.onRefreshClick();
              }
            }
          });
          _block = true;
        }
      }
    }
    return _block;
  }

  async onChangeNinesBooking() {
    if (this.teeSlotNew) return;
    if (1) {
      let _eighteenHolesAllowed;
      let _nineHolesAllowed;
      if (this.bookingSlot) {
        _eighteenHolesAllowed = this.bookingSlot.slotAssigned.eighteenHolesAllowed;
        _nineHolesAllowed = this.bookingSlot.slotAssigned.nineHolesAllowed;
      }
      let _holesPlayed = this.bookingSlot.ninesPlayed * 9;
      if (_holesPlayed === 9 && !_eighteenHolesAllowed) {
        MessageDisplayUtil.showMessageToast(
          'This slot is not allowing 18 holes play',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      if (_holesPlayed === 18 && !_nineHolesAllowed) {
        MessageDisplayUtil.showMessageToast(
          'This slot is not allowing 9 holes play',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
    }
    if (!this.checkHolesAllowedEnable()) return;
    if (this.bookingType === 'past') return;
    if (
      this.bookingSlot.bookingStatus === 'CancelledByPlayer' ||
      this.bookingSlot.bookingStatus === 'CancelledByClub'
    )
      return;
    let _ninesPlayed;
    let _currentNinesPlayed;
    _currentNinesPlayed = this.bookingSlot.ninesPlayed;
    if (_currentNinesPlayed === 1) _ninesPlayed = 2;
    else if (_currentNinesPlayed === 2) _ninesPlayed = 1;
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: ChangesHolesComponent,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        header: 'Change Holes to Play',
        message:
          'Do you want to change <b>Holes to Play</b> from <b>' +
          _currentNinesPlayed * 9 +
          '</b> to <b>' +
          _ninesPlayed * 9 +
          '</b> holes?',
      },
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 105;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    modal.onDidDismiss().then(data => {
      if (data?.data?.confirm) {
        this.goChangeNinesBooking(_ninesPlayed);
        this.captchaResponse = null;
      }
    });
  }

  goChangeNinesBooking(ninesPlayed: number) {
    let _bookingId = this.bookingSlot.id;
    this.flightService.updateNinesBooking(_bookingId, ninesPlayed).subscribe(data => {
      this.onRefreshClick();
    });
  }

  async onUndoCancelBooking() {
    if (this.teeSlotNew) return;
    if (
      this.bookingSlot.bookingStatus !== 'CancelledByPlayer' &&
      this.bookingSlot.bookingStatus !== 'CancelledByClub'
    )
      return;
    let alert = await this.alertCtrl
      .create({
        header: 'Undo Cancellation',
        message:
          'If the slot is still available, this will undo cancellation of this booking. Do you want to proceed?',
        buttons: [
          {
            text: 'No',
          },
          {
            text: 'Yes',
            handler: () => {
              this.goUndoCancelBooking();
            },
          },
        ],
      })
      .then(res => {
        res.present();
        this.captchaResponse = null;
      });
  }

  goUndoCancelBooking() {
    let _bookingId = this.bookingSlot.id;
    this.flightService.undoCancelBooking(_bookingId).subscribe(
      data => {
        this.onRefreshClick();
        MessageDisplayUtil.showMessageToast(
          'Successfully undo cancellation of this booking',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      },
      error => {
        if (error) {
          let _error = error;
          let _msg = _error.errorMessage;
          if (_error.errorCode === 'TeeTimeBooking.SlotAlreadyAssigned') {
            _msg = 'Slot has already assigned to different booking.';
          }
          MessageDisplayUtil.showErrorToast(
            'Failed to undo cancellation of this booking.' + _msg,
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
        }
      }
    );
  }

  // scrollToBottom(): void {
  //   // try {
  //   //     this.myScrollContainer.nativeElement.scrollToBottom = this.myScrollContainer.nativeElement.scrollHeight;
  //   // } catch(err) { }
  //   // var messagesContent = this.app.getComponent('messagesContent') as Content;
  //   // messagesContent.scrollTo(0, messagesContent.getContentDimensions().contentHeight, 700);
  // }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }
  ngAfterViewInit() {
    // this.checkScroll();
  }

  navigateHome() {}

  backRouting() {
    if (this.modalMode) {
      this.modalCtl.dismiss();
    } else {
      this.location.back();
    }
  }

  getDepositPaymentByText() {
    let _depositBy;
    if (this.teeSlotNew && this.teeTimeSlotDisplay.slot.depositBy) {
      _depositBy = moment(this.teeTimeSlotDisplay.slot.depositBy).format('ddd, DD MMM YYYY');
    } else if (!this.teeSlotNew && this.bookingSlot.slotAssigned.depositBy) {
      _depositBy = moment(this.bookingSlot.slotAssigned.depositBy).format('ddd, DD MMM YYYY');
    } else _depositBy = null;
    return _depositBy;
  }

  getFullPaymentByText() {
    let _fullPaymentBy;
    if (this.teeSlotNew && this.teeTimeSlotDisplay.slot.fullPaymentBy) {
      _fullPaymentBy = moment(this.teeTimeSlotDisplay.slot.fullPaymentBy).format(
        'ddd, DD MMM YYYY hh:mm A'
      );
    } else if (!this.teeSlotNew && this.bookingSlot.slotAssigned.fullPaymentBy) {
      _fullPaymentBy = moment(this.bookingSlot.slotAssigned.fullPaymentBy).format(
        'ddd, DD MMM YYYY hh:mm A'
      );
    } else _fullPaymentBy = null;
    return _fullPaymentBy;
  }

  async getTextForPaymentBy() {
    let _textPaymentBy = '';
    let _teeOffTime = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
    let _teeOffDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format('ddd, DD MMM YYYY');
    let _depositCutOffDays = this.bookingOptions ? this.bookingOptions.depositCutOffDays : 1;
    let _holdDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate)
      .subtract(_depositCutOffDays, 'days')
      .format('ddd, DD MMM YYYY');
    let _depositAmount = 'payment';
    let _currency = this.currency
      ? this.currency.symbol
      : this.teeTimeSlotDisplay.slot.currency.symbol;
    if (!this.teeSlotNew && this.bookingSlot.amountPayable === 0) return;
    if (this.bookingOptions && this.appAttribute.showDepoSecureMessage) {
      if (this.bookingOptions.depositAmountType.toLowerCase() === 'percentage') {
        if (this.bookingOptions.depositAmount === 100) {
          _depositAmount = '<b>Full Payment</b>';
        } else if (this.bookingOptions.depositAmount === 50) {
          _depositAmount = '<b>Half Payment</b>';
        } else if (this.bookingOptions.depositAmount === 0) _depositAmount = '<b>no payment</b>';
        else
          _depositAmount =
            '<b>' + this.bookingOptions.depositAmount + '% Payment of the Booking Amount</b>';
      } else if (this.bookingOptions.depositAmountType.toLowerCase() === 'absolute') {
        _depositAmount =
          'Deposit of ' + '<b>' + _currency + this.bookingOptions.depositAmount + '</b>';
      } else _depositAmount = 'payment';
    }
    let _avoidCancelMessage = 'To avoid cancellation,';
    let _additionalChargesMessage = '';
    if (
      this.appAttribute &&
      this.appAttribute.bookingRequest &&
      this.appAttribute.bookingRequest.avoidCancelMessage
    )
      _avoidCancelMessage = this.appAttribute.bookingRequest.avoidCancelMessage;
    let _message =
      _avoidCancelMessage +
      ` you will need to make ` +
      _depositAmount +
      ` before <b style="color:green">` +
      _holdDate +
      `</b> at <b style="color:green">` +
      _teeOffTime +
      `</b>.<br>`;
    if (this.getDepositPaymentByText() && this.bookingSlot.amountPaid < this.depositAmount)
      _textPaymentBy +=
        ' deposit of ' +
        _currency +
        this.depositAmount +
        ' by ' +
        this.getDepositPaymentByText() +
        '<br>';
    else _textPaymentBy += '';
    if (this.getFullPaymentByText())
      _textPaymentBy += 'Full Payment by ' + this.getFullPaymentByText();
    else _textPaymentBy += '';
    if (moment(_holdDate).diff(moment(), 'days') <= 0) {
      if (moment(_teeOffTime, 'HH:mm:ss').diff(moment(), 'minutes') <= 0) {
        if (
          this.bookingOptions.fullPaymentCutOffHours <= 0 &&
          this.appAttribute.bookingCutOffValue
        ) {
          _textPaymentBy +=
            ` you have <b>` +
            this.appAttribute.bookingCutOffValue +
            ' ' +
            this.appAttribute.bookingCutOffValuePeriod +
            `</b> to make full payment`;
        } else {
          _textPaymentBy += ` you have <b>` + '60 minutes' + `</b> to make full payment`;
        }
      } else if (moment(_teeOffTime, 'HH:mm:ss').diff(moment(), 'minutes') > 0) {
        if (this.bookingOptions.fullPaymentCutOffHours > 0) {
          _textPaymentBy +=
            ` you have <b>` +
            this.bookingOptions.fullPaymentCutOffHours +
            ` hour(s)</b> to make Full Payment before tee off time`;
        } else {
          _textPaymentBy += ` you have <b>` + '60 minutes' + `</b> to make full payment`;
        }
      } else {
        _textPaymentBy =
          _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
      }
    }

    let alert = await this.alertCtrl.create({
      header: 'Info',
      message: _textPaymentBy.length > 0 ? _avoidCancelMessage + _textPaymentBy : _message,
      buttons: ['Close'],
    });
    alert.present();

    // if (_textPaymentBy.length > 0) return _avoidCancelMessage + _textPaymentBy;
    // else return _message;
  }

  getClubHasAdditionalItems() {
    if (!this.bookingSlot) return;
    if (!this.appAttribute) return;
    if (this.appAttribute && !this.appAttribute.clubHasAdditionalItems) return;
    if (
      this.appAttribute &&
      this.appAttribute.clubHasAdditionalItems &&
      this.appAttribute.clubHasAdditionalItems.length === 0
    )
      return;
    let _currentClubId = this.bookingSlot.clubData.id;
    let _clubHasAdditionalItems: boolean = false;
    this.appAttribute.clubHasAdditionalItems
      .filter(clubId => {
        return clubId === _currentClubId;
      })
      .map(clubId => {
        _clubHasAdditionalItems = true;
      });
    return _clubHasAdditionalItems;
  }

  async onClubCancelAssignment() {
    let alert = await this.alertCtrl.create({
      header: 'Cancel Assignment',
      cssClass: 'booking-error',
      message: 'This will reverse any assignment of buggy / caddy pairing. Do you want to proceed?', //'Selected date is ' + '<b>' + _date + '</b>',
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.onCancelAssignment(false, true)
              .then((res: any) => {})
              .catch(() => {});
          },
        },
      ],
    });
    alert.present();
  }

  async onClubProcessAssignment() {
    let alert = await this.alertCtrl.create({
      header: 'Process Assignment',
      cssClass: 'booking-error',
      message: 'This will process any assignment of buggy / caddy pairing. Do you want to proceed?', //'Selected date is ' + '<b>' + _date + '</b>',
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.onProcessAssignment();
          },
        },
      ],
    });
    alert.present();
  }

  getAdditionalsInfo(attribute?: string) {
    if (!attribute) return;
    switch (attribute) {
      case 'noticeMessage':
        let _msg = 'This is where you can add any available additional items provided by the Club';
        if (this.appAttribute && this.appAttribute.additionalItemsMessage)
          _msg = this.appAttribute.additionalItemsMessage;
        return _msg;
      case 'icon':
        return `assets/img/icon-bubble-exclamation.svg`;
      case 'hideMessage':
        let _hide: boolean = false;
        let _currentClubId = this.bookingSlot.clubData.id;
        if (this.appAttribute.hideAdditionalItemsMessage)
          this.appAttribute.hideAdditionalItemsMessage
            .filter(clubId => {
              return clubId === _currentClubId;
            })
            .map(clubId => {
              _hide = true;
            });
        return _hide;
      default:
        return;
    }
  }

  getBookingPlayerAddItems(bookingPlayer?: TeeTimeBookingPlayer) {
    if (!this.bookingSlot) return;
    if (this.bookingSlot && !this.bookingSlot.additionalItems) return;
    let _bookingPlayer;
    _bookingPlayer = this.bookingSlot.additionalItems.filter(
      (item: TeeTimeBookingAdditionalItem) => {
        if (bookingPlayer && item.bookingPlayer && item.bookingPlayer.id)
          return bookingPlayer.id === item.bookingPlayer.id;
        else if (!bookingPlayer && item && !item.bookingPlayer) return true;
        else return false;
      }
    );
    return _bookingPlayer;
  }

  onEditAdditionalItem(bookingPlayer: TeeTimeBookingPlayer) {
    this.getPricingComponents(true, true, bookingPlayer)
      .then(result => {
        if (result) {
          this.getSlotPrices(this.pricingComponents, bookingPlayer).then(result => {
            if (result) {
              this.goUpdateAdditionalItem(bookingPlayer);
            } else {
              MessageDisplayUtil.showMessageToast(
                'There is no additional items for selected player.',
                this.platform,
                this.toastCtl,
                5000,
                'bottom'
              );
            }
          });
        } else {
          MessageDisplayUtil.showMessageToast(
            'There is no additional items for selected player.',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
        }
      })
      .catch(() => {
        MessageDisplayUtil.showMessageToast(
          '[catch] There is no additional items for selected player.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      });
  }

  getPricingComponents(
    additionalOnly: boolean = true,
    activeOnly: boolean = true,
    bookingPlayer?: TeeTimeBookingPlayer
  ) {
    let _resolved: boolean = false;
    return new Promise((resolve, reject) => {
      if (!this.bookingSlot) reject();
      let _isPlayer: boolean = false;
      if (bookingPlayer) _isPlayer = true;
      let _params = {};
      let _clubId = this.bookingSlot.clubData.id;
      _params = {
        clubId: _clubId,
        activeOnly: activeOnly,
        additionalOnly: additionalOnly,
      };
      this.flightService.getPricingComponents(_clubId, _params).subscribe(
        (data: any) => {
          if (data) {
            this.pricingComponents = data.filter((priceComponent: TeeTimePriceComponent) => {
              if (!this.fromClub && _isPlayer) return priceComponent.availability === 'A';
              else if (!this.fromClub && !_isPlayer) return false;
              else if (this.fromClub) return true;
              else return true;
            });
            if (this.pricingComponents && this.pricingComponents.length > 0) _resolved = true;
            else if (this.fromClub) _resolved = true;
            else _resolved = false;
            resolve(_resolved);
          } else resolve(false);
        },
        error => {
          reject();
        }
      );
    });
  }

  getSlotPrices(
    priceComponents: Array<TeeTimePriceComponent>,
    bookingPlayer?: TeeTimeBookingPlayer
  ) {
    return new Promise((resolve, reject) => {
      if (!this.bookingSlot) reject();
      let _isPlayer: boolean = false;
      if (bookingPlayer) _isPlayer = true;
      let _params = {};
      let _playerTypes = [];
      let _slotNo = this.bookingSlot.slotAssigned.slotNo;
      let _slotDayId = this.bookingSlot.slotAssigned.slotDayId;
      let _jumboFlight = this.bookingSlot.jumboFlight;
      let _priceComponents = [];
      if (priceComponents) {
        priceComponents.forEach((pc: TeeTimePriceComponent) => {
          _priceComponents.push(pc.id);
        });
      }
      if (bookingPlayer && bookingPlayer.playerTypeUsed)
        _playerTypes.push(bookingPlayer.playerTypeUsed.id);
      else if (bookingPlayer && bookingPlayer.playerType && bookingPlayer.playerType.id)
        _playerTypes.push(bookingPlayer.playerType.id);
      else if (!bookingPlayer) _playerTypes = [];
      else _playerTypes.push('STD');

      _params = {
        slotDayId: _slotDayId,
        slotNo: _slotNo,
        playerTypes: _playerTypes,
        components: _priceComponents,
        jumboFlight: _jumboFlight,
      };
      this.flightService.getSlotPrices(_params).subscribe(
        (data: Array<TeeTimePrice>) => {
          if (data) {
            this.slotPrices = data.filter((price: TeeTimePrice) => {
              if (_isPlayer) return price.applicableTo === 'Player';
              else return price.applicableTo === 'Booking';
            });
            if (this.slotPrices && this.slotPrices.length > 0) resolve(true);
            else resolve(false);
          } else resolve(false);
        },
        error => {
          reject();
        }
      );
    });
  }

  isAdditionalItemValid: boolean = false;

  onAddAdditionalItem(bookingPlayer?: TeeTimeBookingPlayer) {
    this.getPricingComponents(true, true, bookingPlayer)
      .then(result => {
        if (result) {
          this.isAdditionalItemValid = !!result;
          this.getSlotPrices(this.pricingComponents, bookingPlayer).then(result => {
            if (result) {
              this.goToAdditionalItemPage(bookingPlayer);
            } else {
              MessageDisplayUtil.showMessageToast(
                'There is no additional items for selected player.',
                this.platform,
                this.toastCtl,
                5000,
                'bottom'
              );
            }
          });
        } else {
          this.isAdditionalItemValid = false;
          MessageDisplayUtil.showMessageToast(
            'There is no additional items for selected player.',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
        }
      })
      .catch(() => {
        this.isAdditionalItemValid = false;
        MessageDisplayUtil.showMessageToast(
          '[catch] There is no additional items for selected player.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      });
  }

  async onRemoveAdditionalItem(item?: any) {
    if (!item) return;
    let _itemIds = [];
    if (item && item.id) _itemIds.push(item.id);
    let alert = await this.alertCtrl.create({
      header: 'Remove Selected Item',
      message: 'This will remove selected additional item. Do you want to proceed?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove Item',
          handler: () => {
            this.goRemoveAdditionalItem(_itemIds);
          },
        },
      ],
    });
    alert.present();
  }

  async goToAdditionalItemPage(bookingPlayer: TeeTimeBookingPlayer) {
    // this.nav.push(AdditionalItemsListModal,
    //   {
    //     slotPrices: this.slotPrices,
    //     currentSlot: this.bookingSlot,
    //     bookingPlayer: bookingPlayer,
    //     mode: 'add',
    //     fromClub: this.fromClub,
    //     currency: this.currency,
    //   })
    let modal = await this.modalCtl.create({
      component: AdditionalItemsListModal,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      mode: 'ios',
      componentProps: {
        slotPrices: this.slotPrices,
        currentSlot: this.bookingSlot,
        bookingPlayer: bookingPlayer,
        mode: 'add',
        fromClub: this.fromClub,
        currency: this.currency,
        isModal: true,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 105;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.onRefreshClick();
        adjustViewZIndex(this.nav, this.renderer);
      }
    });
    // lists available additional items
    // can select 1 item at a time
    // can - + item
  }

  goRemoveAdditionalItem(itemIds: Array<any>) {
    if (!itemIds) return;
    let _bookingId;
    if (this.bookingSlot) _bookingId = this.bookingSlot.id;
    let _itemIds = [];
    if (itemIds) _itemIds.push(...itemIds);
    this.flightService.deleteAdditionalItems(_bookingId, _itemIds).subscribe(data => {
      this.refreshBookingDetails(true);
    });
  }

  async goUpdateAdditionalItem(bookingPlayer: TeeTimeBookingPlayer) {
    let modal = await this.modalCtl.create({
      component: AdditionalItemsListModal,
      mode: 'ios',
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        slotPrices: this.slotPrices,
        currentSlot: this.bookingSlot,
        bookingPlayer: bookingPlayer,
        mode: 'edit',
        existingAddItems: this.getBookingPlayerAddItems(bookingPlayer),
        fromClub: this.fromClub,
        currency: this.currency,
        isModal: true,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 105;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.onRefreshClick();
        adjustViewZIndex(this.nav, this.renderer);
      }
    });
    // this.nav.push(AdditionalItemsListModal,
    //   {
    //     slotPrices: this.slotPrices,
    //     currentSlot: this.bookingSlot,
    //     bookingPlayer: bookingPlayer,
    //     mode: 'edit',
    //     existingAddItems: this.getBookingPlayerAddItems(bookingPlayer),
    //     fromClub: this.fromClub,
    //     currency: this.currency,
    //   })
  }

  getTotalAdditionalItems() {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    if (this.bookingSlot && !this.bookingSlot.additionalItems) return;
    let _totalAmount = 0;
    _totalAmount = this.bookingSlot.additionalItems
      .map(item => {
        return item.itemCharge;
      })
      .reduce((a, b) => {
        return a + b;
      }, 0);
    return this.mg2uUtil.numberWithCommas(_totalAmount);
  }

  showCaddyAssignedInfo(bookingPlayer: TeeTimeBookingPlayer) {
    if (this.teeSlotNew) return false;
    if (!bookingPlayer) return false;

    if (this.bookingOptions && this.bookingOptions.showCaddieAssignments) return true;
    if (bookingPlayer)
      if (
        bookingPlayer.caddyPreferred &&
        bookingPlayer.caddyAssigned &&
        bookingPlayer.caddyPreferred.id === bookingPlayer.caddyAssigned.id
      )
        return true;
      else return false;
    let _clubs = [];
    let _showCaddyAssigned: boolean = true;

    if (this.appAttribute && this.appAttribute.caddyAssignment)
      _showCaddyAssigned = this.appAttribute.caddyAssignment.show;
    if (
      this.appAttribute &&
      this.appAttribute.caddyAssignment &&
      this.appAttribute.caddyAssignment.excludedClubs
    ) {
      _clubs = this.appAttribute.caddyAssignment.excludedClubs.filter(clubId => {
        return clubId === this.bookingSlot.clubData.id;
      });
    }
    return _showCaddyAssigned && !(_clubs && _clubs.length > 0);
  }

  showCaddyAssignmentText(bookingPlayer: TeeTimeBookingPlayer, short: boolean = false) {
    if (this.teeSlotNew) return '';
    if (!bookingPlayer) return '';
    if (this.appAttribute && this.appAttribute.caddyAssignment) {
      if (
        bookingPlayer.caddyPreferred &&
        bookingPlayer.caddyAssigned &&
        bookingPlayer.caddyPreferred.id !== bookingPlayer.caddyAssigned.id
      ) {
        if (short) return this.appAttribute.caddyAssignment.shortDiffCaddyAssignedText;
        else return this.appAttribute.caddyAssignment.diffCaddyAssignedText;
      } else if (
        bookingPlayer.caddyPreferred &&
        bookingPlayer.caddyAssigned &&
        bookingPlayer.caddyPreferred.id === bookingPlayer.caddyAssigned.id
      ) {
        if (short) return this.appAttribute.caddyAssignment.shortDisplayText;
        else return this.appAttribute.caddyAssignment.displayText;
      } else if (bookingPlayer.caddyAssigned && !bookingPlayer.caddyPreferred) {
        if (short) return this.appAttribute.caddyAssignment.shortDisplayText;
        else return this.appAttribute.caddyAssignment.displayText;
      }
    } else if (!this.appAttribute || (this.appAttribute && !this.appAttribute.caddyAssignment)) {
      if (
        bookingPlayer.caddyPreferred &&
        bookingPlayer.caddyAssigned &&
        bookingPlayer.caddyPreferred.id === bookingPlayer.caddyAssigned.id
      ) {
        if (short) return 'Assigned';
        else return 'Caddy Assigned';
      } else if (
        bookingPlayer.caddyPreferred &&
        bookingPlayer.caddyAssigned &&
        bookingPlayer.caddyPreferred.id !== bookingPlayer.caddyAssigned.id
      ) {
        if (short) return 'Different caddie';
        else return 'Different caddy has been assigned';
      } else {
        if (short) return 'Assigned';
        else return 'Caddy Assigned';
      }
    }
  }
  getGameClubInfo(clubId: number) {
    return new Promise((resolve, reject) => {
      this.clubService.getClubInfo(clubId).subscribe((club: ClubInfo) => {
        if (club) {
          this.gameInfo.club = club;
          resolve(true);
        }
      });
    });
  }
  getGameCoursesInfo(clubId: number, c1: number, c2?: number) {
    return new Promise((resolve, reject) => {
      this.clubService.getClubCourses(this.gameInfo.club.clubId).subscribe(
        (courses: Array<CourseInfo>) => {
          if (courses) {
            this.gameCourses = courses;
            if (this.teeSlotNew) return;
            let _bookingClub: ClubData = this.bookingSlot.clubData;
            // }
            let _course1: CourseInfo;
            let _course2: CourseInfo;

            let _slot = this.bookingSlot.slotAssigned;
            if (this.bookingSlot.ninesPlayed === 1) {
              this.gameCourses
                .filter((course: CourseInfo) => {
                  return course.courseId === _slot.startCourse.id;
                })
                .map((course: CourseInfo) => {
                  this.gameInfo.courses.push(course);
                });
            } else if (this.bookingSlot.ninesPlayed === 2) {
              this.gameCourses
                .filter((course: CourseInfo) => {
                  return course.courseId === _slot.startCourse.id;
                })
                .map((course: CourseInfo) => {
                  this.gameInfo.courses.push(course);
                });
              if (c2)
                this.gameCourses
                  .filter((course2: CourseInfo) => {
                    return _slot.secondCourse && course2.courseId === _slot.secondCourse.id;
                  })
                  .map((course2: CourseInfo) => {
                    this.gameInfo.courses.push(course2);
                  });
            }
          }
          resolve(true);
        },
        error => {
          reject();
        }
      );
    });
  }

  actualPlayersInBooking: Array<TeeTimeBookingPlayer>;
  setActualPlayersInBooking() {
    let _bookingPlayers: Array<TeeTimeBookingPlayer>;
    _bookingPlayers = this.bookingSlot.bookingPlayers.filter(bp => {
      return bp.player;
    });
    return _bookingPlayers;
  }

  getGamePlayersInfo(playerId, index, total, loader?) {
    return new Promise((resolve, reject) => {
      this.playerService.getPlayerInfo(playerId).subscribe((playerInfo: PlayerInfo) => {
        console.debug(
          'start scoring [4] - game players info ',
          playerId,
          index,
          total,
          playerInfo,
          this.gameInfo
        );
        if (playerInfo) {
          this.gameInfo.players.push(playerInfo);
          console.debug('start scoring [5] ', playerId, index, total, this.gameInfo.players);

          if (index === total - 1) {
            resolve({
              isDone: true,
              currentIdx: index,
            });

            this.settingUpScorecard().then((scorecard: any) => {
              if (scorecard) scorecard['bookingId'] = this.bookingSlot.id;
              setTimeout(() => {
                if (loader) loader.dismiss();
                let params: NavigationExtras = {
                  replaceUrl: false,
                  state: {
                    scorecard: scorecard,
                    currentPlayer: this.currentPlayer,
                  },
                };
                this.router.navigate(['gameround-scoring'], params);
              }, 5000);
            });
          } else {
            let _idx = index + 1;
            let _total = this.actualPlayersInBooking?.length;
            this.getGamePlayersInfo(
              this.actualPlayersInBooking[_idx]?.player?.id,
              _idx,
              this.actualPlayersInBooking?.length
            );
          }
          // resolve({
          //   isDone: index >= total,
          //   currentIdx: index
          // });
        }
      });
    });
  }

  getClubCourses() {
    let _bookingClub: ClubData = this.bookingSlot.clubData;
    let _clubId = _bookingClub.id;
    this.clubService.getClubInfo(_clubId).subscribe((club: ClubInfo) => {
      if (club) {
        this.gameInfo.club = club;
        this.clubService.getClubCourses(this.gameInfo.club.clubId).subscribe(
          (courses: Array<CourseInfo>) => {
            if (courses) {
              this.gameCourses = courses;
              if (this.teeSlotNew) return;
              let _bookingClub: ClubData = this.bookingSlot.clubData;
              let _clubInfo: ClubInfo;
              if (!this.teeSlotNew && this.bookingSlot.slotAssigned) {
                _clubInfo = {
                  clubId: _bookingClub.id,
                  clubName: _bookingClub.name,
                  clubImage: _bookingClub.clubImage,
                  clubTag: _bookingClub.tag,
                  latitude: _bookingClub.latitude,
                  longitude: _bookingClub.longitude,
                  address: null,
                  description: null,
                  courses: null,
                  virtualClub: _bookingClub.virtualClub,
                  // timeZone: _bookingClub.timeZone.name
                };

                this.gameInfo.club = _clubInfo;
              }
              // if (!this.gameInfo.club) {
              //     this.gameInfo.club = _clubInfo;
              //     this.gameInfo.courses = [];

              //     // this.gameInfo.courses.push(data);
              // }
              let _course1: CourseInfo;
              let _course2: CourseInfo;

              let _slot = this.bookingSlot.slotAssigned;
              if (this.bookingSlot.ninesPlayed === 1) {
                this.gameCourses
                  .filter((course: CourseInfo) => {
                    return course.courseId === _slot.startCourse.id;
                  })
                  .map((course: CourseInfo) => {
                    this.gameInfo.courses.push(course);
                  });
              } else if (this.bookingSlot.ninesPlayed === 2) {
                this.gameCourses
                  .filter((course: CourseInfo) => {
                    return course.courseId === _slot.startCourse.id;
                  })
                  .map((course: CourseInfo) => {
                    this.gameInfo.courses.push(course);
                  });
                this.gameCourses
                  .filter((course2: CourseInfo) => {
                    return course2.courseId === _slot.secondCourse.id;
                  })
                  .map((course2: CourseInfo) => {
                    this.gameInfo.courses.push(course2);
                  });
              }

              if (this.gameInfo && this.gameInfo.courses) {
                let params: NavigationExtras = {
                  replaceUrl: false,
                  state: {
                    gameInfo: this.gameInfo,
                  },
                };
                this.router.navigate(['flight-setup'], params);
              }
            }
          },
          error => {}
        );
      }
    });
  }

  private _createNewGame() {
    let scorecard: PlainScoreCard = this.normalGameService.createNewGame();
    this.normalGameService.setClubForGame(scorecard, this.gameInfo.club);
    this.normalGameService.setCourses(scorecard, this.gameInfo.courses);
    this.normalGameService.setPlayers(scorecard, this.gameInfo.players);
    scorecard.playerRoundScores.forEach((pr: PlayerRoundScores) => {
      pr.scoringPlayerId = this.currentPlayer.playerId;
    });
    return new Promise((resolve, reject) => {
      resolve(scorecard);
    });
  }

  settingUpScorecard() {
    let valid: boolean = true;
    let selDate = this.bookingSlot.slotAssigned.teeOffDate; //moment(this.bookingSlot.slotAssigned.teeOffDate).format("YYYY-MM-DD");
    let selTime = moment(this.bookingSlot.slotAssigned.teeOffTime, 'HH:mm:ss');
    //  moment(this.bookingSlot.slotAssigned.teeOffTime,"HH:mm:ss").format("HH:mm:ss"); //moment(this.bookingSlot.slotAssigned.teeOffTime).format("HH:mm");
    let currentDate = moment().format('YYYY-MM-DD');
    let currentTime = moment().format('HH:mm');

    let scorecard;
    return new Promise((resolve, reject) => {
      this._createNewGame().then(_scorecard => {
        if (_scorecard) {
          scorecard = _scorecard;

          this.onScoringDeriveIndex(scorecard).then((scorecard: any) => {
            if (scorecard)
              this.onScoringStartGame(scorecard, selTime, selDate).then((scorecard: any) => {
                this.currentScorecardActions
                  .startNewNormalGame(scorecard, this.currentPlayer.playerId)
                  .then(() => {
                    this.currentScorecardActions.setScoringPlayer(this.currentPlayer.playerId);
                    resolve(scorecard);
                  });
              });
          });
        } else reject(true);
      });
    });
  }

  onScoringDeriveIndex(scorecard) {
    return new Promise((resolve, reject) => {
      let _scorecard = this.normalGameService.deriveIndexToUse(scorecard);
      resolve(_scorecard);
    });
  }

  onScoringStartGame(scorecard, time, date) {
    return new Promise((resolve, reject) => {
      let _scorecard = this.normalGameService.startGame(scorecard, time, date);
      resolve(_scorecard);
    });
  }

  async onStartScoring() {
    let _title = 'Start Scoring';
    let _message = 'Do you want to start scoring?';
    if (this.appAttribute && this.appAttribute.scoringTitleDialog)
      _title = this.appAttribute.scoringTitleDialog;
    if (this.appAttribute && this.appAttribute.scoringMessageDialog)
      _message = this.appAttribute.scoringMessageDialog;

    let _bookingPlayers = this.bookingSlot.bookingPlayers.filter((p: TeeTimeBookingPlayer) => {
      return !p.player;
    });
    let _hasGuestPlayers: boolean = false;

    if (_bookingPlayers && _bookingPlayers.length > 0) _hasGuestPlayers = true;
    if (_hasGuestPlayers) {
      _message =
        "There are <b>non-mg2u / guest player(s)</b> in the flight.<br><br>They won't be included in the scorecard. <br>Do you want to start scoring?";
      if (this.appAttribute && this.appAttribute.scoringGuestMessageDialog)
        _message = this.appAttribute.scoringGuestMessageDialog;
    }

    const modal = await this.modalCtl.create({
      backdropDismiss: false,
      component: ChangesHolesComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        header: _title,
        message: _message,
        isStartScoring: true,
        goStartScoring: () => {
          console.debug('start scoring [0]', this.bookingSlot.bookingPlayers);
          this.bookingSlot.bookingPlayers.sort((a, b) => {
            if (a.sequence < b.sequence) return -1;
            else if (a.sequence > b.sequence) return 1;
            else return 0;
          });
          console.debug('start scoring [1]', this.bookingSlot.bookingPlayers);
          this.goStartScoring();
        },
      },
      mode: 'ios',
    });

    await modal.present();
  }

  getBookingScoringText(attribute) {
    let _title = 'Start Scoring';
    let _message = 'Do you want to start scoring?';
    // if(!this.appAttribute) {

    if (this.appAttribute && this.appAttribute.scoringTitleDialog)
      _title = this.appAttribute.scoringTitleDialog;
    if (this.appAttribute && this.appAttribute.scoringMessageDialog)
      _message = this.appAttribute.scoringMessageDialog;

    if (attribute === 'title') return _title;
    else if (attribute === 'message') return _message;
    // }
  }

  async goStartScoring() {
    this.gameInfo = {
      courses: [],
      players: [],
      availablePlayers: [],
    };
    let _clubId = this.bookingSlot.clubData.id;
    let _c1 = this.bookingSlot.slotAssigned.startCourse.id;
    let _c2 =
      this.bookingSlot.ninesPlayed === 2 && this.bookingSlot.slotAssigned.secondCourse
        ? this.bookingSlot.slotAssigned.secondCourse.id
        : null;

    this.actualPlayersInBooking = this.setActualPlayersInBooking();
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: 'Generating scorecards...',
    });
    loader.present().then(() => {
      this.getGameClubInfo(_clubId)
        .then(a => {
          this.getGameCoursesInfo(_clubId, _c1, _c2).then(b => {
            console.debug('start scoring [3]', this.bookingSlot.bookingPlayers);
            this.bookingSlot.bookingPlayers.sort((a, b) => {
              if (a.sequence < b.sequence) return -1;
              else if (a.sequence > b.sequence) return 1;
              else return 0;
            });

            this.getGamePlayersInfo(
              this.actualPlayersInBooking[0]?.player.id,
              0,
              this.actualPlayersInBooking?.length,
              loader
            );
            // .then((result: any) => {
            //   console.debug("start scoring [000] ", result, this.gameInfo, this.bookingSlot.bookingPlayers)
            //   if (
            //     this.gameInfo.players &&
            //     this.gameInfo.players.length === this.bookingSlot.bookingPlayers?.length
            //   ) {
            //     console.debug("start scoring [5]", this.gameInfo.players)
            //     this.settingUpScorecard().then((scorecard: any) => {
            //       if (scorecard)
            //         scorecard['bookingId'] = this.bookingSlot.id;
            //       setTimeout(() => {
            //         // if (loader) loader.dismiss();
            //         let params: NavigationExtras = {
            //           replaceUrl: false,
            //           state: {
            //             scorecard: scorecard,
            //             currentPlayer: this.currentPlayer,
            //           },
            //         };
            //         this.router.navigate(['gameround-scoring'], params);
            //       }, 5000);
            //     });
            //   }
            // });
            // .forEach(
            //   (tbp: TeeTimeBookingPlayer, idx: number, bookingPlayers) => {
            //     let _totalPlayers = bookingPlayers.filter(
            //       (p: TeeTimeBookingPlayer) => {
            //         return p.player;
            //       }
            //     );
            //     let _idx = idx + 1;
            //     if (tbp && tbp.player)
            //       this.getGamePlayersInfo(
            //         tbp.player.id,
            //         _idx,
            //         _totalPlayers.length
            //       ).then((result) => {
            //         if (
            //           this.gameInfo.players &&
            //           this.gameInfo.players.length === _totalPlayers.length
            //         ) {
            //           console.debug("start scoring [5]", this.gameInfo.players)
            //           this.settingUpScorecard().then((scorecard: any) => {
            //             if (scorecard)
            //               scorecard['bookingId'] = this.bookingSlot.id;
            //             setTimeout(() => {
            //               if (loader) loader.dismiss();
            //               let params: NavigationExtras = {
            //                 replaceUrl: false,
            //                 state: {
            //                   scorecard: scorecard,
            //                   currentPlayer: this.currentPlayer,
            //                 },
            //               };
            //               this.router.navigate(['gameround-scoring'], params);
            //             }, 5000);
            //           });
            //         }
            //       });
            //   }
            // );
          });
        })
        .catch(error => {});
    });
  }

  goAddScoringPlayers() {}

  allowBookingScoring() {
    if (this.teeSlotNew) return false;
    if (!this.currentPlayer) return false;
    if (this.fromClub) return false;
    let _isBookingPlayer = this.bookingSlot.bookingPlayers.filter((bp: TeeTimeBookingPlayer) => {
      return bp && bp.player && bp.player.id === this.currentPlayer.playerId;
    });
    return (
      this.appAttribute &&
      this.appAttribute.bookingGameScoring &&
      _isBookingPlayer &&
      _isBookingPlayer.length > 0
    );
  }

  getPlayerRedeemCreditWalletText() {
    if (!this.appAttribute) return;
    let _text = 'Redeem From Credits / eWallet';
    if (this.appAttribute && this.appAttribute.playerRedeemCreditWalletText)
      _text = this.appAttribute.playerRedeemCreditWalletText;
    return _text;
  }

  getWalkingOrOwnBuggyNaming(type?: string) {
    let _textWalk = 'Walk';
    let _appAttribute;
    _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('bookingDetails');
    if (
      _appAttribute &&
      _appAttribute.labels &&
      _appAttribute.labels.flightWalk &&
      (type === 'walk' || !type)
    )
      _textWalk = _appAttribute.labels.flightWalk;
    else if (
      _appAttribute &&
      _appAttribute.labels &&
      _appAttribute.labels.flightWalking &&
      type === 'walking'
    )
      _textWalk = _appAttribute.labels.flightWalking;
    return _textWalk;
  }
  otherPlayer;
  async onSelectOtherPlayerCredits() {
    let _membersOnly: boolean = false;
    let _playerWallet: boolean = true;
    let _currency;
    if (this.currency) _currency = this.currency.symbol;
    else if (
      this.bookingSlot &&
      this.bookingSlot.slotAssigned &&
      this.bookingSlot.slotAssigned.currency
    )
      _currency = this.bookingSlot.slotAssigned.currency.symbol;
    const _playerModal = await this.modalCtl.create({
      component: AddPlayerListPage,
      componentProps: {
        fromClub: true,
        openedModal: true,
        clubId: this.bookingSlot.clubData.id,
        membersOnly: _membersOnly,
        playerWallet: _playerWallet,
        playerAccount: false,
        noNewPlayer: true,
        currencySymbol: _currency,
        bookingPlayers: this.bookingSlot.bookingPlayers,
        currentDate: this.bookingSlot
          ? this.bookingSlot.slotAssigned.teeOffDate
          : this.teeTimeSlotDisplay.slot.teeOffDate,
      },
    });
    _playerModal.onDidDismiss().then((data: any) => {
      if (data) {
        this.otherPlayer = data.item;
        this.goSelectOtherPlayerCredits(data.availableBalance);
      }
    });
    _playerModal.present();
  }
  async goSelectOtherPlayerCredits(availableBalance?: number) {
    let _msg = '';
    let _currencySymbol = '';
    if (this.bookingSlot && this.bookingSlot.slotAssigned) {
      _currencySymbol = this.bookingSlot.slotAssigned.currency.symbol;
    }
    if (this.otherPlayer) {
      _msg = this.otherPlayer.playerName + ' (#' + this.otherPlayer.id + ')';
      _msg +=
        '<br>EWallet Balance : ' +
        _currencySymbol +
        ' ' +
        this.mg2uUtil.numberWithCommas(availableBalance);
      _msg +=
        '<br>Booking Remaining Amount : ' +
        _currencySymbol +
        ' ' +
        this.getBookingBalance(true).toFixed(2);
    }
    let _balance = this.getBookingBalance(true);
    let alert = await this.alertCtrl.create({
      header: 'Pay from this player',
      message: _msg,
      inputs: [
        {
          name: 'amount',
          placeholder: 'Specify Amount',
          type: 'number',
          value: String(_balance),
        },
      ],
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Redeem Now',
          handler: data => {
            if (data && data.amount > availableBalance) {
              MessageDisplayUtil.showMessageToast(
                'EWallet Balance is not sufficient',
                this.platform,
                this.toastCtl,
                5000,
                'bottom'
              );
              return false;
            } else if (data && data.amount < 0) {
              MessageDisplayUtil.showMessageToast(
                'Please specify valid amount',
                this.platform,
                this.toastCtl,
                5000,
                'bottom'
              );
              return false;
            } else if (data && data.amount > _balance) {
              this.goRedeemOtherPlayerCredits(_balance);
            } else {
              this.goRedeemOtherPlayerCredits(data.amount);
            }
          },
        },
      ],
    });
    alert.present();
  }
  goRedeemOtherPlayerCredits(amount: number) {
    let _bookingId = this.bookingSlot.id;
    let _playerId = null;
    if (this.otherPlayer && this.otherPlayer.id) _playerId = this.otherPlayer.id;
    else if (this.otherPlayer && this.otherPlayer.playerId) _playerId = this.otherPlayer.playerId;
    let _redeemAmount = amount;
    let _refundMode = 'Club Wallet';
    this.flightService
      .redeemPlayerClubCredit(_bookingId, _playerId, _redeemAmount)
      .subscribe((data: any) => {
        MessageDisplayUtil.showMessageToast(
          'Successfully redeemed credits.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        this.refreshBookingDetails();
        // return false;
      });
  }
  getClubPayFromOtherPlayerCredit() {
    if (!this.bookingSlot) return;
    if (!this.appAttribute) return;
    if (this.appAttribute && !this.appAttribute.clubToPayFromPlayerWallet) return;
    if (
      this.appAttribute &&
      this.appAttribute.clubToPayFromPlayerWallet &&
      this.appAttribute.clubToPayFromPlayerWallet.length === 0
    )
      return;
    let _currentClubId = this.bookingSlot.clubData.id;
    let _clubCanPay: boolean = false;
    this.appAttribute.clubToPayFromPlayerWallet
      .filter(clubId => {
        return clubId === _currentClubId;
      })
      .map(clubId => {
        _clubCanPay = true;
      });
    return _clubCanPay;
  }
  async goUpdateProfile() {
    const modal = await this.modalCtl.create({
      component: AddPlayerListPage,
      componentProps: {
        homeInfo: this.playerHomeInfo$,
        player: this.player$,
        type: 'playerProfile',
      },
    });
    modal.onDidDismiss().then((data?: any) => {
      this.refreshPlayerInfo();
      this.refreshBookingDetails();
    });
    modal.present();
  }
  async onPrintClick(download?: boolean) {
    let _singleText = '';
    let _msg = '';
    if (!this.fromClub) {
      _singleText = 'For myself';
      _msg = 'Do you want to print for yourself or for all?';
    } else {
      _singleText = 'Single player';
      _msg = 'Do you want to print for a single player or for all players?';
    }
    // let _buttons = [];
    // _buttons.push({
    //   text: 'Cancel',
    // });
    // if (this.fromClub) {
    //   _buttons.push({
    //     text: 'Detailed bill',
    //     handler: () => {
    //       this.onGenerateDetailsItemizedBill();
    //     },
    //   });
    // }
    // _buttons.push(
    //   {
    //     text: 'For all players',
    //     handler: () => {
    //       this.onPrintPDFServer(download, null);
    //     },
    //   },
    //   {
    //     text: _singleText,
    //     handler: () => {
    //       if (!this.fromClub) this.onPrintPDFServer(download, true);
    //       else this.onPrintSelectBookingPlayer(download);
    //     },
    //   }
    // );
    // let alert = await this.alertCtrl.create({
    //   header: 'Print Bill',
    //   message: _msg,
    //   buttons: _buttons,
    // });
    // alert.present();
    let printModal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      componentProps: {
        mode: 'printDetail',
        fromClub: this.fromClub,
        _singleText: _singleText,
        _msg: _msg,
      },
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
    });
    await printModal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    printModal.onWillDismiss().then(data => {
      if (data?.data) {
        switch (data?.data) {
          case 'detaileBill':
            this.onGenerateDetailsItemizedBill();
            break;
          case 'forAllPlayer':
            this.onPrintPDFServer(download, null);
            break;
          case 'singleTxt':
            if (!this.fromClub) this.onPrintPDFServer(download, true);
            else this.onPrintSelectBookingPlayer(download);
            break;
        }
      }
    });
  }
  async onPrintPDFServer(download: boolean, self?: boolean, bookingPlayerId?: number) {
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 30000,
      message: 'Generating receipt...',
    });
    let _bookingId = this.bookingSlot.id;
    let _bookingPlayerId = null;
    if (self) {
      this.bookingSlot.bookingPlayers
        .filter((bp: TeeTimeBookingPlayer) => {
          return bp.player && bp.player.id === this.currentPlayerId;
        })
        .map(bp => {
          _bookingPlayerId = bp.id;
        });
    } else if (bookingPlayerId) {
      _bookingPlayerId = bookingPlayerId;
    }
    loader.present().then(() => {
      this.flightService.getBookingBillPrint(_bookingId, null, _bookingPlayerId).subscribe(
        data => {
          this.filenameBill = 'booking-bill-' + this.bookingSlot.id + '.pdf';
          let fileName = this.filenameBill;
          let _url = global.MygolfServer + data;
          if (!this.platform.is('capacitor')) {
            window.open(_url);
            setTimeout(
              () => {
                window.URL.revokeObjectURL(_url);
              },
              15 * 60 * 1000
            );
          } else {
            Browser.open({ url: _url });
            // this.openWithInAppBrowser(_url, '_system');
          }
          if (loader) loader.dismiss();
          if (1) return;
          if (data) {
            let _data = data;
            let render = '';
            if (render === 'base64') {
              const binaryString = window.atob(_data);
              const bytes = new Uint8Array(binaryString.length);
              const binaryToBlob = bytes.map((byte, i) => binaryString.charCodeAt(i));
              const blob = new Blob([binaryToBlob], {
                type: 'application/pdf',
              });
              this.downloadFile(blob, download);
            } else {
              this.downloadFile(data, download);
            }
          }
        },
        error => {
          if (loader) loader.dismiss();
        }
      );
    });
  }

  downloadFile(blob, download: boolean) {
    this.filenameBill = 'booking-bill-' + this.bookingSlot.id + '.pdf';
    let fileName = this.filenameBill;
    var binaryData = [];
    binaryData.push(blob);
    let _blob = new Blob(binaryData, { type: 'application/pdf' });
    const url = window.URL.createObjectURL(_blob);
    if (download) {
      const link = this.renderer2.createElement('a');
      this.renderer2.setAttribute(link, 'download', fileName);
      this.renderer2.setAttribute(link, 'href', url);
      this.renderer2.setAttribute(link, 'target', '_blank');
      this.renderer2.appendChild(this.el.nativeElement, link);
      link.click();
      this.renderer2.removeChild(this.el.nativeElement, link);
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
    } else if (!download) {
      let _url = global.MygolfServerHost + blob;
      window.open(_url);
      setTimeout(
        () => {
          window.URL.revokeObjectURL(_url);
        },
        15 * 60 * 1000
      );
    }
  }

  async onPrintSelectBookingPlayer(download) {
    let _buttons = [];
    if (this.bookingSlot && this.bookingSlot.bookingPlayers)
      this.bookingSlot.bookingPlayers.forEach(bp => {
        _buttons.push({
          text: bp.playerName,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.onPrintPDFServer(false, false, bp.id);
            });
            return false;
          },
        });
      });
    let actionSheet = await this.actionSheetCtrl.create({
      buttons: _buttons,
    });
    actionSheet.present();
  }
  isJumboFlight() {
    if (this.teeSlotNew) return false;
    if (this.bookingSlot && this.bookingSlot.jumboFlight) return true;
    else return false;
  }

  getJumboPlan(slot: TeeTimeSlot, attribute?: string) {
    let _jumboPlan: TeeTimePricingPlan;
    _jumboPlan = slot && slot.pricingPlanJumbo ? slot.pricingPlanJumbo : null;
    if (_jumboPlan) {
      switch (attribute) {
        case 'name':
          return _jumboPlan.name;
        case 'description':
          return this.escapeCRLF(_jumboPlan.description);
        case 'discounts':
          return _jumboPlan.discountsApplicable;
        case 'addCharges':
          return _jumboPlan.additionalCharges;
        case 'promo':
          return _jumboPlan.promotional;
        case 'prices':
          return _jumboPlan.prices;
        case 'currency':
          return _jumboPlan.currency.symbol;
        case 'jumbo':
          return _jumboPlan;
        case 'minPlayer':
          return this.bookingOptions ? this.bookingOptions.minPlayersJumboFlight : null;
      }
    } else return '';
  }

  async goUpdateTeeTimeSettingsPage() {
    let editTeeTimeSettings = await this.modalCtl.create({
      component: EditTeeTimeSettingsPage,
      componentProps: {
        bookingOptions: this.bookingOptions,
        bookingSlot: !this.teeSlotNew ? this.bookingSlot : null,
        teeTimeSlotDisplay: this.teeSlotNew ? this.teeTimeSlotDisplay : null,
        teeSlotNew: this.teeSlotNew,
        singleMode: true,
        totalSlotsSelected: 1,
      },
    });
    editTeeTimeSettings.onDidDismiss().then((datas: any) => {
      let data = datas.data;
      if (data) {
        if (this.bookingSlot.bookingMedium !== data.bookingMedium) {
          let _params = {
            bookingId: this.bookingSlot.id,
            bookingMedium: data.bookingMedium.toUpperCase(),
          };
          this.flightService.updateBookingMedium(_params).subscribe(data => {
            if (data) this.recalculateBookingPricing(true);
          });
        } else {
          this.updateTeeTimeSettings(data);
          this.recalculateBookingPricing(true);
        }
      }
    });
    editTeeTimeSettings.present();
  }

  updateTeeTimeSettings(params: any) {
    let _params = params;
    _params['buggyRequired'] = params.buggyRequired ? 'Y' : 'N';
    _params['caddieRequired'] = params.caddieRequired ? 'Y' : 'N';
    let _slotDayId;
    let _slotNo;
    if (!this.teeSlotNew) {
      _slotDayId = this.bookingSlot.slotAssigned.slotDayId;
      _slotNo = this.bookingSlot.slotAssigned.slotNo;
    } else {
      _slotDayId = this.teeTimeSlotDisplay.slot.slotDayId;
      _slotNo = this.teeTimeSlotDisplay.slot.slotNo;
    }
    this.flightService
      .updateSlotBuggyCaddieSettings(_slotDayId, _slotNo, _params)
      .subscribe(data => {});
  }

  getClubSpecific(attribute: string) {
    return this.mg2uUtil.getClubSpecificHeader(attribute);
  }
  getColorBookingStatus() {
    if (!this.bookingSlot) return;
    let _color = '';
    _color = this.mg2uUtil.getColorBookingStatus(this.bookingSlot.bookingStatus);
    return _color.toLowerCase();
  }
  getVisibleMode(item?: string) {
    switch (item) {
      case 'teeTimeSettings':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'manageVouchers':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'manageRefundAdjustment':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'offlinePayment':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'autoCancelGuard':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'undoCancel':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'toggleBookingMedium':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'changeCourse':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'moveFlightTime':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'additionalBookingLevel':
        if (this.isBookingAgent()) return false;
        else return true;
      case 'moreBillPaymentActions':
        if (this.isBookingAgent()) return false;
        else return true;
    }
  }
  async onGenerateDetailsItemizedBill() {
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 30000,
      message: 'Generating itemized bill...',
    });
    let _bookingId = this.bookingSlot.id;
    loader.present().then(() => {
      this.flightService.getDetailedItemizedBill(_bookingId, null).subscribe(data => {
        this.filenameBill = 'booking-bill-' + this.bookingSlot.id + '.pdf';
        let fileName = this.filenameBill;
        let _url = global.MygolfServer + data;
        // if (!this.platform.is('capacitor') || !this.platform.is('cordova') || !this.platform.is('android')) {

        if (!this.platform.is('capacitor')) {
          window.open(_url);
          setTimeout(
            () => {
              window.URL.revokeObjectURL(_url);
            },
            15 * 60 * 1000
          );
        } else {
          Browser.open({ url: _url });
          // this.openWithInAppBrowser(_url, null);
        }
        if (loader) loader.dismiss();
      });
    });
  }
  onClickRequireCaddy() {
    if (this.isClubDisableCaddies('isDisable')) {
      let _msg;
      if (!this.isClubDisableCaddies('message'))
        _msg =
          'Club currently disables caddies selection via online. Please contact club for further information';
      else _msg = this.isClubDisableCaddies('message');
      MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }
  }
  onClubChargeToAccount(chargeFor?: string) {
    let _checkFailed: boolean = false;
    this.checkClubPhoneMandatory().then(result => {
      if (!result) _checkFailed = true;
      if (result) {
        this.onProcessAssignment();
        let params: NavigationExtras = {
          // replaceUrl: false,
          state: {
            currentSlot: this.bookingSlot,
            clubId: this.bookingSlot.clubData.id,
            forDate: this.bookingSlot.slotAssigned.teeOffDate,
            courseId: this.bookingSlot.slotAssigned.startCourse.id,
            changeType: 'course',
            currency: this.currency ? this.currency : this.bookingSlot.slotAssigned.currency,
            fromClub: this.fromClub,
            itemizedBill: this.bookingItemBill,
            currentPlayerId: this.currentPlayerId ? this.currentPlayerId : null,
            paymentType: 'chgacc',
            clubMemberships: this.filteredClubMembership,
            chargeFor: chargeFor,
          },
        };
        this.router.navigate(['redeem-player-club-credits'], params);
      }
    });
  }
  isClubChargeToAccountEnable() {
    if (this.isBookingAgent()) return false;
    return this.bookingOptions && this.bookingOptions.chargeToAccountEnabled;
  }
  async onProcessPaymentClick(mode?: string) {
    if (!this.fromClub) {
      if (mode === 'continue') this.onPayNow();
      else this.onCheckBuggyCaddyAssignment();
    }
    if (this.fromClub) {
      if (mode === 'continue') this.onPayNow();
      else this.onCheckBuggyCaddyAssignment();

      if (0 && this.bookingOptions && this.bookingOptions.chargeToAccountEnabled) {
        let alert = await this.alertCtrl.create({
          header: 'Payment Method',
          message:
            'Club has Charge to Account <b>Enabled</b>. Do you want to proceed with <b>Charge to Player Account</b> or <b>Offline Payment</b>? ',
          cssClass: 'booking-alert',
          buttons: [
            {
              text: 'Charge To Account',
              handler: () => {
                this.onClubChargeToAccount();
              },
            },
            {
              text: 'Offline Payment',
              handler: () => {
                if (mode === 'continue') this.onPayNow();
                else this.onCheckBuggyCaddyAssignment();
              },
            },
            {
              text: 'Cancel',
              handler: () => {},
            },
          ],
        });
        alert.present();
      }
    }
  }
  async onMoreBillPaymentsButton() {
    let _currDate = moment().toDate();
    let _teeOffDate = moment(this.bookingSlot.slotAssigned.teeOffDate, 'YYYY-MM-DD').toDate();
    let _bookingType = null;

    if (moment(_teeOffDate).isBefore(_currDate, 'day')) {
      _bookingType = 'past';
    }
    let _buttons = [];
    if (this.fromClub && this.isClubChargeToAccountEnable()) {
      _buttons.push({
        text: 'Charge To Account',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.onClubChargeToAccount();
          });
          return false;
        },
      });
    }
    _buttons.push({
      text: 'View Assignment',
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.onViewAssignmentDetails();
        });
        return false;
      },
    });
    _buttons.push({
      text: 'Generate Itemized Bill',
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.onGenerateDetailsItemizedBill();
        });
        return false;
      },
    });
    if (this.fromClub && this.allowClubManualRecalculate() && this.bookingType !== 'past') {
      _buttons.push({
        text: 'Cancel Assignment',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.onClubCancelAssignment();
          });
          return false;
        },
      });
      _buttons.push({
        text: 'Process Assignment',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.onClubProcessAssignment();
          });
          return false;
        },
      });
      _buttons.push({
        text: 'Re-Calculate',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.onClubManualRecalculate();
          });
          return false;
        },
      });
    }
    if (_bookingType === 'past' && this.mg2uUtil.isBookingOverrideEnable())
      _buttons.push({
        text:
          'Override Past Booking Mode : ' + (this.bookingType === 'past' ? 'Disabled' : 'Enabled'),
        handler: () => {
          actionSheet.dismiss().then(async () => {
            let alert = await this.alertCtrl.create({
              header: 'Override Mode',
              cssClass: 'booking-error',
              message:
                'This will change to Override mode for Past Booking. Do you want to proceed?', //'Selected date is ' + '<b>' + _date + '</b>',
              buttons: [
                {
                  text: 'Cancel',
                },
                {
                  text: 'Yes',
                  handler: () => {
                    if (this.bookingType === 'past') this.toggleBookingType('edit');
                    else this.toggleBookingType();
                  },
                },
              ],
            });
            if (this.bookingType === 'past') {
              alert.present();
            } else this.toggleBookingType();
          });
          return false;
        },
      });

    let actionSheet = await this.actionSheetCtrl.create({
      buttons: _buttons,
    });
    actionSheet.present();
  }
  async onPaymentHistClick(payment: BookingPayment) {
    if (!this.fromClub) return;
    if (!payment) return;

    let _buttons = [];
    _buttons.push({
      text: 'View Details',
      handler: async () => {
        (await actionSheet).dismiss().then(() => {
          this.onViewBillDetails(payment);
        });
        return false;
      },
    });
    if (
      this.fromClub &&
      (payment.paymentMethod.toLowerCase().includes('off') ||
        payment.paymentMethod.toLowerCase().includes('cash'))
    ) {
      _buttons.push({
        text: 'Update Club Payment Method',
        handler: async () => {
          (await actionSheet).dismiss().then(() => {
            this.goClubChangePaymentMethod(payment.billId, payment);
          });
          return false;
        },
      });
    }

    let actionSheet = await this.actionSheetCtrl.create({
      buttons: _buttons,
    });
    actionSheet.present();
  }
  async goClubChangePaymentMethod(billId: number, payment?) {
    if (!billId) return;
    let alert = await this.alertCtrl.create({
      header: 'Update Club Payment Method',
      message: "Do you want to change this bill's payment method? Bill ID : " + billId,
      cssClass: 'booking-error',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {},
        },
        {
          text: 'Yes',
          handler: () => {
            this._onClubChangePaymentMethod(billId, payment);
          },
        },
      ],
    });
    alert.present();
  }
  private async _onClubChangePaymentMethod(billId: number, payment?: BookingPayment) {
    let _clubPaymentMethodList: Array<ClubPaymentMethod>;
    _clubPaymentMethodList = [];
    let _buttons = [];
    let actionSheet = await this.actionSheetCtrl.create({
      buttons: _buttons,
    });
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter(d => {
            return d.page === 'pricesDisplay';
          })
          .map(d => {
            _clubPaymentMethodList = d.clubPaymentMethodList;
            if (_clubPaymentMethodList && _clubPaymentMethodList.length > 0) {
              _clubPaymentMethodList.forEach(pm => {
                if (
                  pm.APIname.toLowerCase().includes('off') ||
                  pm.APIname.toLowerCase().includes('cash')
                ) {
                  if (payment && pm.APIname !== payment.paymentMethod) {
                    _buttons.push({
                      text: pm.name,
                      handler: () => {
                        this._onUpdateClubPaymentMethod(billId, pm.APIname);
                      },
                    });
                  }
                }
              });

              actionSheet.present();
            }
          });
      }
    });
  }
  private _onUpdateClubPaymentMethod(billId: number, method: string) {
    if (!billId) return;
    if (!method) return;
    this.flightService.updateClubPaymentMethod(billId, method).subscribe(data => {
      if (data) {
        MessageDisplayUtil.showMessageToast(
          'Successfully updated club payment method',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        this.refreshBookingDetails();
        return false;
      }
    });
  }
  onViewBillDetails(payment: BookingPayment) {
    if (!payment) return;
    let _paidFor = payment.whatIsPaid === 'D' ? 'Deposit Amount' : 'Full Amount';
    this.flightService.getBillDetails(payment.billId).subscribe(async (bill: Bill) => {
      let alert = await this.alertCtrl.create({
        header: 'Details for Bill ' + payment.billId,
        message: 'Remarks : ' + bill.description,
        cssClass: 'booking-error',
        buttons: [
          {
            text: 'Close',
            role: 'cancel',
            handler: () => {},
          },
        ],
      });
      alert.present();
    });
  }
  getOverpaymentNumber() {
    if (this.teeSlotNew) return 0;
    if (this.getBookingBalance(true) > 0) return 0;
    let _overpayment =
      this.bookingItemBill.totalPayable -
      this.bookingItemBill.totalPayment -
      this.bookingItemBill.totalDeductions +
      this.bookingItemBill.totalRefund;
    return Number(_overpayment);
  }
  getOverpayment(inNumber?: boolean) {
    if (this.teeSlotNew) return 0;
    if (this.getBookingBalance(true) > 0) return 0;
    let _overpayment =
      this.bookingItemBill.totalPayable -
      this.bookingItemBill.totalPayment -
      this.bookingItemBill.totalDeductions +
      this.bookingItemBill.totalRefund;
    if (inNumber) return Number(_overpayment);
    else return _overpayment.toFixed(2);
  }
  hasBuggyPlayerType(i: number) {
    if (this.teeSlotNew) return;
    if (this.buggyTypeList && this.buggyTypeList.length <= 1) return;
    let _bookingPlayers = this.bookingSlot.bookingPlayers;

    console.debug(
      'has buggy player type : ',
      i,
      _bookingPlayers,
      _bookingPlayers[i],
      this.buggyTypeList
    );

    if (!_bookingPlayers) return;
    if (!_bookingPlayers[i]) return;
    if (_bookingPlayers === undefined) return;
    let _playerType = null;
    let _bookingPlayer = _bookingPlayers[i];
    if (_bookingPlayer.playerTypeUsed) _playerType = _bookingPlayer.playerTypeUsed;
    else if (_bookingPlayer.playerType) _playerType = _bookingPlayer.playerType;
    else return false;
    let _hasBuggyType = this.buggyTypeList.filter(bgy => {
      let _canUse;
      let _noAssignable: boolean = false;
      if (bgy) {
        if (bgy.assignableTo && bgy.assignableTo.length > 0) {
          _canUse = bgy.assignableTo.filter(type => {
            return type.toLowerCase() === _playerType.id.toLowerCase();
          });
          _noAssignable = false;
        } else if (bgy.assignableTo && bgy.assignableTo.length === 0) _noAssignable = true;
      }
      return (_canUse && _canUse.length > 0) || _noAssignable;
    });
    return _hasBuggyType && _hasBuggyType.length > 1;
  }
  async onSelectBuggyType(i) {
    let _bookingPlayers = this.bookingSlot.bookingPlayers;
    if (!_bookingPlayers) return;
    if (!_bookingPlayers[i]) return;
    if (_bookingPlayers === undefined) return;
    let _playerType = null;
    let _bookingPlayer = _bookingPlayers[i];
    if (_bookingPlayer.playerTypeUsed) _playerType = _bookingPlayer.playerTypeUsed;
    else if (_bookingPlayer.playerType) _playerType = _bookingPlayer.playerType;
    else return false;
    const popover: any = await this.popoverCtl.create({
      component: BuggySeatingPage,
      componentProps: {
        type: 'buggyType',
        headerName: 'Buggy Type',
        playerType: _playerType,
        playerId: _bookingPlayer.player ? _bookingPlayer.player.id : null,
        buggyTypes: this.buggyTypeList,
      },
      showBackdrop: true,
    });
    popover.onDidDismiss().then((data: any) => {
      if (data?.data && data?.data?.selected) {
        if (data?.data?.buggyType) {
          this.selectedBuggyType[i] = data?.data?.buggyType;
          let _preference = this.newBuggyCaddyPreference;
          let _bookingPlayer;
          let _selectedBuggyType = data?.data?.buggyType;
          _bookingPlayer = this.bookingSlot.bookingPlayers[i];
          _preference.ignoreBuggyUpdate = false;

          _preference.playerPairings.filter((p: PlayerBuggyCaddiePreference) => {
            if (p.bookingPlayerId === _bookingPlayer.id) {
              p.buggyType = _selectedBuggyType.typeId;
            }
          });
        }
      }
    });
    popover.present();
  }
  getBuggyTypeDisplay(i) {
    if (!this.selectedBuggyType[i] || this.selectedBuggyType[i].typeId === null)
      return 'Select Buggy Type';
    else if (!this.selectedBuggyType[i].typeName) return this.getBuggyTypeDetails(i, 'name');
    else return this.selectedBuggyType[i].typeName;
  }
  getBuggyTypeDetails(i: number, attribute: string) {
    if (!this.buggyTypeList) return;
    let _buggyTypeList = JSON.parse(JSON.stringify(this.buggyTypeList));
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    let _type = '';
    if (this.hasPreferenceChanges())
      _type = this.newBuggyCaddyPreference.playerPairings[i].buggyType;
    else if (this.bookingSlot && this.bookingSlot.bookingPlayers[i]) {
      _type = this.bookingSlot.bookingPlayers[i].buggyCaddiePreference.buggyType;
    }
    let _buggyType: BuggyType;
    if (_type)
      _buggyType = _buggyTypeList
        .filter(type => {
          return type.typeId === _type;
        })
        .pop();
    else {
      _buggyType = _buggyTypeList
        .filter(type => {
          return type.typeId === 'STANDARD';
        })
        .pop();
    }
    switch (attribute) {
      case 'id':
        return _buggyType && _buggyType.typeId;
      case 'name':
        return _buggyType && _buggyType.typeName;
      case 'seats':
        return _buggyType && _buggyType.maxSeats;
    }
  }
  isPlayerHasInsurance(i) {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    let _hasPlayerInsurance: boolean = false;
    if (
      this.bookingSlot &&
      this.bookingSlot.bookingPlayers[i] &&
      this.bookingSlot.bookingPlayers[i].playerHasInsurance
    )
      _hasPlayerInsurance = this.bookingSlot.bookingPlayers[i].playerHasInsurance;
    return _hasPlayerInsurance;
  }
  toggleBookingType(type?: string) {
    if (!this.mg2uUtil.isBookingOverrideEnable) return;
    if (type) this.pricingIgnoreDate = true;
    else this.pricingIgnoreDate = false;
    let _currDate = moment().toDate();
    let _teeOffDate = moment(this.bookingSlot.slotAssigned.teeOffDate, 'YYYY-MM-DD').toDate();
    let _bookingType = null;
    if (_teeOffDate < _currDate) {
      _bookingType = 'past';
      if (!type && this.bookingType === 'past') {
        this.bookingType = 'active';
      } else if (!type) this.bookingType = 'past';
      if (type === 'edit' && this.bookingType === 'past') this.bookingType = 'active';
      else this.bookingType = 'past';
    } else {
      if (1) return;
    }
    setTimeout(async () => {
      if (this.bookingType === 'active') {
        let alert = await this.alertCtrl.create({
          header: 'Override Mode',
          cssClass: 'booking-error',
          message:
            'You are currently in Override mode for Past Booking, you may click on Undo to revert to Normal mode. Are you sure you want to proceed?', //'Selected date is ' + '<b>' + _date + '</b>',
          buttons: [
            {
              text: 'Undo to normal',
              handler: () => {
                this.bookingType = 'past';
              },
            },
            {
              text: 'Yes',
              handler: () => {},
            },
          ],
        });
        alert.present();
      }
    }, 500);
  }
  async getSimplePaymentReminder() {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    if (!this.bookingItemBill) return;
    if (
      this.bookingSlot &&
      (this.bookingSlot.bookingStatus === 'CancelledByClub' ||
        this.bookingSlot.bookingStatus === 'CancelledByPlayer')
    )
      return;
    let _txtAmountPayable = '';
    _txtAmountPayable = await this.getSimplePaymentReminderText();

    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'getSimplePaymentReminder',
        msg: _txtAmountPayable,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }
  getSimplePaymentReminderText() {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    if (!this.bookingItemBill) return;
    if (
      this.bookingSlot &&
      (this.bookingSlot.bookingStatus === 'CancelledByClub' ||
        this.bookingSlot.bookingStatus === 'CancelledByPlayer')
    )
      return;
    let _txtAmountPayable = '';
    let _amountPayable = '0';
    let _depositPayable = 0;
    let _hourGracePeriod =
      this.appAttribute && this.appAttribute.bookingCutOffValue
        ? this.appAttribute.bookingCutOffValue
        : 1; //in hour
    let _gracePeriod = moment(this.bookingSlot.gracePeriodFrom).add(_hourGracePeriod, 'h');
    // let _bookingDate = momenthis.bookingSlot.slotAssigned.teeOffDate;
    let _fullPaymentBy = moment(this.bookingSlot.fullPaymentBy); //.subtract();
    let _fullPayByText;
    if (
      this.bookingOptions.depositAmountType === 'Percentage' &&
      this.bookingOptions.depositAmount === 100
    )
      _fullPayByText = moment(this.bookingSlot.fullPaymentBy);
    _depositPayable = this.bookingSlot.depositPayable ? this.bookingSlot.depositPayable : 0;
    // .subtract(this.bookingOptions.depositCutOffDays, 'd').add(1,'d')
    let _depositBy = moment(this.bookingSlot.depositBy); //.add(_hourGracePeriod,'h');
    let _currency = this.currency
      ? this.currency
      : this.bookingSlot.clubData.address.countryData.currencySymbol;
    if (this.getBookingBalance(true) <= 0) return;
    if (_depositPayable > 0 && Number(_depositPayable.toFixed(2)) > this.getBookingPayment(true)) {
      _amountPayable = String(_depositPayable);
      let _depositText = '';
      if (
        this.bookingOptions.depositAmountType === 'Percentage' &&
        this.bookingOptions.depositAmount === 100
      )
        _depositText = 'Payment';
      else _depositText = 'Payment';
      //   _depositText = 'Full Payment';
      // else _depositText = 'Deposit Payment';

      _txtAmountPayable =
        'Please make a ' +
        _depositText +
        ' of amount ' +
        _currency +
        ' ' +
        _depositPayable.toFixed(2);
    } else if (this.getBookingPayment(true) > 0 && this.getBookingBalance(true) > 0) {
      _amountPayable = this.getBookingBalance();
      _txtAmountPayable =
        'Please make a <b>Payment of remaining  ' + _currency + ' ' + _amountPayable + '</b>';
    } else {
      _amountPayable = this.mg2uUtil.numberWithCommas(
        Number(this.bookingSlot.amountPayable.toFixed(2))
      );
      _txtAmountPayable = 'Please make a Full Payment of ' + _currency + ' ' + _amountPayable;
    }
    if (moment(_gracePeriod).isSameOrAfter(moment(_depositBy))) {
      if (_gracePeriod.diff(_depositBy) > 0) {
        _txtAmountPayable += ' by ' + moment(_gracePeriod).format('ddd, DD MMM YYYY hh:mm A');
      } else
        _txtAmountPayable +=
          '<br> by end of <b>' + moment(_depositBy).format('ddd, DD MMM YYYY') + '</b>';
    } else if (moment(_depositBy).isSameOrAfter(moment(), 'date') && _depositPayable > 0)
      _txtAmountPayable +=
        '<br> by end of <b>' + moment(_depositBy).format('ddd, DD MMM YYYY') + '</b>';
    else if (moment(_fullPaymentBy).isSameOrAfter(moment()) && _depositPayable === 0)
      _txtAmountPayable +=
        '<br> by <b>' + moment(_fullPaymentBy).format('ddd, DD MMM YYYY hh:mm A') + '</b>';
    else {
      _txtAmountPayable +=
        '<br> by <b>' + moment(_gracePeriod).format('ddd, DD MMM YYYY hh:mm A') + '</b>';
    }
    _txtAmountPayable += ' to avoid cancellation';

    return _txtAmountPayable;
  }

  getSummaryPaymentReminderText() {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    if (!this.bookingItemBill) return;
    if (
      this.bookingSlot &&
      (this.bookingSlot.bookingStatus === 'CancelledByClub' ||
        this.bookingSlot.bookingStatus === 'CancelledByPlayer')
    )
      return;
    let _txtAmountPayable = '';
    let _amountPayable = '0';
    let _depositPayable = 0;
    let _hourGracePeriod =
      this.appAttribute && this.appAttribute.bookingCutOffValue
        ? this.appAttribute.bookingCutOffValue
        : 1; //in hour
    let _gracePeriod = moment(this.bookingSlot.gracePeriodFrom).add(_hourGracePeriod, 'h');
    // let _bookingDate = momenthis.bookingSlot.slotAssigned.teeOffDate;
    let _fullPaymentBy = moment(this.bookingSlot.fullPaymentBy); //.subtract();
    let _fullPayByText;
    if (
      this.bookingOptions.depositAmountType === 'Percentage' &&
      this.bookingOptions.depositAmount === 100
    )
      _fullPayByText = moment(this.bookingSlot.fullPaymentBy);
    _depositPayable = this.bookingSlot.depositPayable ? this.bookingSlot.depositPayable : 0;
    // .subtract(this.bookingOptions.depositCutOffDays, 'd').add(1,'d')
    let _depositBy = moment(this.bookingSlot.depositBy); //.add(_hourGracePeriod,'h');
    let _currency = this.currency
      ? this.currency
      : this.bookingSlot.clubData.address.countryData.currencySymbol;
    if (this.getBookingBalance(true) <= 0) return;
    // if (
    //     _depositPayable > 0 &&
    //     Number(_depositPayable.toFixed(2)) > this.getBookingPayment(true)
    // ) {
    //     _amountPayable = String(_depositPayable);
    //     let _depositText = '';
    //     if (
    //         this.bookingOptions.depositAmountType === 'Percentage' &&
    //         this.bookingOptions.depositAmount === 100
    //     )
    //         _depositText = 'Payment';
    //     else _depositText = 'Payment';
    //     //   _depositText = 'Full Payment';
    //     // else _depositText = 'Deposit Payment';

    //     _txtAmountPayable =
    //         'Please make a ' +
    //         _depositText +
    //         ' of amount ' +
    //         _currency +
    //         ' ' +
    //         _depositPayable.toFixed(2);
    // } else if (
    //     this.getBookingPayment(true) > 0 &&
    //     this.getBookingBalance(true) > 0
    // ) {
    //     _amountPayable = this.getBookingBalance();
    //     _txtAmountPayable =
    //         'Please make a <b>Payment of remaining  ' +
    //         _currency +
    //         ' ' +
    //         _amountPayable +
    //         '</b>';
    // } else {
    //     _amountPayable = this.mg2uUtil.numberWithCommas(
    //         Number(this.bookingSlot.amountPayable.toFixed(2))
    //     );
    //     _txtAmountPayable =
    //         'Please make a Full Payment of ' + _currency + ' ' + _amountPayable;
    // }
    _txtAmountPayable = 'Pay by ';
    if (moment(_gracePeriod).isSameOrAfter(moment(_depositBy))) {
      if (_gracePeriod.diff(_depositBy) > 0) {
        _txtAmountPayable += ' ' + moment(_gracePeriod).format('ddd, DD MMM YYYY hh:mm A');
      } else
        _txtAmountPayable += 'end of <b>' + moment(_depositBy).format('ddd, DD MMM YYYY') + '</b>';
    } else if (moment(_depositBy).isSameOrAfter(moment(), 'date') && _depositPayable > 0)
      _txtAmountPayable += 'End of <b>' + moment(_depositBy).format('ddd, DD MMM YYYY') + '</b>';
    else if (moment(_fullPaymentBy).isSameOrAfter(moment()) && _depositPayable === 0)
      _txtAmountPayable +=
        '<b>' + moment(_fullPaymentBy).format('ddd, DD MMM YYYY hh:mm A') + '</b>';
    else {
      _txtAmountPayable += '<b>' + moment(_gracePeriod).format('ddd, DD MMM YYYY hh:mm A') + '</b>';
    }
    return _txtAmountPayable;
  }

  async showDetailsPlayer(slot: number) {
    let _slot = slot - 1;
    let player = this.bookingSlot.bookingPlayers[_slot];
    let _player: PlayerData = player.player ? player.player : null;
    if (!_player) return;
    let _image;
    let _description = '';
    if (_player && _player.profile) _image = _player.profile;
    if (_player && _player.image) _image = _player.image;
    if (_player && _player.playerName) _description = _player.playerName;
    if (player && player.playerTypeUsed) _description += '<br>Rate: ' + player.playerTypeUsed.name;
    if (player && player.playerType && !player.playerTypeUsed)
      _description += '<br>Rate: ' + player.playerType.name;
    if (this.getPlayerMembershipImage(player))
      _image += ',' + this.getPlayerMembershipImage(player);
    const imageZoom = await this.modalCtl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: _image,
        description: _description,
        descTopDown: 'top',
      },
    });
    imageZoom.onDidDismiss().then((data: any) => {});
    imageZoom.present();
  }
  getPlayerMembershipImage(bp: TeeTimeBookingPlayer) {
    if (!bp) return;
    if (bp && !bp.player) return;
    let _memberImage: string = '';

    if (this.filteredClubMembership)
      this.filteredClubMembership
        .filter(cm => {
          return cm && cm.player && cm.player.id === bp.player.id;
        })
        .map(cm => {
          _memberImage = cm.memberImage;
        });
    return _memberImage;
  }
  getBookedByDetails() {
    if (!this.bookingSlot) return;
    if (this.bookingSlot.bookingAgent)
      return (
        '[Agent - ' + this.bookingSlot.bookingAgent.name + '] ' + this.bookingSlot.bookedByUser.name
      );
    else if (this.bookingSlot.bookedByUser && !this.bookingSlot.bookedByPlayer)
      return '[Club] ' + this.bookingSlot.bookedByUser.name;
    else if (this.bookingSlot.bookedByPlayer) return this.bookingSlot.bookedByPlayer.playerName;
    else return '';
  }

  getClubCourseImage() {
    let _club = this.dataExtras.clubInfo;
    if (_club?.clubThumbnail) return _club.clubThumbnail;
    else if (_club?.clubImage) return _club.clubImage;
    else if (_club?.club.clubLogo) return _club.club.clubLogo;
    else return '/assets/image/default_club.png';
  }

  async openDealsModal(viewTnc?: boolean) {
    const modal = await this.modalCtl.create({
      cssClass: 'self-adjustable-modal',
      component: DealsPage,
      componentProps: {
        getAllowUpdatePostPayment: this.getAllowUpdatePostPayment.bind(this),
        getPromoPlan: this.getPromoPlan.bind(this),
        getNormalPlan: this.getNormalPlan.bind(this),
        getJumboPlan: this.getJumboPlan.bind(this),
        getClubPackages: this.getClubPackages.bind(this),
        getSlotPrice: this.getSlotPrice.bind(this),
        prices: this.prices,
        promoPrices: this.promoPrices,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingOptions: this.bookingOptions,
        teeSlotNew: this.teeSlotNew,
        fromClub: this.fromClub,
        clubs: this.clubs,
        clubInfo: this.clubInfo,
        bookingSlot: this.bookingSlot,
        currentPlayerId: this.currentPlayerId,
        playerVoucher: this.playerVoucher,
        voucherSeries: this.voucherSeries,
        onlyDescription: viewTnc,
        dealsTitle: viewTnc ? 'Terms & Conditions' : null,
      },
      mode: 'ios',
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async openOtherDealsModal() {
    const modal = await this.modalCtl.create({
      cssClass: 'self-adjustable-modal',
      component: OtherDealsComponent,
      componentProps: {
        getAllowUpdatePostPayment: this.getAllowUpdatePostPayment.bind(this),
        getPromoPlan: this.getPromoPlan.bind(this),
        getNormalPlan: this.getNormalPlan.bind(this),
        getJumboPlan: this.getJumboPlan.bind(this),
        getClubPackages: this.getClubPackages.bind(this),
        getSlotPrice: this.getIndividualSlotPrice.bind(this), // this.getSlotPrice.bind(this),
        prices: this.prices,
        promoPrices: this.promoPrices,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingOptions: this.bookingOptions,
        teeSlotNew: this.teeSlotNew,
        fromClub: this.fromClub,
        clubs: this.clubs,
        clubInfo: this.clubInfo,
        bookingSlot: this.bookingSlot,
        currentPlayerId: this.currentPlayerId,
        playerVoucher: this.playerVoucher,
        voucherSeries: this.voucherSeries,
      },
      mode: 'ios',
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  additionalOptionalType(type: string, rowIndex: number) {
    this.aditionaleTypeArray[rowIndex] = type;
  }

  // Method to toggle the player details
  togglePlayerDetails(index: number) {
    this.playerDetailsExpanded[index] = !this.playerDetailsExpanded[index];
  }

  // Method for the Pricing Plan Toggle
  pricingPlanToggle() {
    this.isPricingPlanSeeMore = !this.isPricingPlanSeeMore;
  }

  onEditBookingPlayer(index: number) {
    this.editPlayerDetailsExpanded[index] = !this.editPlayerDetailsExpanded[index];
  }

  bookingDetailsType(type: string) {
    this.currentBookingType = type;
  }

  segmentChanged(event: any) {
    this.selectedSegment = event.detail.value;
  }

  async optionsModal(i: any, event: any, _caddyNo?: number, data?: any) {
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: OptionsModalComponent,
      cssClass: this.isMobileLayout() ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        index: i,
        driverAssginged: this.getPlayerDriving(i),
        caddyIndex: this.bookingSlot.bookingPlayers[i].pairingNo,
        caddyNo: _caddyNo,
        newSetBuggySeating: (value, event) => {
          return this.newSetBuggySeating(i, event);
        },
        newSetCaddyPairing: (value, event) => {
          return this.newSetCaddyPairing(i, event);
        },
        getBuggySlotDisplay: value => {
          return this.getBuggySlotDisplay(i);
        },
        onNewSelectCaddy: (value, caddyNo) => {
          return this.onNewSelectCaddy(i, _caddyNo);
        },
        getCaddyPreferred: (value, data) => {
          return this.getCaddyPreferred(i, data);
        },
        newClearPlayerDetails: value => {
          return this.newClearPlayerDetails(i);
        },
        hasBuggyPlayerType: this.hasBuggyPlayerType(i),
        //  (value) => {
        //   return this.hasBuggyPlayerType(i)
        // },
        onSelectBuggyType: value => {
          return this.onSelectBuggyType(i);
        },
        getBuggyTypeDisplay: value => {
          return this.getBuggyTypeDisplay(i);
        },
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 105;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(value => {
      if (value?.data) {
        if (value?.data?.driverValue === 'No' || value?.data?.driverValue === 'Yes') {
          this.newSetPlayerDriving(i, data, value?.data?.driverValue);
          this.driverAssginged = value?.data?.driverValue;
          this.getPlayerDriving(i);
        }
      }
    });
  }

  getBookingAssignmentDetails() {
    if (this.teeSlotNew) return;
    if (!this.bookingSlot) return;
    if (!this.bookingSlot.assignments) return false;
    if (this.bookingSlot.assignments) {
      return (
        this.bookingSlot.assignments.allCaddiesAssigned ||
        this.bookingSlot.assignments.preferredCaddieAssigned ||
        this.bookingSlot.assignments.buggyAssignmentDone
      );
    }
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  validateCheckInPlayers() {
    let _complete: boolean = true;
    this.bookingSlot.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
      if (!p.confirmed) {
        _complete = false;
      }
    });
    return _complete;
  }

  validateFlightCreated() {
    if (!this.teeSlotNew && this.bookingSlot)
      if (this.bookingSlot.flight) return true;
      else return false;
  }

  async onForceCheckInClick() {
    let alert = await this.alertCtrl.create({
      header: 'Check-In',
      cssClass: 'booking-error',
      message: 'Do you want to proceed?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        },
        {
          text: 'Check-in',
          handler: () => {
            this.goCheckInBooking(true);
          },
        },
      ],
    });

    alert.present();
  }

  onCheckCaddyPreferredStatus(bp: TeeTimeBookingPlayer, beforeAssignment: boolean = false) {
    if (!this.bookingSlot) return;
    if (this.teeSlotNew) return;
    if (this.hasPreferenceChanges() && !beforeAssignment) return;
    let _bookingAssignments = this.bookingSlot.assignments;
    let _playerAssignments = bp.assignment;
    if (beforeAssignment) {
      if (_bookingAssignments && !_bookingAssignments.preferredCaddieAssigned) {
        if (bp.caddyPreferred && !bp.caddyAssigned) return true;
      } else return false;
    } else {
      if (_bookingAssignments && _bookingAssignments.preferredCaddieAssigned) {
        if (bp.caddyAssigned && bp.caddyPreferred && bp.caddyAssigned.id !== bp.caddyPreferred.id)
          return true;
        else if (bp.caddyPreferred && !bp.caddyAssigned) return true;
        else return false;
        // else if((bp.caddyAssigned && !bp.caddyPreferred) || (bp.caddyPreferred && !bp.caddyAssigned))
        //     return true;
      } else return false;
    }
  }

  isDiffBooker() {
    if (this.isBookingAgent()) return false;
    if (!this.fromClub) return;
    if (this.teeSlotNew) return;
    return (
      this.bookingSlot.bookedByUser &&
      this.bookingSlot.bookedByPlayer &&
      this.bookingSlot.bookedByPlayer.userId !== this.bookingSlot.bookedByUser.id
    );
    // if()
  }
  // onClubManualAssignment() {
  //     let _noBuggyAuth: boolean = false;
  //     let _noCaddyAuth: boolean = false;
  //     if(!this.mg2uUtil.checkAuthority('ASSIGN_BUGGIES')) {
  //         // this.mg2uUtil.displayAuthorityMessage('ASSIGN_BUGGIES', 'E')
  //         // .then((result: any)=>{
  //         //     if(result) {
  //                 _noBuggyAuth = true;
  //         //     }
  //         // })
  //         // return;
  //     }
  //     if(!this.mg2uUtil.checkAuthority('ASSIGN_CADDIES')) {
  //         // this.mg2uUtil.displayAuthorityMessage('ASSIGN_CADDIES', 'E')
  //         // .then((result: any)=>{
  //         //     if(result) {
  //                 _noCaddyAuth = true;
  //         //     }
  //         // })
  //         // return;
  //     }
  //     if(_noBuggyAuth && _noCaddyAuth) {
  //         let alert = this.alertCtrl.create({
  //             title: 'Unauthorized Access',
  //             message: "You don't have privilege to make manual assignments. Please contact the club administrator.",
  //             cssClass: 'booking-error',
  //             buttons: [{
  //                     text: 'Dismiss',
  //                     role: 'cancel',
  //                     handler: () => {
  //                     }
  //                 },
  //                 {
  //                     text: 'Ok',
  //                     handler: () => {
  //                     }
  //                 },
  //             ]
  //         });
  //         alert.present();
  //         return;
  //     }
  //     // goFlightDetail(teeTimeBooking: TeeTimeBooking, flightNo ? : number) {
  //         this.nav.push(TeeBuggyListPage, {
  //             teeTimeBooking: this.bookingSlot,
  //             // flightNumber: flightNo,
  //             caddieMaster: true,
  //             filteredClubMembership: this.filteredClubMembership,
  //         });
  // }

  async moreMenuPopover() {
    let moreMenuItemLists = [
      {
        label: 'Refresh',
        value: 'refresh',
        iconUrl: 'assets/icons/outline/outline_refresh.png',
      },
      // { label: 'Share Booking', value: 'share_booking', iconUrl: 'assets/image/icons/ShareInformation.png' },
      {
        label: 'Cancel Booking',
        value: 'cancel_booking',
        iconUrl: 'assets/image/icons/remove-date-calendar-icon.svg',
      },
      {
        label: 'Go to Home',
        value: 'home',
        iconUrl: 'assets/icons/outline/outline_home.png',
      },
      {
        label: 'Share Booking',
        value: 'ShareBooking',
        iconUrl: 'assets/image/icons/ShareInformation.png',
      },
    ];

    if (
      this.allowBookingScoring() &&
      !this.teeSlotNew &&
      this.bookingType !== 'past' &&
      this.bookingSlot.bookingStatus !== 'CancelledByPlayer' &&
      this.bookingSlot.bookingStatus !== 'CancelledByClub'
    ) {
      const scoringItem = {
        label: 'Start Scoring',
        value: 'start_scoring',
        iconUrl: 'assets/icons/outline/outline_scorecard.png',
      };
      moreMenuItemLists.splice(1, 0, scoringItem);
    }

    if (this.appAttribute && this.appAttribute.showReceipt && this.fromClub && !this.teeSlotNew) {
      const scoringItem = {
        label: 'Print',
        value: 'Print',
        iconUrl: 'assets/icons/outline/printing-button-outline.png',
      };
      moreMenuItemLists.splice(1, 0, scoringItem);
    }

    if (
      this.appAttribute &&
      this.appAttribute.showReceipt &&
      this.appAttribute.receiptForPlayer &&
      !this.fromClub &&
      !this.teeSlotNew
    ) {
      const scoringItem = {
        label: 'Print',
        value: 'Print',
        iconUrl: 'assets/icons/outline/printing-button-outline.png',
      };
      moreMenuItemLists.splice(1, 0, scoringItem);
    }

    if (!this.teeSlotNew) {
      const scoringItem = {
        label: 'Rate Us',
        value: 'clubRating',
        iconUrl: 'assets/icons/outline/five-stars-outlines.png',
      };
      moreMenuItemLists.splice(moreMenuItemLists?.length - 1, 0, scoringItem);
    }

    let popover = await this.popoverCtl.create({
      component: MoreMenuPopoverComponent,
      event: event,
      mode: 'ios',
      cssClass: 'popoverWidth',
      componentProps: {
        moreMenuItemLists: moreMenuItemLists,
        alignment: 'left',
      },
    });
    popover.present();
    await popover.onDidDismiss().then(data => {
      if (data?.data) {
        switch (data?.data) {
          case 'refresh':
            this.onRefreshClick();
            break;
          case 'start_scoring':
            this.onStartScoring();
            break;
          case 'cancel_booking':
            this.onCancelBooking();
            break;
          case 'Print':
            this.onPrintClick();
            break;
          case 'share_booking':
            break;
          case 'clubRating':
            this.onClickOpenClubRatings();
            break;
          case 'home':
            this.goToHome();
            break;
          case 'ShareBooking':
            this.shareBooking();
            break;
        }
      }
    });
  }

  async moreMenuPopoverForPlayer(slot: number = 0) {
    let _notAllowed = await this.allowChangeBooking()
      .then(result => {
        if (result) {
          return false;
        } else return true;
      })
      .catch(error => {
        let _msg = error?.message;
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        return true;
      });
    if (_notAllowed) {
      return;
    }
    // let moreMenuItemLists = [
    //   { label: 'Select Voucher', value: 'voucher' },
    //   { label: 'Edit Player', value: 'EditPlayer' },
    //   { label: 'Delete Player', value: 'DeletePlayer' },
    // ];

    // let popover = await this.popoverCtl.create({
    //   component: MoreMenuPopoverComponent,
    //   event: event,
    //   mode: 'ios',
    //   cssClass: 'popoverWidth',
    //   componentProps: {
    //     moreMenuItemLists: moreMenuItemLists,
    //   },
    // });
    // popover.present();
    // await popover.onDidDismiss().then((data) => {
    //   if (data?.data) {
    //     switch (data?.data) {
    //       case 'voucher':

    //       case 'EditPlayer':

    //       case 'DeletePlayer':

    //     }
    //   }
    // });
    let _dataList = [];
    _dataList.push({
      id: 1,
      name: 'Select Deals / Vouchers',
      visible: true,
    });
    _dataList.push({
      id: 2,
      name: 'Change Player',
      visible: true,
    });
    _dataList.push({
      id: 4,
      name: 'Quick Change Player',
      visible: true,
    });
    _dataList.push({
      id: 3,
      name: 'Remove Player',
      visible: true,
    });
    if (this.hasIntlRate(this.bookingSlot?.bookingPlayers[slot - 1])) {
      _dataList.push({
        id: 5,
        name: 'Toggle Local Resident / Non-Resident',
        visible: true,
      });
    }

    console.debug('has intl rate? ', this.hasIntlRate(), _dataList);

    const modal = await this.modalCtl.create({
      component: HamerburgMenuComponent,
      backdropDismiss: false,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        isMoreOption: false,
        dataList: _dataList,
      },
      mode: 'ios',
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data?.id) {
        switch (data.data.id) {
          case 1:
            this.onPlayerVoucher(slot, 'player', 'voucher');
            break;
          case 2:
            this.onPlayerSelect(slot, false, true);
            break;
          case 3:
            this.onDeleteBookingPlayer(slot);
            break;
          case 4:
            this.onQuickAddPlayer(slot, false, true);
            break;
          case 5:
            this.onClickToggleLocalIntl(this.bookingSlot?.bookingPlayers[slot - 1], true);
            break;
        }
      }
    });
  }

  openBookingDetailsPage() {
    let params: NavigationExtras = {
      // replaceUrl: false,
      state: {
        clubInfo: this.clubInfo,
        teeSlotNew: this.teeSlotNew,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingSlot: this.bookingSlot,
        bookingType: this.bookingType,
        bookingOptions: this.bookingOptions,
      },
    };
    this.router.navigate(['booking-detail-modal'], params);
  }

  openAdditionalItemsPage() {
    let params: NavigationExtras = {
      // replaceUrl: false,
      state: {
        fromClub: true,
        currSession: this.currSession,
        clubInfo: this.clubInfo,
        teeSlotNew: this.teeSlotNew,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingSlot: this.bookingSlot,
        bookingType: this.bookingType,
      },
    };
    this.router.navigate(['additional-items'], params);
  }

  openBookingcaddiesBuggiesDetailsPage() {
    let params: NavigationExtras = {
      // replaceUrl: false,
      state: {
        fromClub: true,
        currSession: this.currSession,
        clubInfo: this.clubInfo,
        teeSlotNew: this.teeSlotNew,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingSlot: this.bookingSlot,
        bookingType: this.bookingType,
      },
    };
    this.router.navigate(['booking-caddies-Buggies-details'], params);
  }
  openBookingPayment() {
    let params: NavigationExtras = {
      // replaceUrl: false,
      state: {
        fromClub: this.fromClub,
        currSession: this.currSession,
        clubInfo: this.clubInfo,
        teeSlotNew: this.teeSlotNew,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingSlot: this.bookingSlot,
        bookingType: this.bookingType,
        bookingItemBill: this.bookingItemBill,
      },
    };
    this.router.navigate(['booking-payment'], params);
  }

  async openCheckInModal() {
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CheckInComponent,

      componentProps: {
        etaCounter: this.etaCounter,
        bookingType: this.bookingType,
        bookingSlot: this.bookingSlot,
        arrivalOption: this.arrivalOption,
        checkInPlayers: this.checkInPlayers,
        checkInAllPlayers: this.checkInAllPlayers,
        getPlayerSlotDetails: this.getPlayerSlotDetails.bind(this),
      },
    });

    await modal.present();

    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.etaCounter = data?.data?.etaCounter;
        this.arrivalOption = data?.data?.arrivalOption;
        this.checkInPlayers = data?.data?.checkInPlayers;
        this.checkInAllPlayers = data?.data?.checkInAllPlayers;
        this.onCheckInClick();
      }
    });
  }

  async moreOptionClick() {
    // this.sessionDataService.getNeedRefresh().subscribe(needRefresh => {
    //   console.debug("session view did enter ", needRefresh)

    //   this.sessionActions.setNeedRefresh(true);
    //   if (needRefresh) {
    //     this.sessionActions.setNeedRefresh(!needRefresh);
    //   }
    // });
    let _dataList = [];
    // _dataList.push({
    //   id: 5,
    //   name: 'Add Player',
    //   visible: this.allowChangeBooking()
    // })
    const modal = await this.modalCtl.create({
      component: HamerburgMenuComponent,

      backdropDismiss: false,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        bookingType: this.bookingType,
      },
      mode: 'ios',
    });
    await modal.present();
    modal.onDidDismiss().then((data: any) => {
      if (data.data?.id) {
        switch (data.data.id) {
          case 1:
            this.openBookingDetailsPage();
            break;
          case 2:
            this.openDealsModal();
            break;
          case 3:
            this.openBookingcaddiesBuggiesDetailsPage();
            break;
          case 4: //Additional Items
            this.allowChangeBooking()
              .then(result => {
                if (result) {
                  this.openAdditionalItemsPage();
                }
              })
              .catch(error => {
                let _msg = error?.message;
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                return;
              });
            break;
          case 5:
            this.allowChangeBooking()
              .then(result => {
                if (result) {
                  this.onPlayerSelect(null);
                }
              })
              .catch(error => {
                let _msg = error?.message;
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                return;
              });
            break;
          case 6: //Check In
            this.allowChangeBooking()
              .then(result => {
                if (result) {
                  this.openCheckInModal();
                }
              })
              .catch(error => {
                let _msg = error?.message;
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                return;
              });
            // this.openCheckInModal();
            break;
          case 7: //Billing & Payments
            this.openBookingPayment();
            break;
          case 8: // Cancel Booking
            this.allowChangeBooking()
              .then(result => {
                if (result) {
                  this.onCancelBooking();
                }
              })
              .catch(error => {
                let _msg = error?.message;
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                return;
              });
            // if(!this.allowChangeBooking()) {
            //   MessageDisplayUtil.showMessageToast('Updated to ' + this.bookingSlot.bookingPlayers[idx]?.playerName, this.platform, this.toastCtl, 3000, 'bottom');
            //   return
            // };
            // this.onCancelBooking();
            break;
          case 9: //Share booking
            this.shareBooking();
            // let _msg = 'This feature will be available in the future.';
            // MessageDisplayUtil.showMessageToast(
            //     _msg,
            //     this.platform,
            //     this.toastCtl,
            //     3000,
            //     'bottom'
            // );
            break;
          case 10: //view T&C
            this.openDealsModal(true);
            break;
        }
      }
    });
  }

  hasAvailablePlayer() {
    let _totalPlayers = this.bookingSlot?.bookingPlayers?.length;
    let _maxPlayers = this.bookingSlot.slotAssigned.maxPlayers;
    return _totalPlayers < _maxPlayers;
  }

  async openPaymentSelection() {
    if (!this.checkBookingTabsComplete('2')) {
      // const modal = await this.modalCtl.create({
      //     component: ChangesHolesComponent,
      //     cssClass: 'self-adjustable-modal',
      //     componentProps: {
      //         header: 'Minimum Players check',
      //         message: msg,
      //         showConfirmBtn: false,
      //     },
      // });
      // await modal.present().then(() => {
      //     const height = this.platform.height() - 250;
      //     if (
      //         document.getElementsByClassName('inner-content')[0]['style'] !==
      //         undefined
      //     )
      //         document.getElementsByClassName('inner-content')[0][
      //             'style'
      //         ].maxHeight = `${height}px`;
      // });

      let _header = 'Minimum Players check';

      const msg =
        'Minimum number of players for this slot is <b>' +
        this.bookingSlot.slotAssigned.minPlayers +
        '</b>. <br>Please add players before payment';
      let message = {
        content: msg,
      };
      let modal = await this.modalCtl.create({
        component: CommonPullupMenuComponent, // DeleteRoomModalComponent,
        // showBackdrop:true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'infoDisplay',
          headerTitle: _header,
          message: message,
        },
      });
      await modal.present();
      modal.onDidDismiss().then(data => {});
      return false;
    }
    console.log(this.fromClub, 'fromClub');
    // let params: NavigationExtras = {
    //   state: {
    //     fromClub: this.fromClub,
    //     currSession: this.currSession,
    //     clubInfo: this.clubInfo,
    //     teeSlotNew: this.teeSlotNew,
    //     teeTimeSlotDisplay: this.teeTimeSlotDisplay,
    //     bookingSlot: this.bookingSlot,
    //     bookingType: this.bookingType,
    //     modalMode: true,
    //   },
    // };
    // this.router.navigate(['payment-selection'], params);

    const modal = await this.modalCtl.create({
      component: PaymentSelectionPage,
      cssClass: 'full-screen-modal',
      componentProps: {
        fromClub: this.fromClub,
        currSession: this.currSession,
        clubInfo: this.clubInfo,
        teeSlotNew: this.teeSlotNew,
        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
        bookingSlot: this.bookingSlot,
        bookingType: this.bookingType,
        modalMode: true,
      },
      mode: 'ios',
    });

    modal.onDidDismiss().then(data => {
      console.debug('payment selection dismiss ', data);
      if (data?.data) {
        if (data?.data?.needRefresh) this.onRefreshClick();
        // setTimeout(()=>{
        // },250)
      }
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  goProcessAddPlayer(playerList: Array<any>, counter: number) {
    return new Promise((resolve, reject) => {
      let i = counter;
      console.debug('go process add player [1]', playerList, i);
      let _player = playerList[i];
      if (!_player?.playerDetails) _player.playerDetails = {};
      _player.playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true;

      _player.playerDetails['caddySelectionCriteria'] = {};
      _player.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
        ? this.caddyRequired
        : false;

      this.addPlayerToBooking(
        {
          new: false,
          playerId: _player?.item.playerId ? _player?.item.playerId : _player?.item.id,
          sequence: null, //i > 1 ? slot + 1 : slot,
          playerDetails: _player?.playerDetails,
        },
        null,
        false
      ).then((result: any) => {
        counter++;
        if (result && counter === playerList.length) {
          resolve({
            done: true,
          });
        } else {
          this.goProcessAddPlayer(playerList, counter);
        }
      });
    });
  }

  getcalncelDetail(attribute: any) {
    switch (attribute) {
      case 'canceledBy':
        return this.bookingSlot?.canceledBy ? this.bookingSlot?.canceledBy?.name : '-';
      case 'cancelledAt':
        return !!this.bookingSlot?.cancelledAt
          ? moment(this.bookingSlot?.cancelledAt, 'YYYY-MM-DDTHH:mm:ss').format(
              "ddd, DD MMM 'YY hh:mm A"
            )
          : '-';
      case 'reason':
        return this.bookingSlot?.cancellationReason ? this.bookingSlot?.cancellationReason : '-';
    }
  }

  getAffiliateInfo(slot: number) {
    let hasPlayer = this.bookingSlot.bookingPlayers[slot - 1];
    if (!hasPlayer) return;
    if (hasPlayer && !hasPlayer.affiliateMember) return;
    this.getContactInfo('affiliateMember', slot);
  }

  clubAddNonMg2uPlayer: string;
  addlBookingPlayers: Array<AddlBookingPlayers> = [];

  addBookingPlayers(x: number, member: boolean = false) {
    console.debug('adding addl booking players', this.addlBookingPlayers, x);
    let _length = this.addlBookingPlayers.length || 0;
    if (this.isMember()) {
      if (member) {
        if (x > 0) this.addlBookingPlayers.push(createAddlBookingPlayers(this.memberReq - 1, true));
        else if (x < 0) this.addlBookingPlayers = this.addlBookingPlayers.slice(0, -1);
      } else {
        if (x > 0) this.addlBookingPlayers.push(createAddlBookingPlayers(this.guestReq));
        else if (x < 0) this.addlBookingPlayers = this.addlBookingPlayers.slice(0, -1);
      }
    } else {
      if (x > 0) this.addlBookingPlayers.push(createAddlBookingPlayers(_length + 1));
      else if (x < 0) this.addlBookingPlayers = this.addlBookingPlayers.slice(0, -1);
    }
  }
  getAddlBookingPlayers() {
    // console.debug("get addl booking players", this.addlBookingPlayers)
    return this.addlBookingPlayers;
  }

  onAddAdditionalPlayers() {
    return new Promise((resolve, reject) => {});
  }

  async onProcessAddAdditionalPlayers(playerA: any, bookingId: number, idx?: number) {
    // AddlBookingPlayers
    return new Promise((resolve, reject) => {
      // if (!data?.data?.playerDetails) data.data.playerDetails = {};
      // data.data.playerDetails['walking'] = this.buggyRequired
      //   ? !this.buggyRequired
      //   : true;
      // data.data.playerDetails['caddySelectionCriteria'] = {};
      // data.data.playerDetails['caddySelectionCriteria']['caddyRequired'] =
      //   this.caddyRequired ? this.caddyRequired : false;
      console.debug('adding player - ', idx, playerA, playerA[idx]);
      let player = playerA[idx]; // this.addlBookingPlayers[idx];
      let _playerInfo = {
        playerDetails: {},
        new: player.player ? false : true,
        id: player.player ? player.player.id : null,
        playerId: player.player ? player.player.id : null,
      };
      _playerInfo.playerDetails = {
        playerName: player?.playerName,
        email: '',
        gender: 'M',
        phone: '',
        walking: this.buggyRequired ? !this.buggyRequired : true,
        caddySelectionCriteria: {},
        playerContact: {},
      };
      _playerInfo.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
        ? this.caddyRequired
        : false;
      // idx += 1;
      this.flightService.addPlayerToBooking(bookingId, _playerInfo).subscribe(
        (data: any) => {
          console.debug('adding player - ', data, idx, this.addlBookingPlayers.length);
          if (data) {
            resolve({
              status: 'success',
              idx: idx,
              done: idx === playerA.length - 1 ? true : false,
            });
          }
        },
        error => {
          reject({
            status: 'failed',
            idx: idx,
            done: idx === playerA.length - 1 ? true : false,
            error: error,
          });
        }
      );
    });
  }

  // goProcessAddAdditionalPlayers(bookingId: number, counter: number = 0, data?: any, bookQuit?: boolean) {
  //   return new Promise((resolve, reject) => {
  //     this.onProcessAddAdditionalPlayers(null, bookingId, counter)
  //       .then((result: any) => {
  //         console.debug("on process add player : ", result, counter, this.addlBookingPlayers?.length, this.addlBookingPlayers)
  //         counter += 1;
  //         if (result.done) {
  //           console.debug("on process add player DONE : ", data)
  //           this.nav.navigateBack('booking-home').then(() => {
  //             let _params: NavigationExtras = {
  //               state: {
  //                 teeSlotNew: false,
  //                 teeTimeSlotDisplay: data?.bookingSlot?.slotAssigned,
  //                 bookingSlot: data?.bookingSlot,
  //                 clubInfo: data?.bookingSlot?.clubData,
  //                 fromClub: true,
  //                 currSession: this.currSession,
  //               }
  //             };
  //             if (bookQuit) {} else this.router.navigate(['booking-details'], _params);
  //           })
  //           resolve({
  //             status: 'success',
  //             done: true
  //           })
  //           // MessageDisplayUtil.showMessageToast('Done add players',this.platform, this.toastCtl, 5000, 'bottom');
  //         } else {
  //           this.goProcessAddAdditionalPlayers(bookingId, counter, data, bookQuit)
  //           // MessageDisplayUtil.showMessageToast('keep adding players '+counter+' | '+result.idx,this.platform, this.toastCtl, 5000, 'bottom');
  //         }
  //       }).catch((error) => {
  //         // console.debug("process add player error ", error)
  //         // if(error?.error) {
  //         //   let _error = error?.error;
  //         //   let _message = _error?.errorMessage || 'Please at least specify each a player name';
  //         //   MessageDisplayUtil.showErrorToast(_message,this.platform, this.toastCtl, 5000, 'bottom');
  //         // }

  //       });
  //   });
  // }

  checkExistingByBookingReference(bookingReference: string) {
    return new Promise((resolve, reject) => {
      let _clubId = this.clubs ? this.clubs.club.id : this.clubInfo.clubId;

      if (!bookingReference) reject('no booking reference');
      this.flightService
        .getBookingByReference(_clubId, bookingReference)
        .subscribe((data: TeeTimeBooking) => {
          if (data) {
            resolve({
              success: true,
              data: data,
            });
          } else reject('not exists');
        });
    });
  }

  onToggleEditPlayerName(idx: number) {
    // console.debug("on toggle edit player name", this.editingPlayerName, idx);
    this.allowChangeBooking()
      .then(result => {
        if (result) {
          this.editingPlayerName[idx] = true; //!this.editingPlayerName[idx];
        }
      })
      .catch(error => {
        let _msg = error?.message;
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        return;
      });
  }

  onSavePlayerName(idx: number) {
    console.debug(
      'on save player name',
      this.editingPlayerName[idx],
      idx,
      this.bookingSlot?.bookingPlayers[idx]
    );
    this.editingPlayerName[idx] = false;

    this.flightService
      .updateBookingPlayerDetails(this.bookingSlot.id, this.bookingSlot.bookingPlayers[idx])
      .subscribe((updatePlayerDetails: any) => {
        if (updatePlayerDetails) {
          this.refreshBookingDetails();
          MessageDisplayUtil.showMessageToast(
            'Updated to ' + this.bookingSlot.bookingPlayers[idx]?.playerName,
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      });
  }

  onNavigateBack(page: string, params?: any, forceNav?: boolean) {
    console.debug('on nav back ', page, params, this.modalMode);
    if (this.modalMode) {
      this.modalCtl.dismiss({
        afterBook: true,
        needRefresh: true,
      });
    } else {
      this.router.navigate([page], params);
    }
  }

  goProcessAddAdditionalPlayers(
    bookingId: number,
    counter: number = 0,
    players?: Array<any>,
    data?: any,
    bookQuit?: boolean
  ) {
    return new Promise((resolve, reject) => {
      this.onProcessAddAdditionalPlayers(players, bookingId, counter)
        .then((result: any) => {
          console.debug('on process add player : ', result, counter, players);
          counter += 1;
          if (result.done) {
            console.debug('on process add player DONE : ', data);
            this.getBookingItemizedBill(true);
            this.recalculateBookingPricing();
            if (this.teeSlotNew)
              this.nav.navigateBack('booking-home').then(() => {
                let _params: NavigationExtras = {
                  state: {
                    teeSlotNew: false,
                    teeTimeSlotDisplay: data?.bookingSlot?.slotAssigned,
                    bookingSlot: data?.bookingSlot,
                    clubInfo: data?.bookingSlot?.clubData,
                    fromClub: true,
                    currSession: this.currSession,
                  },
                };
                if (bookQuit) {
                } else this.router.navigate(['booking-details'], _params);
              });
            resolve({
              status: 'success',
              done: true,
            });
            // MessageDisplayUtil.showMessageToast('Done add players',this.platform, this.toastCtl, 5000, 'bottom');
          } else {
            this.goProcessAddAdditionalPlayers(bookingId, counter, players, data, bookQuit);
            // MessageDisplayUtil.showMessageToast('keep adding players '+counter+' | '+result.idx,this.platform, this.toastCtl, 5000, 'bottom');
          }
        })
        .catch(error => {
          // console.debug("process add player error ", error)
          // if(error?.error) {
          //   let _error = error?.error;
          //   let _message = _error?.errorMessage || 'Please at least specify each a player name';
          //   MessageDisplayUtil.showErrorToast(_message,this.platform, this.toastCtl, 5000, 'bottom');
          // }
        });
    });
  }

  hasIntlRate(bookingPlayer?: TeeTimeBookingPlayer) {
    // if(this.bookingSlot?.bookingStatus === 'CancelledByClub' || this.bookingSlot?.bookingStatus === 'CancelledByPlayer'
    // || this.bookingSlot?.bookingStatus === 'PaymentFull') return;
    if (!this.isAllowedToChange()) return false;
    let _hasIntlRate: boolean = false;
    if (this.teeSlotNew) {
      // if (Object.keys(this.teeTimeSlotDisplay?.displayPrices || {}).some(key => /INTL/i.test(key))) {
      //   _hasIntlRate = true;
      // }
      if (this.teeTimeSlotDisplay?.displayPrices?.INTL) _hasIntlRate = true;
    } else {
      // if (Object.keys(this.bookingSlot?.priceMap || {}).some(key => /INTL/i.test(key))) {
      //   _hasIntlRate = true;
      // }
      if (this.bookingSlot?.priceMap?.INTL) _hasIntlRate = true;
    }
    if (bookingPlayer) {
      let _playerType = null;
      _playerType = bookingPlayer?.playerTypeUsed || bookingPlayer?.playerType;

      if (
        _playerType.id?.toLowerCase().includes('member') ||
        _playerType.id?.toLowerCase().includes('mbr') ||
        _playerType.id?.toLowerCase().includes('mmbr')
      ) {
        _hasIntlRate = false;
      }
    }
    return _hasIntlRate;
  }
  playerToggleResident: Array<boolean> = [];
  isPlayerLocal(bookingPlayer: TeeTimeBookingPlayer) {
    if (!bookingPlayer) return;
    let _isLocal: boolean = true;
    let _idx = this.bookingSlot.bookingPlayers.findIndex((bp, idx) => {
      return bp?.id === bookingPlayer?.id;
    });
    if (bookingPlayer) {
      let _playerType = null;
      _playerType = bookingPlayer?.playerTypeUsed || bookingPlayer?.playerType;

      if (_playerType.id?.toLowerCase().includes('intl')) {
        _isLocal = false;
      }
      this.playerToggleResident[_idx] = _isLocal;
    }
    return _isLocal;
  }

  async onClickToggleLocalIntl(bookingPlayer: TeeTimeBookingPlayer, noPrompt: boolean = false) {
    if (!bookingPlayer) return;
    if (noPrompt) {
      this.toggleLocalIntl(bookingPlayer);
      return;
    }
    let _residentOrNon = 'Non-Resident';
    let _title = '';
    let _message = `This will change to ${_residentOrNon} rate. Do you want to proceed?`;
    if (!this.isPlayerLocal(bookingPlayer)) {
      _residentOrNon = 'Resident';
      if (this.appAttribute?.localInternational?.promptNonResident) {
        _message = this.appAttribute?.localInternational?.promptNonResident;
      }
    } else {
      if (this.appAttribute?.localInternational?.promptResident) {
        _message = this.appAttribute?.localInternational?.promptResident;
      }
    }
    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'notification',
        header: _title,
        msg: _message,
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      if (data) {
        if (data?.data === 'confirm') {
          this.toggleLocalIntl(bookingPlayer);
        }
      }
    });
  }

  async toggleLocalIntl(bookingPlayer: TeeTimeBookingPlayer) {
    if (!bookingPlayer) return false;
    if (!this.bookingSlot) return false;
    let _isLocal = await this.isPlayerLocal(bookingPlayer);
    let _bookingId = this.bookingSlot?.id;
    let _bookingPlayer = bookingPlayer;
    let _idx = this.bookingSlot.bookingPlayers.findIndex((bp, idx) => {
      return bp?.id === bookingPlayer?.id;
    });
    this.playerToggleResident[_idx] = _isLocal ? false : true;
    _bookingPlayer['playerTypeUsed.id'] = _isLocal ? 'INTL' : '';
    // _bookingPlayer?.playerTypeUsed?.id = _isLocal?'INTL':'';
    let _updateType = _isLocal ? 'playerType' : 'resetProfile';
    console.debug(
      'toggling local intl : ',
      this.isPlayerLocal(bookingPlayer),
      _isLocal,
      _bookingId,
      _updateType,
      _bookingPlayer
    );
    this.flightService
      .updateBookingPlayerDetails(_bookingId, _bookingPlayer, _updateType)
      .subscribe(data => {
        if (data) {
          this.onRefreshClick();
        }
      });
  }

  getResidentNonLabel(isResident: boolean) {
    let _residentLabel = 'Resident';
    if (isResident) {
      _residentLabel = 'Resident';
      if (this.appAttribute?.localInternational?.labelResident)
        _residentLabel = this.appAttribute?.localInternational?.labelResident;
    } else {
      _residentLabel = 'Non-Resident';
      if (this.appAttribute?.localInternational?.labelNonResident)
        _residentLabel = this.appAttribute?.localInternational?.labelNonResident;
    }
    return _residentLabel;
  }

  allowChangeBooking() {
    return new Promise((resolve, reject) => {
      if (this.teeSlotNew) resolve({ result: true });
      let _currDate = moment();
      let _isPast: boolean = false;
      if (moment(this.bookingSlot.teeOffDate).isBefore(_currDate, 'day')) {
        _isPast = true;
      }
      if (this.bookingType === 'past' || _isPast)
        reject({
          type: 'past',
          message:
            'Booking is already in the past. Unable to change, please contact club or myGolf2u admin for further inquiry',
          result: false,
        });
      if (
        this.bookingSlot?.bookingStatus === 'CancelledByClub' ||
        this.bookingSlot?.bookingStatus === 'CancelledByPlayer'
      )
        reject({
          type: 'cancelled',
          message:
            'Booking is already Cancelled. Unable to change, please contact club or myGolf2u admin for further inquiry',
          result: false,
        });
      resolve(true);
    });
  }

  isAllowedToChange() {
    if (!this.teeSlotNew && !this.bookingSlot) return false;
    let _currDate = moment();
    if (this.bookingSlot) {
      if (moment(this.bookingSlot.teeOffDate).isBefore(_currDate, 'day')) {
        return false;
      }
    }
    if (this.bookingType === 'past') return false;
    if (
      this.bookingSlot?.bookingStatus === 'CancelledByClub' ||
      this.bookingSlot?.bookingStatus === 'CancelledByPlayer'
    )
      return false;
    return true;
  }

  @ViewChild(IonContent) content: IonContent;
  showScrollFab = false;
  showScrollIndicator = false;
  fabIcon = 'arrow-down';
  isAtBottom = false;

  async checkScroll() {
    // const scrollElement = await this.content.getScrollElement();
    // this.showScrollFab = scrollElement.scrollHeight > scrollElement.clientHeight;
    // this.showScrollIndicator = this.showScrollFab; // You can use either or both

    // const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
    // const currentScroll = scrollElement.scrollTop;
    // console.debug("[on scroll] ", scrollElement, scrollHeight, currentScroll, this.showScrollFab, this.isAtBottom )
    const scrollElement = await this.content.getScrollElement();
    const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
    const currentScroll = scrollElement.scrollTop;

    this.showScrollFab = scrollHeight > 0;
    this.isAtBottom = currentScroll > scrollHeight - 50;
    this.fabIcon = this.isAtBottom ? 'arrow-up' : 'arrow-down';
  }

  scrollToPosition() {
    if (this.isAtBottom) {
      this.content.scrollToTop(300);
    } else {
      this.content.scrollToBottom(300);
    }
  }

  scrollToBottom() {
    this.content.scrollToBottom(300);
  }

  onScroll(event: any) {
    // CustomEvent<ScrollDetail>
    // const scrollElement = event.target;
    // const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
    // const currentScroll = scrollElement.scrollTop;

    // this.showScrollFab = scrollHeight > 0; // Show FAB if there's scrollable content

    // // Check if we're near the bottom (within 100px)
    // this.isAtBottom = currentScroll > scrollHeight - 100;

    // console.debug("[on scroll] ", scrollElement, scrollHeight, currentScroll, this.showScrollFab, this.isAtBottom )

    // // Update the FAB icon based on scroll position
    // this.fabIcon = this.isAtBottom ? 'arrow-up' : 'arrow-down';

    const scrollElement = event.target as HTMLElement;
    const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
    const currentScroll = scrollElement.scrollTop;

    this.showScrollFab = scrollHeight > 0;
    this.isAtBottom = currentScroll > scrollHeight - 50;
    this.fabIcon = this.isAtBottom ? 'arrow-up' : 'arrow-down';
  }

  goToHome() {
    this.mg2uUtil.goToHome();
  }

  async onClickOpenClubRatings() {
    const modal = await this.modalCtl.create({
      cssClass: 'self-adjustable-modal',
      component: ClubRatingsModal,
      componentProps: {
        clubId: this.bookingSlot?.clubData?.id,
        uniqCaddy: this.uniqCaddy,
        bookingSlot: this.bookingSlot,
        currentPlayerId: this.currentPlayerId,
        currentPlayer: this.currentPlayer,
      },
      mode: 'ios',
    });

    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onQuickAddPlayer(
    slot: number,
    isGroupSelect: boolean = false,
    isEditPlayer: boolean = false
  ) {
    if (!this.getAllowUpdatePostPayment() && !this.fromClub) {
      MessageDisplayUtil.showMessageToast(
        'Flight have started. Adding/Removing player is disabled. Please refer to club.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    let _exclusionList = [];
    this.bookingSlot.bookingPlayers.forEach(tbp => {
      if (tbp?.player) _exclusionList.push(tbp.player);
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      backdropDismiss: false,
      componentProps: {
        app: null,
        mode: 'quickPlayer',
        dataId: this.bookingSlot?.clubData?.id || this.bookingSlot?.clubData?.clubId,
        headerTitle: 'Quick Add Player',
        subTitle: 'Search / Add player by',
        exclusionList: _exclusionList,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0] !== undefined)
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(async (data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.playerList?.length > 0) {
          var i = 0;
          let playerList = [];
          playerList = data?.data?.playerList;
          if (isEditPlayer) {
            let idx = slot - 1;
            let player = this.bookingSlot.bookingPlayers[idx];

            await this.deleteBookingPlayer(player, false);
            this.captchaResponse = null;

            setTimeout(async () => {
              await this.addPlayerToBooking({
                new: false,
                playerId: playerList[0]?.item.playerId
                  ? playerList[0]?.item.playerId
                  : playerList[0]?.item.id,
                sequence: slot,
                playerDetails: playerList[0]?.playerDetails,
              });
            }, 2000);
          } else {
            this.goProcessAddPlayer(playerList, 0).then((result: any) => {
              console.debug('go process add player [0]', result);
              if (result?.done) {
                if (this.fromClub && !this.teeSlotNew) {
                  this.getBookingItemizedBill(true, false);
                  this.recalculateBookingPricing(false, false);
                }
              }
            });
          }
        }
      }
      // if(data)
    });

    // let playersToExclude = this.bookingSlot.bookingPlayers.filter(
    //   (p: TeeTimeBookingPlayer) => {
    //     return !p.playerRemoved;
    //   }
    // );

    // let _playerSlots = 1;
    // if (!this.teeSlotNew) {
    //   _playerSlots =
    //     this.slots.length -
    //     (this.bookingSlot ? this.bookingSlot.bookingPlayers.length : 0);
    // }
    // console.debug("adding multi", _playerSlots, this.slots, this.bookingSlot)
    // this.modaladdplayerList(
    //   playersToExclude,
    //   _playerSlots,
    //   slot,
    //   isGroupSelect,
    //   isEditPlayer
    // );
  }

  //(click)="onProcessPaymentClick()">Pay Now</ion-button>

  async requestStoragePermissions(): Promise<boolean> {
    try {
      const permissionStatus = await Filesystem.requestPermissions();
      return permissionStatus.publicStorage === 'granted';
    } catch (error) {
      console.error('Error requesting permissions:', error);
      return false;
    }
  }

  // capturedImage: string | null = null;
  // async shareBooking() {
  //   if (1) {
  //     MessageDisplayUtil.showErrorToast(
  //       'Share functionality is not available at the moment.',
  //       this.platform,
  //       this.toastCtl,
  //       5000,
  //       'bottom'
  //     );
  //     return;
  //   }

  //   if (
  //     this.bookingSlot.bookingStatus !== 'CancelledByClub' &&
  //     this.bookingSlot.bookingStatus !== 'CancelledByPlayer'
  //   ) {
  //     const loader = await this.loadingCtrl.create({
  //       showBackdrop: false,
  //       duration: 5000,
  //     });

  //     let fileUri = '';

  //     try {
  //       // Show the loader
  //       await loader.present();

  //       const clubImage = this.getClubCourseDetails('image');
  //       const clubName = this.getClubCourseDetails('club');
  //       const clubCourse = this.getClubCourseDetails('course');
  //       const bookingStatus = this.getBookingDetails('status').toString();
  //       const bookingSlots = this.bookingSlot;
  //       // const clubImageBase64 = await toBase64(clubImage);
  //       // Generate HTML content
  //       this.htmlContent = await htmlStringUtility.getHtmlString(
  //         bookingSlots,
  //         clubImage,
  //         clubName,
  //         clubCourse,
  //         bookingStatus
  //       );

  //       // Create an off-screen container for rendering the HTML
  //       const container = this.renderer.createElement('div');
  //       this.renderer.setStyle(container, 'position', 'absolute');
  //       this.renderer.setStyle(container, 'top', '-9999px'); // Hide the container off-screen
  //       this.renderer.setProperty(container, 'innerHTML', this.htmlContent);

  //       const images = container.querySelectorAll('img');

  //       await Promise.all(
  //         Array.from(images).map(img => {
  //           return new Promise((resolve, reject) => {
  //             const imageElement = img as HTMLImageElement; // Assert the type as HTMLImageElement
  //             if (imageElement.complete) {
  //               resolve(true);
  //             } else {
  //               imageElement.onload = () => resolve(true);
  //               imageElement.onerror = () => reject(false);
  //             }
  //           });
  //         })
  //       );

  //       this.renderer.appendChild(this.el.nativeElement, container);

  //       // Generate the file URI
  //       fileUri = await this.createAndShareBookingDetail(container);

  //       // Cleanup the off-screen container
  //       this.renderer.removeChild(this.el.nativeElement, container);
  //     } catch (error) {
  //       console.error('Error during sharing:', error);
  //     } finally {
  //       // Dismiss the loader
  //       await loader.dismiss();
  //     }

  //     if (fileUri) {
  //       try {
  //         // Share the file
  //         // await Share.share({
  //         //     url: fileUri,
  //         //     dialogTitle: 'Share your Booking Detail',
  //         // });
  //       } catch (shareError) {
  //         console.error('Error sharing the file:', shareError);
  //       }
  //     } else {
  //       // Show error toast if fileUri is not created
  //       MessageDisplayUtil.showErrorToast(
  //         'Something went wrong. Please try again later.',
  //         this.platform,
  //         this.toastCtl,
  //         5000,
  //         'bottom'
  //       );
  //     }
  //   } else {
  //     return;
  //   }
  // }

  capturedImage: string | null = null;
  async shareBooking() {
    console.log('booking working');

    if (
      this.bookingSlot.bookingStatus !== 'CancelledByClub' &&
      this.bookingSlot.bookingStatus !== 'CancelledByPlayer'
    ) {
      const loader = await this.loadingCtrl.create({
        showBackdrop: false,
        duration: 5000,
      });

      let base64Image = '';
      let container: HTMLElement | null = null;

      try {
        await loader.present();

        const clubImage = this.getClubCourseDetails('image');
        const clubName = this.getClubCourseDetails('club');
        const clubCourse = this.getClubCourseDetails('course');
        const bookingStatus = this.getBookingDetails('status').toString();
        const bookingSlots = this.bookingSlot;

        if (this.isMobileLayout()) {
          this.htmlContent = await htmlStringUtility.getHtmlString_Mobile(
            bookingSlots,
            clubImage,
            clubName,
            clubCourse,
            bookingStatus
          );
        } else {
          this.htmlContent = await htmlStringUtility.getHtmlString_Desktop(
            bookingSlots,
            clubImage,
            clubName,
            clubCourse,
            bookingStatus
          );
        }

        container = this.renderer.createElement('div');
        this.renderer.setStyle(container, 'position', 'absolute');
        this.renderer.setStyle(container, 'top', '-9999px');
        this.renderer.setProperty(container, 'innerHTML', this.htmlContent);

        const images = container.querySelectorAll('img');
        await Promise.all(
          Array.from(images).map(img => {
            return new Promise((resolve, reject) => {
              const imageElement = img as HTMLImageElement;
              if (imageElement.complete) {
                resolve(true);
              } else {
                imageElement.onload = () => resolve(true);
                imageElement.onerror = () => reject(false);
              }
            });
          })
        );

        this.renderer.appendChild(this.el.nativeElement, container);

        const canvas = await html2canvas(container, { useCORS: true });
        base64Image = canvas.toDataURL('image/png');

        const platform = Capacitor.getPlatform();
        console.log('platform ===>', platform);

        if (platform === 'web') {
          const newTab = window.open('', '_blank');
          if (newTab) {
            newTab.document.write(this.htmlContent);
            newTab.document.close();
            newTab.focus();
          } else {
            console.error('Popup blocked or could not open a new tab.');
          }
        } else {
          const fileName = `booking_${new Date().getTime()}.jpg`;

          await Filesystem.writeFile({
            path: fileName,
            data: base64Image.split(',')[1], // Strip "data:image/png;base64,"
            directory: Directory.External,
          });

          const uriResult = await Filesystem.getUri({
            directory: Directory.External,
            path: fileName,
          });

          const fileUri = uriResult.uri;
          console.log('fileUri:', fileUri);

          // 👉 Share the generated local image
          await Share.share({
            title: 'Booking Confirmation',
            text: 'Check out my booking!',
            url: fileUri, // Now sharing the actual generated image file
            dialogTitle: 'Share your booking',
          });
        }
      } catch (error) {
        console.error('Error during sharing:', error);
        MessageDisplayUtil.showErrorToast(
          'Something went wrong. Please try again later.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      } finally {
        if (container) {
          this.renderer.removeChild(this.el.nativeElement, container);
        }
        await loader.dismiss();
      }
    }
  }

  // async createAndShareBookingDetail(container: HTMLElement): Promise<string> {
  //     debugger
  //     try {
  //         // Capture the image
  //         const canvas = await html2canvas(container, { useCORS: true });
  //         this.capturedImage = canvas.toDataURL('image/png');
  //         const fileName = `bookingDetail_${new Date().getTime()}.jpg`;

  //         // Save the file
  //         await Filesystem.writeFile({
  //             path: fileName,
  //             data: this.capturedImage.split(',')[1],
  //             directory: Directory.Cache,
  //         });

  //         // Retrieve the file URI
  //         const uriResult = await Filesystem.getUri({
  //             directory: Directory.Cache,
  //             path: fileName,
  //         });

  //         // Return the URI
  //         return uriResult.uri;
  //     } catch (error) {
  //         console.error('Error creating or retrieving the file:', error);
  //         throw error; // Re-throw the error for the caller to handle
  //     }
  // }
  async createAndShareBookingDetail(container: HTMLElement): Promise<string> {
    try {
      const canvas = await html2canvas(container, { useCORS: true });
      const base64Image = canvas.toDataURL('image/jpeg', 0.95);
      const fileName = `booking_${Date.now()}.jpg`;

      await Filesystem.writeFile({
        path: fileName,
        data: base64Image.split(',')[1], // remove data:image/jpeg;base64,
        directory: Directory.Data,
      });

      const result = await Filesystem.getUri({
        directory: Directory.Data,
        path: fileName,
      });

      return result.uri;
    } catch (error) {
      console.error('Error generating image file:', error);
      return '';
    }
  }

  isMember() {
    let _clubId = this.clubInfo?.clubId || this.clubs?.club?.clubId || this.clubs?.club?.id;
    let _clubMembership = this.mg2uUtil.getPlayerClubMembership();
    let _isMember: boolean = false;
    if (_clubMembership && _clubMembership.length > 0) {
      _clubMembership
        .filter(cm => {
          return cm.club?.id === _clubId && cm?.active;
        })
        .map(cm => {
          _isMember = true;
        });
    } else _isMember = false;
    // console.debug("is member? ", this.clubs, this.clubInfo);
    // console.debug("is member? ", _clubId, _clubMembership);
    // console.debug("is member? ", _isMember);
    return _isMember;
  }

  isMemberType() {
    let _clubId = this.clubInfo?.clubId || this.clubs?.club?.clubId || this.clubs?.club?.id;
    let _clubMembership = this.mg2uUtil.getPlayerClubMembership();
    let isMemberType: string = '';
    if (_clubMembership && _clubMembership.length > 0) {
      _clubMembership
        .filter(cm => {
          return cm.club?.id === _clubId && cm?.active;
        })
        .map(cm => {
          // console.debug("get member type : ", cm)
          isMemberType = cm?.effectivePlayerType;
        });
    } else isMemberType = '';
    return isMemberType;
  }

  isBookingConfirmed() {
    if (!this.bookingSlot) return true;
    if (this.bookingSlot?.bookingConfirmationStatus === null) return true;
    if (this.bookingSlot?.bookingConfirmationStatus === undefined) return true;
    if (
      this.bookingSlot?.bookingConfirmationStatus === 'Pending' ||
      this.bookingSlot?.bookingConfirmationStatus === 'Rejected'
    )
      return false;
    return true;
  }

  async onClickPendingBooking() {
    let _header = 'Pending Confirmation';

    const msg = `Booking is Pending Confirmation. <br>Once Confirmed by the Club, you will be able to make payment.`;
    let message = {
      content: msg,
    };
    let modal = await this.modalCtl.create({
      component: CommonPullupMenuComponent, // DeleteRoomModalComponent,
      // showBackdrop:true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'infoDisplay',
        headerTitle: _header,
        message: message,
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      this.onRefreshClick();
    });
  }

  oneSignalListener() {
    OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
      const _event = event;

      if (this.bookingSlot?.bookingConfirmationStatus !== 'Confirmed') {
        this.onRefreshClick();
      }
      console.debug(event, _event);
    });
  }

  bookingSub: Subscription;
  initSubWebsocket() {
    if (this.bookingSub) return;
    this.bookingSub = this.websocketActions
      .subscribeTo(SUBSCRIBE_TEETIME_BOOKING)
      .subscribe((data: any) => {
        let _clubId = this.bookingSlot?.clubData?.id;
        setTimeout(() => {
          if (data && Number(data.clubId) === Number(_clubId)) {
            if (
              String(data.bookingReference).trim() ===
              String(this.bookingSlot?.bookingReference).trim()
            ) {
              if (data.action === 'booked') {
                if (this.bookingSlot?.bookingConfirmationStatus !== 'Confirmed') {
                  MessageDisplayUtil.showMessageToast(
                    'Booking has been updated',
                    this.platform,
                    this.toastCtl,
                    5000,
                    'bottom'
                  );
                  this.onRefreshClick();
                }
              } else if (data.action === 'rejected') {
                if (this.bookingSlot?.bookingConfirmationStatus !== 'Confirmed') {
                  MessageDisplayUtil.showMessageToast(
                    'Booking has been Rejected',
                    this.platform,
                    this.toastCtl,
                    5000,
                    'bottom'
                  );
                  this.onRefreshClick();
                }
              } else if (data.action === 'confirmed') {
                if (this.bookingSlot?.bookingConfirmationStatus !== 'Confirmed') {
                  MessageDisplayUtil.showMessageToast(
                    'Booking has been Confirmed',
                    this.platform,
                    this.toastCtl,
                    5000,
                    'bottom'
                  );
                  this.onRefreshClick();
                }
              }
            }
          }
        }, 750);
      });
  }

  async onClickUploadPlayerDocument(bookingPlayer: TeeTimeBookingPlayer) {
    let headerTitle;
    let _data;
    const type = 'playerType';
    const player = this.player$.subscribe((player: PlayerInfo) => {
      return player;
    });
    console.debug('on add click ', headerTitle, type, player, bookingPlayer);
    let typeModal = await this.modalCtl.create({
      component: AddPlayerTypeDiscountPage,
      componentProps: {
        headerTitle: headerTitle,
        type: type,
        mode: 'new',
        player: bookingPlayer?.player,
        forBooking: true,
        forSpecificOnly: true,
        specificType: 'STD', //'INTL',
        fromClub: false,
        clubId: this.clubInfo && this.clubInfo.id ? this.clubInfo.id : null,
        data: _data,
      },
    });

    let _deleteMultiDone: boolean = false;
    typeModal.onDidDismiss().then((data: any) => {
      console.debug('on dismiss player document', data);
      if (data && data.data && data?.data?.created) {
        setTimeout(() => {
          // if (type === 'playerType') this.setOptionType(1);
        }, 1000);
      }
      this.getAssignedPlayerTypes();
    });
    typeModal.present();
  }

  isMe(bookingPlayer: TeeTimeBookingPlayer) {
    if (!bookingPlayer) return;
    let _player: TeeTimeBookingPlayer = bookingPlayer; // this.bookingSlot.bookingPlayers[_slot];
    let _isMe: boolean = false;
    _isMe = _player?.player?.id === this.currentPlayerId ? true : false;
    return _isMe;
  }
  hasIntlDoc(bookingPlayer: TeeTimeBookingPlayer) {
    if (!bookingPlayer) return;
    if (!bookingPlayer?.player) return;
    if (!this.assignedPlayerTypes) return;
    if (!this.assignedPlayerTypes?.length) return;
    let _player: TeeTimeBookingPlayer = bookingPlayer;

    // if (!bookingPlayer) return;
    // if (!bookingPlayer?.player) return;
    // if (!this.assignedPlayerTypes) return;
    // if (!this.assignedPlayerTypes?.length) return;
    // let _player: TeeTimeBookingPlayer = bookingPlayer;

    // console.debug("has intl doc [0] : ", _player, this.assignedPlayerTypes, );
    // console.debug("has intl doc [1] : ", this.assignedPlayerTypes?.find(
    //   (playerType: PlayerBookingTypeAssociationExt) => {
    //   return playerType?.bookingPlayer?.player?.id === _player?.player?.id && playerType?.playerTypes?.some((type)=>{
    //     return type?.bookingPlayerType?.id?.toLowerCase().includes('intl');
    //   }); }));
    return this.assignedPlayerTypes?.find((playerType: PlayerBookingTypeAssociationExt) => {
      return (
        playerType?.bookingPlayer?.player?.id === _player?.player?.id &&
        playerType?.playerTypes?.some(type => {
          return (
            type?.bookingPlayerType?.id?.toLowerCase().includes('intl') ||
            type?.bookingPlayerType?.id?.toLowerCase().includes('std')
          );
        })
      );
    });
  }

  isGuest(bookingPlayer: TeeTimeBookingPlayer) {
    if (!bookingPlayer?.player) return true;
  }

  assignedPlayerTypes: Array<PlayerBookingTypeAssociationExt> = [];
  getAssignedPlayerTypes() {
    this.assignedPlayerTypes = [];
    this.bookingSlot?.bookingPlayers?.forEach((bplayer: TeeTimeBookingPlayer) => {
      if (bplayer?.player) {
        this.flightService
          .assignedBookingPlayerType(bplayer?.player?.id)
          .subscribe((data: Array<PlayerBookingTypeAssociation>) => {
            // console.debug("assigned player types [0]", data);
            if (data?.length > 0)
              this.assignedPlayerTypes.push({
                bookingPlayer: bplayer,
                playerTypes: data,
              });
          });
      }
    });
    // console.debug("assigned player types", this.bookingSlot.bookingPlayers, this.assignedPlayerTypes);
  }
}
